/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * SmartBPM
 * API BPMS da SmartPlatform
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessProfileInputCreate,
  AccessProfileInputEdit,
  AccessProfileWithAllPropertiesDto,
  AccessTokenSwagger,
  ActivateDataListParams,
  ActiveServicesDto,
  ActivityInstanceDto,
  AddFileBody,
  AdministrativeDashboardDto,
  AlunoBusca,
  AlunoResult,
  AnalyticalPendingDocumentDto,
  ApiExecutionResultDto,
  ApiManagerDto,
  ApiManagerExecuteInput,
  ApiManagerInput,
  AttachmentDetailsDto,
  AttachmentSignatureDto,
  Authenticate401,
  AuthenticateRequest,
  BatchResultDto,
  BpmnActivityDto,
  BuscarSgeAlunoListParams,
  BuscarSgeAlunoParams,
  BuscarSgePessoaParams,
  CadastrarSgeAlunoParams,
  CadastrarSgeClienteFornecedorParams,
  CadastrarSgeIntegracaoMatriculaParams,
  CadastrarSgePessoaParams,
  CadastroAlunoInput,
  CadastroClienteFornecedorInput,
  CadastroPessoaInput,
  CategoryDto,
  CategoryInput,
  CheckToken400,
  CheckTokenRequest,
  CheckTokenSwagger,
  ClientFornecedorResult,
  CloneDataListParams,
  CompleteTaskBpmDto,
  CompleteTaskDto,
  CompleteTaskInput,
  CompleteTaskSignInput,
  CompleteTaskSignOtpInput,
  ConfirmationLinkInput,
  ConsultaSgeMatriculaAtivaParams,
  ConvertToDocx200,
  ConvertToSfdtBody,
  CreateDataListFromCsvBody,
  CreateDeploymentBody,
  CreateEmailTemplateFormDataBody,
  CreatePhotoUserBody,
  CreateProcessDefinitionDraftBody,
  CreateTermBody,
  CreateUserFromCsvBody,
  CreateUserFromCsvForMultipleTenantsBody,
  CustomHistoricProcessInstanceDto,
  DataExportJob,
  DataListDto,
  DataListEditInput,
  DataListImportResultDto,
  DataListInput,
  DataListRowDtoSwagger,
  DataListRowPageSwagger,
  DeleteDataListParams,
  DeleteProcessDefinitionByIdParams,
  DeleteProcessDefinitionByKeyParams,
  DeleteUserFromCsvForMultipleTenantsBody,
  DeploymentWithDefinitionsDto,
  DisableDataListParams,
  DisableProcessDefinitionByIdParams,
  DisableProcessDefinitionByKeyParams,
  DocumentWithAllPropertiesDto,
  DoczClassificacaoDto,
  DoczClienteProjetos,
  DoczDocumentoSmartResponse,
  DoczGenerateEtiquetaTokenInput,
  DoczImportClienteDto,
  DoczMetadadoDto,
  DoczObjetoLogDto,
  DoczSesiPastaListDto,
  DoczSesiProjetoDto,
  DoczUploadSmartResponse,
  DownloadDoczArquivoById200,
  DownloadEmailTemplate200,
  DownloadFileParams,
  DownloadProcessDefinitionDraft200,
  DownloadPublicThemeParams,
  DownloadSesiIpaasUrlCsv200,
  DownloadStorageReportCsvParams,
  DownloadTermById200,
  DownloadThemeConfigurationParams,
  EditDataListParams,
  EditProcessDefinitionDraftBody,
  EditUserFromCsvForMultipleTenantsBody,
  EmailProcessConfigurationDto,
  EmailProcessConfigurationRequest,
  EmailProcessDefinitionOptionDto,
  EmailProcessEventDto,
  EmailProcessMailboxTestDto,
  EmailProcessReprocessResponseDto,
  EmailProcessStartedEventDto,
  EmailTemplateCreateRequest,
  EmailTemplateDto,
  EmailTemplateEditRequest,
  EmailTemplateTestRequest,
  EnableProcessDefinitionByIdParams,
  EnableProcessDefinitionByKeyParams,
  FindAllByVariableTextValueIgnoreCaseParams,
  FindDataListParams,
  ForceCancelInput,
  FormFieldDto,
  FormSmartDto,
  GenerateAndDownloadStorageReportParams,
  GenerateStorageReportRequestDto,
  GetAdministrativeDashboardParams,
  GetConfirmationLinkByCodeParams,
  GetFormByActivityInstanceIdParams,
  GetLastestTermAcceptanceByUserParams,
  GetLatestTermParams,
  GetOrganizationDashboardParams,
  GetOrganizationDashboardUsersParams,
  GetPasswordResetLinkByCodeParams,
  GetProcessActivitiesHistoricParams,
  GetProcessDashboardParams,
  GetProcessInstanceByEtiquetaParams,
  GetProcessInstanceStatisticParams,
  GetTaskDashboardParams,
  GetTaskFormVariables200,
  GetTaskFormVariablesParams,
  GetTaskVariables200,
  GetTaskVariablesIgnoringTenant200,
  GetTaskVariablesIgnoringTenantParams,
  GetThemeConfigurationParams,
  HasPermissionDto,
  HasPermissionInput,
  ImportDataListCsvBody,
  ImportSesiIpaasUrlsBody,
  IncidentDto,
  IntegracaoMatriculaInput,
  InviteDto,
  InviteInputCreate,
  InviteInputEdit,
  JsonNode,
  ListAccessProfileLogsParams,
  ListAccessProfilesParams,
  ListActivityInstancesParams,
  ListApiManagerParams,
  ListDataListParams,
  ListDataListRowParams,
  ListDoczClassificacoesParams,
  ListDoczClientesProjetosParams,
  ListDoczDocumentosParams,
  ListDoczDocumentosPermitidosParams,
  ListExternalPortalProcessDefinitionsParams,
  ListExternalPortalTasksParams,
  ListFileSignaturesParams,
  ListGroupParams,
  ListGroupsByUserParams,
  ListLastActivityIgnoringTenantParams,
  ListLastActivityParams,
  ListNotificationCenterParams,
  ListParams,
  ListPermissionParams,
  ListProcessDefinitionDraftParams,
  ListProcessDefinitionIgnoringTenantParams,
  ListProcessDefinitionParams,
  ListProcessedEmailsParams,
  ListProcessesHistoricIgnoringTenantParams,
  ListProcessesHistoricParams,
  ListProjetosDoczParams,
  ListScanningProfileParams,
  ListSgeCursosParams,
  ListSgeMatrizParams,
  ListSgeParametrizacaoCursoParams,
  ListSgeParcelaPlanoPagamentoParams,
  ListSgePeriodoLetivoParams,
  ListSgePlanoPagamentoParams,
  ListSgeSeriesParams,
  ListSgeSituacaoMatriculaParams,
  ListSgeTurmasDisciplinaParams,
  ListSgeTurmasParams,
  ListSgeUnidadeParams,
  ListSmartUserLogsParams,
  ListStorageReportsParams,
  ListSystemLogsParams,
  ListTasksIgnoringTenantParams,
  ListTasksParams,
  ListTemplateExternalLinkParams,
  ListTemplateParams,
  ListUserNotificationsParams,
  ListUserParams,
  ListUserPermissionsParams,
  ListUsersPortalExternoParams,
  ListarSgeDocumentosMatriculaParams,
  LoginInput,
  LoginWithDoczToken401,
  LoginWithKeycloakToken401,
  MatriculaAtiva,
  MatriculaResult,
  NotificationCenterCreateRequest,
  NotificationCenterDto,
  NotificationDto,
  NotificationSmtpConfigTestConnectionDto,
  OrganizationConsolidatedDashboardDto,
  OrganizationDashboardUsersDto,
  OrganizationDto,
  OrganizationInputCreate,
  OrganizationInputEdit,
  OrganizationSeiIntegrationDto,
  OrganizationSeiIntegrationInput,
  OrganizationWithAllPropertiesDto,
  PageAccessProfileDto,
  PageAccessProfileLogDto,
  PageActivityInstanceDto,
  PageApiManagerDto,
  PageCustomHistoricActivityInstanceDto,
  PageCustomHistoricProcessInstanceDto,
  PageCustomTaskBpmDto,
  PageDataListDto,
  PageDoczDocumentoResumoSmartResponse,
  PageEmailProcessConfigurationDto,
  PageEmailProcessProcessedEmailDto,
  PageNotificationCenterDto,
  PageNotificationDto,
  PagePortalExternoUsuarioDto,
  PageProcessDefinitionDraftDto,
  PageProcessDefinitionDto,
  PageScanningProfileDto,
  PageSmartEcmSuccinctPropertiesDto,
  PageSmartGroupDto,
  PageSmartLogDto,
  PageSmartPermissionDto,
  PageSmartUserDto,
  PageSmartUserLogDto,
  PageStorageUsageReportDto,
  PageTemplateDto,
  PageTemplateExternalLinkDto,
  PendingDocumentSyntheticDto,
  PessoaBusca,
  PessoaResult,
  PhotoSmartUserDto,
  Problem,
  ProcessDashboardDto,
  ProcessDefinitionDraftDto,
  ProcessDefinitionDto,
  ProcessDoczDto,
  ProcessInstanceDto,
  ProcessInstanceNupDto,
  ProcessInstanceStatisticDto,
  ProcessLinkStringDto,
  ProcessSebraeContractParams,
  RedirectView,
  ResendOtpTaskInput,
  ResetUserPasswordParams,
  ResponseTaskBpmDto,
  SaveThemeConfigurationBody,
  SaveThemeConfigurationParams,
  ScanningProfileDto,
  ScanningProfileInputClone,
  ScanningProfileInputCreate,
  ScanningProfileInputEdit,
  SearchAuditLogsParams,
  SearchFilesParams,
  SenhaInput,
  SesiIpaasUrlDto,
  SgeHealthDto,
  SignUpStateDto,
  SignerSignatureProcessDto,
  SignupParams,
  SimpleTokenResponseDto,
  SmartGroupDto,
  SmartGroupInputCreate,
  SmartGroupInputEdit,
  SmartGroupWitlAllPropertiesDto,
  SmartLogDto,
  SmartPermissionDtoApi,
  SmartTenantDto,
  SmartTenantInputCreate,
  SmartTenantInputEdit,
  SmartTenantWithAllPropertiesDto,
  SmartUserDto,
  SmartUserInputCreate,
  SmartUserInputEdit,
  SmartUserInputEditProfile,
  SmartUserInputSignup,
  SmartUserWithAllPropertiesDto,
  SmartVariableValueHistoryDto,
  SmtpConfigCreateEditRequest,
  SmtpConfigDto,
  SmtpConfigTestRequest,
  SyncfusionDto,
  TaskAssignInput,
  TaskDashboradDto,
  TemplateDto,
  TemplateDtoInputCreate,
  TemplateDtoInputEdit,
  TermsAcceptanceDto,
  TermsOfUseDto,
  TestEmailTemplateFormDataBody,
  ThemeConfigurationDownloadDto,
  ThemeConfigurationDto,
  TokenLoginInput,
  TokenLoginKeycloakInput,
  UpdateEmailTemplateFormDataBody,
  UpdateFileBody,
  UpdateFileParams,
  UploadFileBody,
  UploadFileByLinkBody,
  UploadFileDto,
  UserGroupListDto
} from './model';

import { customInstanceBpm } from '../axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type findUserResponse404 = {
  data: Problem
  status: 404
}

;
export type findUserResponseError = (findUserResponse404) & {
  headers: Headers;
};

export type findUserResponse = (findUserResponseError)

export const getFindUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}`
}

/**
 * @summary Busca um usuário por ID
 */
export const findUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<findUserResponse> => {

  return customInstanceBpm<findUserResponse>(getFindUserUrl(tenant,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindUserQueryKey = (tenant: string,
    userId: string,) => {
    return [
    `/v1/${tenant}/users/${userId}`
    ] as const;
    }


export const getFindUserQueryOptions = <TData = Awaited<ReturnType<typeof findUser>>, TError = Problem>(tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindUserQueryKey(tenant,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUser>>> = ({ signal }) => findUser(tenant,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindUserQueryResult = NonNullable<Awaited<ReturnType<typeof findUser>>>
export type FindUserQueryError = Problem


export function useFindUser<TData = Awaited<ReturnType<typeof findUser>>, TError = Problem>(
 tenant: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUser>>,
          TError,
          Awaited<ReturnType<typeof findUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUser<TData = Awaited<ReturnType<typeof findUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUser>>,
          TError,
          Awaited<ReturnType<typeof findUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUser<TData = Awaited<ReturnType<typeof findUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um usuário por ID
 */

export function useFindUser<TData = Awaited<ReturnType<typeof findUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserQueryOptions(tenant,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editUserResponse200 = {
  data: SmartUserWithAllPropertiesDto
  status: 200
}

export type editUserResponse404 = {
  data: Problem
  status: 404
}

export type editUserResponseSuccess = (editUserResponse200) & {
  headers: Headers;
};
export type editUserResponseError = (editUserResponse404) & {
  headers: Headers;
};

export type editUserResponse = (editUserResponseSuccess | editUserResponseError)

export const getEditUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}`
}

/**
 * @summary Edita um usuário por ID
 */
export const editUser = async (tenant: string,
    userId: string,
    smartUserInputEdit: SmartUserInputEdit, options?: RequestInit): Promise<editUserResponse> => {

  return customInstanceBpm<editUserResponse>(getEditUserUrl(tenant,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartUserInputEdit)
  }
);}




export const getEditUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,{tenant: string;userId: string;data: SmartUserInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,{tenant: string;userId: string;data: SmartUserInputEdit}, TContext> => {

const mutationKey = ['editUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUser>>, {tenant: string;userId: string;data: SmartUserInputEdit}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  editUser(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserMutationResult = NonNullable<Awaited<ReturnType<typeof editUser>>>
    export type EditUserMutationBody = SmartUserInputEdit
    export type EditUserMutationError = Problem

    /**
 * @summary Edita um usuário por ID
 */
export const useEditUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUser>>, TError,{tenant: string;userId: string;data: SmartUserInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUser>>,
        TError,
        {tenant: string;userId: string;data: SmartUserInputEdit},
        TContext
      > => {
      return useMutation(getEditUserMutationOptions(options), queryClient);
    }

export type deleteUserResponse204 = {
  data: void
  status: 204
}

export type deleteUserResponse404 = {
  data: Problem
  status: 404
}

export type deleteUserResponseSuccess = (deleteUserResponse204) & {
  headers: Headers;
};
export type deleteUserResponseError = (deleteUserResponse404) & {
  headers: Headers;
};

export type deleteUserResponse = (deleteUserResponseSuccess | deleteUserResponseError)

export const getDeleteUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}`
}

/**
 * @summary Exclui um usuário por ID
 */
export const deleteUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<deleteUserResponse> => {

  return customInstanceBpm<deleteUserResponse>(getDeleteUserUrl(tenant,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{tenant: string;userId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {tenant: string;userId: string}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  deleteUser(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = Problem

    /**
 * @summary Exclui um usuário por ID
 */
export const useDeleteUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {tenant: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }

export type editUserProfileResponse200 = {
  data: SmartUserWithAllPropertiesDto
  status: 200
}

export type editUserProfileResponse404 = {
  data: Problem
  status: 404
}

export type editUserProfileResponseSuccess = (editUserProfileResponse200) & {
  headers: Headers;
};
export type editUserProfileResponseError = (editUserProfileResponse404) & {
  headers: Headers;
};

export type editUserProfileResponse = (editUserProfileResponseSuccess | editUserProfileResponseError)

export const getEditUserProfileUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/profile`
}

/**
 * @summary Edita perfil do usuário por ID (somente informações básicas)
 */
export const editUserProfile = async (tenant: string,
    userId: string,
    smartUserInputEditProfile: SmartUserInputEditProfile, options?: RequestInit): Promise<editUserProfileResponse> => {

  return customInstanceBpm<editUserProfileResponse>(getEditUserProfileUrl(tenant,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartUserInputEditProfile)
  }
);}




export const getEditUserProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserProfile>>, TError,{tenant: string;userId: string;data: SmartUserInputEditProfile}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserProfile>>, TError,{tenant: string;userId: string;data: SmartUserInputEditProfile}, TContext> => {

const mutationKey = ['editUserProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserProfile>>, {tenant: string;userId: string;data: SmartUserInputEditProfile}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  editUserProfile(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof editUserProfile>>>
    export type EditUserProfileMutationBody = SmartUserInputEditProfile
    export type EditUserProfileMutationError = Problem

    /**
 * @summary Edita perfil do usuário por ID (somente informações básicas)
 */
export const useEditUserProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserProfile>>, TError,{tenant: string;userId: string;data: SmartUserInputEditProfile}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUserProfile>>,
        TError,
        {tenant: string;userId: string;data: SmartUserInputEditProfile},
        TContext
      > => {
      return useMutation(getEditUserProfileMutationOptions(options), queryClient);
    }

export type editInviteResponse200 = {
  data: InviteDto
  status: 200
}

export type editInviteResponse404 = {
  data: Problem
  status: 404
}

export type editInviteResponseSuccess = (editInviteResponse200) & {
  headers: Headers;
};
export type editInviteResponseError = (editInviteResponse404) & {
  headers: Headers;
};

export type editInviteResponse = (editInviteResponseSuccess | editInviteResponseError)

export const getEditInviteUrl = (tenant: string,
    userId: string,
    inviteId: number,) => {




  return `/v1/${tenant}/users/${userId}/invites/${inviteId}`
}

/**
 * @summary Edita um convite por ID
 */
export const editInvite = async (tenant: string,
    userId: string,
    inviteId: number,
    inviteInputEdit: InviteInputEdit, options?: RequestInit): Promise<editInviteResponse> => {

  return customInstanceBpm<editInviteResponse>(getEditInviteUrl(tenant,userId,inviteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inviteInputEdit)
  }
);}




export const getEditInviteMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editInvite>>, TError,{tenant: string;userId: string;inviteId: number;data: InviteInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editInvite>>, TError,{tenant: string;userId: string;inviteId: number;data: InviteInputEdit}, TContext> => {

const mutationKey = ['editInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editInvite>>, {tenant: string;userId: string;inviteId: number;data: InviteInputEdit}> = (props) => {
          const {tenant,userId,inviteId,data} = props ?? {};

          return  editInvite(tenant,userId,inviteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditInviteMutationResult = NonNullable<Awaited<ReturnType<typeof editInvite>>>
    export type EditInviteMutationBody = InviteInputEdit
    export type EditInviteMutationError = Problem

    /**
 * @summary Edita um convite por ID
 */
export const useEditInvite = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editInvite>>, TError,{tenant: string;userId: string;inviteId: number;data: InviteInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editInvite>>,
        TError,
        {tenant: string;userId: string;inviteId: number;data: InviteInputEdit},
        TContext
      > => {
      return useMutation(getEditInviteMutationOptions(options), queryClient);
    }

export type resendInviteResponse200 = {
  data: InviteDto
  status: 200
}

export type resendInviteResponse404 = {
  data: Problem
  status: 404
}

export type resendInviteResponseSuccess = (resendInviteResponse200) & {
  headers: Headers;
};
export type resendInviteResponseError = (resendInviteResponse404) & {
  headers: Headers;
};

export type resendInviteResponse = (resendInviteResponseSuccess | resendInviteResponseError)

export const getResendInviteUrl = (tenant: string,
    userId: string,
    inviteId: number,) => {




  return `/v1/${tenant}/users/${userId}/invites/${inviteId}/resend`
}

/**
 * @summary Reenvia um convite por ID
 */
export const resendInvite = async (tenant: string,
    userId: string,
    inviteId: number, options?: RequestInit): Promise<resendInviteResponse> => {

  return customInstanceBpm<resendInviteResponse>(getResendInviteUrl(tenant,userId,inviteId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getResendInviteMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{tenant: string;userId: string;inviteId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{tenant: string;userId: string;inviteId: number}, TContext> => {

const mutationKey = ['resendInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvite>>, {tenant: string;userId: string;inviteId: number}> = (props) => {
          const {tenant,userId,inviteId} = props ?? {};

          return  resendInvite(tenant,userId,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvite>>>

    export type ResendInviteMutationError = Problem

    /**
 * @summary Reenvia um convite por ID
 */
export const useResendInvite = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{tenant: string;userId: string;inviteId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvite>>,
        TError,
        {tenant: string;userId: string;inviteId: number},
        TContext
      > => {
      return useMutation(getResendInviteMutationOptions(options), queryClient);
    }

export type findPhotoUserResponse404 = {
  data: Problem
  status: 404
}

;
export type findPhotoUserResponseError = (findPhotoUserResponse404) & {
  headers: Headers;
};

export type findPhotoUserResponse = (findPhotoUserResponseError)

export const getFindPhotoUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/foto`
}

/**
 * @summary Busca a foto do perfil do usuário por ID
 */
export const findPhotoUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<findPhotoUserResponse> => {

  return customInstanceBpm<findPhotoUserResponse>(getFindPhotoUserUrl(tenant,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindPhotoUserQueryKey = (tenant: string,
    userId: string,) => {
    return [
    `/v1/${tenant}/users/${userId}/foto`
    ] as const;
    }


export const getFindPhotoUserQueryOptions = <TData = Awaited<ReturnType<typeof findPhotoUser>>, TError = Problem>(tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPhotoUserQueryKey(tenant,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPhotoUser>>> = ({ signal }) => findPhotoUser(tenant,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPhotoUserQueryResult = NonNullable<Awaited<ReturnType<typeof findPhotoUser>>>
export type FindPhotoUserQueryError = Problem


export function useFindPhotoUser<TData = Awaited<ReturnType<typeof findPhotoUser>>, TError = Problem>(
 tenant: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPhotoUser>>,
          TError,
          Awaited<ReturnType<typeof findPhotoUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPhotoUser<TData = Awaited<ReturnType<typeof findPhotoUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPhotoUser>>,
          TError,
          Awaited<ReturnType<typeof findPhotoUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPhotoUser<TData = Awaited<ReturnType<typeof findPhotoUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca a foto do perfil do usuário por ID
 */

export function useFindPhotoUser<TData = Awaited<ReturnType<typeof findPhotoUser>>, TError = Problem>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPhotoUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPhotoUserQueryOptions(tenant,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createPhotoUserResponse200 = {
  data: PhotoSmartUserDto
  status: 200
}

export type createPhotoUserResponse404 = {
  data: Problem
  status: 404
}

export type createPhotoUserResponseSuccess = (createPhotoUserResponse200) & {
  headers: Headers;
};
export type createPhotoUserResponseError = (createPhotoUserResponse404) & {
  headers: Headers;
};

export type createPhotoUserResponse = (createPhotoUserResponseSuccess | createPhotoUserResponseError)

export const getCreatePhotoUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/foto`
}

/**
 * @summary Atualiza a foto do perfil do usuário
 */
export const createPhotoUser = async (tenant: string,
    userId: string,
    createPhotoUserBody?: CreatePhotoUserBody, options?: RequestInit): Promise<createPhotoUserResponse> => {
    const formData = new FormData();
if(createPhotoUserBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(createPhotoUserBody.input));
 }
if(createPhotoUserBody?.file !== undefined) {
 formData.append(`file`, createPhotoUserBody.file);
 }

  return customInstanceBpm<createPhotoUserResponse>(getCreatePhotoUserUrl(tenant,userId),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getCreatePhotoUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoUser>>, TError,{tenant: string;userId: string;data?: CreatePhotoUserBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createPhotoUser>>, TError,{tenant: string;userId: string;data?: CreatePhotoUserBody}, TContext> => {

const mutationKey = ['createPhotoUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPhotoUser>>, {tenant: string;userId: string;data?: CreatePhotoUserBody}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  createPhotoUser(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePhotoUserMutationResult = NonNullable<Awaited<ReturnType<typeof createPhotoUser>>>
    export type CreatePhotoUserMutationBody = CreatePhotoUserBody | undefined
    export type CreatePhotoUserMutationError = Problem

    /**
 * @summary Atualiza a foto do perfil do usuário
 */
export const useCreatePhotoUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoUser>>, TError,{tenant: string;userId: string;data?: CreatePhotoUserBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPhotoUser>>,
        TError,
        {tenant: string;userId: string;data?: CreatePhotoUserBody},
        TContext
      > => {
      return useMutation(getCreatePhotoUserMutationOptions(options), queryClient);
    }

export type deletePhotoUserResponse204 = {
  data: Problem
  status: 204
}

export type deletePhotoUserResponse404 = {
  data: Problem
  status: 404
}

export type deletePhotoUserResponseSuccess = (deletePhotoUserResponse204) & {
  headers: Headers;
};
export type deletePhotoUserResponseError = (deletePhotoUserResponse404) & {
  headers: Headers;
};

export type deletePhotoUserResponse = (deletePhotoUserResponseSuccess | deletePhotoUserResponseError)

export const getDeletePhotoUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/foto`
}

/**
 * @summary Exclui a foto do perfil do usuário por ID
 */
export const deletePhotoUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<deletePhotoUserResponse> => {

  return customInstanceBpm<deletePhotoUserResponse>(getDeletePhotoUserUrl(tenant,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePhotoUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePhotoUser>>, TError,{tenant: string;userId: string}, TContext> => {

const mutationKey = ['deletePhotoUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePhotoUser>>, {tenant: string;userId: string}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  deletePhotoUser(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePhotoUserMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhotoUser>>>

    export type DeletePhotoUserMutationError = Problem

    /**
 * @summary Exclui a foto do perfil do usuário por ID
 */
export const useDeletePhotoUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePhotoUser>>,
        TError,
        {tenant: string;userId: string},
        TContext
      > => {
      return useMutation(getDeletePhotoUserMutationOptions(options), queryClient);
    }

export type enableUserResponse204 = {
  data: void
  status: 204
}

export type enableUserResponse404 = {
  data: Problem
  status: 404
}

export type enableUserResponseSuccess = (enableUserResponse204) & {
  headers: Headers;
};
export type enableUserResponseError = (enableUserResponse404) & {
  headers: Headers;
};

export type enableUserResponse = (enableUserResponseSuccess | enableUserResponseError)

export const getEnableUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/enable`
}

/**
 * @summary Ativa um usuário por ID
 */
export const enableUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<enableUserResponse> => {

  return customInstanceBpm<enableUserResponse>(getEnableUserUrl(tenant,userId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{tenant: string;userId: string}, TContext> => {

const mutationKey = ['enableUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableUser>>, {tenant: string;userId: string}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  enableUser(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableUserMutationResult = NonNullable<Awaited<ReturnType<typeof enableUser>>>

    export type EnableUserMutationError = Problem

    /**
 * @summary Ativa um usuário por ID
 */
export const useEnableUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableUser>>,
        TError,
        {tenant: string;userId: string},
        TContext
      > => {
      return useMutation(getEnableUserMutationOptions(options), queryClient);
    }

export type disableUserResponse204 = {
  data: void
  status: 204
}

export type disableUserResponse404 = {
  data: Problem
  status: 404
}

export type disableUserResponseSuccess = (disableUserResponse204) & {
  headers: Headers;
};
export type disableUserResponseError = (disableUserResponse404) & {
  headers: Headers;
};

export type disableUserResponse = (disableUserResponseSuccess | disableUserResponseError)

export const getDisableUserUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/enable`
}

/**
 * @summary Inativa um usuário por ID
 */
export const disableUser = async (tenant: string,
    userId: string, options?: RequestInit): Promise<disableUserResponse> => {

  return customInstanceBpm<disableUserResponse>(getDisableUserUrl(tenant,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableUserMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{tenant: string;userId: string}, TContext> => {

const mutationKey = ['disableUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableUser>>, {tenant: string;userId: string}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  disableUser(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableUserMutationResult = NonNullable<Awaited<ReturnType<typeof disableUser>>>

    export type DisableUserMutationError = Problem

    /**
 * @summary Inativa um usuário por ID
 */
export const useDisableUser = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUser>>, TError,{tenant: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableUser>>,
        TError,
        {tenant: string;userId: string},
        TContext
      > => {
      return useMutation(getDisableUserMutationOptions(options), queryClient);
    }

export type editUserPasswordResponse204 = {
  data: void
  status: 204
}

export type editUserPasswordResponse404 = {
  data: Problem
  status: 404
}

export type editUserPasswordResponseSuccess = (editUserPasswordResponse204) & {
  headers: Headers;
};
export type editUserPasswordResponseError = (editUserPasswordResponse404) & {
  headers: Headers;
};

export type editUserPasswordResponse = (editUserPasswordResponseSuccess | editUserPasswordResponseError)

export const getEditUserPasswordUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/credentials`
}

/**
 * @summary Edita senha do usuário por ID
 */
export const editUserPassword = async (tenant: string,
    userId: string,
    senhaInput: SenhaInput, options?: RequestInit): Promise<editUserPasswordResponse> => {

  return customInstanceBpm<editUserPasswordResponse>(getEditUserPasswordUrl(tenant,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(senhaInput)
  }
);}




export const getEditUserPasswordMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserPassword>>, TError,{tenant: string;userId: string;data: SenhaInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserPassword>>, TError,{tenant: string;userId: string;data: SenhaInput}, TContext> => {

const mutationKey = ['editUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserPassword>>, {tenant: string;userId: string;data: SenhaInput}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  editUserPassword(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof editUserPassword>>>
    export type EditUserPasswordMutationBody = SenhaInput
    export type EditUserPasswordMutationError = Problem

    /**
 * @summary Edita senha do usuário por ID
 */
export const useEditUserPassword = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserPassword>>, TError,{tenant: string;userId: string;data: SenhaInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUserPassword>>,
        TError,
        {tenant: string;userId: string;data: SenhaInput},
        TContext
      > => {
      return useMutation(getEditUserPasswordMutationOptions(options), queryClient);
    }

export type clearTaskAssignmentResponse204 = {
  data: void
  status: 204
}

export type clearTaskAssignmentResponseSuccess = (clearTaskAssignmentResponse204) & {
  headers: Headers;
};
;

export type clearTaskAssignmentResponse = (clearTaskAssignmentResponseSuccess)

export const getClearTaskAssignmentUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/clear-assignment`
}

/**
 * @summary Limpa a atribuição da tarefa
 */
export const clearTaskAssignment = async (tenant: string,
    id: string, options?: RequestInit): Promise<clearTaskAssignmentResponse> => {

  return customInstanceBpm<clearTaskAssignmentResponse>(getClearTaskAssignmentUrl(tenant,id),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getClearTaskAssignmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTaskAssignment>>, TError,{tenant: string;id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof clearTaskAssignment>>, TError,{tenant: string;id: string}, TContext> => {

const mutationKey = ['clearTaskAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearTaskAssignment>>, {tenant: string;id: string}> = (props) => {
          const {tenant,id} = props ?? {};

          return  clearTaskAssignment(tenant,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearTaskAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof clearTaskAssignment>>>

    export type ClearTaskAssignmentMutationError = unknown

    /**
 * @summary Limpa a atribuição da tarefa
 */
export const useClearTaskAssignment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearTaskAssignment>>, TError,{tenant: string;id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearTaskAssignment>>,
        TError,
        {tenant: string;id: string},
        TContext
      > => {
      return useMutation(getClearTaskAssignmentMutationOptions(options), queryClient);
    }

export type assignTaskResponse204 = {
  data: void
  status: 204
}

export type assignTaskResponseSuccess = (assignTaskResponse204) & {
  headers: Headers;
};
;

export type assignTaskResponse = (assignTaskResponseSuccess)

export const getAssignTaskUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/assign`
}

/**
 * @summary Atribui a tarefa para outro usuário
 */
export const assignTask = async (tenant: string,
    id: string,
    taskAssignInput: TaskAssignInput, options?: RequestInit): Promise<assignTaskResponse> => {

  return customInstanceBpm<assignTaskResponse>(getAssignTaskUrl(tenant,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskAssignInput)
  }
);}




export const getAssignTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTask>>, TError,{tenant: string;id: string;data: TaskAssignInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof assignTask>>, TError,{tenant: string;id: string;data: TaskAssignInput}, TContext> => {

const mutationKey = ['assignTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignTask>>, {tenant: string;id: string;data: TaskAssignInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  assignTask(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignTaskMutationResult = NonNullable<Awaited<ReturnType<typeof assignTask>>>
    export type AssignTaskMutationBody = TaskAssignInput
    export type AssignTaskMutationError = unknown

    /**
 * @summary Atribui a tarefa para outro usuário
 */
export const useAssignTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTask>>, TError,{tenant: string;id: string;data: TaskAssignInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignTask>>,
        TError,
        {tenant: string;id: string;data: TaskAssignInput},
        TContext
      > => {
      return useMutation(getAssignTaskMutationOptions(options), queryClient);
    }

export type assignTaskToMeResponse204 = {
  data: void
  status: 204
}

export type assignTaskToMeResponseSuccess = (assignTaskToMeResponse204) & {
  headers: Headers;
};
;

export type assignTaskToMeResponse = (assignTaskToMeResponseSuccess)

export const getAssignTaskToMeUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/assign-to-me`
}

/**
 * @summary Atribui a tarefa para o usuário atual
 */
export const assignTaskToMe = async (tenant: string,
    id: string, options?: RequestInit): Promise<assignTaskToMeResponse> => {

  return customInstanceBpm<assignTaskToMeResponse>(getAssignTaskToMeUrl(tenant,id),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getAssignTaskToMeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTaskToMe>>, TError,{tenant: string;id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof assignTaskToMe>>, TError,{tenant: string;id: string}, TContext> => {

const mutationKey = ['assignTaskToMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignTaskToMe>>, {tenant: string;id: string}> = (props) => {
          const {tenant,id} = props ?? {};

          return  assignTaskToMe(tenant,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignTaskToMeMutationResult = NonNullable<Awaited<ReturnType<typeof assignTaskToMe>>>

    export type AssignTaskToMeMutationError = unknown

    /**
 * @summary Atribui a tarefa para o usuário atual
 */
export const useAssignTaskToMe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTaskToMe>>, TError,{tenant: string;id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignTaskToMe>>,
        TError,
        {tenant: string;id: string},
        TContext
      > => {
      return useMutation(getAssignTaskToMeMutationOptions(options), queryClient);
    }

export type findScanningProfileResponse404 = {
  data: Problem
  status: 404
}

;
export type findScanningProfileResponseError = (findScanningProfileResponse404) & {
  headers: Headers;
};

export type findScanningProfileResponse = (findScanningProfileResponseError)

export const getFindScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}`
}

/**
 * @summary Busca um perfil de digitalização por ID
 */
export const findScanningProfile = async (tenant: string,
    scanningProfileId: number, options?: RequestInit): Promise<findScanningProfileResponse> => {

  return customInstanceBpm<findScanningProfileResponse>(getFindScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindScanningProfileQueryKey = (tenant: string,
    scanningProfileId: number,) => {
    return [
    `/v1/${tenant}/scanning-profiles/${scanningProfileId}`
    ] as const;
    }


export const getFindScanningProfileQueryOptions = <TData = Awaited<ReturnType<typeof findScanningProfile>>, TError = Problem>(tenant: string,
    scanningProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindScanningProfileQueryKey(tenant,scanningProfileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findScanningProfile>>> = ({ signal }) => findScanningProfile(tenant,scanningProfileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && scanningProfileId !== null && scanningProfileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindScanningProfileQueryResult = NonNullable<Awaited<ReturnType<typeof findScanningProfile>>>
export type FindScanningProfileQueryError = Problem


export function useFindScanningProfile<TData = Awaited<ReturnType<typeof findScanningProfile>>, TError = Problem>(
 tenant: string,
    scanningProfileId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findScanningProfile>>,
          TError,
          Awaited<ReturnType<typeof findScanningProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindScanningProfile<TData = Awaited<ReturnType<typeof findScanningProfile>>, TError = Problem>(
 tenant: string,
    scanningProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findScanningProfile>>,
          TError,
          Awaited<ReturnType<typeof findScanningProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindScanningProfile<TData = Awaited<ReturnType<typeof findScanningProfile>>, TError = Problem>(
 tenant: string,
    scanningProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um perfil de digitalização por ID
 */

export function useFindScanningProfile<TData = Awaited<ReturnType<typeof findScanningProfile>>, TError = Problem>(
 tenant: string,
    scanningProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindScanningProfileQueryOptions(tenant,scanningProfileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editScanningProfileResponse200 = {
  data: ScanningProfileDto
  status: 200
}

export type editScanningProfileResponse404 = {
  data: Problem
  status: 404
}

export type editScanningProfileResponseSuccess = (editScanningProfileResponse200) & {
  headers: Headers;
};
export type editScanningProfileResponseError = (editScanningProfileResponse404) & {
  headers: Headers;
};

export type editScanningProfileResponse = (editScanningProfileResponseSuccess | editScanningProfileResponseError)

export const getEditScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}`
}

/**
 * @summary Atualiza um perfil de digitalização por ID
 */
export const editScanningProfile = async (tenant: string,
    scanningProfileId: number,
    scanningProfileInputEdit: ScanningProfileInputEdit, options?: RequestInit): Promise<editScanningProfileResponse> => {

  return customInstanceBpm<editScanningProfileResponse>(getEditScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scanningProfileInputEdit)
  }
);}




export const getEditScanningProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputEdit}, TContext> => {

const mutationKey = ['editScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editScanningProfile>>, {tenant: string;scanningProfileId: number;data: ScanningProfileInputEdit}> = (props) => {
          const {tenant,scanningProfileId,data} = props ?? {};

          return  editScanningProfile(tenant,scanningProfileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof editScanningProfile>>>
    export type EditScanningProfileMutationBody = ScanningProfileInputEdit
    export type EditScanningProfileMutationError = Problem

    /**
 * @summary Atualiza um perfil de digitalização por ID
 */
export const useEditScanningProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editScanningProfile>>,
        TError,
        {tenant: string;scanningProfileId: number;data: ScanningProfileInputEdit},
        TContext
      > => {
      return useMutation(getEditScanningProfileMutationOptions(options), queryClient);
    }

export type deleteScanningProfileResponse204 = {
  data: void
  status: 204
}

export type deleteScanningProfileResponse404 = {
  data: Problem
  status: 404
}

export type deleteScanningProfileResponseSuccess = (deleteScanningProfileResponse204) & {
  headers: Headers;
};
export type deleteScanningProfileResponseError = (deleteScanningProfileResponse404) & {
  headers: Headers;
};

export type deleteScanningProfileResponse = (deleteScanningProfileResponseSuccess | deleteScanningProfileResponseError)

export const getDeleteScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}`
}

/**
 * @summary Exclui um perfil de digitalização por ID
 */
export const deleteScanningProfile = async (tenant: string,
    scanningProfileId: number, options?: RequestInit): Promise<deleteScanningProfileResponse> => {

  return customInstanceBpm<deleteScanningProfileResponse>(getDeleteScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteScanningProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext> => {

const mutationKey = ['deleteScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScanningProfile>>, {tenant: string;scanningProfileId: number}> = (props) => {
          const {tenant,scanningProfileId} = props ?? {};

          return  deleteScanningProfile(tenant,scanningProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScanningProfile>>>

    export type DeleteScanningProfileMutationError = Problem

    /**
 * @summary Exclui um perfil de digitalização por ID
 */
export const useDeleteScanningProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScanningProfile>>,
        TError,
        {tenant: string;scanningProfileId: number},
        TContext
      > => {
      return useMutation(getDeleteScanningProfileMutationOptions(options), queryClient);
    }

export type enableScanningProfileResponse204 = {
  data: void
  status: 204
}

export type enableScanningProfileResponse404 = {
  data: Problem
  status: 404
}

export type enableScanningProfileResponseSuccess = (enableScanningProfileResponse204) & {
  headers: Headers;
};
export type enableScanningProfileResponseError = (enableScanningProfileResponse404) & {
  headers: Headers;
};

export type enableScanningProfileResponse = (enableScanningProfileResponseSuccess | enableScanningProfileResponseError)

export const getEnableScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}/enable`
}

/**
 * @summary Ativa um perfil de digitalização por ID
 */
export const enableScanningProfile = async (tenant: string,
    scanningProfileId: number, options?: RequestInit): Promise<enableScanningProfileResponse> => {

  return customInstanceBpm<enableScanningProfileResponse>(getEnableScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableScanningProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext> => {

const mutationKey = ['enableScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableScanningProfile>>, {tenant: string;scanningProfileId: number}> = (props) => {
          const {tenant,scanningProfileId} = props ?? {};

          return  enableScanningProfile(tenant,scanningProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof enableScanningProfile>>>

    export type EnableScanningProfileMutationError = Problem

    /**
 * @summary Ativa um perfil de digitalização por ID
 */
export const useEnableScanningProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableScanningProfile>>,
        TError,
        {tenant: string;scanningProfileId: number},
        TContext
      > => {
      return useMutation(getEnableScanningProfileMutationOptions(options), queryClient);
    }

export type disableScanningProfileResponse204 = {
  data: void
  status: 204
}

export type disableScanningProfileResponse404 = {
  data: Problem
  status: 404
}

export type disableScanningProfileResponseSuccess = (disableScanningProfileResponse204) & {
  headers: Headers;
};
export type disableScanningProfileResponseError = (disableScanningProfileResponse404) & {
  headers: Headers;
};

export type disableScanningProfileResponse = (disableScanningProfileResponseSuccess | disableScanningProfileResponseError)

export const getDisableScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}/enable`
}

/**
 * @summary Inativa um perfil de digitalização por ID
 */
export const disableScanningProfile = async (tenant: string,
    scanningProfileId: number, options?: RequestInit): Promise<disableScanningProfileResponse> => {

  return customInstanceBpm<disableScanningProfileResponse>(getDisableScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableScanningProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext> => {

const mutationKey = ['disableScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableScanningProfile>>, {tenant: string;scanningProfileId: number}> = (props) => {
          const {tenant,scanningProfileId} = props ?? {};

          return  disableScanningProfile(tenant,scanningProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof disableScanningProfile>>>

    export type DisableScanningProfileMutationError = Problem

    /**
 * @summary Inativa um perfil de digitalização por ID
 */
export const useDisableScanningProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableScanningProfile>>, TError,{tenant: string;scanningProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableScanningProfile>>,
        TError,
        {tenant: string;scanningProfileId: number},
        TContext
      > => {
      return useMutation(getDisableScanningProfileMutationOptions(options), queryClient);
    }

export type enableProcessDefinitionByIdResponse204 = {
  data: void
  status: 204
}

export type enableProcessDefinitionByIdResponse404 = {
  data: Problem
  status: 404
}

export type enableProcessDefinitionByIdResponseSuccess = (enableProcessDefinitionByIdResponse204) & {
  headers: Headers;
};
export type enableProcessDefinitionByIdResponseError = (enableProcessDefinitionByIdResponse404) & {
  headers: Headers;
};

export type enableProcessDefinitionByIdResponse = (enableProcessDefinitionByIdResponseSuccess | enableProcessDefinitionByIdResponseError)

export const getEnableProcessDefinitionByIdUrl = (tenant: string,
    processDefinitionId: string,
    params?: EnableProcessDefinitionByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions/${processDefinitionId}/enable?${stringifiedParams}` : `/v1/${tenant}/process-definitions/${processDefinitionId}/enable`
}

/**
 * @summary Ativa definição do processo pelo ID
 */
export const enableProcessDefinitionById = async (tenant: string,
    processDefinitionId: string,
    params?: EnableProcessDefinitionByIdParams, options?: RequestInit): Promise<enableProcessDefinitionByIdResponse> => {

  return customInstanceBpm<enableProcessDefinitionByIdResponse>(getEnableProcessDefinitionByIdUrl(tenant,processDefinitionId,params),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableProcessDefinitionByIdMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: EnableProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: EnableProcessDefinitionByIdParams}, TContext> => {

const mutationKey = ['enableProcessDefinitionById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableProcessDefinitionById>>, {tenant: string;processDefinitionId: string;params?: EnableProcessDefinitionByIdParams}> = (props) => {
          const {tenant,processDefinitionId,params} = props ?? {};

          return  enableProcessDefinitionById(tenant,processDefinitionId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableProcessDefinitionByIdMutationResult = NonNullable<Awaited<ReturnType<typeof enableProcessDefinitionById>>>

    export type EnableProcessDefinitionByIdMutationError = Problem

    /**
 * @summary Ativa definição do processo pelo ID
 */
export const useEnableProcessDefinitionById = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: EnableProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableProcessDefinitionById>>,
        TError,
        {tenant: string;processDefinitionId: string;params?: EnableProcessDefinitionByIdParams},
        TContext
      > => {
      return useMutation(getEnableProcessDefinitionByIdMutationOptions(options), queryClient);
    }

export type disableProcessDefinitionByIdResponse204 = {
  data: void
  status: 204
}

export type disableProcessDefinitionByIdResponse404 = {
  data: Problem
  status: 404
}

export type disableProcessDefinitionByIdResponseSuccess = (disableProcessDefinitionByIdResponse204) & {
  headers: Headers;
};
export type disableProcessDefinitionByIdResponseError = (disableProcessDefinitionByIdResponse404) & {
  headers: Headers;
};

export type disableProcessDefinitionByIdResponse = (disableProcessDefinitionByIdResponseSuccess | disableProcessDefinitionByIdResponseError)

export const getDisableProcessDefinitionByIdUrl = (tenant: string,
    processDefinitionId: string,
    params?: DisableProcessDefinitionByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions/${processDefinitionId}/enable?${stringifiedParams}` : `/v1/${tenant}/process-definitions/${processDefinitionId}/enable`
}

/**
 * @summary Inativa definição do processo por ID
 */
export const disableProcessDefinitionById = async (tenant: string,
    processDefinitionId: string,
    params?: DisableProcessDefinitionByIdParams, options?: RequestInit): Promise<disableProcessDefinitionByIdResponse> => {

  return customInstanceBpm<disableProcessDefinitionByIdResponse>(getDisableProcessDefinitionByIdUrl(tenant,processDefinitionId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableProcessDefinitionByIdMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DisableProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DisableProcessDefinitionByIdParams}, TContext> => {

const mutationKey = ['disableProcessDefinitionById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableProcessDefinitionById>>, {tenant: string;processDefinitionId: string;params?: DisableProcessDefinitionByIdParams}> = (props) => {
          const {tenant,processDefinitionId,params} = props ?? {};

          return  disableProcessDefinitionById(tenant,processDefinitionId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableProcessDefinitionByIdMutationResult = NonNullable<Awaited<ReturnType<typeof disableProcessDefinitionById>>>

    export type DisableProcessDefinitionByIdMutationError = Problem

    /**
 * @summary Inativa definição do processo por ID
 */
export const useDisableProcessDefinitionById = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DisableProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableProcessDefinitionById>>,
        TError,
        {tenant: string;processDefinitionId: string;params?: DisableProcessDefinitionByIdParams},
        TContext
      > => {
      return useMutation(getDisableProcessDefinitionByIdMutationOptions(options), queryClient);
    }

export type enableProcessDefinitionByKeyResponse204 = {
  data: void
  status: 204
}

export type enableProcessDefinitionByKeyResponse404 = {
  data: Problem
  status: 404
}

export type enableProcessDefinitionByKeyResponseSuccess = (enableProcessDefinitionByKeyResponse204) & {
  headers: Headers;
};
export type enableProcessDefinitionByKeyResponseError = (enableProcessDefinitionByKeyResponse404) & {
  headers: Headers;
};

export type enableProcessDefinitionByKeyResponse = (enableProcessDefinitionByKeyResponseSuccess | enableProcessDefinitionByKeyResponseError)

export const getEnableProcessDefinitionByKeyUrl = (tenant: string,
    params: EnableProcessDefinitionByKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions/enable?${stringifiedParams}` : `/v1/${tenant}/process-definitions/enable`
}

/**
 * @summary Ativa definição do processo pela chave
 */
export const enableProcessDefinitionByKey = async (tenant: string,
    params: EnableProcessDefinitionByKeyParams, options?: RequestInit): Promise<enableProcessDefinitionByKeyResponse> => {

  return customInstanceBpm<enableProcessDefinitionByKeyResponse>(getEnableProcessDefinitionByKeyUrl(tenant,params),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableProcessDefinitionByKeyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionByKey>>, TError,{tenant: string;params: EnableProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionByKey>>, TError,{tenant: string;params: EnableProcessDefinitionByKeyParams}, TContext> => {

const mutationKey = ['enableProcessDefinitionByKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableProcessDefinitionByKey>>, {tenant: string;params: EnableProcessDefinitionByKeyParams}> = (props) => {
          const {tenant,params} = props ?? {};

          return  enableProcessDefinitionByKey(tenant,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableProcessDefinitionByKeyMutationResult = NonNullable<Awaited<ReturnType<typeof enableProcessDefinitionByKey>>>

    export type EnableProcessDefinitionByKeyMutationError = Problem

    /**
 * @summary Ativa definição do processo pela chave
 */
export const useEnableProcessDefinitionByKey = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableProcessDefinitionByKey>>, TError,{tenant: string;params: EnableProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableProcessDefinitionByKey>>,
        TError,
        {tenant: string;params: EnableProcessDefinitionByKeyParams},
        TContext
      > => {
      return useMutation(getEnableProcessDefinitionByKeyMutationOptions(options), queryClient);
    }

export type disableProcessDefinitionByKeyResponse204 = {
  data: void
  status: 204
}

export type disableProcessDefinitionByKeyResponse404 = {
  data: Problem
  status: 404
}

export type disableProcessDefinitionByKeyResponseSuccess = (disableProcessDefinitionByKeyResponse204) & {
  headers: Headers;
};
export type disableProcessDefinitionByKeyResponseError = (disableProcessDefinitionByKeyResponse404) & {
  headers: Headers;
};

export type disableProcessDefinitionByKeyResponse = (disableProcessDefinitionByKeyResponseSuccess | disableProcessDefinitionByKeyResponseError)

export const getDisableProcessDefinitionByKeyUrl = (tenant: string,
    params: DisableProcessDefinitionByKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions/enable?${stringifiedParams}` : `/v1/${tenant}/process-definitions/enable`
}

/**
 * @summary Inativa definição do processo pela chave
 */
export const disableProcessDefinitionByKey = async (tenant: string,
    params: DisableProcessDefinitionByKeyParams, options?: RequestInit): Promise<disableProcessDefinitionByKeyResponse> => {

  return customInstanceBpm<disableProcessDefinitionByKeyResponse>(getDisableProcessDefinitionByKeyUrl(tenant,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableProcessDefinitionByKeyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionByKey>>, TError,{tenant: string;params: DisableProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionByKey>>, TError,{tenant: string;params: DisableProcessDefinitionByKeyParams}, TContext> => {

const mutationKey = ['disableProcessDefinitionByKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableProcessDefinitionByKey>>, {tenant: string;params: DisableProcessDefinitionByKeyParams}> = (props) => {
          const {tenant,params} = props ?? {};

          return  disableProcessDefinitionByKey(tenant,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableProcessDefinitionByKeyMutationResult = NonNullable<Awaited<ReturnType<typeof disableProcessDefinitionByKey>>>

    export type DisableProcessDefinitionByKeyMutationError = Problem

    /**
 * @summary Inativa definição do processo pela chave
 */
export const useDisableProcessDefinitionByKey = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableProcessDefinitionByKey>>, TError,{tenant: string;params: DisableProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableProcessDefinitionByKey>>,
        TError,
        {tenant: string;params: DisableProcessDefinitionByKeyParams},
        TContext
      > => {
      return useMutation(getDisableProcessDefinitionByKeyMutationOptions(options), queryClient);
    }

export type findProcessDefinitionDraftResponse404 = {
  data: Problem
  status: 404
}

;
export type findProcessDefinitionDraftResponseError = (findProcessDefinitionDraftResponse404) & {
  headers: Headers;
};

export type findProcessDefinitionDraftResponse = (findProcessDefinitionDraftResponseError)

export const getFindProcessDefinitionDraftUrl = (tenant: string,
    draftId: number,) => {




  return `/v1/${tenant}/process-definition-drafts/${draftId}`
}

/**
 * @summary Busca um rascunho por ID
 */
export const findProcessDefinitionDraft = async (tenant: string,
    draftId: number, options?: RequestInit): Promise<findProcessDefinitionDraftResponse> => {

  return customInstanceBpm<findProcessDefinitionDraftResponse>(getFindProcessDefinitionDraftUrl(tenant,draftId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindProcessDefinitionDraftQueryKey = (tenant: string,
    draftId: number,) => {
    return [
    `/v1/${tenant}/process-definition-drafts/${draftId}`
    ] as const;
    }


export const getFindProcessDefinitionDraftQueryOptions = <TData = Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError = Problem>(tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindProcessDefinitionDraftQueryKey(tenant,draftId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findProcessDefinitionDraft>>> = ({ signal }) => findProcessDefinitionDraft(tenant,draftId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && draftId !== null && draftId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindProcessDefinitionDraftQueryResult = NonNullable<Awaited<ReturnType<typeof findProcessDefinitionDraft>>>
export type FindProcessDefinitionDraftQueryError = Problem


export function useFindProcessDefinitionDraft<TData = Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError = Problem>(
 tenant: string,
    draftId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof findProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindProcessDefinitionDraft<TData = Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError = Problem>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof findProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindProcessDefinitionDraft<TData = Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError = Problem>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um rascunho por ID
 */

export function useFindProcessDefinitionDraft<TData = Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError = Problem>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindProcessDefinitionDraftQueryOptions(tenant,draftId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editProcessDefinitionDraftResponse200 = {
  data: ProcessDefinitionDraftDto
  status: 200
}

export type editProcessDefinitionDraftResponse404 = {
  data: Problem
  status: 404
}

export type editProcessDefinitionDraftResponseSuccess = (editProcessDefinitionDraftResponse200) & {
  headers: Headers;
};
export type editProcessDefinitionDraftResponseError = (editProcessDefinitionDraftResponse404) & {
  headers: Headers;
};

export type editProcessDefinitionDraftResponse = (editProcessDefinitionDraftResponseSuccess | editProcessDefinitionDraftResponseError)

export const getEditProcessDefinitionDraftUrl = (tenant: string,
    draftId: number,) => {




  return `/v1/${tenant}/process-definition-drafts/${draftId}`
}

/**
 * @summary Edita um rascunho por ID
 */
export const editProcessDefinitionDraft = async (tenant: string,
    draftId: number,
    editProcessDefinitionDraftBody?: EditProcessDefinitionDraftBody, options?: RequestInit): Promise<editProcessDefinitionDraftResponse> => {
    const formData = new FormData();
if(editProcessDefinitionDraftBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(editProcessDefinitionDraftBody.input));
 }
if(editProcessDefinitionDraftBody?.diagram !== undefined) {
 formData.append(`diagram`, editProcessDefinitionDraftBody.diagram);
 }

  return customInstanceBpm<editProcessDefinitionDraftResponse>(getEditProcessDefinitionDraftUrl(tenant,draftId),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getEditProcessDefinitionDraftMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editProcessDefinitionDraft>>, TError,{tenant: string;draftId: number;data?: EditProcessDefinitionDraftBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editProcessDefinitionDraft>>, TError,{tenant: string;draftId: number;data?: EditProcessDefinitionDraftBody}, TContext> => {

const mutationKey = ['editProcessDefinitionDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editProcessDefinitionDraft>>, {tenant: string;draftId: number;data?: EditProcessDefinitionDraftBody}> = (props) => {
          const {tenant,draftId,data} = props ?? {};

          return  editProcessDefinitionDraft(tenant,draftId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditProcessDefinitionDraftMutationResult = NonNullable<Awaited<ReturnType<typeof editProcessDefinitionDraft>>>
    export type EditProcessDefinitionDraftMutationBody = EditProcessDefinitionDraftBody | undefined
    export type EditProcessDefinitionDraftMutationError = Problem

    /**
 * @summary Edita um rascunho por ID
 */
export const useEditProcessDefinitionDraft = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editProcessDefinitionDraft>>, TError,{tenant: string;draftId: number;data?: EditProcessDefinitionDraftBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editProcessDefinitionDraft>>,
        TError,
        {tenant: string;draftId: number;data?: EditProcessDefinitionDraftBody},
        TContext
      > => {
      return useMutation(getEditProcessDefinitionDraftMutationOptions(options), queryClient);
    }

export type deleteProcessDefinitionDraftResponse204 = {
  data: void
  status: 204
}

export type deleteProcessDefinitionDraftResponse404 = {
  data: Problem
  status: 404
}

export type deleteProcessDefinitionDraftResponseSuccess = (deleteProcessDefinitionDraftResponse204) & {
  headers: Headers;
};
export type deleteProcessDefinitionDraftResponseError = (deleteProcessDefinitionDraftResponse404) & {
  headers: Headers;
};

export type deleteProcessDefinitionDraftResponse = (deleteProcessDefinitionDraftResponseSuccess | deleteProcessDefinitionDraftResponseError)

export const getDeleteProcessDefinitionDraftUrl = (tenant: string,
    draftId: number,) => {




  return `/v1/${tenant}/process-definition-drafts/${draftId}`
}

/**
 * @summary Exclui um rascunho por ID
 */
export const deleteProcessDefinitionDraft = async (tenant: string,
    draftId: number, options?: RequestInit): Promise<deleteProcessDefinitionDraftResponse> => {

  return customInstanceBpm<deleteProcessDefinitionDraftResponse>(getDeleteProcessDefinitionDraftUrl(tenant,draftId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProcessDefinitionDraftMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>, TError,{tenant: string;draftId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>, TError,{tenant: string;draftId: number}, TContext> => {

const mutationKey = ['deleteProcessDefinitionDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>, {tenant: string;draftId: number}> = (props) => {
          const {tenant,draftId} = props ?? {};

          return  deleteProcessDefinitionDraft(tenant,draftId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProcessDefinitionDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>>

    export type DeleteProcessDefinitionDraftMutationError = Problem

    /**
 * @summary Exclui um rascunho por ID
 */
export const useDeleteProcessDefinitionDraft = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>, TError,{tenant: string;draftId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProcessDefinitionDraft>>,
        TError,
        {tenant: string;draftId: number},
        TContext
      > => {
      return useMutation(getDeleteProcessDefinitionDraftMutationOptions(options), queryClient);
    }

export type enableUserPortalExternoResponse204 = {
  data: void
  status: 204
}

export type enableUserPortalExternoResponseSuccess = (enableUserPortalExternoResponse204) & {
  headers: Headers;
};
;

export type enableUserPortalExternoResponse = (enableUserPortalExternoResponseSuccess)

export const getEnableUserPortalExternoUrl = (tenant: string,
    userId: number,) => {




  return `/v1/${tenant}/portal-externo/users/${userId}/enable`
}

/**
 * @summary Ativa um usuário do portal externo
 */
export const enableUserPortalExterno = async (tenant: string,
    userId: number, options?: RequestInit): Promise<enableUserPortalExternoResponse> => {

  return customInstanceBpm<enableUserPortalExternoResponse>(getEnableUserPortalExternoUrl(tenant,userId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableUserPortalExternoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext> => {

const mutationKey = ['enableUserPortalExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableUserPortalExterno>>, {tenant: string;userId: number}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  enableUserPortalExterno(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableUserPortalExternoMutationResult = NonNullable<Awaited<ReturnType<typeof enableUserPortalExterno>>>

    export type EnableUserPortalExternoMutationError = unknown

    /**
 * @summary Ativa um usuário do portal externo
 */
export const useEnableUserPortalExterno = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableUserPortalExterno>>,
        TError,
        {tenant: string;userId: number},
        TContext
      > => {
      return useMutation(getEnableUserPortalExternoMutationOptions(options), queryClient);
    }

export type disableUserPortalExternoResponse204 = {
  data: void
  status: 204
}

export type disableUserPortalExternoResponseSuccess = (disableUserPortalExternoResponse204) & {
  headers: Headers;
};
;

export type disableUserPortalExternoResponse = (disableUserPortalExternoResponseSuccess)

export const getDisableUserPortalExternoUrl = (tenant: string,
    userId: number,) => {




  return `/v1/${tenant}/portal-externo/users/${userId}/disable`
}

/**
 * @summary Desativa um usuário do portal externo
 */
export const disableUserPortalExterno = async (tenant: string,
    userId: number, options?: RequestInit): Promise<disableUserPortalExternoResponse> => {

  return customInstanceBpm<disableUserPortalExternoResponse>(getDisableUserPortalExternoUrl(tenant,userId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getDisableUserPortalExternoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext> => {

const mutationKey = ['disableUserPortalExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableUserPortalExterno>>, {tenant: string;userId: number}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  disableUserPortalExterno(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableUserPortalExternoMutationResult = NonNullable<Awaited<ReturnType<typeof disableUserPortalExterno>>>

    export type DisableUserPortalExternoMutationError = unknown

    /**
 * @summary Desativa um usuário do portal externo
 */
export const useDisableUserPortalExterno = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUserPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableUserPortalExterno>>,
        TError,
        {tenant: string;userId: number},
        TContext
      > => {
      return useMutation(getDisableUserPortalExternoMutationOptions(options), queryClient);
    }

export type getOrganizationResponse404 = {
  data: Problem
  status: 404
}

;
export type getOrganizationResponseError = (getOrganizationResponse404) & {
  headers: Headers;
};

export type getOrganizationResponse = (getOrganizationResponseError)

export const getGetOrganizationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}`
}

/**
 * @summary Busca uma organização pela key
 */
export const getOrganization = async (tenant: string,
    organizationKey: string, options?: RequestInit): Promise<getOrganizationResponse> => {

  return customInstanceBpm<getOrganizationResponse>(getGetOrganizationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationQueryKey = (tenant: string,
    organizationKey: string,) => {
    return [
    `/v1/${tenant}/organizations/${organizationKey}`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = Problem>(tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(tenant,organizationKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(tenant,organizationKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && organizationKey !== null && organizationKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = Problem


export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = Problem>(
 tenant: string,
    organizationKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = Problem>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = Problem>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma organização pela key
 */

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = Problem>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationQueryOptions(tenant,organizationKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editOrganizationResponse200 = {
  data: OrganizationWithAllPropertiesDto
  status: 200
}

export type editOrganizationResponse404 = {
  data: Problem
  status: 404
}

export type editOrganizationResponseSuccess = (editOrganizationResponse200) & {
  headers: Headers;
};
export type editOrganizationResponseError = (editOrganizationResponse404) & {
  headers: Headers;
};

export type editOrganizationResponse = (editOrganizationResponseSuccess | editOrganizationResponseError)

export const getEditOrganizationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}`
}

/**
 * @summary Atualiza uma organização pela key
 */
export const editOrganization = async (tenant: string,
    organizationKey: string,
    organizationInputEdit: OrganizationInputEdit, options?: RequestInit): Promise<editOrganizationResponse> => {

  return customInstanceBpm<editOrganizationResponse>(getEditOrganizationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(organizationInputEdit)
  }
);}




export const getEditOrganizationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editOrganization>>, TError,{tenant: string;organizationKey: string;data: OrganizationInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editOrganization>>, TError,{tenant: string;organizationKey: string;data: OrganizationInputEdit}, TContext> => {

const mutationKey = ['editOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editOrganization>>, {tenant: string;organizationKey: string;data: OrganizationInputEdit}> = (props) => {
          const {tenant,organizationKey,data} = props ?? {};

          return  editOrganization(tenant,organizationKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof editOrganization>>>
    export type EditOrganizationMutationBody = OrganizationInputEdit
    export type EditOrganizationMutationError = Problem

    /**
 * @summary Atualiza uma organização pela key
 */
export const useEditOrganization = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editOrganization>>, TError,{tenant: string;organizationKey: string;data: OrganizationInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editOrganization>>,
        TError,
        {tenant: string;organizationKey: string;data: OrganizationInputEdit},
        TContext
      > => {
      return useMutation(getEditOrganizationMutationOptions(options), queryClient);
    }

export type getSeiIntegrationResponse200 = {
  data: OrganizationSeiIntegrationDto
  status: 200
}

export type getSeiIntegrationResponseSuccess = (getSeiIntegrationResponse200) & {
  headers: Headers;
};
;

export type getSeiIntegrationResponse = (getSeiIntegrationResponseSuccess)

export const getGetSeiIntegrationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}/sei-integration`
}

/**
 * @summary Busca a configuração de integração SEI da organização
 */
export const getSeiIntegration = async (tenant: string,
    organizationKey: string, options?: RequestInit): Promise<getSeiIntegrationResponse> => {

  return customInstanceBpm<getSeiIntegrationResponse>(getGetSeiIntegrationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSeiIntegrationQueryKey = (tenant: string,
    organizationKey: string,) => {
    return [
    `/v1/${tenant}/organizations/${organizationKey}/sei-integration`
    ] as const;
    }


export const getGetSeiIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getSeiIntegration>>, TError = unknown>(tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeiIntegrationQueryKey(tenant,organizationKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeiIntegration>>> = ({ signal }) => getSeiIntegration(tenant,organizationKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && organizationKey !== null && organizationKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeiIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getSeiIntegration>>>
export type GetSeiIntegrationQueryError = unknown


export function useGetSeiIntegration<TData = Awaited<ReturnType<typeof getSeiIntegration>>, TError = unknown>(
 tenant: string,
    organizationKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeiIntegration>>,
          TError,
          Awaited<ReturnType<typeof getSeiIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeiIntegration<TData = Awaited<ReturnType<typeof getSeiIntegration>>, TError = unknown>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeiIntegration>>,
          TError,
          Awaited<ReturnType<typeof getSeiIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeiIntegration<TData = Awaited<ReturnType<typeof getSeiIntegration>>, TError = unknown>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca a configuração de integração SEI da organização
 */

export function useGetSeiIntegration<TData = Awaited<ReturnType<typeof getSeiIntegration>>, TError = unknown>(
 tenant: string,
    organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeiIntegration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeiIntegrationQueryOptions(tenant,organizationKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateSeiIntegrationResponse200 = {
  data: OrganizationSeiIntegrationDto
  status: 200
}

export type updateSeiIntegrationResponseSuccess = (updateSeiIntegrationResponse200) & {
  headers: Headers;
};
;

export type updateSeiIntegrationResponse = (updateSeiIntegrationResponseSuccess)

export const getUpdateSeiIntegrationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}/sei-integration`
}

/**
 * @summary Atualiza a configuração de integração SEI da organizacão
 */
export const updateSeiIntegration = async (tenant: string,
    organizationKey: string,
    organizationSeiIntegrationInput: OrganizationSeiIntegrationInput, options?: RequestInit): Promise<updateSeiIntegrationResponse> => {

  return customInstanceBpm<updateSeiIntegrationResponse>(getUpdateSeiIntegrationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(organizationSeiIntegrationInput)
  }
);}




export const getUpdateSeiIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSeiIntegration>>, TError,{tenant: string;organizationKey: string;data: OrganizationSeiIntegrationInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSeiIntegration>>, TError,{tenant: string;organizationKey: string;data: OrganizationSeiIntegrationInput}, TContext> => {

const mutationKey = ['updateSeiIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSeiIntegration>>, {tenant: string;organizationKey: string;data: OrganizationSeiIntegrationInput}> = (props) => {
          const {tenant,organizationKey,data} = props ?? {};

          return  updateSeiIntegration(tenant,organizationKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSeiIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateSeiIntegration>>>
    export type UpdateSeiIntegrationMutationBody = OrganizationSeiIntegrationInput
    export type UpdateSeiIntegrationMutationError = unknown

    /**
 * @summary Atualiza a configuração de integração SEI da organizacão
 */
export const useUpdateSeiIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSeiIntegration>>, TError,{tenant: string;organizationKey: string;data: OrganizationSeiIntegrationInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSeiIntegration>>,
        TError,
        {tenant: string;organizationKey: string;data: OrganizationSeiIntegrationInput},
        TContext
      > => {
      return useMutation(getUpdateSeiIntegrationMutationOptions(options), queryClient);
    }

export type enableTenantOrganizationResponse204 = {
  data: void
  status: 204
}

export type enableTenantOrganizationResponse404 = {
  data: Problem
  status: 404
}

export type enableTenantOrganizationResponseSuccess = (enableTenantOrganizationResponse204) & {
  headers: Headers;
};
export type enableTenantOrganizationResponseError = (enableTenantOrganizationResponse404) & {
  headers: Headers;
};

export type enableTenantOrganizationResponse = (enableTenantOrganizationResponseSuccess | enableTenantOrganizationResponseError)

export const getEnableTenantOrganizationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}/enable`
}

/**
 * @summary Ativa uma organização por ID
 */
export const enableTenantOrganization = async (tenant: string,
    organizationKey: string, options?: RequestInit): Promise<enableTenantOrganizationResponse> => {

  return customInstanceBpm<enableTenantOrganizationResponse>(getEnableTenantOrganizationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableTenantOrganizationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext> => {

const mutationKey = ['enableTenantOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableTenantOrganization>>, {tenant: string;organizationKey: string}> = (props) => {
          const {tenant,organizationKey} = props ?? {};

          return  enableTenantOrganization(tenant,organizationKey,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableTenantOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof enableTenantOrganization>>>

    export type EnableTenantOrganizationMutationError = Problem

    /**
 * @summary Ativa uma organização por ID
 */
export const useEnableTenantOrganization = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableTenantOrganization>>,
        TError,
        {tenant: string;organizationKey: string},
        TContext
      > => {
      return useMutation(getEnableTenantOrganizationMutationOptions(options), queryClient);
    }

export type disableTenantOrganizationResponse204 = {
  data: void
  status: 204
}

export type disableTenantOrganizationResponse404 = {
  data: Problem
  status: 404
}

export type disableTenantOrganizationResponseSuccess = (disableTenantOrganizationResponse204) & {
  headers: Headers;
};
export type disableTenantOrganizationResponseError = (disableTenantOrganizationResponse404) & {
  headers: Headers;
};

export type disableTenantOrganizationResponse = (disableTenantOrganizationResponseSuccess | disableTenantOrganizationResponseError)

export const getDisableTenantOrganizationUrl = (tenant: string,
    organizationKey: string,) => {




  return `/v1/${tenant}/organizations/${organizationKey}/enable`
}

/**
 * @summary Inativa uma organização por ID
 */
export const disableTenantOrganization = async (tenant: string,
    organizationKey: string, options?: RequestInit): Promise<disableTenantOrganizationResponse> => {

  return customInstanceBpm<disableTenantOrganizationResponse>(getDisableTenantOrganizationUrl(tenant,organizationKey),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableTenantOrganizationMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext> => {

const mutationKey = ['disableTenantOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableTenantOrganization>>, {tenant: string;organizationKey: string}> = (props) => {
          const {tenant,organizationKey} = props ?? {};

          return  disableTenantOrganization(tenant,organizationKey,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableTenantOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof disableTenantOrganization>>>

    export type DisableTenantOrganizationMutationError = Problem

    /**
 * @summary Inativa uma organização por ID
 */
export const useDisableTenantOrganization = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTenantOrganization>>, TError,{tenant: string;organizationKey: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableTenantOrganization>>,
        TError,
        {tenant: string;organizationKey: string},
        TContext
      > => {
      return useMutation(getDisableTenantOrganizationMutationOptions(options), queryClient);
    }

export type findGroupResponse404 = {
  data: Problem
  status: 404
}

;
export type findGroupResponseError = (findGroupResponse404) & {
  headers: Headers;
};

export type findGroupResponse = (findGroupResponseError)

export const getFindGroupUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}`
}

/**
 * @summary Busca um grupo por ID
 */
export const findGroup = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<findGroupResponse> => {

  return customInstanceBpm<findGroupResponse>(getFindGroupUrl(tenant,groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindGroupQueryKey = (tenant: string,
    groupId: string,) => {
    return [
    `/v1/${tenant}/groups/${groupId}`
    ] as const;
    }


export const getFindGroupQueryOptions = <TData = Awaited<ReturnType<typeof findGroup>>, TError = Problem>(tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindGroupQueryKey(tenant,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findGroup>>> = ({ signal }) => findGroup(tenant,groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindGroupQueryResult = NonNullable<Awaited<ReturnType<typeof findGroup>>>
export type FindGroupQueryError = Problem


export function useFindGroup<TData = Awaited<ReturnType<typeof findGroup>>, TError = Problem>(
 tenant: string,
    groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGroup>>,
          TError,
          Awaited<ReturnType<typeof findGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroup<TData = Awaited<ReturnType<typeof findGroup>>, TError = Problem>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGroup>>,
          TError,
          Awaited<ReturnType<typeof findGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroup<TData = Awaited<ReturnType<typeof findGroup>>, TError = Problem>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um grupo por ID
 */

export function useFindGroup<TData = Awaited<ReturnType<typeof findGroup>>, TError = Problem>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindGroupQueryOptions(tenant,groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editGroupResponse200 = {
  data: SmartGroupWitlAllPropertiesDto
  status: 200
}

export type editGroupResponse404 = {
  data: Problem
  status: 404
}

export type editGroupResponseSuccess = (editGroupResponse200) & {
  headers: Headers;
};
export type editGroupResponseError = (editGroupResponse404) & {
  headers: Headers;
};

export type editGroupResponse = (editGroupResponseSuccess | editGroupResponseError)

export const getEditGroupUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}`
}

/**
 * @summary Edita um grupo por ID
 */
export const editGroup = async (tenant: string,
    groupId: string,
    smartGroupInputEdit: SmartGroupInputEdit, options?: RequestInit): Promise<editGroupResponse> => {

  return customInstanceBpm<editGroupResponse>(getEditGroupUrl(tenant,groupId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartGroupInputEdit)
  }
);}




export const getEditGroupMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editGroup>>, TError,{tenant: string;groupId: string;data: SmartGroupInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editGroup>>, TError,{tenant: string;groupId: string;data: SmartGroupInputEdit}, TContext> => {

const mutationKey = ['editGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editGroup>>, {tenant: string;groupId: string;data: SmartGroupInputEdit}> = (props) => {
          const {tenant,groupId,data} = props ?? {};

          return  editGroup(tenant,groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditGroupMutationResult = NonNullable<Awaited<ReturnType<typeof editGroup>>>
    export type EditGroupMutationBody = SmartGroupInputEdit
    export type EditGroupMutationError = Problem

    /**
 * @summary Edita um grupo por ID
 */
export const useEditGroup = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editGroup>>, TError,{tenant: string;groupId: string;data: SmartGroupInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editGroup>>,
        TError,
        {tenant: string;groupId: string;data: SmartGroupInputEdit},
        TContext
      > => {
      return useMutation(getEditGroupMutationOptions(options), queryClient);
    }

export type deleteGroupResponse204 = {
  data: void
  status: 204
}

export type deleteGroupResponse404 = {
  data: Problem
  status: 404
}

export type deleteGroupResponseSuccess = (deleteGroupResponse204) & {
  headers: Headers;
};
export type deleteGroupResponseError = (deleteGroupResponse404) & {
  headers: Headers;
};

export type deleteGroupResponse = (deleteGroupResponseSuccess | deleteGroupResponseError)

export const getDeleteGroupUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}`
}

/**
 * @summary Exclui um grupo por ID
 */
export const deleteGroup = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<deleteGroupResponse> => {

  return customInstanceBpm<deleteGroupResponse>(getDeleteGroupUrl(tenant,groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteGroupMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{tenant: string;groupId: string}, TContext> => {

const mutationKey = ['deleteGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroup>>, {tenant: string;groupId: string}> = (props) => {
          const {tenant,groupId} = props ?? {};

          return  deleteGroup(tenant,groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>

    export type DeleteGroupMutationError = Problem

    /**
 * @summary Exclui um grupo por ID
 */
export const useDeleteGroup = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroup>>,
        TError,
        {tenant: string;groupId: string},
        TContext
      > => {
      return useMutation(getDeleteGroupMutationOptions(options), queryClient);
    }

export type addGroupMemberResponse204 = {
  data: void
  status: 204
}

export type addGroupMemberResponse404 = {
  data: Problem
  status: 404
}

export type addGroupMemberResponseSuccess = (addGroupMemberResponse204) & {
  headers: Headers;
};
export type addGroupMemberResponseError = (addGroupMemberResponse404) & {
  headers: Headers;
};

export type addGroupMemberResponse = (addGroupMemberResponseSuccess | addGroupMemberResponseError)

export const getAddGroupMemberUrl = (tenant: string,
    groupId: string,
    userId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/members/${userId}`
}

/**
 * @summary Adiciona usuário no grupo
 */
export const addGroupMember = async (tenant: string,
    groupId: string,
    userId: string, options?: RequestInit): Promise<addGroupMemberResponse> => {

  return customInstanceBpm<addGroupMemberResponse>(getAddGroupMemberUrl(tenant,groupId,userId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getAddGroupMemberMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof addGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext> => {

const mutationKey = ['addGroupMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addGroupMember>>, {tenant: string;groupId: string;userId: string}> = (props) => {
          const {tenant,groupId,userId} = props ?? {};

          return  addGroupMember(tenant,groupId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddGroupMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addGroupMember>>>

    export type AddGroupMemberMutationError = Problem

    /**
 * @summary Adiciona usuário no grupo
 */
export const useAddGroupMember = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addGroupMember>>,
        TError,
        {tenant: string;groupId: string;userId: string},
        TContext
      > => {
      return useMutation(getAddGroupMemberMutationOptions(options), queryClient);
    }

export type removeGroupMemberResponse204 = {
  data: void
  status: 204
}

export type removeGroupMemberResponse404 = {
  data: Problem
  status: 404
}

export type removeGroupMemberResponseSuccess = (removeGroupMemberResponse204) & {
  headers: Headers;
};
export type removeGroupMemberResponseError = (removeGroupMemberResponse404) & {
  headers: Headers;
};

export type removeGroupMemberResponse = (removeGroupMemberResponseSuccess | removeGroupMemberResponseError)

export const getRemoveGroupMemberUrl = (tenant: string,
    groupId: string,
    userId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/members/${userId}`
}

/**
 * @summary Remove usuário do grupo
 */
export const removeGroupMember = async (tenant: string,
    groupId: string,
    userId: string, options?: RequestInit): Promise<removeGroupMemberResponse> => {

  return customInstanceBpm<removeGroupMemberResponse>(getRemoveGroupMemberUrl(tenant,groupId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveGroupMemberMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof removeGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext> => {

const mutationKey = ['removeGroupMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeGroupMember>>, {tenant: string;groupId: string;userId: string}> = (props) => {
          const {tenant,groupId,userId} = props ?? {};

          return  removeGroupMember(tenant,groupId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveGroupMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeGroupMember>>>

    export type RemoveGroupMemberMutationError = Problem

    /**
 * @summary Remove usuário do grupo
 */
export const useRemoveGroupMember = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGroupMember>>, TError,{tenant: string;groupId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeGroupMember>>,
        TError,
        {tenant: string;groupId: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveGroupMemberMutationOptions(options), queryClient);
    }

export type enableGroupResponse204 = {
  data: void
  status: 204
}

export type enableGroupResponse404 = {
  data: Problem
  status: 404
}

export type enableGroupResponseSuccess = (enableGroupResponse204) & {
  headers: Headers;
};
export type enableGroupResponseError = (enableGroupResponse404) & {
  headers: Headers;
};

export type enableGroupResponse = (enableGroupResponseSuccess | enableGroupResponseError)

export const getEnableGroupUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/enable`
}

/**
 * @summary Ativa um grupo por ID
 */
export const enableGroup = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<enableGroupResponse> => {

  return customInstanceBpm<enableGroupResponse>(getEnableGroupUrl(tenant,groupId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableGroupMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableGroup>>, TError,{tenant: string;groupId: string}, TContext> => {

const mutationKey = ['enableGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableGroup>>, {tenant: string;groupId: string}> = (props) => {
          const {tenant,groupId} = props ?? {};

          return  enableGroup(tenant,groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableGroupMutationResult = NonNullable<Awaited<ReturnType<typeof enableGroup>>>

    export type EnableGroupMutationError = Problem

    /**
 * @summary Ativa um grupo por ID
 */
export const useEnableGroup = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableGroup>>,
        TError,
        {tenant: string;groupId: string},
        TContext
      > => {
      return useMutation(getEnableGroupMutationOptions(options), queryClient);
    }

export type disableGroupResponse204 = {
  data: void
  status: 204
}

export type disableGroupResponse404 = {
  data: Problem
  status: 404
}

export type disableGroupResponseSuccess = (disableGroupResponse204) & {
  headers: Headers;
};
export type disableGroupResponseError = (disableGroupResponse404) & {
  headers: Headers;
};

export type disableGroupResponse = (disableGroupResponseSuccess | disableGroupResponseError)

export const getDisableGroupUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/enable`
}

/**
 * @summary Inativa um grupo por ID
 */
export const disableGroup = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<disableGroupResponse> => {

  return customInstanceBpm<disableGroupResponse>(getDisableGroupUrl(tenant,groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableGroupMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableGroup>>, TError,{tenant: string;groupId: string}, TContext> => {

const mutationKey = ['disableGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableGroup>>, {tenant: string;groupId: string}> = (props) => {
          const {tenant,groupId} = props ?? {};

          return  disableGroup(tenant,groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableGroupMutationResult = NonNullable<Awaited<ReturnType<typeof disableGroup>>>

    export type DisableGroupMutationError = Problem

    /**
 * @summary Inativa um grupo por ID
 */
export const useDisableGroup = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableGroup>>, TError,{tenant: string;groupId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableGroup>>,
        TError,
        {tenant: string;groupId: string},
        TContext
      > => {
      return useMutation(getDisableGroupMutationOptions(options), queryClient);
    }

export type getEmailTemplateResponse200 = {
  data: EmailTemplateDto
  status: 200
}

export type getEmailTemplateResponseSuccess = (getEmailTemplateResponse200) & {
  headers: Headers;
};
;

export type getEmailTemplateResponse = (getEmailTemplateResponseSuccess)

export const getGetEmailTemplateUrl = (tenant: string,
    templateId: string,) => {




  return `/v1/${tenant}/email-templates/${templateId}`
}

/**
 * @summary Retorna template de email por ID
 */
export const getEmailTemplate = async (tenant: string,
    templateId: string, options?: RequestInit): Promise<getEmailTemplateResponse> => {

  return customInstanceBpm<getEmailTemplateResponse>(getGetEmailTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmailTemplateQueryKey = (tenant: string,
    templateId: string,) => {
    return [
    `/v1/${tenant}/email-templates/${templateId}`
    ] as const;
    }


export const getGetEmailTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailTemplateQueryKey(tenant,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailTemplate>>> = ({ signal }) => getEmailTemplate(tenant,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailTemplate>>>
export type GetEmailTemplateQueryError = unknown


export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna template de email por ID
 */

export function useGetEmailTemplate<TData = Awaited<ReturnType<typeof getEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailTemplateQueryOptions(tenant,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateEmailTemplateResponse200 = {
  data: EmailTemplateDto
  status: 200
}

export type updateEmailTemplateResponseSuccess = (updateEmailTemplateResponse200) & {
  headers: Headers;
};
;

export type updateEmailTemplateResponse = (updateEmailTemplateResponseSuccess)

export const getUpdateEmailTemplateUrl = (tenant: string,
    templateId: string,) => {




  return `/v1/${tenant}/email-templates/${templateId}`
}

/**
 * @summary Atualiza template de email
 */
export const updateEmailTemplate = async (tenant: string,
    templateId: string,
    emailTemplateEditRequest: EmailTemplateEditRequest, options?: RequestInit): Promise<updateEmailTemplateResponse> => {

  return customInstanceBpm<updateEmailTemplateResponse>(getUpdateEmailTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailTemplateEditRequest)
  }
);}




export const getUpdateEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{tenant: string;templateId: string;data: EmailTemplateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{tenant: string;templateId: string;data: EmailTemplateEditRequest}, TContext> => {

const mutationKey = ['updateEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailTemplate>>, {tenant: string;templateId: string;data: EmailTemplateEditRequest}> = (props) => {
          const {tenant,templateId,data} = props ?? {};

          return  updateEmailTemplate(tenant,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailTemplate>>>
    export type UpdateEmailTemplateMutationBody = EmailTemplateEditRequest
    export type UpdateEmailTemplateMutationError = unknown

    /**
 * @summary Atualiza template de email
 */
export const useUpdateEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{tenant: string;templateId: string;data: EmailTemplateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailTemplate>>,
        TError,
        {tenant: string;templateId: string;data: EmailTemplateEditRequest},
        TContext
      > => {
      return useMutation(getUpdateEmailTemplateMutationOptions(options), queryClient);
    }

export type deleteEmailTemplateResponse204 = {
  data: void
  status: 204
}

export type deleteEmailTemplateResponseSuccess = (deleteEmailTemplateResponse204) & {
  headers: Headers;
};
;

export type deleteEmailTemplateResponse = (deleteEmailTemplateResponseSuccess)

export const getDeleteEmailTemplateUrl = (tenant: string,
    templateId: string,) => {




  return `/v1/${tenant}/email-templates/${templateId}`
}

/**
 * @summary Exclui template de email por ID
 */
export const deleteEmailTemplate = async (tenant: string,
    templateId: string, options?: RequestInit): Promise<deleteEmailTemplateResponse> => {

  return customInstanceBpm<deleteEmailTemplateResponse>(getDeleteEmailTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{tenant: string;templateId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{tenant: string;templateId: string}, TContext> => {

const mutationKey = ['deleteEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailTemplate>>, {tenant: string;templateId: string}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  deleteEmailTemplate(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailTemplate>>>

    export type DeleteEmailTemplateMutationError = unknown

    /**
 * @summary Exclui template de email por ID
 */
export const useDeleteEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{tenant: string;templateId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailTemplate>>,
        TError,
        {tenant: string;templateId: string},
        TContext
      > => {
      return useMutation(getDeleteEmailTemplateMutationOptions(options), queryClient);
    }

export type updateEmailTemplateFormDataResponse200 = {
  data: EmailTemplateDto
  status: 200
}

export type updateEmailTemplateFormDataResponseSuccess = (updateEmailTemplateFormDataResponse200) & {
  headers: Headers;
};
;

export type updateEmailTemplateFormDataResponse = (updateEmailTemplateFormDataResponseSuccess)

export const getUpdateEmailTemplateFormDataUrl = (tenant: string,
    templateId: string,) => {




  return `/v1/${tenant}/email-templates/form/${templateId}`
}

/**
 * @summary Atualiza template de email (com form-data)
 */
export const updateEmailTemplateFormData = async (tenant: string,
    templateId: string,
    updateEmailTemplateFormDataBody?: UpdateEmailTemplateFormDataBody, options?: RequestInit): Promise<updateEmailTemplateFormDataResponse> => {
    const formData = new FormData();
if(updateEmailTemplateFormDataBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(updateEmailTemplateFormDataBody.input));
 }
if(updateEmailTemplateFormDataBody?.htmlFile !== undefined) {
 formData.append(`htmlFile`, updateEmailTemplateFormDataBody.htmlFile);
 }

  return customInstanceBpm<updateEmailTemplateFormDataResponse>(getUpdateEmailTemplateFormDataUrl(tenant,templateId),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getUpdateEmailTemplateFormDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplateFormData>>, TError,{tenant: string;templateId: string;data?: UpdateEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplateFormData>>, TError,{tenant: string;templateId: string;data?: UpdateEmailTemplateFormDataBody}, TContext> => {

const mutationKey = ['updateEmailTemplateFormData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailTemplateFormData>>, {tenant: string;templateId: string;data?: UpdateEmailTemplateFormDataBody}> = (props) => {
          const {tenant,templateId,data} = props ?? {};

          return  updateEmailTemplateFormData(tenant,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailTemplateFormDataMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailTemplateFormData>>>
    export type UpdateEmailTemplateFormDataMutationBody = UpdateEmailTemplateFormDataBody | undefined
    export type UpdateEmailTemplateFormDataMutationError = unknown

    /**
 * @summary Atualiza template de email (com form-data)
 */
export const useUpdateEmailTemplateFormData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplateFormData>>, TError,{tenant: string;templateId: string;data?: UpdateEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailTemplateFormData>>,
        TError,
        {tenant: string;templateId: string;data?: UpdateEmailTemplateFormDataBody},
        TContext
      > => {
      return useMutation(getUpdateEmailTemplateFormDataMutationOptions(options), queryClient);
    }

export type updateResponse200 = {
  data: EmailProcessConfigurationDto
  status: 200
}

export type updateResponseSuccess = (updateResponse200) & {
  headers: Headers;
};
;

export type updateResponse = (updateResponseSuccess)

export const getUpdateUrl = (tenant: string,
    routeId: string,) => {




  return `/v1/${tenant}/email-process/configurations/${routeId}`
}

/**
 * @summary Edita uma configuracao de gatilho de email
 */
export const update = async (tenant: string,
    routeId: string,
    emailProcessConfigurationRequest: EmailProcessConfigurationRequest, options?: RequestInit): Promise<updateResponse> => {

  return customInstanceBpm<updateResponse>(getUpdateUrl(tenant,routeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessConfigurationRequest)
  }
);}




export const getUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext> => {

const mutationKey = ['update'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update>>, {tenant: string;routeId: string;data: EmailProcessConfigurationRequest}> = (props) => {
          const {tenant,routeId,data} = props ?? {};

          return  update(tenant,routeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof update>>>
    export type UpdateMutationBody = EmailProcessConfigurationRequest
    export type UpdateMutationError = unknown

    /**
 * @summary Edita uma configuracao de gatilho de email
 */
export const useUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update>>,
        TError,
        {tenant: string;routeId: string;data: EmailProcessConfigurationRequest},
        TContext
      > => {
      return useMutation(getUpdateMutationOptions(options), queryClient);
    }

export type _deleteResponse204 = {
  data: void
  status: 204
}

export type _deleteResponseSuccess = (_deleteResponse204) & {
  headers: Headers;
};
;

export type _deleteResponse = (_deleteResponseSuccess)

export const getDeleteUrl = (tenant: string,
    routeId: string,) => {




  return `/v1/${tenant}/email-process/configurations/${routeId}`
}

/**
 * @summary Remove uma configuracao de gatilho de email
 */
export const _delete = async (tenant: string,
    routeId: string, options?: RequestInit): Promise<_deleteResponse> => {

  return customInstanceBpm<_deleteResponse>(getDeleteUrl(tenant,routeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{tenant: string;routeId: string}, TContext> => {

const mutationKey = ['_delete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _delete>>, {tenant: string;routeId: string}> = (props) => {
          const {tenant,routeId} = props ?? {};

          return  _delete(tenant,routeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type _DeleteMutationResult = NonNullable<Awaited<ReturnType<typeof _delete>>>

    export type _DeleteMutationError = unknown

    /**
 * @summary Remove uma configuracao de gatilho de email
 */
export const useDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof _delete>>,
        TError,
        {tenant: string;routeId: string},
        TContext
      > => {
      return useMutation(getDeleteMutationOptions(options), queryClient);
    }

export type findDataListResponse404 = {
  data: Problem
  status: 404
}

;
export type findDataListResponseError = (findDataListResponse404) & {
  headers: Headers;
};

export type findDataListResponse = (findDataListResponseError)

export const getFindDataListUrl = (tenant: string,
    dataListId: string,
    params?: FindDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}`
}

/**
 * @summary Busca uma lista de dados por ID
 */
export const findDataList = async (tenant: string,
    dataListId: string,
    params?: FindDataListParams, options?: RequestInit): Promise<findDataListResponse> => {

  return customInstanceBpm<findDataListResponse>(getFindDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindDataListQueryKey = (tenant: string,
    dataListId: string,
    params?: FindDataListParams,) => {
    return [
    `/v1/${tenant}/data-list/${dataListId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindDataListQueryOptions = <TData = Awaited<ReturnType<typeof findDataList>>, TError = Problem>(tenant: string,
    dataListId: string,
    params?: FindDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDataListQueryKey(tenant,dataListId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDataList>>> = ({ signal }) => findDataList(tenant,dataListId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && dataListId !== null && dataListId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDataListQueryResult = NonNullable<Awaited<ReturnType<typeof findDataList>>>
export type FindDataListQueryError = Problem


export function useFindDataList<TData = Awaited<ReturnType<typeof findDataList>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    params: undefined |  FindDataListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDataList>>,
          TError,
          Awaited<ReturnType<typeof findDataList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDataList<TData = Awaited<ReturnType<typeof findDataList>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    params?: FindDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDataList>>,
          TError,
          Awaited<ReturnType<typeof findDataList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDataList<TData = Awaited<ReturnType<typeof findDataList>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    params?: FindDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma lista de dados por ID
 */

export function useFindDataList<TData = Awaited<ReturnType<typeof findDataList>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    params?: FindDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDataListQueryOptions(tenant,dataListId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editDataListResponse200 = {
  data: DataListDto
  status: 200
}

export type editDataListResponse404 = {
  data: Problem
  status: 404
}

export type editDataListResponseSuccess = (editDataListResponse200) & {
  headers: Headers;
};
export type editDataListResponseError = (editDataListResponse404) & {
  headers: Headers;
};

export type editDataListResponse = (editDataListResponseSuccess | editDataListResponseError)

export const getEditDataListUrl = (tenant: string,
    dataListId: string,
    params?: EditDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}`
}

/**
 * @summary Atualiza uma lista de dados por ID
 */
export const editDataList = async (tenant: string,
    dataListId: string,
    dataListEditInput: DataListEditInput,
    params?: EditDataListParams, options?: RequestInit): Promise<editDataListResponse> => {

  return customInstanceBpm<editDataListResponse>(getEditDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dataListEditInput)
  }
);}




export const getEditDataListMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDataList>>, TError,{tenant: string;dataListId: string;data: DataListEditInput;params?: EditDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editDataList>>, TError,{tenant: string;dataListId: string;data: DataListEditInput;params?: EditDataListParams}, TContext> => {

const mutationKey = ['editDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editDataList>>, {tenant: string;dataListId: string;data: DataListEditInput;params?: EditDataListParams}> = (props) => {
          const {tenant,dataListId,data,params} = props ?? {};

          return  editDataList(tenant,dataListId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditDataListMutationResult = NonNullable<Awaited<ReturnType<typeof editDataList>>>
    export type EditDataListMutationBody = DataListEditInput
    export type EditDataListMutationError = Problem

    /**
 * @summary Atualiza uma lista de dados por ID
 */
export const useEditDataList = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDataList>>, TError,{tenant: string;dataListId: string;data: DataListEditInput;params?: EditDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editDataList>>,
        TError,
        {tenant: string;dataListId: string;data: DataListEditInput;params?: EditDataListParams},
        TContext
      > => {
      return useMutation(getEditDataListMutationOptions(options), queryClient);
    }

export type deleteDataListResponse204 = {
  data: void
  status: 204
}

export type deleteDataListResponse404 = {
  data: Problem
  status: 404
}

export type deleteDataListResponseSuccess = (deleteDataListResponse204) & {
  headers: Headers;
};
export type deleteDataListResponseError = (deleteDataListResponse404) & {
  headers: Headers;
};

export type deleteDataListResponse = (deleteDataListResponseSuccess | deleteDataListResponseError)

export const getDeleteDataListUrl = (tenant: string,
    dataListId: string,
    params?: DeleteDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}`
}

/**
 * @summary Exclui uma lista de dados por ID
 */
export const deleteDataList = async (tenant: string,
    dataListId: string,
    params?: DeleteDataListParams, options?: RequestInit): Promise<deleteDataListResponse> => {

  return customInstanceBpm<deleteDataListResponse>(getDeleteDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDataListMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataList>>, TError,{tenant: string;dataListId: string;params?: DeleteDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDataList>>, TError,{tenant: string;dataListId: string;params?: DeleteDataListParams}, TContext> => {

const mutationKey = ['deleteDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDataList>>, {tenant: string;dataListId: string;params?: DeleteDataListParams}> = (props) => {
          const {tenant,dataListId,params} = props ?? {};

          return  deleteDataList(tenant,dataListId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDataListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDataList>>>

    export type DeleteDataListMutationError = Problem

    /**
 * @summary Exclui uma lista de dados por ID
 */
export const useDeleteDataList = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataList>>, TError,{tenant: string;dataListId: string;params?: DeleteDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDataList>>,
        TError,
        {tenant: string;dataListId: string;params?: DeleteDataListParams},
        TContext
      > => {
      return useMutation(getDeleteDataListMutationOptions(options), queryClient);
    }

export type findDataListRowResponse200 = {
  data: DataListRowDtoSwagger
  status: 200
}

export type findDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type findDataListRowResponseSuccess = (findDataListRowResponse200) & {
  headers: Headers;
};
export type findDataListRowResponseError = (findDataListRowResponse404) & {
  headers: Headers;
};

export type findDataListRowResponse = (findDataListRowResponseSuccess | findDataListRowResponseError)

export const getFindDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}`
}

/**
 * @summary Busca item da lista de dados por ID
 */
export const findDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string, options?: RequestInit): Promise<findDataListRowResponse> => {

  return customInstanceBpm<findDataListRowResponse>(getFindDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindDataListRowQueryKey = (tenant: string,
    dataListId: string,
    itemId: string,) => {
    return [
    `/v1/${tenant}/data-list/${dataListId}/items/${itemId}`
    ] as const;
    }


export const getFindDataListRowQueryOptions = <TData = Awaited<ReturnType<typeof findDataListRow>>, TError = Problem>(tenant: string,
    dataListId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDataListRowQueryKey(tenant,dataListId,itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDataListRow>>> = ({ signal }) => findDataListRow(tenant,dataListId,itemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && dataListId !== null && dataListId !== undefined && itemId !== null && itemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDataListRowQueryResult = NonNullable<Awaited<ReturnType<typeof findDataListRow>>>
export type FindDataListRowQueryError = Problem


export function useFindDataListRow<TData = Awaited<ReturnType<typeof findDataListRow>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDataListRow>>,
          TError,
          Awaited<ReturnType<typeof findDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDataListRow<TData = Awaited<ReturnType<typeof findDataListRow>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDataListRow>>,
          TError,
          Awaited<ReturnType<typeof findDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDataListRow<TData = Awaited<ReturnType<typeof findDataListRow>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca item da lista de dados por ID
 */

export function useFindDataListRow<TData = Awaited<ReturnType<typeof findDataListRow>>, TError = Problem>(
 tenant: string,
    dataListId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDataListRowQueryOptions(tenant,dataListId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editDataListRowResponse200 = {
  data: DataListRowDtoSwagger
  status: 200
}

export type editDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type editDataListRowResponseSuccess = (editDataListRowResponse200) & {
  headers: Headers;
};
export type editDataListRowResponseError = (editDataListRowResponse404) & {
  headers: Headers;
};

export type editDataListRowResponse = (editDataListRowResponseSuccess | editDataListRowResponseError)

export const getEditDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}`
}

/**
 * @summary Atualiza um item da lista de dados por ID
 */
export const editDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string,
    jsonNode: JsonNode, options?: RequestInit): Promise<editDataListRowResponse> => {

  return customInstanceBpm<editDataListRowResponse>(getEditDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jsonNode)
  }
);}




export const getEditDataListRowMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string;data: JsonNode}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string;data: JsonNode}, TContext> => {

const mutationKey = ['editDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editDataListRow>>, {tenant: string;dataListId: string;itemId: string;data: JsonNode}> = (props) => {
          const {tenant,dataListId,itemId,data} = props ?? {};

          return  editDataListRow(tenant,dataListId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof editDataListRow>>>
    export type EditDataListRowMutationBody = JsonNode
    export type EditDataListRowMutationError = Problem

    /**
 * @summary Atualiza um item da lista de dados por ID
 */
export const useEditDataListRow = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string;data: JsonNode}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editDataListRow>>,
        TError,
        {tenant: string;dataListId: string;itemId: string;data: JsonNode},
        TContext
      > => {
      return useMutation(getEditDataListRowMutationOptions(options), queryClient);
    }

export type deleteDataListRowResponse204 = {
  data: void
  status: 204
}

export type deleteDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type deleteDataListRowResponseSuccess = (deleteDataListRowResponse204) & {
  headers: Headers;
};
export type deleteDataListRowResponseError = (deleteDataListRowResponse404) & {
  headers: Headers;
};

export type deleteDataListRowResponse = (deleteDataListRowResponseSuccess | deleteDataListRowResponseError)

export const getDeleteDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}`
}

/**
 * @summary Exclui um item da lista de dados por ID
 */
export const deleteDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string, options?: RequestInit): Promise<deleteDataListRowResponse> => {

  return customInstanceBpm<deleteDataListRowResponse>(getDeleteDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDataListRowMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext> => {

const mutationKey = ['deleteDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDataListRow>>, {tenant: string;dataListId: string;itemId: string}> = (props) => {
          const {tenant,dataListId,itemId} = props ?? {};

          return  deleteDataListRow(tenant,dataListId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDataListRow>>>

    export type DeleteDataListRowMutationError = Problem

    /**
 * @summary Exclui um item da lista de dados por ID
 */
export const useDeleteDataListRow = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDataListRow>>,
        TError,
        {tenant: string;dataListId: string;itemId: string},
        TContext
      > => {
      return useMutation(getDeleteDataListRowMutationOptions(options), queryClient);
    }

export type activateDataListRowResponse204 = {
  data: void
  status: 204
}

export type activateDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type activateDataListRowResponseSuccess = (activateDataListRowResponse204) & {
  headers: Headers;
};
export type activateDataListRowResponseError = (activateDataListRowResponse404) & {
  headers: Headers;
};

export type activateDataListRowResponse = (activateDataListRowResponseSuccess | activateDataListRowResponseError)

export const getActivateDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}/activate`
}

/**
 * @summary Ativa um item da lista de dados por ID
 */
export const activateDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string, options?: RequestInit): Promise<activateDataListRowResponse> => {

  return customInstanceBpm<activateDataListRowResponse>(getActivateDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getActivateDataListRowMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof activateDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext> => {

const mutationKey = ['activateDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateDataListRow>>, {tenant: string;dataListId: string;itemId: string}> = (props) => {
          const {tenant,dataListId,itemId} = props ?? {};

          return  activateDataListRow(tenant,dataListId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof activateDataListRow>>>

    export type ActivateDataListRowMutationError = Problem

    /**
 * @summary Ativa um item da lista de dados por ID
 */
export const useActivateDataListRow = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateDataListRow>>,
        TError,
        {tenant: string;dataListId: string;itemId: string},
        TContext
      > => {
      return useMutation(getActivateDataListRowMutationOptions(options), queryClient);
    }

export type activateDataListResponse204 = {
  data: void
  status: 204
}

export type activateDataListResponse404 = {
  data: Problem
  status: 404
}

export type activateDataListResponseSuccess = (activateDataListResponse204) & {
  headers: Headers;
};
export type activateDataListResponseError = (activateDataListResponse404) & {
  headers: Headers;
};

export type activateDataListResponse = (activateDataListResponseSuccess | activateDataListResponseError)

export const getActivateDataListUrl = (tenant: string,
    dataListId: string,
    params?: ActivateDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}/activate?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}/activate`
}

/**
 * @summary Ativa uma lista de dados por ID
 */
export const activateDataList = async (tenant: string,
    dataListId: string,
    params?: ActivateDataListParams, options?: RequestInit): Promise<activateDataListResponse> => {

  return customInstanceBpm<activateDataListResponse>(getActivateDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getActivateDataListMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateDataList>>, TError,{tenant: string;dataListId: string;params?: ActivateDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof activateDataList>>, TError,{tenant: string;dataListId: string;params?: ActivateDataListParams}, TContext> => {

const mutationKey = ['activateDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateDataList>>, {tenant: string;dataListId: string;params?: ActivateDataListParams}> = (props) => {
          const {tenant,dataListId,params} = props ?? {};

          return  activateDataList(tenant,dataListId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateDataListMutationResult = NonNullable<Awaited<ReturnType<typeof activateDataList>>>

    export type ActivateDataListMutationError = Problem

    /**
 * @summary Ativa uma lista de dados por ID
 */
export const useActivateDataList = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateDataList>>, TError,{tenant: string;dataListId: string;params?: ActivateDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateDataList>>,
        TError,
        {tenant: string;dataListId: string;params?: ActivateDataListParams},
        TContext
      > => {
      return useMutation(getActivateDataListMutationOptions(options), queryClient);
    }

export type findCategoryResponse200 = {
  data: CategoryDto
  status: 200
}

export type findCategoryResponseSuccess = (findCategoryResponse200) & {
  headers: Headers;
};
;

export type findCategoryResponse = (findCategoryResponseSuccess)

export const getFindCategoryUrl = (tenant: string,
    categoryId: string,) => {




  return `/v1/${tenant}/categories/${categoryId}`
}

/**
 * @summary Busca uma categoria por id
 */
export const findCategory = async (tenant: string,
    categoryId: string, options?: RequestInit): Promise<findCategoryResponse> => {

  return customInstanceBpm<findCategoryResponse>(getFindCategoryUrl(tenant,categoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindCategoryQueryKey = (tenant: string,
    categoryId: string,) => {
    return [
    `/v1/${tenant}/categories/${categoryId}`
    ] as const;
    }


export const getFindCategoryQueryOptions = <TData = Awaited<ReturnType<typeof findCategory>>, TError = unknown>(tenant: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCategoryQueryKey(tenant,categoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCategory>>> = ({ signal }) => findCategory(tenant,categoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && categoryId !== null && categoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof findCategory>>>
export type FindCategoryQueryError = unknown


export function useFindCategory<TData = Awaited<ReturnType<typeof findCategory>>, TError = unknown>(
 tenant: string,
    categoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCategory>>,
          TError,
          Awaited<ReturnType<typeof findCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCategory<TData = Awaited<ReturnType<typeof findCategory>>, TError = unknown>(
 tenant: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCategory>>,
          TError,
          Awaited<ReturnType<typeof findCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCategory<TData = Awaited<ReturnType<typeof findCategory>>, TError = unknown>(
 tenant: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma categoria por id
 */

export function useFindCategory<TData = Awaited<ReturnType<typeof findCategory>>, TError = unknown>(
 tenant: string,
    categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCategoryQueryOptions(tenant,categoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editCategoryResponse200 = {
  data: CategoryDto
  status: 200
}

export type editCategoryResponseSuccess = (editCategoryResponse200) & {
  headers: Headers;
};
;

export type editCategoryResponse = (editCategoryResponseSuccess)

export const getEditCategoryUrl = (tenant: string,
    categoryId: string,) => {




  return `/v1/${tenant}/categories/${categoryId}`
}

/**
 * @summary Edita uma categoria
 */
export const editCategory = async (tenant: string,
    categoryId: string,
    categoryInput: CategoryInput, options?: RequestInit): Promise<editCategoryResponse> => {

  return customInstanceBpm<editCategoryResponse>(getEditCategoryUrl(tenant,categoryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryInput)
  }
);}




export const getEditCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editCategory>>, TError,{tenant: string;categoryId: string;data: CategoryInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editCategory>>, TError,{tenant: string;categoryId: string;data: CategoryInput}, TContext> => {

const mutationKey = ['editCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editCategory>>, {tenant: string;categoryId: string;data: CategoryInput}> = (props) => {
          const {tenant,categoryId,data} = props ?? {};

          return  editCategory(tenant,categoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof editCategory>>>
    export type EditCategoryMutationBody = CategoryInput
    export type EditCategoryMutationError = unknown

    /**
 * @summary Edita uma categoria
 */
export const useEditCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editCategory>>, TError,{tenant: string;categoryId: string;data: CategoryInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editCategory>>,
        TError,
        {tenant: string;categoryId: string;data: CategoryInput},
        TContext
      > => {
      return useMutation(getEditCategoryMutationOptions(options), queryClient);
    }

export type deleteCategoryResponse204 = {
  data: void
  status: 204
}

export type deleteCategoryResponseSuccess = (deleteCategoryResponse204) & {
  headers: Headers;
};
;

export type deleteCategoryResponse = (deleteCategoryResponseSuccess)

export const getDeleteCategoryUrl = (tenant: string,
    categoryId: string,) => {




  return `/v1/${tenant}/categories/${categoryId}`
}

/**
 * @summary Exclui uma categoria
 */
export const deleteCategory = async (tenant: string,
    categoryId: string, options?: RequestInit): Promise<deleteCategoryResponse> => {

  return customInstanceBpm<deleteCategoryResponse>(getDeleteCategoryUrl(tenant,categoryId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{tenant: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{tenant: string;categoryId: string}, TContext> => {

const mutationKey = ['deleteCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, {tenant: string;categoryId: string}> = (props) => {
          const {tenant,categoryId} = props ?? {};

          return  deleteCategory(tenant,categoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>

    export type DeleteCategoryMutationError = unknown

    /**
 * @summary Exclui uma categoria
 */
export const useDeleteCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{tenant: string;categoryId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        {tenant: string;categoryId: string},
        TContext
      > => {
      return useMutation(getDeleteCategoryMutationOptions(options), queryClient);
    }

export type findApiManagerByIdResponse200 = {
  data: ApiManagerDto
  status: 200
}

export type findApiManagerByIdResponseSuccess = (findApiManagerByIdResponse200) & {
  headers: Headers;
};
;

export type findApiManagerByIdResponse = (findApiManagerByIdResponseSuccess)

export const getFindApiManagerByIdUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/api_manager/${id}`
}

/**
 * @summary Retorna uma lista de apis previamente cadastrada na plataforma
 */
export const findApiManagerById = async (tenant: string,
    id: number, options?: RequestInit): Promise<findApiManagerByIdResponse> => {

  return customInstanceBpm<findApiManagerByIdResponse>(getFindApiManagerByIdUrl(tenant,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindApiManagerByIdQueryKey = (tenant: string,
    id: number,) => {
    return [
    `/v1/${tenant}/api_manager/${id}`
    ] as const;
    }


export const getFindApiManagerByIdQueryOptions = <TData = Awaited<ReturnType<typeof findApiManagerById>>, TError = unknown>(tenant: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindApiManagerByIdQueryKey(tenant,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findApiManagerById>>> = ({ signal }) => findApiManagerById(tenant,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindApiManagerByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findApiManagerById>>>
export type FindApiManagerByIdQueryError = unknown


export function useFindApiManagerById<TData = Awaited<ReturnType<typeof findApiManagerById>>, TError = unknown>(
 tenant: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findApiManagerById>>,
          TError,
          Awaited<ReturnType<typeof findApiManagerById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindApiManagerById<TData = Awaited<ReturnType<typeof findApiManagerById>>, TError = unknown>(
 tenant: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findApiManagerById>>,
          TError,
          Awaited<ReturnType<typeof findApiManagerById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindApiManagerById<TData = Awaited<ReturnType<typeof findApiManagerById>>, TError = unknown>(
 tenant: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna uma lista de apis previamente cadastrada na plataforma
 */

export function useFindApiManagerById<TData = Awaited<ReturnType<typeof findApiManagerById>>, TError = unknown>(
 tenant: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findApiManagerById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindApiManagerByIdQueryOptions(tenant,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateApiManagerResponse200 = {
  data: ApiManagerDto
  status: 200
}

export type updateApiManagerResponseSuccess = (updateApiManagerResponse200) & {
  headers: Headers;
};
;

export type updateApiManagerResponse = (updateApiManagerResponseSuccess)

export const getUpdateApiManagerUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/api_manager/${id}`
}

/**
 * @summary Alterar uma api já existente
 */
export const updateApiManager = async (tenant: string,
    id: number,
    apiManagerInput: ApiManagerInput, options?: RequestInit): Promise<updateApiManagerResponse> => {

  return customInstanceBpm<updateApiManagerResponse>(getUpdateApiManagerUrl(tenant,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(apiManagerInput)
  }
);}




export const getUpdateApiManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiManager>>, TError,{tenant: string;id: number;data: ApiManagerInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApiManager>>, TError,{tenant: string;id: number;data: ApiManagerInput}, TContext> => {

const mutationKey = ['updateApiManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApiManager>>, {tenant: string;id: number;data: ApiManagerInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  updateApiManager(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateApiManagerMutationResult = NonNullable<Awaited<ReturnType<typeof updateApiManager>>>
    export type UpdateApiManagerMutationBody = ApiManagerInput
    export type UpdateApiManagerMutationError = unknown

    /**
 * @summary Alterar uma api já existente
 */
export const useUpdateApiManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiManager>>, TError,{tenant: string;id: number;data: ApiManagerInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateApiManager>>,
        TError,
        {tenant: string;id: number;data: ApiManagerInput},
        TContext
      > => {
      return useMutation(getUpdateApiManagerMutationOptions(options), queryClient);
    }

export type deleteApiManagerResponse204 = {
  data: void
  status: 204
}

export type deleteApiManagerResponseSuccess = (deleteApiManagerResponse204) & {
  headers: Headers;
};
;

export type deleteApiManagerResponse = (deleteApiManagerResponseSuccess)

export const getDeleteApiManagerUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/api_manager/${id}`
}

/**
 * @summary Exclui uma api previamente cadastrada na plataforma
 */
export const deleteApiManager = async (tenant: string,
    id: number, options?: RequestInit): Promise<deleteApiManagerResponse> => {

  return customInstanceBpm<deleteApiManagerResponse>(getDeleteApiManagerUrl(tenant,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiManager>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiManager>>, TError,{tenant: string;id: number}, TContext> => {

const mutationKey = ['deleteApiManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiManager>>, {tenant: string;id: number}> = (props) => {
          const {tenant,id} = props ?? {};

          return  deleteApiManager(tenant,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiManagerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiManager>>>

    export type DeleteApiManagerMutationError = unknown

    /**
 * @summary Exclui uma api previamente cadastrada na plataforma
 */
export const useDeleteApiManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiManager>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiManager>>,
        TError,
        {tenant: string;id: number},
        TContext
      > => {
      return useMutation(getDeleteApiManagerMutationOptions(options), queryClient);
    }

export type findAccessProfileResponse404 = {
  data: Problem
  status: 404
}

;
export type findAccessProfileResponseError = (findAccessProfileResponse404) & {
  headers: Headers;
};

export type findAccessProfileResponse = (findAccessProfileResponseError)

export const getFindAccessProfileUrl = (tenant: string,
    accessProfileId: number,) => {




  return `/v1/${tenant}/access-profiles/${accessProfileId}`
}

/**
 * @summary Busca um perfil de acesso por ID
 */
export const findAccessProfile = async (tenant: string,
    accessProfileId: number, options?: RequestInit): Promise<findAccessProfileResponse> => {

  return customInstanceBpm<findAccessProfileResponse>(getFindAccessProfileUrl(tenant,accessProfileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindAccessProfileQueryKey = (tenant: string,
    accessProfileId: number,) => {
    return [
    `/v1/${tenant}/access-profiles/${accessProfileId}`
    ] as const;
    }


export const getFindAccessProfileQueryOptions = <TData = Awaited<ReturnType<typeof findAccessProfile>>, TError = Problem>(tenant: string,
    accessProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAccessProfileQueryKey(tenant,accessProfileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAccessProfile>>> = ({ signal }) => findAccessProfile(tenant,accessProfileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && accessProfileId !== null && accessProfileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAccessProfileQueryResult = NonNullable<Awaited<ReturnType<typeof findAccessProfile>>>
export type FindAccessProfileQueryError = Problem


export function useFindAccessProfile<TData = Awaited<ReturnType<typeof findAccessProfile>>, TError = Problem>(
 tenant: string,
    accessProfileId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAccessProfile>>,
          TError,
          Awaited<ReturnType<typeof findAccessProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAccessProfile<TData = Awaited<ReturnType<typeof findAccessProfile>>, TError = Problem>(
 tenant: string,
    accessProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAccessProfile>>,
          TError,
          Awaited<ReturnType<typeof findAccessProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAccessProfile<TData = Awaited<ReturnType<typeof findAccessProfile>>, TError = Problem>(
 tenant: string,
    accessProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um perfil de acesso por ID
 */

export function useFindAccessProfile<TData = Awaited<ReturnType<typeof findAccessProfile>>, TError = Problem>(
 tenant: string,
    accessProfileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAccessProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAccessProfileQueryOptions(tenant,accessProfileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editAccessProfileResponse200 = {
  data: AccessProfileWithAllPropertiesDto
  status: 200
}

export type editAccessProfileResponse404 = {
  data: Problem
  status: 404
}

export type editAccessProfileResponseSuccess = (editAccessProfileResponse200) & {
  headers: Headers;
};
export type editAccessProfileResponseError = (editAccessProfileResponse404) & {
  headers: Headers;
};

export type editAccessProfileResponse = (editAccessProfileResponseSuccess | editAccessProfileResponseError)

export const getEditAccessProfileUrl = (tenant: string,
    accessProfileId: number,) => {




  return `/v1/${tenant}/access-profiles/${accessProfileId}`
}

/**
 * @summary Atualiza um perfil de acesso por ID
 */
export const editAccessProfile = async (tenant: string,
    accessProfileId: number,
    accessProfileInputEdit: AccessProfileInputEdit, options?: RequestInit): Promise<editAccessProfileResponse> => {

  return customInstanceBpm<editAccessProfileResponse>(getEditAccessProfileUrl(tenant,accessProfileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accessProfileInputEdit)
  }
);}




export const getEditAccessProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAccessProfile>>, TError,{tenant: string;accessProfileId: number;data: AccessProfileInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editAccessProfile>>, TError,{tenant: string;accessProfileId: number;data: AccessProfileInputEdit}, TContext> => {

const mutationKey = ['editAccessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editAccessProfile>>, {tenant: string;accessProfileId: number;data: AccessProfileInputEdit}> = (props) => {
          const {tenant,accessProfileId,data} = props ?? {};

          return  editAccessProfile(tenant,accessProfileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditAccessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof editAccessProfile>>>
    export type EditAccessProfileMutationBody = AccessProfileInputEdit
    export type EditAccessProfileMutationError = Problem

    /**
 * @summary Atualiza um perfil de acesso por ID
 */
export const useEditAccessProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editAccessProfile>>, TError,{tenant: string;accessProfileId: number;data: AccessProfileInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editAccessProfile>>,
        TError,
        {tenant: string;accessProfileId: number;data: AccessProfileInputEdit},
        TContext
      > => {
      return useMutation(getEditAccessProfileMutationOptions(options), queryClient);
    }

export type deleteAccessProfileResponse204 = {
  data: void
  status: 204
}

export type deleteAccessProfileResponse404 = {
  data: Problem
  status: 404
}

export type deleteAccessProfileResponseSuccess = (deleteAccessProfileResponse204) & {
  headers: Headers;
};
export type deleteAccessProfileResponseError = (deleteAccessProfileResponse404) & {
  headers: Headers;
};

export type deleteAccessProfileResponse = (deleteAccessProfileResponseSuccess | deleteAccessProfileResponseError)

export const getDeleteAccessProfileUrl = (tenant: string,
    accessProfileId: number,) => {




  return `/v1/${tenant}/access-profiles/${accessProfileId}`
}

/**
 * @summary Exclui um perfil de acesso por ID
 */
export const deleteAccessProfile = async (tenant: string,
    accessProfileId: number, options?: RequestInit): Promise<deleteAccessProfileResponse> => {

  return customInstanceBpm<deleteAccessProfileResponse>(getDeleteAccessProfileUrl(tenant,accessProfileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAccessProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext> => {

const mutationKey = ['deleteAccessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessProfile>>, {tenant: string;accessProfileId: number}> = (props) => {
          const {tenant,accessProfileId} = props ?? {};

          return  deleteAccessProfile(tenant,accessProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessProfile>>>

    export type DeleteAccessProfileMutationError = Problem

    /**
 * @summary Exclui um perfil de acesso por ID
 */
export const useDeleteAccessProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessProfile>>,
        TError,
        {tenant: string;accessProfileId: number},
        TContext
      > => {
      return useMutation(getDeleteAccessProfileMutationOptions(options), queryClient);
    }

export type enableAccessProfileResponse204 = {
  data: void
  status: 204
}

export type enableAccessProfileResponse404 = {
  data: Problem
  status: 404
}

export type enableAccessProfileResponseSuccess = (enableAccessProfileResponse204) & {
  headers: Headers;
};
export type enableAccessProfileResponseError = (enableAccessProfileResponse404) & {
  headers: Headers;
};

export type enableAccessProfileResponse = (enableAccessProfileResponseSuccess | enableAccessProfileResponseError)

export const getEnableAccessProfileUrl = (tenant: string,
    accessProfileId: number,) => {




  return `/v1/${tenant}/access-profiles/${accessProfileId}/enable`
}

/**
 * @summary Ativa um perfil de acesso por ID
 */
export const enableAccessProfile = async (tenant: string,
    accessProfileId: number, options?: RequestInit): Promise<enableAccessProfileResponse> => {

  return customInstanceBpm<enableAccessProfileResponse>(getEnableAccessProfileUrl(tenant,accessProfileId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableAccessProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext> => {

const mutationKey = ['enableAccessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAccessProfile>>, {tenant: string;accessProfileId: number}> = (props) => {
          const {tenant,accessProfileId} = props ?? {};

          return  enableAccessProfile(tenant,accessProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAccessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof enableAccessProfile>>>

    export type EnableAccessProfileMutationError = Problem

    /**
 * @summary Ativa um perfil de acesso por ID
 */
export const useEnableAccessProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableAccessProfile>>,
        TError,
        {tenant: string;accessProfileId: number},
        TContext
      > => {
      return useMutation(getEnableAccessProfileMutationOptions(options), queryClient);
    }

export type disableAccessProfileResponse204 = {
  data: void
  status: 204
}

export type disableAccessProfileResponse404 = {
  data: Problem
  status: 404
}

export type disableAccessProfileResponseSuccess = (disableAccessProfileResponse204) & {
  headers: Headers;
};
export type disableAccessProfileResponseError = (disableAccessProfileResponse404) & {
  headers: Headers;
};

export type disableAccessProfileResponse = (disableAccessProfileResponseSuccess | disableAccessProfileResponseError)

export const getDisableAccessProfileUrl = (tenant: string,
    accessProfileId: number,) => {




  return `/v1/${tenant}/access-profiles/${accessProfileId}/enable`
}

/**
 * @summary Inativa um perfil de acesso por ID
 */
export const disableAccessProfile = async (tenant: string,
    accessProfileId: number, options?: RequestInit): Promise<disableAccessProfileResponse> => {

  return customInstanceBpm<disableAccessProfileResponse>(getDisableAccessProfileUrl(tenant,accessProfileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableAccessProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext> => {

const mutationKey = ['disableAccessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAccessProfile>>, {tenant: string;accessProfileId: number}> = (props) => {
          const {tenant,accessProfileId} = props ?? {};

          return  disableAccessProfile(tenant,accessProfileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAccessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof disableAccessProfile>>>

    export type DisableAccessProfileMutationError = Problem

    /**
 * @summary Inativa um perfil de acesso por ID
 */
export const useDisableAccessProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAccessProfile>>, TError,{tenant: string;accessProfileId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableAccessProfile>>,
        TError,
        {tenant: string;accessProfileId: number},
        TContext
      > => {
      return useMutation(getDisableAccessProfileMutationOptions(options), queryClient);
    }

export type getTenantResponse404 = {
  data: Problem
  status: 404
}

;
export type getTenantResponseError = (getTenantResponse404) & {
  headers: Headers;
};

export type getTenantResponse = (getTenantResponseError)

export const getGetTenantUrl = (tenantId: string,) => {




  return `/v1/tenants/${tenantId}`
}

/**
 * @summary Busca um tenant pelo ID
 */
export const getTenant = async (tenantId: string, options?: RequestInit): Promise<getTenantResponse> => {

  return customInstanceBpm<getTenantResponse>(getGetTenantUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantQueryKey = (tenantId: string,) => {
    return [
    `/v1/tenants/${tenantId}`
    ] as const;
    }


export const getGetTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTenant>>, TError = Problem>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenant>>> = ({ signal }) => getTenant(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTenant>>>
export type GetTenantQueryError = Problem


export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = Problem>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = Problem>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenant>>,
          TError,
          Awaited<ReturnType<typeof getTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = Problem>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um tenant pelo ID
 */

export function useGetTenant<TData = Awaited<ReturnType<typeof getTenant>>, TError = Problem>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editTenantResponse200 = {
  data: SmartTenantWithAllPropertiesDto
  status: 200
}

export type editTenantResponse404 = {
  data: Problem
  status: 404
}

export type editTenantResponseSuccess = (editTenantResponse200) & {
  headers: Headers;
};
export type editTenantResponseError = (editTenantResponse404) & {
  headers: Headers;
};

export type editTenantResponse = (editTenantResponseSuccess | editTenantResponseError)

export const getEditTenantUrl = (tenantId: string,) => {




  return `/v1/tenants/${tenantId}`
}

/**
 * @summary Atualiza um tenant por ID
 */
export const editTenant = async (tenantId: string,
    smartTenantInputEdit: SmartTenantInputEdit, options?: RequestInit): Promise<editTenantResponse> => {

  return customInstanceBpm<editTenantResponse>(getEditTenantUrl(tenantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartTenantInputEdit)
  }
);}




export const getEditTenantMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTenant>>, TError,{tenantId: string;data: SmartTenantInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editTenant>>, TError,{tenantId: string;data: SmartTenantInputEdit}, TContext> => {

const mutationKey = ['editTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editTenant>>, {tenantId: string;data: SmartTenantInputEdit}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  editTenant(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditTenantMutationResult = NonNullable<Awaited<ReturnType<typeof editTenant>>>
    export type EditTenantMutationBody = SmartTenantInputEdit
    export type EditTenantMutationError = Problem

    /**
 * @summary Atualiza um tenant por ID
 */
export const useEditTenant = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTenant>>, TError,{tenantId: string;data: SmartTenantInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editTenant>>,
        TError,
        {tenantId: string;data: SmartTenantInputEdit},
        TContext
      > => {
      return useMutation(getEditTenantMutationOptions(options), queryClient);
    }

export type enableTenantResponse204 = {
  data: void
  status: 204
}

export type enableTenantResponse404 = {
  data: Problem
  status: 404
}

export type enableTenantResponseSuccess = (enableTenantResponse204) & {
  headers: Headers;
};
export type enableTenantResponseError = (enableTenantResponse404) & {
  headers: Headers;
};

export type enableTenantResponse = (enableTenantResponseSuccess | enableTenantResponseError)

export const getEnableTenantUrl = (tenantId: string,) => {




  return `/v1/tenants/${tenantId}/enable`
}

/**
 * @summary Ativa um tenant
 */
export const enableTenant = async (tenantId: string, options?: RequestInit): Promise<enableTenantResponse> => {

  return customInstanceBpm<enableTenantResponse>(getEnableTenantUrl(tenantId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableTenantMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableTenant>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['enableTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableTenant>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  enableTenant(tenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableTenantMutationResult = NonNullable<Awaited<ReturnType<typeof enableTenant>>>

    export type EnableTenantMutationError = Problem

    /**
 * @summary Ativa um tenant
 */
export const useEnableTenant = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableTenant>>,
        TError,
        {tenantId: string},
        TContext
      > => {
      return useMutation(getEnableTenantMutationOptions(options), queryClient);
    }

export type disableTenantResponse204 = {
  data: void
  status: 204
}

export type disableTenantResponse404 = {
  data: Problem
  status: 404
}

export type disableTenantResponseSuccess = (disableTenantResponse204) & {
  headers: Headers;
};
export type disableTenantResponseError = (disableTenantResponse404) & {
  headers: Headers;
};

export type disableTenantResponse = (disableTenantResponseSuccess | disableTenantResponseError)

export const getDisableTenantUrl = (tenantId: string,) => {




  return `/v1/tenants/${tenantId}/enable`
}

/**
 * @summary Inativa um tenant
 */
export const disableTenant = async (tenantId: string, options?: RequestInit): Promise<disableTenantResponse> => {

  return customInstanceBpm<disableTenantResponse>(getDisableTenantUrl(tenantId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableTenantMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableTenant>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['disableTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableTenant>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  disableTenant(tenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableTenantMutationResult = NonNullable<Awaited<ReturnType<typeof disableTenant>>>

    export type DisableTenantMutationError = Problem

    /**
 * @summary Inativa um tenant
 */
export const useDisableTenant = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTenant>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableTenant>>,
        TError,
        {tenantId: string},
        TContext
      > => {
      return useMutation(getDisableTenantMutationOptions(options), queryClient);
    }

export type updateProcessInstanceVariablesResponse204 = {
  data: void
  status: 204
}

export type updateProcessInstanceVariablesResponseSuccess = (updateProcessInstanceVariablesResponse204) & {
  headers: Headers;
};
;

export type updateProcessInstanceVariablesResponse = (updateProcessInstanceVariablesResponseSuccess)

export const getUpdateProcessInstanceVariablesUrl = (processInstanceId: string,) => {




  return `/v1/process-instances/${processInstanceId}/update-variables`
}

/**
 * @summary Atualiza variaveis da instância do processo
 */
export const updateProcessInstanceVariables = async (processInstanceId: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<updateProcessInstanceVariablesResponse> => {

  return customInstanceBpm<updateProcessInstanceVariablesResponse>(getUpdateProcessInstanceVariablesUrl(processInstanceId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getUpdateProcessInstanceVariablesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProcessInstanceVariables>>, TError,{processInstanceId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProcessInstanceVariables>>, TError,{processInstanceId: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['updateProcessInstanceVariables'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProcessInstanceVariables>>, {processInstanceId: string;data: CompleteTaskInput}> = (props) => {
          const {processInstanceId,data} = props ?? {};

          return  updateProcessInstanceVariables(processInstanceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProcessInstanceVariablesMutationResult = NonNullable<Awaited<ReturnType<typeof updateProcessInstanceVariables>>>
    export type UpdateProcessInstanceVariablesMutationBody = CompleteTaskInput
    export type UpdateProcessInstanceVariablesMutationError = unknown

    /**
 * @summary Atualiza variaveis da instância do processo
 */
export const useUpdateProcessInstanceVariables = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProcessInstanceVariables>>, TError,{processInstanceId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProcessInstanceVariables>>,
        TError,
        {processInstanceId: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getUpdateProcessInstanceVariablesMutationOptions(options), queryClient);
    }

export type editUserFromCsvForMultipleTenantsResponse202 = {
  data: string[]
  status: 202
}

export type editUserFromCsvForMultipleTenantsResponseSuccess = (editUserFromCsvForMultipleTenantsResponse202) & {
  headers: Headers;
};
;

export type editUserFromCsvForMultipleTenantsResponse = (editUserFromCsvForMultipleTenantsResponseSuccess)

export const getEditUserFromCsvForMultipleTenantsUrl = (tenant: string,) => {




  return `/v1/batch/${tenant}/users-multiple-tenants`
}

/**
 * @summary Edita usuários em lote
 */
export const editUserFromCsvForMultipleTenants = async (tenant: string,
    editUserFromCsvForMultipleTenantsBody?: EditUserFromCsvForMultipleTenantsBody, options?: RequestInit): Promise<editUserFromCsvForMultipleTenantsResponse> => {
    const formData = new FormData();
if(editUserFromCsvForMultipleTenantsBody?.file !== undefined) {
 formData.append(`file`, editUserFromCsvForMultipleTenantsBody.file);
 }

  return customInstanceBpm<editUserFromCsvForMultipleTenantsResponse>(getEditUserFromCsvForMultipleTenantsUrl(tenant),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}




export const getEditUserFromCsvForMultipleTenantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: EditUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: EditUserFromCsvForMultipleTenantsBody}, TContext> => {

const mutationKey = ['editUserFromCsvForMultipleTenants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>, {tenant: string;data?: EditUserFromCsvForMultipleTenantsBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  editUserFromCsvForMultipleTenants(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditUserFromCsvForMultipleTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>>
    export type EditUserFromCsvForMultipleTenantsMutationBody = EditUserFromCsvForMultipleTenantsBody | undefined
    export type EditUserFromCsvForMultipleTenantsMutationError = unknown

    /**
 * @summary Edita usuários em lote
 */
export const useEditUserFromCsvForMultipleTenants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: EditUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUserFromCsvForMultipleTenants>>,
        TError,
        {tenant: string;data?: EditUserFromCsvForMultipleTenantsBody},
        TContext
      > => {
      return useMutation(getEditUserFromCsvForMultipleTenantsMutationOptions(options), queryClient);
    }

export type createUserFromCsvForMultipleTenantsResponse202 = {
  data: string[]
  status: 202
}

export type createUserFromCsvForMultipleTenantsResponseSuccess = (createUserFromCsvForMultipleTenantsResponse202) & {
  headers: Headers;
};
;

export type createUserFromCsvForMultipleTenantsResponse = (createUserFromCsvForMultipleTenantsResponseSuccess)

export const getCreateUserFromCsvForMultipleTenantsUrl = (tenant: string,) => {




  return `/v1/batch/${tenant}/users-multiple-tenants`
}

/**
 * @summary Cria usuários em lote
 */
export const createUserFromCsvForMultipleTenants = async (tenant: string,
    createUserFromCsvForMultipleTenantsBody?: CreateUserFromCsvForMultipleTenantsBody, options?: RequestInit): Promise<createUserFromCsvForMultipleTenantsResponse> => {
    const formData = new FormData();
if(createUserFromCsvForMultipleTenantsBody?.file !== undefined) {
 formData.append(`file`, createUserFromCsvForMultipleTenantsBody.file);
 }

  return customInstanceBpm<createUserFromCsvForMultipleTenantsResponse>(getCreateUserFromCsvForMultipleTenantsUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateUserFromCsvForMultipleTenantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: CreateUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: CreateUserFromCsvForMultipleTenantsBody}, TContext> => {

const mutationKey = ['createUserFromCsvForMultipleTenants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>, {tenant: string;data?: CreateUserFromCsvForMultipleTenantsBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createUserFromCsvForMultipleTenants(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserFromCsvForMultipleTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>>
    export type CreateUserFromCsvForMultipleTenantsMutationBody = CreateUserFromCsvForMultipleTenantsBody | undefined
    export type CreateUserFromCsvForMultipleTenantsMutationError = unknown

    /**
 * @summary Cria usuários em lote
 */
export const useCreateUserFromCsvForMultipleTenants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: CreateUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserFromCsvForMultipleTenants>>,
        TError,
        {tenant: string;data?: CreateUserFromCsvForMultipleTenantsBody},
        TContext
      > => {
      return useMutation(getCreateUserFromCsvForMultipleTenantsMutationOptions(options), queryClient);
    }

export type deleteUserFromCsvForMultipleTenantsResponse202 = {
  data: string[]
  status: 202
}

export type deleteUserFromCsvForMultipleTenantsResponseSuccess = (deleteUserFromCsvForMultipleTenantsResponse202) & {
  headers: Headers;
};
;

export type deleteUserFromCsvForMultipleTenantsResponse = (deleteUserFromCsvForMultipleTenantsResponseSuccess)

export const getDeleteUserFromCsvForMultipleTenantsUrl = (tenant: string,) => {




  return `/v1/batch/${tenant}/users-multiple-tenants`
}

/**
 * @summary Excluir usuários em lote
 */
export const deleteUserFromCsvForMultipleTenants = async (tenant: string,
    deleteUserFromCsvForMultipleTenantsBody?: DeleteUserFromCsvForMultipleTenantsBody, options?: RequestInit): Promise<deleteUserFromCsvForMultipleTenantsResponse> => {
    const formData = new FormData();
if(deleteUserFromCsvForMultipleTenantsBody?.file !== undefined) {
 formData.append(`file`, deleteUserFromCsvForMultipleTenantsBody.file);
 }

  return customInstanceBpm<deleteUserFromCsvForMultipleTenantsResponse>(getDeleteUserFromCsvForMultipleTenantsUrl(tenant),
  {
    ...options,
    method: 'DELETE'
    ,
    body: formData
  }
);}




export const getDeleteUserFromCsvForMultipleTenantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: DeleteUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: DeleteUserFromCsvForMultipleTenantsBody}, TContext> => {

const mutationKey = ['deleteUserFromCsvForMultipleTenants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>, {tenant: string;data?: DeleteUserFromCsvForMultipleTenantsBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  deleteUserFromCsvForMultipleTenants(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFromCsvForMultipleTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>>
    export type DeleteUserFromCsvForMultipleTenantsMutationBody = DeleteUserFromCsvForMultipleTenantsBody | undefined
    export type DeleteUserFromCsvForMultipleTenantsMutationError = unknown

    /**
 * @summary Excluir usuários em lote
 */
export const useDeleteUserFromCsvForMultipleTenants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>, TError,{tenant: string;data?: DeleteUserFromCsvForMultipleTenantsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserFromCsvForMultipleTenants>>,
        TError,
        {tenant: string;data?: DeleteUserFromCsvForMultipleTenantsBody},
        TContext
      > => {
      return useMutation(getDeleteUserFromCsvForMultipleTenantsMutationOptions(options), queryClient);
    }

export type updateFileResponse200 = {
  data: AttachmentDetailsDto
  status: 200
}

export type updateFileResponseSuccess = (updateFileResponse200) & {
  headers: Headers;
};
;

export type updateFileResponse = (updateFileResponseSuccess)

export const getUpdateFileUrl = (documentUID: string,
    params?: UpdateFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/attachment/${documentUID}/update?${stringifiedParams}` : `/smart-bpm/rest/attachment/${documentUID}/update`
}

/**
 * @summary Atualiza o arquivo
 */
export const updateFile = async (documentUID: string,
    updateFileBody?: UpdateFileBody,
    params?: UpdateFileParams, options?: RequestInit): Promise<updateFileResponse> => {

  return customInstanceBpm<updateFileResponse>(getUpdateFileUrl(documentUID,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateFileBody)
  }
);}




export const getUpdateFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFile>>, TError,{documentUID: string;data?: UpdateFileBody;params?: UpdateFileParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFile>>, TError,{documentUID: string;data?: UpdateFileBody;params?: UpdateFileParams}, TContext> => {

const mutationKey = ['updateFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFile>>, {documentUID: string;data?: UpdateFileBody;params?: UpdateFileParams}> = (props) => {
          const {documentUID,data,params} = props ?? {};

          return  updateFile(documentUID,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateFile>>>
    export type UpdateFileMutationBody = UpdateFileBody | undefined
    export type UpdateFileMutationError = unknown

    /**
 * @summary Atualiza o arquivo
 */
export const useUpdateFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFile>>, TError,{documentUID: string;data?: UpdateFileBody;params?: UpdateFileParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFile>>,
        TError,
        {documentUID: string;data?: UpdateFileBody;params?: UpdateFileParams},
        TContext
      > => {
      return useMutation(getUpdateFileMutationOptions(options), queryClient);
    }

export type findTemplateResponse404 = {
  data: Problem
  status: 404
}

;
export type findTemplateResponseError = (findTemplateResponse404) & {
  headers: Headers;
};

export type findTemplateResponse = (findTemplateResponseError)

export const getFindTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}`
}

/**
 * @summary Busca um template por ID
 */
export const findTemplate = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<findTemplateResponse> => {

  return customInstanceBpm<findTemplateResponse>(getFindTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindTemplateQueryKey = (tenant: string,
    templateId: number,) => {
    return [
    `/documents/rest/${tenant}/templates/${templateId}`
    ] as const;
    }


export const getFindTemplateQueryOptions = <TData = Awaited<ReturnType<typeof findTemplate>>, TError = Problem>(tenant: string,
    templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTemplateQueryKey(tenant,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTemplate>>> = ({ signal }) => findTemplate(tenant,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof findTemplate>>>
export type FindTemplateQueryError = Problem


export function useFindTemplate<TData = Awaited<ReturnType<typeof findTemplate>>, TError = Problem>(
 tenant: string,
    templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTemplate>>,
          TError,
          Awaited<ReturnType<typeof findTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTemplate<TData = Awaited<ReturnType<typeof findTemplate>>, TError = Problem>(
 tenant: string,
    templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTemplate>>,
          TError,
          Awaited<ReturnType<typeof findTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTemplate<TData = Awaited<ReturnType<typeof findTemplate>>, TError = Problem>(
 tenant: string,
    templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca um template por ID
 */

export function useFindTemplate<TData = Awaited<ReturnType<typeof findTemplate>>, TError = Problem>(
 tenant: string,
    templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTemplateQueryOptions(tenant,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type editTemplateResponse200 = {
  data: TemplateDto
  status: 200
}

export type editTemplateResponse404 = {
  data: Problem
  status: 404
}

export type editTemplateResponseSuccess = (editTemplateResponse200) & {
  headers: Headers;
};
export type editTemplateResponseError = (editTemplateResponse404) & {
  headers: Headers;
};

export type editTemplateResponse = (editTemplateResponseSuccess | editTemplateResponseError)

export const getEditTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}`
}

/**
 * @summary Atualiza um template por ID
 */
export const editTemplate = async (tenant: string,
    templateId: number,
    templateDtoInputEdit: TemplateDtoInputEdit, options?: RequestInit): Promise<editTemplateResponse> => {

  return customInstanceBpm<editTemplateResponse>(getEditTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(templateDtoInputEdit)
  }
);}




export const getEditTemplateMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTemplate>>, TError,{tenant: string;templateId: number;data: TemplateDtoInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof editTemplate>>, TError,{tenant: string;templateId: number;data: TemplateDtoInputEdit}, TContext> => {

const mutationKey = ['editTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editTemplate>>, {tenant: string;templateId: number;data: TemplateDtoInputEdit}> = (props) => {
          const {tenant,templateId,data} = props ?? {};

          return  editTemplate(tenant,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof editTemplate>>>
    export type EditTemplateMutationBody = TemplateDtoInputEdit
    export type EditTemplateMutationError = Problem

    /**
 * @summary Atualiza um template por ID
 */
export const useEditTemplate = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTemplate>>, TError,{tenant: string;templateId: number;data: TemplateDtoInputEdit}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editTemplate>>,
        TError,
        {tenant: string;templateId: number;data: TemplateDtoInputEdit},
        TContext
      > => {
      return useMutation(getEditTemplateMutationOptions(options), queryClient);
    }

export type deleteTemplateResponse204 = {
  data: void
  status: 204
}

export type deleteTemplateResponse404 = {
  data: Problem
  status: 404
}

export type deleteTemplateResponseSuccess = (deleteTemplateResponse204) & {
  headers: Headers;
};
export type deleteTemplateResponseError = (deleteTemplateResponse404) & {
  headers: Headers;
};

export type deleteTemplateResponse = (deleteTemplateResponseSuccess | deleteTemplateResponseError)

export const getDeleteTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}`
}

/**
 * @summary Exclui um template por ID
 */
export const deleteTemplate = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<deleteTemplateResponse> => {

  return customInstanceBpm<deleteTemplateResponse>(getDeleteTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTemplateMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{tenant: string;templateId: number}, TContext> => {

const mutationKey = ['deleteTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, {tenant: string;templateId: number}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  deleteTemplate(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>

    export type DeleteTemplateMutationError = Problem

    /**
 * @summary Exclui um template por ID
 */
export const useDeleteTemplate = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        {tenant: string;templateId: number},
        TContext
      > => {
      return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
    }

export type publishTemplateResponse204 = {
  data: void
  status: 204
}

export type publishTemplateResponse404 = {
  data: Problem
  status: 404
}

export type publishTemplateResponseSuccess = (publishTemplateResponse204) & {
  headers: Headers;
};
export type publishTemplateResponseError = (publishTemplateResponse404) & {
  headers: Headers;
};

export type publishTemplateResponse = (publishTemplateResponseSuccess | publishTemplateResponseError)

export const getPublishTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/publish`
}

/**
 * @summary Publica um template por ID
 */
export const publishTemplate = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<publishTemplateResponse> => {

  return customInstanceBpm<publishTemplateResponse>(getPublishTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getPublishTemplateMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof publishTemplate>>, TError,{tenant: string;templateId: number}, TContext> => {

const mutationKey = ['publishTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishTemplate>>, {tenant: string;templateId: number}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  publishTemplate(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof publishTemplate>>>

    export type PublishTemplateMutationError = Problem

    /**
 * @summary Publica um template por ID
 */
export const usePublishTemplate = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishTemplate>>,
        TError,
        {tenant: string;templateId: number},
        TContext
      > => {
      return useMutation(getPublishTemplateMutationOptions(options), queryClient);
    }

export type enableTemplateResponse204 = {
  data: void
  status: 204
}

export type enableTemplateResponse404 = {
  data: Problem
  status: 404
}

export type enableTemplateResponseSuccess = (enableTemplateResponse204) & {
  headers: Headers;
};
export type enableTemplateResponseError = (enableTemplateResponse404) & {
  headers: Headers;
};

export type enableTemplateResponse = (enableTemplateResponseSuccess | enableTemplateResponseError)

export const getEnableTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/enable`
}

/**
 * @summary Ativa um template por ID
 */
export const enableTemplate = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<enableTemplateResponse> => {

  return customInstanceBpm<enableTemplateResponse>(getEnableTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'PUT'


  }
);}




export const getEnableTemplateMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enableTemplate>>, TError,{tenant: string;templateId: number}, TContext> => {

const mutationKey = ['enableTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableTemplate>>, {tenant: string;templateId: number}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  enableTemplate(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof enableTemplate>>>

    export type EnableTemplateMutationError = Problem

    /**
 * @summary Ativa um template por ID
 */
export const useEnableTemplate = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableTemplate>>,
        TError,
        {tenant: string;templateId: number},
        TContext
      > => {
      return useMutation(getEnableTemplateMutationOptions(options), queryClient);
    }

export type disableTemplateResponse204 = {
  data: void
  status: 204
}

export type disableTemplateResponse404 = {
  data: Problem
  status: 404
}

export type disableTemplateResponseSuccess = (disableTemplateResponse204) & {
  headers: Headers;
};
export type disableTemplateResponseError = (disableTemplateResponse404) & {
  headers: Headers;
};

export type disableTemplateResponse = (disableTemplateResponseSuccess | disableTemplateResponseError)

export const getDisableTemplateUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/enable`
}

/**
 * @summary Inativa um template por ID
 */
export const disableTemplate = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<disableTemplateResponse> => {

  return customInstanceBpm<disableTemplateResponse>(getDisableTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableTemplateMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableTemplate>>, TError,{tenant: string;templateId: number}, TContext> => {

const mutationKey = ['disableTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableTemplate>>, {tenant: string;templateId: number}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  disableTemplate(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof disableTemplate>>>

    export type DisableTemplateMutationError = Problem

    /**
 * @summary Inativa um template por ID
 */
export const useDisableTemplate = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTemplate>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableTemplate>>,
        TError,
        {tenant: string;templateId: number},
        TContext
      > => {
      return useMutation(getDisableTemplateMutationOptions(options), queryClient);
    }

export type replaceCnaeResponse202 = {
  data: void
  status: 202
}

export type replaceCnaeResponseSuccess = (replaceCnaeResponse202) & {
  headers: Headers;
};
;

export type replaceCnaeResponse = (replaceCnaeResponseSuccess)

export const getReplaceCnaeUrl = () => {




  return `/api/v1/cnae/replace-by-cnae`
}

/**
 * @summary Recebe csv sem cabeçalho e substitui os dados dos cnaes cadastrados baseados no código cnae.
 */
export const replaceCnae = async (replaceCnaeBody: string, options?: RequestInit): Promise<replaceCnaeResponse> => {

  return customInstanceBpm<replaceCnaeResponse>(getReplaceCnaeUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceCnaeBody)
  }
);}




export const getReplaceCnaeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCnae>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceCnae>>, TError,{data: string}, TContext> => {

const mutationKey = ['replaceCnae'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCnae>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  replaceCnae(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCnaeMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCnae>>>
    export type ReplaceCnaeMutationBody = string
    export type ReplaceCnaeMutationError = unknown

    /**
 * @summary Recebe csv sem cabeçalho e substitui os dados dos cnaes cadastrados baseados no código cnae.
 */
export const useReplaceCnae = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCnae>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCnae>>,
        TError,
        {data: string},
        TContext
      > => {
      return useMutation(getReplaceCnaeMutationOptions(options), queryClient);
    }

export type replaceAllCnaesResponse202 = {
  data: void
  status: 202
}

export type replaceAllCnaesResponseSuccess = (replaceAllCnaesResponse202) & {
  headers: Headers;
};
;

export type replaceAllCnaesResponse = (replaceAllCnaesResponseSuccess)

export const getReplaceAllCnaesUrl = () => {




  return `/api/v1/cnae/replace-all`
}

/**
 * @summary Recebe csv sem cabeçalho e substitui todos os registros da tabela de cnaes
 */
export const replaceAllCnaes = async (replaceAllCnaesBody: string, options?: RequestInit): Promise<replaceAllCnaesResponse> => {

  return customInstanceBpm<replaceAllCnaesResponse>(getReplaceAllCnaesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceAllCnaesBody)
  }
);}




export const getReplaceAllCnaesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAllCnaes>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceAllCnaes>>, TError,{data: string}, TContext> => {

const mutationKey = ['replaceAllCnaes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAllCnaes>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  replaceAllCnaes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAllCnaesMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAllCnaes>>>
    export type ReplaceAllCnaesMutationBody = string
    export type ReplaceAllCnaesMutationError = unknown

    /**
 * @summary Recebe csv sem cabeçalho e substitui todos os registros da tabela de cnaes
 */
export const useReplaceAllCnaes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAllCnaes>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceAllCnaes>>,
        TError,
        {data: string},
        TContext
      > => {
      return useMutation(getReplaceAllCnaesMutationOptions(options), queryClient);
    }

export type getPasswordResetLinkByCodeResponse404 = {
  data: Problem
  status: 404
}

;
export type getPasswordResetLinkByCodeResponseError = (getPasswordResetLinkByCodeResponse404) & {
  headers: Headers;
};

export type getPasswordResetLinkByCodeResponse = (getPasswordResetLinkByCodeResponseError)

export const getGetPasswordResetLinkByCodeUrl = (params: GetPasswordResetLinkByCodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account/reset-password?${stringifiedParams}` : `/account/reset-password`
}

/**
 * @summary Retorna link de redefinição de senha pelo código
 */
export const getPasswordResetLinkByCode = async (params: GetPasswordResetLinkByCodeParams, options?: RequestInit): Promise<getPasswordResetLinkByCodeResponse> => {

  return customInstanceBpm<getPasswordResetLinkByCodeResponse>(getGetPasswordResetLinkByCodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPasswordResetLinkByCodeQueryKey = (params?: GetPasswordResetLinkByCodeParams,) => {
    return [
    `/account/reset-password`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPasswordResetLinkByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError = Problem>(params: GetPasswordResetLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPasswordResetLinkByCodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>> = ({ signal }) => getPasswordResetLinkByCode(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPasswordResetLinkByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>>
export type GetPasswordResetLinkByCodeQueryError = Problem


export function useGetPasswordResetLinkByCode<TData = Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError = Problem>(
 params: GetPasswordResetLinkByCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordResetLinkByCode>>,
          TError,
          Awaited<ReturnType<typeof getPasswordResetLinkByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordResetLinkByCode<TData = Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError = Problem>(
 params: GetPasswordResetLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordResetLinkByCode>>,
          TError,
          Awaited<ReturnType<typeof getPasswordResetLinkByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordResetLinkByCode<TData = Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError = Problem>(
 params: GetPasswordResetLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna link de redefinição de senha pelo código
 */

export function useGetPasswordResetLinkByCode<TData = Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError = Problem>(
 params: GetPasswordResetLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordResetLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPasswordResetLinkByCodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type resetUserPasswordResponse204 = {
  data: void
  status: 204
}

export type resetUserPasswordResponse404 = {
  data: Problem
  status: 404
}

export type resetUserPasswordResponseSuccess = (resetUserPasswordResponse204) & {
  headers: Headers;
};
export type resetUserPasswordResponseError = (resetUserPasswordResponse404) & {
  headers: Headers;
};

export type resetUserPasswordResponse = (resetUserPasswordResponseSuccess | resetUserPasswordResponseError)

export const getResetUserPasswordUrl = (params: ResetUserPasswordParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account/reset-password?${stringifiedParams}` : `/account/reset-password`
}

/**
 * @summary Redefine a senha do usuário
 */
export const resetUserPassword = async (senhaInput: SenhaInput,
    params: ResetUserPasswordParams, options?: RequestInit): Promise<resetUserPasswordResponse> => {

  return customInstanceBpm<resetUserPasswordResponse>(getResetUserPasswordUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(senhaInput)
  }
);}




export const getResetUserPasswordMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: SenhaInput;params: ResetUserPasswordParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: SenhaInput;params: ResetUserPasswordParams}, TContext> => {

const mutationKey = ['resetUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, {data: SenhaInput;params: ResetUserPasswordParams}> = (props) => {
          const {data,params} = props ?? {};

          return  resetUserPassword(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>
    export type ResetUserPasswordMutationBody = SenhaInput
    export type ResetUserPasswordMutationError = Problem

    /**
 * @summary Redefine a senha do usuário
 */
export const useResetUserPassword = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: SenhaInput;params: ResetUserPasswordParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        {data: SenhaInput;params: ResetUserPasswordParams},
        TContext
      > => {
      return useMutation(getResetUserPasswordMutationOptions(options), queryClient);
    }

export type listExportsResponse200 = {
  data: DataExportJob[]
  status: 200
}

export type listExportsResponseSuccess = (listExportsResponse200) & {
  headers: Headers;
};
;

export type listExportsResponse = (listExportsResponseSuccess)

export const getListExportsUrl = () => {




  return `/admin/export`
}

export const listExports = async ( options?: RequestInit): Promise<listExportsResponse> => {

  return customInstanceBpm<listExportsResponse>(getListExportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExportsQueryKey = () => {
    return [
    `/admin/export`
    ] as const;
    }


export const getListExportsQueryOptions = <TData = Awaited<ReturnType<typeof listExports>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExports>>> = ({ signal }) => listExports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExportsQueryResult = NonNullable<Awaited<ReturnType<typeof listExports>>>
export type ListExportsQueryError = unknown


export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports>>,
          TError,
          Awaited<ReturnType<typeof listExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports>>,
          TError,
          Awaited<ReturnType<typeof listExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListExports<TData = Awaited<ReturnType<typeof listExports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type requestExportResponse200 = {
  data: DataExportJob
  status: 200
}

export type requestExportResponseSuccess = (requestExportResponse200) & {
  headers: Headers;
};
;

export type requestExportResponse = (requestExportResponseSuccess)

export const getRequestExportUrl = () => {




  return `/admin/export`
}

export const requestExport = async ( options?: RequestInit): Promise<requestExportResponse> => {

  return customInstanceBpm<requestExportResponse>(getRequestExportUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRequestExportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestExport>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof requestExport>>, TError,void, TContext> => {

const mutationKey = ['requestExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestExport>>, void> = () => {


          return  requestExport(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestExportMutationResult = NonNullable<Awaited<ReturnType<typeof requestExport>>>

    export type RequestExportMutationError = unknown

    export const useRequestExport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestExport>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestExport>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestExportMutationOptions(options), queryClient);
    }

export type listExports1Response200 = {
  data: DataExportJob[]
  status: 200
}

export type listExports1ResponseSuccess = (listExports1Response200) & {
  headers: Headers;
};
;

export type listExports1Response = (listExports1ResponseSuccess)

export const getListExports1Url = () => {




  return `/v1/admin/export`
}

export const listExports1 = async ( options?: RequestInit): Promise<listExports1Response> => {

  return customInstanceBpm<listExports1Response>(getListExports1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExports1QueryKey = () => {
    return [
    `/v1/admin/export`
    ] as const;
    }


export const getListExports1QueryOptions = <TData = Awaited<ReturnType<typeof listExports1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExports1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExports1>>> = ({ signal }) => listExports1({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExports1QueryResult = NonNullable<Awaited<ReturnType<typeof listExports1>>>
export type ListExports1QueryError = unknown


export function useListExports1<TData = Awaited<ReturnType<typeof listExports1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports1>>,
          TError,
          Awaited<ReturnType<typeof listExports1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports1<TData = Awaited<ReturnType<typeof listExports1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExports1>>,
          TError,
          Awaited<ReturnType<typeof listExports1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExports1<TData = Awaited<ReturnType<typeof listExports1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListExports1<TData = Awaited<ReturnType<typeof listExports1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExports1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExports1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type requestExport1Response200 = {
  data: DataExportJob
  status: 200
}

export type requestExport1ResponseSuccess = (requestExport1Response200) & {
  headers: Headers;
};
;

export type requestExport1Response = (requestExport1ResponseSuccess)

export const getRequestExport1Url = () => {




  return `/v1/admin/export`
}

export const requestExport1 = async ( options?: RequestInit): Promise<requestExport1Response> => {

  return customInstanceBpm<requestExport1Response>(getRequestExport1Url(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRequestExport1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestExport1>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof requestExport1>>, TError,void, TContext> => {

const mutationKey = ['requestExport1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestExport1>>, void> = () => {


          return  requestExport1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestExport1MutationResult = NonNullable<Awaited<ReturnType<typeof requestExport1>>>

    export type RequestExport1MutationError = unknown

    export const useRequestExport1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestExport1>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestExport1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestExport1MutationOptions(options), queryClient);
    }

export type listUserResponse200 = {
  data: PageSmartUserDto
  status: 200
}

export type listUserResponseSuccess = (listUserResponse200) & {
  headers: Headers;
};
;

export type listUserResponse = (listUserResponseSuccess)

export const getListUserUrl = (tenant: string,
    params?: ListUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/users?${stringifiedParams}` : `/v1/${tenant}/users`
}

/**
 * @summary Lista os usuários
 */
export const listUser = async (tenant: string,
    params?: ListUserParams, options?: RequestInit): Promise<listUserResponse> => {

  return customInstanceBpm<listUserResponse>(getListUserUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserQueryKey = (tenant: string,
    params?: ListUserParams,) => {
    return [
    `/v1/${tenant}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUserQueryOptions = <TData = Awaited<ReturnType<typeof listUser>>, TError = unknown>(tenant: string,
    params?: ListUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUser>>> = ({ signal }) => listUser(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserQueryResult = NonNullable<Awaited<ReturnType<typeof listUser>>>
export type ListUserQueryError = unknown


export function useListUser<TData = Awaited<ReturnType<typeof listUser>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUser>>,
          TError,
          Awaited<ReturnType<typeof listUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUser<TData = Awaited<ReturnType<typeof listUser>>, TError = unknown>(
 tenant: string,
    params?: ListUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUser>>,
          TError,
          Awaited<ReturnType<typeof listUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUser<TData = Awaited<ReturnType<typeof listUser>>, TError = unknown>(
 tenant: string,
    params?: ListUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os usuários
 */

export function useListUser<TData = Awaited<ReturnType<typeof listUser>>, TError = unknown>(
 tenant: string,
    params?: ListUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createUserResponse201 = {
  data: SmartUserWithAllPropertiesDto
  status: 201
}

export type createUserResponseSuccess = (createUserResponse201) & {
  headers: Headers;
};
;

export type createUserResponse = (createUserResponseSuccess)

export const getCreateUserUrl = (tenant: string,) => {




  return `/v1/${tenant}/users`
}

/**
 * @summary Cria um usuário
 */
export const createUser = async (tenant: string,
    smartUserInputCreate: SmartUserInputCreate, options?: RequestInit): Promise<createUserResponse> => {

  return customInstanceBpm<createUserResponse>(getCreateUserUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartUserInputCreate)
  }
);}




export const getCreateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{tenant: string;data: SmartUserInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{tenant: string;data: SmartUserInputCreate}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {tenant: string;data: SmartUserInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createUser(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = SmartUserInputCreate
    export type CreateUserMutationError = unknown

    /**
 * @summary Cria um usuário
 */
export const useCreateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{tenant: string;data: SmartUserInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {tenant: string;data: SmartUserInputCreate},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }

export type userHasPermissionResponse200 = {
  data: HasPermissionDto
  status: 200
}

export type userHasPermissionResponseSuccess = (userHasPermissionResponse200) & {
  headers: Headers;
};
;

export type userHasPermissionResponse = (userHasPermissionResponseSuccess)

export const getUserHasPermissionUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/permissions/has-permission`
}

/**
 * @summary Verifica se o usuário tem uma determinada permissão
 */
export const userHasPermission = async (tenant: string,
    userId: string,
    hasPermissionInput: HasPermissionInput, options?: RequestInit): Promise<userHasPermissionResponse> => {

  return customInstanceBpm<userHasPermissionResponse>(getUserHasPermissionUrl(tenant,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hasPermissionInput)
  }
);}




export const getUserHasPermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userHasPermission>>, TError,{tenant: string;userId: string;data: HasPermissionInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof userHasPermission>>, TError,{tenant: string;userId: string;data: HasPermissionInput}, TContext> => {

const mutationKey = ['userHasPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userHasPermission>>, {tenant: string;userId: string;data: HasPermissionInput}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  userHasPermission(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserHasPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof userHasPermission>>>
    export type UserHasPermissionMutationBody = HasPermissionInput
    export type UserHasPermissionMutationError = unknown

    /**
 * @summary Verifica se o usuário tem uma determinada permissão
 */
export const useUserHasPermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userHasPermission>>, TError,{tenant: string;userId: string;data: HasPermissionInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userHasPermission>>,
        TError,
        {tenant: string;userId: string;data: HasPermissionInput},
        TContext
      > => {
      return useMutation(getUserHasPermissionMutationOptions(options), queryClient);
    }

export type listInviteResponse200 = {
  data: InviteDto[]
  status: 200
}

export type listInviteResponseSuccess = (listInviteResponse200) & {
  headers: Headers;
};
;

export type listInviteResponse = (listInviteResponseSuccess)

export const getListInviteUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/invites`
}

/**
 * @summary Lista os convites do usuário
 */
export const listInvite = async (tenant: string,
    userId: string, options?: RequestInit): Promise<listInviteResponse> => {

  return customInstanceBpm<listInviteResponse>(getListInviteUrl(tenant,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInviteQueryKey = (tenant: string,
    userId: string,) => {
    return [
    `/v1/${tenant}/users/${userId}/invites`
    ] as const;
    }


export const getListInviteQueryOptions = <TData = Awaited<ReturnType<typeof listInvite>>, TError = unknown>(tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInviteQueryKey(tenant,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvite>>> = ({ signal }) => listInvite(tenant,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInviteQueryResult = NonNullable<Awaited<ReturnType<typeof listInvite>>>
export type ListInviteQueryError = unknown


export function useListInvite<TData = Awaited<ReturnType<typeof listInvite>>, TError = unknown>(
 tenant: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvite>>,
          TError,
          Awaited<ReturnType<typeof listInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvite<TData = Awaited<ReturnType<typeof listInvite>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvite>>,
          TError,
          Awaited<ReturnType<typeof listInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvite<TData = Awaited<ReturnType<typeof listInvite>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os convites do usuário
 */

export function useListInvite<TData = Awaited<ReturnType<typeof listInvite>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInviteQueryOptions(tenant,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createInviteResponse201 = {
  data: InviteDto
  status: 201
}

export type createInviteResponseSuccess = (createInviteResponse201) & {
  headers: Headers;
};
;

export type createInviteResponse = (createInviteResponseSuccess)

export const getCreateInviteUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/invites`
}

/**
 * @summary Envia um convite para se cadastrar na plataforma
 */
export const createInvite = async (tenant: string,
    userId: string,
    inviteInputCreate: InviteInputCreate, options?: RequestInit): Promise<createInviteResponse> => {

  return customInstanceBpm<createInviteResponse>(getCreateInviteUrl(tenant,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inviteInputCreate)
  }
);}




export const getCreateInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{tenant: string;userId: string;data: InviteInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{tenant: string;userId: string;data: InviteInputCreate}, TContext> => {

const mutationKey = ['createInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvite>>, {tenant: string;userId: string;data: InviteInputCreate}> = (props) => {
          const {tenant,userId,data} = props ?? {};

          return  createInvite(tenant,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createInvite>>>
    export type CreateInviteMutationBody = InviteInputCreate
    export type CreateInviteMutationError = unknown

    /**
 * @summary Envia um convite para se cadastrar na plataforma
 */
export const useCreateInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{tenant: string;userId: string;data: InviteInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvite>>,
        TError,
        {tenant: string;userId: string;data: InviteInputCreate},
        TContext
      > => {
      return useMutation(getCreateInviteMutationOptions(options), queryClient);
    }

export type uploadFileResponse200 = {
  data: UploadFileDto
  status: 200
}

export type uploadFileResponseSuccess = (uploadFileResponse200) & {
  headers: Headers;
};
;

export type uploadFileResponse = (uploadFileResponseSuccess)

export const getUploadFileUrl = (tenant: string,) => {




  return `/v1/${tenant}/upload`
}

/**
 * @summary Faz uplaod de um arquivo
 */
export const uploadFile = async (tenant: string,
    uploadFileBody?: UploadFileBody, options?: RequestInit): Promise<uploadFileResponse> => {
    const formData = new FormData();
if(uploadFileBody?.RemoteFile !== undefined) {
 formData.append(`RemoteFile`, uploadFileBody.RemoteFile);
 }
if(uploadFileBody?.file !== undefined) {
 formData.append(`file`, uploadFileBody.file);
 }

  return customInstanceBpm<uploadFileResponse>(getUploadFileUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getUploadFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{tenant: string;data?: UploadFileBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{tenant: string;data?: UploadFileBody}, TContext> => {

const mutationKey = ['uploadFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFile>>, {tenant: string;data?: UploadFileBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  uploadFile(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>
    export type UploadFileMutationBody = UploadFileBody | undefined
    export type UploadFileMutationError = unknown

    /**
 * @summary Faz uplaod de um arquivo
 */
export const useUploadFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{tenant: string;data?: UploadFileBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadFile>>,
        TError,
        {tenant: string;data?: UploadFileBody},
        TContext
      > => {
      return useMutation(getUploadFileMutationOptions(options), queryClient);
    }

export type signAndCompleteTaskResponse204 = {
  data: void
  status: 204
}

export type signAndCompleteTaskResponseSuccess = (signAndCompleteTaskResponse204) & {
  headers: Headers;
};
;

export type signAndCompleteTaskResponse = (signAndCompleteTaskResponseSuccess)

export const getSignAndCompleteTaskUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/sign-and-complete`
}

/**
 * @summary Assina documentos e conclui tarefa por ID
 */
export const signAndCompleteTask = async (tenant: string,
    id: string,
    completeTaskSignInput: CompleteTaskSignInput, options?: RequestInit): Promise<signAndCompleteTaskResponse> => {

  return customInstanceBpm<signAndCompleteTaskResponse>(getSignAndCompleteTaskUrl(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskSignInput)
  }
);}




export const getSignAndCompleteTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTask>>, TError,{tenant: string;id: string;data: CompleteTaskSignInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTask>>, TError,{tenant: string;id: string;data: CompleteTaskSignInput}, TContext> => {

const mutationKey = ['signAndCompleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signAndCompleteTask>>, {tenant: string;id: string;data: CompleteTaskSignInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  signAndCompleteTask(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignAndCompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof signAndCompleteTask>>>
    export type SignAndCompleteTaskMutationBody = CompleteTaskSignInput
    export type SignAndCompleteTaskMutationError = unknown

    /**
 * @summary Assina documentos e conclui tarefa por ID
 */
export const useSignAndCompleteTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTask>>, TError,{tenant: string;id: string;data: CompleteTaskSignInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signAndCompleteTask>>,
        TError,
        {tenant: string;id: string;data: CompleteTaskSignInput},
        TContext
      > => {
      return useMutation(getSignAndCompleteTaskMutationOptions(options), queryClient);
    }

export type signAndCompleteTaskOtpResponse204 = {
  data: void
  status: 204
}

export type signAndCompleteTaskOtpResponseSuccess = (signAndCompleteTaskOtpResponse204) & {
  headers: Headers;
};
;

export type signAndCompleteTaskOtpResponse = (signAndCompleteTaskOtpResponseSuccess)

export const getSignAndCompleteTaskOtpUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/sign-and-complete-otp`
}

/**
 * @summary Assina documentos e conclui tarefa por ID utilizando OTP
 */
export const signAndCompleteTaskOtp = async (tenant: string,
    id: string,
    completeTaskSignOtpInput: CompleteTaskSignOtpInput, options?: RequestInit): Promise<signAndCompleteTaskOtpResponse> => {

  return customInstanceBpm<signAndCompleteTaskOtpResponse>(getSignAndCompleteTaskOtpUrl(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskSignOtpInput)
  }
);}




export const getSignAndCompleteTaskOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTaskOtp>>, TError,{tenant: string;id: string;data: CompleteTaskSignOtpInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTaskOtp>>, TError,{tenant: string;id: string;data: CompleteTaskSignOtpInput}, TContext> => {

const mutationKey = ['signAndCompleteTaskOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signAndCompleteTaskOtp>>, {tenant: string;id: string;data: CompleteTaskSignOtpInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  signAndCompleteTaskOtp(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignAndCompleteTaskOtpMutationResult = NonNullable<Awaited<ReturnType<typeof signAndCompleteTaskOtp>>>
    export type SignAndCompleteTaskOtpMutationBody = CompleteTaskSignOtpInput
    export type SignAndCompleteTaskOtpMutationError = unknown

    /**
 * @summary Assina documentos e conclui tarefa por ID utilizando OTP
 */
export const useSignAndCompleteTaskOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signAndCompleteTaskOtp>>, TError,{tenant: string;id: string;data: CompleteTaskSignOtpInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signAndCompleteTaskOtp>>,
        TError,
        {tenant: string;id: string;data: CompleteTaskSignOtpInput},
        TContext
      > => {
      return useMutation(getSignAndCompleteTaskOtpMutationOptions(options), queryClient);
    }

export type resendOtpTaskResponse204 = {
  data: void
  status: 204
}

export type resendOtpTaskResponseSuccess = (resendOtpTaskResponse204) & {
  headers: Headers;
};
;

export type resendOtpTaskResponse = (resendOtpTaskResponseSuccess)

export const getResendOtpTaskUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/resend-otp`
}

/**
 * @summary Reenvia código OTP para os assinantes
 */
export const resendOtpTask = async (tenant: string,
    id: string,
    resendOtpTaskInput: ResendOtpTaskInput, options?: RequestInit): Promise<resendOtpTaskResponse> => {

  return customInstanceBpm<resendOtpTaskResponse>(getResendOtpTaskUrl(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resendOtpTaskInput)
  }
);}




export const getResendOtpTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOtpTask>>, TError,{tenant: string;id: string;data: ResendOtpTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof resendOtpTask>>, TError,{tenant: string;id: string;data: ResendOtpTaskInput}, TContext> => {

const mutationKey = ['resendOtpTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendOtpTask>>, {tenant: string;id: string;data: ResendOtpTaskInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  resendOtpTask(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendOtpTaskMutationResult = NonNullable<Awaited<ReturnType<typeof resendOtpTask>>>
    export type ResendOtpTaskMutationBody = ResendOtpTaskInput
    export type ResendOtpTaskMutationError = unknown

    /**
 * @summary Reenvia código OTP para os assinantes
 */
export const useResendOtpTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOtpTask>>, TError,{tenant: string;id: string;data: ResendOtpTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendOtpTask>>,
        TError,
        {tenant: string;id: string;data: ResendOtpTaskInput},
        TContext
      > => {
      return useMutation(getResendOtpTaskMutationOptions(options), queryClient);
    }

export type forceCancelTaskResponse204 = {
  data: void
  status: 204
}

export type forceCancelTaskResponseSuccess = (forceCancelTaskResponse204) & {
  headers: Headers;
};
;

export type forceCancelTaskResponse = (forceCancelTaskResponseSuccess)

export const getForceCancelTaskUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/force-cancel`
}

/**
 * @summary Forçar cancelamento de uma tarefa
 */
export const forceCancelTask = async (tenant: string,
    id: string,
    forceCancelInput: ForceCancelInput, options?: RequestInit): Promise<forceCancelTaskResponse> => {

  return customInstanceBpm<forceCancelTaskResponse>(getForceCancelTaskUrl(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forceCancelInput)
  }
);}




export const getForceCancelTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceCancelTask>>, TError,{tenant: string;id: string;data: ForceCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof forceCancelTask>>, TError,{tenant: string;id: string;data: ForceCancelInput}, TContext> => {

const mutationKey = ['forceCancelTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forceCancelTask>>, {tenant: string;id: string;data: ForceCancelInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  forceCancelTask(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForceCancelTaskMutationResult = NonNullable<Awaited<ReturnType<typeof forceCancelTask>>>
    export type ForceCancelTaskMutationBody = ForceCancelInput
    export type ForceCancelTaskMutationError = unknown

    /**
 * @summary Forçar cancelamento de uma tarefa
 */
export const useForceCancelTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceCancelTask>>, TError,{tenant: string;id: string;data: ForceCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forceCancelTask>>,
        TError,
        {tenant: string;id: string;data: ForceCancelInput},
        TContext
      > => {
      return useMutation(getForceCancelTaskMutationOptions(options), queryClient);
    }

export type completeTaskV2Response204 = {
  data: void
  status: 204
}

export type completeTaskV2ResponseSuccess = (completeTaskV2Response204) & {
  headers: Headers;
};
;

export type completeTaskV2Response = (completeTaskV2ResponseSuccess)

export const getCompleteTaskV2Url = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/complete`
}

/**
 * @summary Conclui tarefa por ID
 */
export const completeTaskV2 = async (tenant: string,
    id: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<completeTaskV2Response> => {

  return customInstanceBpm<completeTaskV2Response>(getCompleteTaskV2Url(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getCompleteTaskV2MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTaskV2>>, TError,{tenant: string;id: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTaskV2>>, TError,{tenant: string;id: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['completeTaskV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTaskV2>>, {tenant: string;id: string;data: CompleteTaskInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  completeTaskV2(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTaskV2MutationResult = NonNullable<Awaited<ReturnType<typeof completeTaskV2>>>
    export type CompleteTaskV2MutationBody = CompleteTaskInput
    export type CompleteTaskV2MutationError = unknown

    /**
 * @summary Conclui tarefa por ID
 */
export const useCompleteTaskV2 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTaskV2>>, TError,{tenant: string;id: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeTaskV2>>,
        TError,
        {tenant: string;id: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getCompleteTaskV2MutationOptions(options), queryClient);
    }

export type generateAndDownloadStorageReportResponse201 = {
  data: string
  status: 201
}

export type generateAndDownloadStorageReportResponseSuccess = (generateAndDownloadStorageReportResponse201) & {
  headers: Headers;
};
;

export type generateAndDownloadStorageReportResponse = (generateAndDownloadStorageReportResponseSuccess)

export const getGenerateAndDownloadStorageReportUrl = (tenant: string,
    params?: GenerateAndDownloadStorageReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/storage/reports/generate-and-download?${stringifiedParams}` : `/v1/${tenant}/storage/reports/generate-and-download`
}

/**
 * @summary Gera e faz download de um relatório de consumo de dados
 */
export const generateAndDownloadStorageReport = async (tenant: string,
    generateStorageReportRequestDto: GenerateStorageReportRequestDto,
    params?: GenerateAndDownloadStorageReportParams, options?: RequestInit): Promise<generateAndDownloadStorageReportResponse> => {

  return customInstanceBpm<generateAndDownloadStorageReportResponse>(getGenerateAndDownloadStorageReportUrl(tenant,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateStorageReportRequestDto)
  }
);}




export const getGenerateAndDownloadStorageReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAndDownloadStorageReport>>, TError,{tenant: string;data: GenerateStorageReportRequestDto;params?: GenerateAndDownloadStorageReportParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof generateAndDownloadStorageReport>>, TError,{tenant: string;data: GenerateStorageReportRequestDto;params?: GenerateAndDownloadStorageReportParams}, TContext> => {

const mutationKey = ['generateAndDownloadStorageReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateAndDownloadStorageReport>>, {tenant: string;data: GenerateStorageReportRequestDto;params?: GenerateAndDownloadStorageReportParams}> = (props) => {
          const {tenant,data,params} = props ?? {};

          return  generateAndDownloadStorageReport(tenant,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateAndDownloadStorageReportMutationResult = NonNullable<Awaited<ReturnType<typeof generateAndDownloadStorageReport>>>
    export type GenerateAndDownloadStorageReportMutationBody = GenerateStorageReportRequestDto
    export type GenerateAndDownloadStorageReportMutationError = unknown

    /**
 * @summary Gera e faz download de um relatório de consumo de dados
 */
export const useGenerateAndDownloadStorageReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAndDownloadStorageReport>>, TError,{tenant: string;data: GenerateStorageReportRequestDto;params?: GenerateAndDownloadStorageReportParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateAndDownloadStorageReport>>,
        TError,
        {tenant: string;data: GenerateStorageReportRequestDto;params?: GenerateAndDownloadStorageReportParams},
        TContext
      > => {
      return useMutation(getGenerateAndDownloadStorageReportMutationOptions(options), queryClient);
    }

export type listScanningProfileResponse200 = {
  data: PageScanningProfileDto
  status: 200
}

export type listScanningProfileResponseSuccess = (listScanningProfileResponse200) & {
  headers: Headers;
};
;

export type listScanningProfileResponse = (listScanningProfileResponseSuccess)

export const getListScanningProfileUrl = (tenant: string,
    params?: ListScanningProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/scanning-profiles?${stringifiedParams}` : `/v1/${tenant}/scanning-profiles`
}

/**
 * @summary Lista os perfis de digitalização
 */
export const listScanningProfile = async (tenant: string,
    params?: ListScanningProfileParams, options?: RequestInit): Promise<listScanningProfileResponse> => {

  return customInstanceBpm<listScanningProfileResponse>(getListScanningProfileUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScanningProfileQueryKey = (tenant: string,
    params?: ListScanningProfileParams,) => {
    return [
    `/v1/${tenant}/scanning-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScanningProfileQueryOptions = <TData = Awaited<ReturnType<typeof listScanningProfile>>, TError = unknown>(tenant: string,
    params?: ListScanningProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScanningProfileQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScanningProfile>>> = ({ signal }) => listScanningProfile(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScanningProfileQueryResult = NonNullable<Awaited<ReturnType<typeof listScanningProfile>>>
export type ListScanningProfileQueryError = unknown


export function useListScanningProfile<TData = Awaited<ReturnType<typeof listScanningProfile>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListScanningProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScanningProfile>>,
          TError,
          Awaited<ReturnType<typeof listScanningProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScanningProfile<TData = Awaited<ReturnType<typeof listScanningProfile>>, TError = unknown>(
 tenant: string,
    params?: ListScanningProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScanningProfile>>,
          TError,
          Awaited<ReturnType<typeof listScanningProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScanningProfile<TData = Awaited<ReturnType<typeof listScanningProfile>>, TError = unknown>(
 tenant: string,
    params?: ListScanningProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os perfis de digitalização
 */

export function useListScanningProfile<TData = Awaited<ReturnType<typeof listScanningProfile>>, TError = unknown>(
 tenant: string,
    params?: ListScanningProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScanningProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScanningProfileQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createScanningProfileResponse201 = {
  data: ScanningProfileDto
  status: 201
}

export type createScanningProfileResponseSuccess = (createScanningProfileResponse201) & {
  headers: Headers;
};
;

export type createScanningProfileResponse = (createScanningProfileResponseSuccess)

export const getCreateScanningProfileUrl = (tenant: string,) => {




  return `/v1/${tenant}/scanning-profiles`
}

/**
 * @summary Cria um perfil de digitalização
 */
export const createScanningProfile = async (tenant: string,
    scanningProfileInputCreate: ScanningProfileInputCreate, options?: RequestInit): Promise<createScanningProfileResponse> => {

  return customInstanceBpm<createScanningProfileResponse>(getCreateScanningProfileUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scanningProfileInputCreate)
  }
);}




export const getCreateScanningProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScanningProfile>>, TError,{tenant: string;data: ScanningProfileInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createScanningProfile>>, TError,{tenant: string;data: ScanningProfileInputCreate}, TContext> => {

const mutationKey = ['createScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScanningProfile>>, {tenant: string;data: ScanningProfileInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createScanningProfile(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createScanningProfile>>>
    export type CreateScanningProfileMutationBody = ScanningProfileInputCreate
    export type CreateScanningProfileMutationError = unknown

    /**
 * @summary Cria um perfil de digitalização
 */
export const useCreateScanningProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScanningProfile>>, TError,{tenant: string;data: ScanningProfileInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScanningProfile>>,
        TError,
        {tenant: string;data: ScanningProfileInputCreate},
        TContext
      > => {
      return useMutation(getCreateScanningProfileMutationOptions(options), queryClient);
    }

export type cloneScanningProfileResponse200 = {
  data: ScanningProfileDto
  status: 200
}

export type cloneScanningProfileResponse201 = {
  data: ScanningProfileDto
  status: 201
}

export type cloneScanningProfileResponse404 = {
  data: Problem
  status: 404
}

export type cloneScanningProfileResponseSuccess = (cloneScanningProfileResponse200 | cloneScanningProfileResponse201) & {
  headers: Headers;
};
export type cloneScanningProfileResponseError = (cloneScanningProfileResponse404) & {
  headers: Headers;
};

export type cloneScanningProfileResponse = (cloneScanningProfileResponseSuccess | cloneScanningProfileResponseError)

export const getCloneScanningProfileUrl = (tenant: string,
    scanningProfileId: number,) => {




  return `/v1/${tenant}/scanning-profiles/${scanningProfileId}/clone`
}

/**
 * @summary Clona um perfil de digitalização por ID
 */
export const cloneScanningProfile = async (tenant: string,
    scanningProfileId: number,
    scanningProfileInputClone: ScanningProfileInputClone, options?: RequestInit): Promise<cloneScanningProfileResponse> => {

  return customInstanceBpm<cloneScanningProfileResponse>(getCloneScanningProfileUrl(tenant,scanningProfileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scanningProfileInputClone)
  }
);}




export const getCloneScanningProfileMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputClone}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputClone}, TContext> => {

const mutationKey = ['cloneScanningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneScanningProfile>>, {tenant: string;scanningProfileId: number;data: ScanningProfileInputClone}> = (props) => {
          const {tenant,scanningProfileId,data} = props ?? {};

          return  cloneScanningProfile(tenant,scanningProfileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneScanningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof cloneScanningProfile>>>
    export type CloneScanningProfileMutationBody = ScanningProfileInputClone
    export type CloneScanningProfileMutationError = Problem

    /**
 * @summary Clona um perfil de digitalização por ID
 */
export const useCloneScanningProfile = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneScanningProfile>>, TError,{tenant: string;scanningProfileId: number;data: ScanningProfileInputClone}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneScanningProfile>>,
        TError,
        {tenant: string;scanningProfileId: number;data: ScanningProfileInputClone},
        TContext
      > => {
      return useMutation(getCloneScanningProfileMutationOptions(options), queryClient);
    }

export type forceCancelProcessInstanceResponse204 = {
  data: void
  status: 204
}

export type forceCancelProcessInstanceResponseSuccess = (forceCancelProcessInstanceResponse204) & {
  headers: Headers;
};
;

export type forceCancelProcessInstanceResponse = (forceCancelProcessInstanceResponseSuccess)

export const getForceCancelProcessInstanceUrl = (tenant: string,
    processInstanceId: string,) => {




  return `/v1/${tenant}/process-instances/${processInstanceId}/force-cancel`
}

/**
 * @summary Forçar cancelamento de um processo
 */
export const forceCancelProcessInstance = async (tenant: string,
    processInstanceId: string,
    forceCancelInput: ForceCancelInput, options?: RequestInit): Promise<forceCancelProcessInstanceResponse> => {

  return customInstanceBpm<forceCancelProcessInstanceResponse>(getForceCancelProcessInstanceUrl(tenant,processInstanceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forceCancelInput)
  }
);}




export const getForceCancelProcessInstanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceCancelProcessInstance>>, TError,{tenant: string;processInstanceId: string;data: ForceCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof forceCancelProcessInstance>>, TError,{tenant: string;processInstanceId: string;data: ForceCancelInput}, TContext> => {

const mutationKey = ['forceCancelProcessInstance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forceCancelProcessInstance>>, {tenant: string;processInstanceId: string;data: ForceCancelInput}> = (props) => {
          const {tenant,processInstanceId,data} = props ?? {};

          return  forceCancelProcessInstance(tenant,processInstanceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForceCancelProcessInstanceMutationResult = NonNullable<Awaited<ReturnType<typeof forceCancelProcessInstance>>>
    export type ForceCancelProcessInstanceMutationBody = ForceCancelInput
    export type ForceCancelProcessInstanceMutationError = unknown

    /**
 * @summary Forçar cancelamento de um processo
 */
export const useForceCancelProcessInstance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceCancelProcessInstance>>, TError,{tenant: string;processInstanceId: string;data: ForceCancelInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forceCancelProcessInstance>>,
        TError,
        {tenant: string;processInstanceId: string;data: ForceCancelInput},
        TContext
      > => {
      return useMutation(getForceCancelProcessInstanceMutationOptions(options), queryClient);
    }

export type startProcessByProcessDefinitionIdResponse200 = {
  data: ProcessInstanceDto
  status: 200
}

export type startProcessByProcessDefinitionIdResponseSuccess = (startProcessByProcessDefinitionIdResponse200) & {
  headers: Headers;
};
;

export type startProcessByProcessDefinitionIdResponse = (startProcessByProcessDefinitionIdResponseSuccess)

export const getStartProcessByProcessDefinitionIdUrl = (tenant: string,
    processDefinitionId: string,) => {




  return `/v1/${tenant}/process-definitions/${processDefinitionId}/start`
}

/**
 * @summary Inicia uma instância de processo por ID
 */
export const startProcessByProcessDefinitionId = async (tenant: string,
    processDefinitionId: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<startProcessByProcessDefinitionIdResponse> => {

  return customInstanceBpm<startProcessByProcessDefinitionIdResponse>(getStartProcessByProcessDefinitionIdUrl(tenant,processDefinitionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getStartProcessByProcessDefinitionIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>, TError,{tenant: string;processDefinitionId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>, TError,{tenant: string;processDefinitionId: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['startProcessByProcessDefinitionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>, {tenant: string;processDefinitionId: string;data: CompleteTaskInput}> = (props) => {
          const {tenant,processDefinitionId,data} = props ?? {};

          return  startProcessByProcessDefinitionId(tenant,processDefinitionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProcessByProcessDefinitionIdMutationResult = NonNullable<Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>>
    export type StartProcessByProcessDefinitionIdMutationBody = CompleteTaskInput
    export type StartProcessByProcessDefinitionIdMutationError = unknown

    /**
 * @summary Inicia uma instância de processo por ID
 */
export const useStartProcessByProcessDefinitionId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>, TError,{tenant: string;processDefinitionId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startProcessByProcessDefinitionId>>,
        TError,
        {tenant: string;processDefinitionId: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getStartProcessByProcessDefinitionIdMutationOptions(options), queryClient);
    }

export type startProcessByProcessDefinitionKeyResponse200 = {
  data: ProcessInstanceDto
  status: 200
}

export type startProcessByProcessDefinitionKeyResponseSuccess = (startProcessByProcessDefinitionKeyResponse200) & {
  headers: Headers;
};
;

export type startProcessByProcessDefinitionKeyResponse = (startProcessByProcessDefinitionKeyResponseSuccess)

export const getStartProcessByProcessDefinitionKeyUrl = (tenant: string,
    processDefinitionKey: string,) => {




  return `/v1/${tenant}/process-definitions/key/${processDefinitionKey}/start`
}

/**
 * @summary Inicia uma instância de processo pela chave
 */
export const startProcessByProcessDefinitionKey = async (tenant: string,
    processDefinitionKey: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<startProcessByProcessDefinitionKeyResponse> => {

  return customInstanceBpm<startProcessByProcessDefinitionKeyResponse>(getStartProcessByProcessDefinitionKeyUrl(tenant,processDefinitionKey),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getStartProcessByProcessDefinitionKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>, TError,{tenant: string;processDefinitionKey: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>, TError,{tenant: string;processDefinitionKey: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['startProcessByProcessDefinitionKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>, {tenant: string;processDefinitionKey: string;data: CompleteTaskInput}> = (props) => {
          const {tenant,processDefinitionKey,data} = props ?? {};

          return  startProcessByProcessDefinitionKey(tenant,processDefinitionKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProcessByProcessDefinitionKeyMutationResult = NonNullable<Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>>
    export type StartProcessByProcessDefinitionKeyMutationBody = CompleteTaskInput
    export type StartProcessByProcessDefinitionKeyMutationError = unknown

    /**
 * @summary Inicia uma instância de processo pela chave
 */
export const useStartProcessByProcessDefinitionKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>, TError,{tenant: string;processDefinitionKey: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startProcessByProcessDefinitionKey>>,
        TError,
        {tenant: string;processDefinitionKey: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getStartProcessByProcessDefinitionKeyMutationOptions(options), queryClient);
    }

export type listProcessDefinitionDraftResponse200 = {
  data: PageProcessDefinitionDraftDto
  status: 200
}

export type listProcessDefinitionDraftResponseSuccess = (listProcessDefinitionDraftResponse200) & {
  headers: Headers;
};
;

export type listProcessDefinitionDraftResponse = (listProcessDefinitionDraftResponseSuccess)

export const getListProcessDefinitionDraftUrl = (tenant: string,
    params?: ListProcessDefinitionDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definition-drafts?${stringifiedParams}` : `/v1/${tenant}/process-definition-drafts`
}

/**
 * @summary Lista os rascunhos
 */
export const listProcessDefinitionDraft = async (tenant: string,
    params?: ListProcessDefinitionDraftParams, options?: RequestInit): Promise<listProcessDefinitionDraftResponse> => {

  return customInstanceBpm<listProcessDefinitionDraftResponse>(getListProcessDefinitionDraftUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessDefinitionDraftQueryKey = (tenant: string,
    params?: ListProcessDefinitionDraftParams,) => {
    return [
    `/v1/${tenant}/process-definition-drafts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessDefinitionDraftQueryOptions = <TData = Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError = unknown>(tenant: string,
    params?: ListProcessDefinitionDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessDefinitionDraftQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessDefinitionDraft>>> = ({ signal }) => listProcessDefinitionDraft(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessDefinitionDraftQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessDefinitionDraft>>>
export type ListProcessDefinitionDraftQueryError = unknown


export function useListProcessDefinitionDraft<TData = Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListProcessDefinitionDraftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitionDraft<TData = Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitionDraft<TData = Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os rascunhos
 */

export function useListProcessDefinitionDraft<TData = Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessDefinitionDraftQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createProcessDefinitionDraftResponse201 = {
  data: ProcessDefinitionDraftDto
  status: 201
}

export type createProcessDefinitionDraftResponse404 = {
  data: Problem
  status: 404
}

export type createProcessDefinitionDraftResponseSuccess = (createProcessDefinitionDraftResponse201) & {
  headers: Headers;
};
export type createProcessDefinitionDraftResponseError = (createProcessDefinitionDraftResponse404) & {
  headers: Headers;
};

export type createProcessDefinitionDraftResponse = (createProcessDefinitionDraftResponseSuccess | createProcessDefinitionDraftResponseError)

export const getCreateProcessDefinitionDraftUrl = (tenant: string,) => {




  return `/v1/${tenant}/process-definition-drafts`
}

/**
 * @summary Cria um rascunho
 */
export const createProcessDefinitionDraft = async (tenant: string,
    createProcessDefinitionDraftBody?: CreateProcessDefinitionDraftBody, options?: RequestInit): Promise<createProcessDefinitionDraftResponse> => {
    const formData = new FormData();
if(createProcessDefinitionDraftBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(createProcessDefinitionDraftBody.input));
 }
if(createProcessDefinitionDraftBody?.diagram !== undefined) {
 formData.append(`diagram`, createProcessDefinitionDraftBody.diagram);
 }

  return customInstanceBpm<createProcessDefinitionDraftResponse>(getCreateProcessDefinitionDraftUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateProcessDefinitionDraftMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProcessDefinitionDraft>>, TError,{tenant: string;data?: CreateProcessDefinitionDraftBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createProcessDefinitionDraft>>, TError,{tenant: string;data?: CreateProcessDefinitionDraftBody}, TContext> => {

const mutationKey = ['createProcessDefinitionDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProcessDefinitionDraft>>, {tenant: string;data?: CreateProcessDefinitionDraftBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createProcessDefinitionDraft(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProcessDefinitionDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createProcessDefinitionDraft>>>
    export type CreateProcessDefinitionDraftMutationBody = CreateProcessDefinitionDraftBody | undefined
    export type CreateProcessDefinitionDraftMutationError = Problem

    /**
 * @summary Cria um rascunho
 */
export const useCreateProcessDefinitionDraft = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProcessDefinitionDraft>>, TError,{tenant: string;data?: CreateProcessDefinitionDraftBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProcessDefinitionDraft>>,
        TError,
        {tenant: string;data?: CreateProcessDefinitionDraftBody},
        TContext
      > => {
      return useMutation(getCreateProcessDefinitionDraftMutationOptions(options), queryClient);
    }

export type resendPasswordPortalExternoResponse204 = {
  data: void
  status: 204
}

export type resendPasswordPortalExternoResponseSuccess = (resendPasswordPortalExternoResponse204) & {
  headers: Headers;
};
;

export type resendPasswordPortalExternoResponse = (resendPasswordPortalExternoResponseSuccess)

export const getResendPasswordPortalExternoUrl = (tenant: string,
    userId: number,) => {




  return `/v1/${tenant}/portal-externo/users/${userId}/resend-password`
}

/**
 * @summary Reenvia e-mail de redefinição de senha do usuário do portal externo
 */
export const resendPasswordPortalExterno = async (tenant: string,
    userId: number, options?: RequestInit): Promise<resendPasswordPortalExternoResponse> => {

  return customInstanceBpm<resendPasswordPortalExternoResponse>(getResendPasswordPortalExternoUrl(tenant,userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendPasswordPortalExternoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPasswordPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof resendPasswordPortalExterno>>, TError,{tenant: string;userId: number}, TContext> => {

const mutationKey = ['resendPasswordPortalExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendPasswordPortalExterno>>, {tenant: string;userId: number}> = (props) => {
          const {tenant,userId} = props ?? {};

          return  resendPasswordPortalExterno(tenant,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendPasswordPortalExternoMutationResult = NonNullable<Awaited<ReturnType<typeof resendPasswordPortalExterno>>>

    export type ResendPasswordPortalExternoMutationError = unknown

    /**
 * @summary Reenvia e-mail de redefinição de senha do usuário do portal externo
 */
export const useResendPasswordPortalExterno = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPasswordPortalExterno>>, TError,{tenant: string;userId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendPasswordPortalExterno>>,
        TError,
        {tenant: string;userId: number},
        TContext
      > => {
      return useMutation(getResendPasswordPortalExternoMutationOptions(options), queryClient);
    }

export type listAllOrganizationResponse200 = {
  data: OrganizationDto[]
  status: 200
}

export type listAllOrganizationResponseSuccess = (listAllOrganizationResponse200) & {
  headers: Headers;
};
;

export type listAllOrganizationResponse = (listAllOrganizationResponseSuccess)

export const getListAllOrganizationUrl = (tenant: string,) => {




  return `/v1/${tenant}/organizations`
}

/**
 * @summary Lista as organizações do tenant
 */
export const listAllOrganization = async (tenant: string, options?: RequestInit): Promise<listAllOrganizationResponse> => {

  return customInstanceBpm<listAllOrganizationResponse>(getListAllOrganizationUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllOrganizationQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/organizations`
    ] as const;
    }


export const getListAllOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof listAllOrganization>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllOrganizationQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllOrganization>>> = ({ signal }) => listAllOrganization(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof listAllOrganization>>>
export type ListAllOrganizationQueryError = unknown


export function useListAllOrganization<TData = Awaited<ReturnType<typeof listAllOrganization>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllOrganization>>,
          TError,
          Awaited<ReturnType<typeof listAllOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllOrganization<TData = Awaited<ReturnType<typeof listAllOrganization>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllOrganization>>,
          TError,
          Awaited<ReturnType<typeof listAllOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllOrganization<TData = Awaited<ReturnType<typeof listAllOrganization>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as organizações do tenant
 */

export function useListAllOrganization<TData = Awaited<ReturnType<typeof listAllOrganization>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllOrganizationQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createOrganizationResponse201 = {
  data: OrganizationDto
  status: 201
}

export type createOrganizationResponseSuccess = (createOrganizationResponse201) & {
  headers: Headers;
};
;

export type createOrganizationResponse = (createOrganizationResponseSuccess)

export const getCreateOrganizationUrl = (tenant: string,) => {




  return `/v1/${tenant}/organizations`
}

/**
 * @summary Cria uma organização (sub-tenant)
 */
export const createOrganization = async (tenant: string,
    organizationInputCreate: OrganizationInputCreate, options?: RequestInit): Promise<createOrganizationResponse> => {

  return customInstanceBpm<createOrganizationResponse>(getCreateOrganizationUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(organizationInputCreate)
  }
);}




export const getCreateOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{tenant: string;data: OrganizationInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{tenant: string;data: OrganizationInputCreate}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {tenant: string;data: OrganizationInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createOrganization(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = OrganizationInputCreate
    export type CreateOrganizationMutationError = unknown

    /**
 * @summary Cria uma organização (sub-tenant)
 */
export const useCreateOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{tenant: string;data: OrganizationInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {tenant: string;data: OrganizationInputCreate},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
    }

export type listNotificationCenterResponse200 = {
  data: PageNotificationCenterDto
  status: 200
}

export type listNotificationCenterResponseSuccess = (listNotificationCenterResponse200) & {
  headers: Headers;
};
;

export type listNotificationCenterResponse = (listNotificationCenterResponseSuccess)

export const getListNotificationCenterUrl = (tenant: string,
    params?: ListNotificationCenterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/notification-center/notifications?${stringifiedParams}` : `/v1/${tenant}/notification-center/notifications`
}

/**
 * @summary Lista notificacoes do usuario logado
 */
export const listNotificationCenter = async (tenant: string,
    params?: ListNotificationCenterParams, options?: RequestInit): Promise<listNotificationCenterResponse> => {

  return customInstanceBpm<listNotificationCenterResponse>(getListNotificationCenterUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationCenterQueryKey = (tenant: string,
    params?: ListNotificationCenterParams,) => {
    return [
    `/v1/${tenant}/notification-center/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationCenterQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationCenter>>, TError = unknown>(tenant: string,
    params?: ListNotificationCenterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationCenterQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationCenter>>> = ({ signal }) => listNotificationCenter(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationCenterQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationCenter>>>
export type ListNotificationCenterQueryError = unknown


export function useListNotificationCenter<TData = Awaited<ReturnType<typeof listNotificationCenter>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListNotificationCenterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationCenter>>,
          TError,
          Awaited<ReturnType<typeof listNotificationCenter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationCenter<TData = Awaited<ReturnType<typeof listNotificationCenter>>, TError = unknown>(
 tenant: string,
    params?: ListNotificationCenterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotificationCenter>>,
          TError,
          Awaited<ReturnType<typeof listNotificationCenter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotificationCenter<TData = Awaited<ReturnType<typeof listNotificationCenter>>, TError = unknown>(
 tenant: string,
    params?: ListNotificationCenterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista notificacoes do usuario logado
 */

export function useListNotificationCenter<TData = Awaited<ReturnType<typeof listNotificationCenter>>, TError = unknown>(
 tenant: string,
    params?: ListNotificationCenterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationCenterQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createNotificationCenterResponse200 = {
  data: NotificationCenterDto
  status: 200
}

export type createNotificationCenterResponseSuccess = (createNotificationCenterResponse200) & {
  headers: Headers;
};
;

export type createNotificationCenterResponse = (createNotificationCenterResponseSuccess)

export const getCreateNotificationCenterUrl = (tenant: string,) => {




  return `/v1/${tenant}/notification-center/notifications`
}

/**
 * @summary Cria notificacao para usuarios especificos
 */
export const createNotificationCenter = async (tenant: string,
    notificationCenterCreateRequest: NotificationCenterCreateRequest, options?: RequestInit): Promise<createNotificationCenterResponse> => {

  return customInstanceBpm<createNotificationCenterResponse>(getCreateNotificationCenterUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationCenterCreateRequest)
  }
);}




export const getCreateNotificationCenterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationCenter>>, TError,{tenant: string;data: NotificationCenterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotificationCenter>>, TError,{tenant: string;data: NotificationCenterCreateRequest}, TContext> => {

const mutationKey = ['createNotificationCenter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotificationCenter>>, {tenant: string;data: NotificationCenterCreateRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createNotificationCenter(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationCenterMutationResult = NonNullable<Awaited<ReturnType<typeof createNotificationCenter>>>
    export type CreateNotificationCenterMutationBody = NotificationCenterCreateRequest
    export type CreateNotificationCenterMutationError = unknown

    /**
 * @summary Cria notificacao para usuarios especificos
 */
export const useCreateNotificationCenter = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationCenter>>, TError,{tenant: string;data: NotificationCenterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotificationCenter>>,
        TError,
        {tenant: string;data: NotificationCenterCreateRequest},
        TContext
      > => {
      return useMutation(getCreateNotificationCenterMutationOptions(options), queryClient);
    }

export type deleteAllNotificationCenterResponse204 = {
  data: void
  status: 204
}

export type deleteAllNotificationCenterResponseSuccess = (deleteAllNotificationCenterResponse204) & {
  headers: Headers;
};
;

export type deleteAllNotificationCenterResponse = (deleteAllNotificationCenterResponseSuccess)

export const getDeleteAllNotificationCenterUrl = (tenant: string,) => {




  return `/v1/${tenant}/notification-center/notifications`
}

/**
 * @summary Exclui todas as notificacoes do usuario logado
 */
export const deleteAllNotificationCenter = async (tenant: string, options?: RequestInit): Promise<deleteAllNotificationCenterResponse> => {

  return customInstanceBpm<deleteAllNotificationCenterResponse>(getDeleteAllNotificationCenterUrl(tenant),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAllNotificationCenterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllNotificationCenter>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAllNotificationCenter>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['deleteAllNotificationCenter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAllNotificationCenter>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  deleteAllNotificationCenter(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAllNotificationCenterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAllNotificationCenter>>>

    export type DeleteAllNotificationCenterMutationError = unknown

    /**
 * @summary Exclui todas as notificacoes do usuario logado
 */
export const useDeleteAllNotificationCenter = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAllNotificationCenter>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAllNotificationCenter>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getDeleteAllNotificationCenterMutationOptions(options), queryClient);
    }

export type setNupIdResponse200 = {
  data: void
  status: 200
}

export type setNupIdResponseSuccess = (setNupIdResponse200) & {
  headers: Headers;
};
;

export type setNupIdResponse = (setNupIdResponseSuccess)

export const getSetNupIdUrl = (tenant: string,
    processInstanceId: string,) => {




  return `/v1/${tenant}/new-nup/${processInstanceId}`
}

/**
 * @summary Vincula um processId a uma nup caso ainda não tenha vinculo
 */
export const setNupId = async (tenant: string,
    processInstanceId: string, options?: RequestInit): Promise<setNupIdResponse> => {

  return customInstanceBpm<setNupIdResponse>(getSetNupIdUrl(tenant,processInstanceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSetNupIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNupId>>, TError,{tenant: string;processInstanceId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof setNupId>>, TError,{tenant: string;processInstanceId: string}, TContext> => {

const mutationKey = ['setNupId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setNupId>>, {tenant: string;processInstanceId: string}> = (props) => {
          const {tenant,processInstanceId} = props ?? {};

          return  setNupId(tenant,processInstanceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetNupIdMutationResult = NonNullable<Awaited<ReturnType<typeof setNupId>>>

    export type SetNupIdMutationError = unknown

    /**
 * @summary Vincula um processId a uma nup caso ainda não tenha vinculo
 */
export const useSetNupId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNupId>>, TError,{tenant: string;processInstanceId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setNupId>>,
        TError,
        {tenant: string;processInstanceId: string},
        TContext
      > => {
      return useMutation(getSetNupIdMutationOptions(options), queryClient);
    }

export type listGroupResponse200 = {
  data: PageSmartGroupDto
  status: 200
}

export type listGroupResponseSuccess = (listGroupResponse200) & {
  headers: Headers;
};
;

export type listGroupResponse = (listGroupResponseSuccess)

export const getListGroupUrl = (tenant: string,
    params?: ListGroupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/groups?${stringifiedParams}` : `/v1/${tenant}/groups`
}

/**
 * @summary Lista os grupos
 */
export const listGroup = async (tenant: string,
    params?: ListGroupParams, options?: RequestInit): Promise<listGroupResponse> => {

  return customInstanceBpm<listGroupResponse>(getListGroupUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGroupQueryKey = (tenant: string,
    params?: ListGroupParams,) => {
    return [
    `/v1/${tenant}/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGroupQueryOptions = <TData = Awaited<ReturnType<typeof listGroup>>, TError = unknown>(tenant: string,
    params?: ListGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroup>>> = ({ signal }) => listGroup(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupQueryResult = NonNullable<Awaited<ReturnType<typeof listGroup>>>
export type ListGroupQueryError = unknown


export function useListGroup<TData = Awaited<ReturnType<typeof listGroup>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroup>>,
          TError,
          Awaited<ReturnType<typeof listGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroup<TData = Awaited<ReturnType<typeof listGroup>>, TError = unknown>(
 tenant: string,
    params?: ListGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroup>>,
          TError,
          Awaited<ReturnType<typeof listGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroup<TData = Awaited<ReturnType<typeof listGroup>>, TError = unknown>(
 tenant: string,
    params?: ListGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os grupos
 */

export function useListGroup<TData = Awaited<ReturnType<typeof listGroup>>, TError = unknown>(
 tenant: string,
    params?: ListGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createGroupResponse201 = {
  data: SmartGroupWitlAllPropertiesDto
  status: 201
}

export type createGroupResponseSuccess = (createGroupResponse201) & {
  headers: Headers;
};
;

export type createGroupResponse = (createGroupResponseSuccess)

export const getCreateGroupUrl = (tenant: string,) => {




  return `/v1/${tenant}/groups`
}

/**
 * @summary Cria um grupo
 */
export const createGroup = async (tenant: string,
    smartGroupInputCreate: SmartGroupInputCreate, options?: RequestInit): Promise<createGroupResponse> => {

  return customInstanceBpm<createGroupResponse>(getCreateGroupUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartGroupInputCreate)
  }
);}




export const getCreateGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{tenant: string;data: SmartGroupInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{tenant: string;data: SmartGroupInputCreate}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {tenant: string;data: SmartGroupInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createGroup(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = SmartGroupInputCreate
    export type CreateGroupMutationError = unknown

    /**
 * @summary Cria um grupo
 */
export const useCreateGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{tenant: string;data: SmartGroupInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {tenant: string;data: SmartGroupInputCreate},
        TContext
      > => {
      return useMutation(getCreateGroupMutationOptions(options), queryClient);
    }

export type listEmailTemplateResponse200 = {
  data: EmailTemplateDto[]
  status: 200
}

export type listEmailTemplateResponseSuccess = (listEmailTemplateResponse200) & {
  headers: Headers;
};
;

export type listEmailTemplateResponse = (listEmailTemplateResponseSuccess)

export const getListEmailTemplateUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-templates`
}

/**
 * @summary Lista os templates de email
 */
export const listEmailTemplate = async (tenant: string, options?: RequestInit): Promise<listEmailTemplateResponse> => {

  return customInstanceBpm<listEmailTemplateResponse>(getListEmailTemplateUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailTemplateQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/email-templates`
    ] as const;
    }


export const getListEmailTemplateQueryOptions = <TData = Awaited<ReturnType<typeof listEmailTemplate>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailTemplateQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailTemplate>>> = ({ signal }) => listEmailTemplate(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmailTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailTemplate>>>
export type ListEmailTemplateQueryError = unknown


export function useListEmailTemplate<TData = Awaited<ReturnType<typeof listEmailTemplate>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof listEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailTemplate<TData = Awaited<ReturnType<typeof listEmailTemplate>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof listEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmailTemplate<TData = Awaited<ReturnType<typeof listEmailTemplate>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os templates de email
 */

export function useListEmailTemplate<TData = Awaited<ReturnType<typeof listEmailTemplate>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmailTemplateQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createEmailTemplateResponse200 = {
  data: EmailTemplateDto
  status: 200
}

export type createEmailTemplateResponseSuccess = (createEmailTemplateResponse200) & {
  headers: Headers;
};
;

export type createEmailTemplateResponse = (createEmailTemplateResponseSuccess)

export const getCreateEmailTemplateUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-templates`
}

/**
 * @summary Cria template de email
 */
export const createEmailTemplate = async (tenant: string,
    emailTemplateCreateRequest: EmailTemplateCreateRequest, options?: RequestInit): Promise<createEmailTemplateResponse> => {

  return customInstanceBpm<createEmailTemplateResponse>(getCreateEmailTemplateUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailTemplateCreateRequest)
  }
);}




export const getCreateEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{tenant: string;data: EmailTemplateCreateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{tenant: string;data: EmailTemplateCreateRequest}, TContext> => {

const mutationKey = ['createEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailTemplate>>, {tenant: string;data: EmailTemplateCreateRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createEmailTemplate(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailTemplate>>>
    export type CreateEmailTemplateMutationBody = EmailTemplateCreateRequest
    export type CreateEmailTemplateMutationError = unknown

    /**
 * @summary Cria template de email
 */
export const useCreateEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{tenant: string;data: EmailTemplateCreateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailTemplate>>,
        TError,
        {tenant: string;data: EmailTemplateCreateRequest},
        TContext
      > => {
      return useMutation(getCreateEmailTemplateMutationOptions(options), queryClient);
    }

export type testEmailTemplateResponse204 = {
  data: void
  status: 204
}

export type testEmailTemplateResponseSuccess = (testEmailTemplateResponse204) & {
  headers: Headers;
};
;

export type testEmailTemplateResponse = (testEmailTemplateResponseSuccess)

export const getTestEmailTemplateUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-templates/test-template`
}

/**
 * @summary Testa configuração Smtp do Tenant
 */
export const testEmailTemplate = async (tenant: string,
    emailTemplateTestRequest: EmailTemplateTestRequest, options?: RequestInit): Promise<testEmailTemplateResponse> => {

  return customInstanceBpm<testEmailTemplateResponse>(getTestEmailTemplateUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailTemplateTestRequest)
  }
);}




export const getTestEmailTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplate>>, TError,{tenant: string;data: EmailTemplateTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplate>>, TError,{tenant: string;data: EmailTemplateTestRequest}, TContext> => {

const mutationKey = ['testEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testEmailTemplate>>, {tenant: string;data: EmailTemplateTestRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  testEmailTemplate(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof testEmailTemplate>>>
    export type TestEmailTemplateMutationBody = EmailTemplateTestRequest
    export type TestEmailTemplateMutationError = unknown

    /**
 * @summary Testa configuração Smtp do Tenant
 */
export const useTestEmailTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplate>>, TError,{tenant: string;data: EmailTemplateTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testEmailTemplate>>,
        TError,
        {tenant: string;data: EmailTemplateTestRequest},
        TContext
      > => {
      return useMutation(getTestEmailTemplateMutationOptions(options), queryClient);
    }

export type testEmailTemplateFormDataResponse204 = {
  data: void
  status: 204
}

export type testEmailTemplateFormDataResponseSuccess = (testEmailTemplateFormDataResponse204) & {
  headers: Headers;
};
;

export type testEmailTemplateFormDataResponse = (testEmailTemplateFormDataResponseSuccess)

export const getTestEmailTemplateFormDataUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-templates/form/test-template`
}

/**
 * @summary Testa configuração Smtp do Tenant (comf form-data)
 */
export const testEmailTemplateFormData = async (tenant: string,
    testEmailTemplateFormDataBody?: TestEmailTemplateFormDataBody, options?: RequestInit): Promise<testEmailTemplateFormDataResponse> => {

  return customInstanceBpm<testEmailTemplateFormDataResponse>(getTestEmailTemplateFormDataUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(testEmailTemplateFormDataBody)
  }
);}




export const getTestEmailTemplateFormDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplateFormData>>, TError,{tenant: string;data?: TestEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplateFormData>>, TError,{tenant: string;data?: TestEmailTemplateFormDataBody}, TContext> => {

const mutationKey = ['testEmailTemplateFormData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testEmailTemplateFormData>>, {tenant: string;data?: TestEmailTemplateFormDataBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  testEmailTemplateFormData(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestEmailTemplateFormDataMutationResult = NonNullable<Awaited<ReturnType<typeof testEmailTemplateFormData>>>
    export type TestEmailTemplateFormDataMutationBody = TestEmailTemplateFormDataBody | undefined
    export type TestEmailTemplateFormDataMutationError = unknown

    /**
 * @summary Testa configuração Smtp do Tenant (comf form-data)
 */
export const useTestEmailTemplateFormData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEmailTemplateFormData>>, TError,{tenant: string;data?: TestEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testEmailTemplateFormData>>,
        TError,
        {tenant: string;data?: TestEmailTemplateFormDataBody},
        TContext
      > => {
      return useMutation(getTestEmailTemplateFormDataMutationOptions(options), queryClient);
    }

export type createEmailTemplateFormDataResponse200 = {
  data: EmailTemplateDto
  status: 200
}

export type createEmailTemplateFormDataResponseSuccess = (createEmailTemplateFormDataResponse200) & {
  headers: Headers;
};
;

export type createEmailTemplateFormDataResponse = (createEmailTemplateFormDataResponseSuccess)

export const getCreateEmailTemplateFormDataUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-templates/form`
}

/**
 * @summary Cria template de email (com form-data)
 */
export const createEmailTemplateFormData = async (tenant: string,
    createEmailTemplateFormDataBody?: CreateEmailTemplateFormDataBody, options?: RequestInit): Promise<createEmailTemplateFormDataResponse> => {
    const formData = new FormData();
if(createEmailTemplateFormDataBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(createEmailTemplateFormDataBody.input));
 }
if(createEmailTemplateFormDataBody?.htmlFile !== undefined) {
 formData.append(`htmlFile`, createEmailTemplateFormDataBody.htmlFile);
 }

  return customInstanceBpm<createEmailTemplateFormDataResponse>(getCreateEmailTemplateFormDataUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateEmailTemplateFormDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplateFormData>>, TError,{tenant: string;data?: CreateEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplateFormData>>, TError,{tenant: string;data?: CreateEmailTemplateFormDataBody}, TContext> => {

const mutationKey = ['createEmailTemplateFormData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailTemplateFormData>>, {tenant: string;data?: CreateEmailTemplateFormDataBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createEmailTemplateFormData(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailTemplateFormDataMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailTemplateFormData>>>
    export type CreateEmailTemplateFormDataMutationBody = CreateEmailTemplateFormDataBody | undefined
    export type CreateEmailTemplateFormDataMutationError = unknown

    /**
 * @summary Cria template de email (com form-data)
 */
export const useCreateEmailTemplateFormData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplateFormData>>, TError,{tenant: string;data?: CreateEmailTemplateFormDataBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailTemplateFormData>>,
        TError,
        {tenant: string;data?: CreateEmailTemplateFormDataBody},
        TContext
      > => {
      return useMutation(getCreateEmailTemplateFormDataMutationOptions(options), queryClient);
    }

export type listResponse200 = {
  data: PageEmailProcessConfigurationDto
  status: 200
}

export type listResponseSuccess = (listResponse200) & {
  headers: Headers;
};
;

export type listResponse = (listResponseSuccess)

export const getListUrl = (tenant: string,
    params: ListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/email-process/configurations?${stringifiedParams}` : `/v1/${tenant}/email-process/configurations`
}

/**
 * @summary Lista as configurações do email-process enriquecidas com dados do BPM
 */
export const list = async (tenant: string,
    params: ListParams, options?: RequestInit): Promise<listResponse> => {

  return customInstanceBpm<listResponse>(getListUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQueryKey = (tenant: string,
    params?: ListParams,) => {
    return [
    `/v1/${tenant}/email-process/configurations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQueryOptions = <TData = Awaited<ReturnType<typeof list>>, TError = unknown>(tenant: string,
    params: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list>>> = ({ signal }) => list(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQueryResult = NonNullable<Awaited<ReturnType<typeof list>>>
export type ListQueryError = unknown


export function useList<TData = Awaited<ReturnType<typeof list>>, TError = unknown>(
 tenant: string,
    params: ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list>>,
          TError,
          Awaited<ReturnType<typeof list>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList<TData = Awaited<ReturnType<typeof list>>, TError = unknown>(
 tenant: string,
    params: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list>>,
          TError,
          Awaited<ReturnType<typeof list>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList<TData = Awaited<ReturnType<typeof list>>, TError = unknown>(
 tenant: string,
    params: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as configurações do email-process enriquecidas com dados do BPM
 */

export function useList<TData = Awaited<ReturnType<typeof list>>, TError = unknown>(
 tenant: string,
    params: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createResponse201 = {
  data: EmailProcessConfigurationDto
  status: 201
}

export type createResponseSuccess = (createResponse201) & {
  headers: Headers;
};
;

export type createResponse = (createResponseSuccess)

export const getCreateUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-process/configurations`
}

/**
 * @summary Cadastra uma configuracao de gatilho de email
 */
export const create = async (tenant: string,
    emailProcessConfigurationRequest: EmailProcessConfigurationRequest, options?: RequestInit): Promise<createResponse> => {

  return customInstanceBpm<createResponse>(getCreateUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessConfigurationRequest)
  }
);}




export const getCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext> => {

const mutationKey = ['create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof create>>, {tenant: string;data: EmailProcessConfigurationRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  create(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMutationResult = NonNullable<Awaited<ReturnType<typeof create>>>
    export type CreateMutationBody = EmailProcessConfigurationRequest
    export type CreateMutationError = unknown

    /**
 * @summary Cadastra uma configuracao de gatilho de email
 */
export const useCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof create>>,
        TError,
        {tenant: string;data: EmailProcessConfigurationRequest},
        TContext
      > => {
      return useMutation(getCreateMutationOptions(options), queryClient);
    }

export type testMailboxResponse200 = {
  data: EmailProcessMailboxTestDto
  status: 200
}

export type testMailboxResponseSuccess = (testMailboxResponse200) & {
  headers: Headers;
};
;

export type testMailboxResponse = (testMailboxResponseSuccess)

export const getTestMailboxUrl = (tenant: string,
    routeId: string,) => {




  return `/v1/${tenant}/email-process/configurations/${routeId}/test-mailbox`
}

/**
 * @summary Testa a conexao da caixa de email do gatilho usando o token salvo quando nao informado
 */
export const testMailbox = async (tenant: string,
    routeId: string,
    emailProcessConfigurationRequest: EmailProcessConfigurationRequest, options?: RequestInit): Promise<testMailboxResponse> => {

  return customInstanceBpm<testMailboxResponse>(getTestMailboxUrl(tenant,routeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessConfigurationRequest)
  }
);}




export const getTestMailboxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailbox>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testMailbox>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext> => {

const mutationKey = ['testMailbox'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testMailbox>>, {tenant: string;routeId: string;data: EmailProcessConfigurationRequest}> = (props) => {
          const {tenant,routeId,data} = props ?? {};

          return  testMailbox(tenant,routeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof testMailbox>>>
    export type TestMailboxMutationBody = EmailProcessConfigurationRequest
    export type TestMailboxMutationError = unknown

    /**
 * @summary Testa a conexao da caixa de email do gatilho usando o token salvo quando nao informado
 */
export const useTestMailbox = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailbox>>, TError,{tenant: string;routeId: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testMailbox>>,
        TError,
        {tenant: string;routeId: string;data: EmailProcessConfigurationRequest},
        TContext
      > => {
      return useMutation(getTestMailboxMutationOptions(options), queryClient);
    }

export type testMailbox1Response200 = {
  data: EmailProcessMailboxTestDto
  status: 200
}

export type testMailbox1ResponseSuccess = (testMailbox1Response200) & {
  headers: Headers;
};
;

export type testMailbox1Response = (testMailbox1ResponseSuccess)

export const getTestMailbox1Url = (tenant: string,) => {




  return `/v1/${tenant}/email-process/configurations/test-mailbox`
}

/**
 * @summary Testa a conexao da caixa de email do gatilho
 */
export const testMailbox1 = async (tenant: string,
    emailProcessConfigurationRequest: EmailProcessConfigurationRequest, options?: RequestInit): Promise<testMailbox1Response> => {

  return customInstanceBpm<testMailbox1Response>(getTestMailbox1Url(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessConfigurationRequest)
  }
);}




export const getTestMailbox1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailbox1>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testMailbox1>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext> => {

const mutationKey = ['testMailbox1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testMailbox1>>, {tenant: string;data: EmailProcessConfigurationRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  testMailbox1(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestMailbox1MutationResult = NonNullable<Awaited<ReturnType<typeof testMailbox1>>>
    export type TestMailbox1MutationBody = EmailProcessConfigurationRequest
    export type TestMailbox1MutationError = unknown

    /**
 * @summary Testa a conexao da caixa de email do gatilho
 */
export const useTestMailbox1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMailbox1>>, TError,{tenant: string;data: EmailProcessConfigurationRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testMailbox1>>,
        TError,
        {tenant: string;data: EmailProcessConfigurationRequest},
        TContext
      > => {
      return useMutation(getTestMailbox1MutationOptions(options), queryClient);
    }

export type reprocessEmailResponse200 = {
  data: EmailProcessReprocessResponseDto
  status: 200
}

export type reprocessEmailResponseSuccess = (reprocessEmailResponse200) & {
  headers: Headers;
};
;

export type reprocessEmailResponse = (reprocessEmailResponseSuccess)

export const getReprocessEmailUrl = (tenant: string,
    controlId: string,) => {




  return `/v1/${tenant}/email-process/configurations/processed-emails/${controlId}/reprocess`
}

/**
 * @summary Reprocessa um email com falha
 */
export const reprocessEmail = async (tenant: string,
    controlId: string, options?: RequestInit): Promise<reprocessEmailResponse> => {

  return customInstanceBpm<reprocessEmailResponse>(getReprocessEmailUrl(tenant,controlId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReprocessEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessEmail>>, TError,{tenant: string;controlId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof reprocessEmail>>, TError,{tenant: string;controlId: string}, TContext> => {

const mutationKey = ['reprocessEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reprocessEmail>>, {tenant: string;controlId: string}> = (props) => {
          const {tenant,controlId} = props ?? {};

          return  reprocessEmail(tenant,controlId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReprocessEmailMutationResult = NonNullable<Awaited<ReturnType<typeof reprocessEmail>>>

    export type ReprocessEmailMutationError = unknown

    /**
 * @summary Reprocessa um email com falha
 */
export const useReprocessEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessEmail>>, TError,{tenant: string;controlId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reprocessEmail>>,
        TError,
        {tenant: string;controlId: string},
        TContext
      > => {
      return useMutation(getReprocessEmailMutationOptions(options), queryClient);
    }

export type generateDoczTokenResponse200 = {
  data: string
  status: 200
}

export type generateDoczTokenResponseSuccess = (generateDoczTokenResponse200) & {
  headers: Headers;
};
;

export type generateDoczTokenResponse = (generateDoczTokenResponseSuccess)

export const getGenerateDoczTokenUrl = (tenant: string,) => {




  return `/v1/${tenant}/docz/generate-token`
}

/**
 * @summary Gera token no docz
 */
export const generateDoczToken = async (tenant: string, options?: RequestInit): Promise<generateDoczTokenResponse> => {

  return customInstanceBpm<generateDoczTokenResponse>(getGenerateDoczTokenUrl(tenant),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateDoczTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDoczToken>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDoczToken>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['generateDoczToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDoczToken>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  generateDoczToken(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDoczTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateDoczToken>>>

    export type GenerateDoczTokenMutationError = unknown

    /**
 * @summary Gera token no docz
 */
export const useGenerateDoczToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDoczToken>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateDoczToken>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getGenerateDoczTokenMutationOptions(options), queryClient);
    }

export type generateTokenEtiquetaResponse200 = {
  data: string
  status: 200
}

export type generateTokenEtiquetaResponseSuccess = (generateTokenEtiquetaResponse200) & {
  headers: Headers;
};
;

export type generateTokenEtiquetaResponse = (generateTokenEtiquetaResponseSuccess)

export const getGenerateTokenEtiquetaUrl = (tenant: string,) => {




  return `/v1/${tenant}/docz/generate-token/etiqueta`
}

/**
 * @summary Gera token no docz
 */
export const generateTokenEtiqueta = async (tenant: string,
    doczGenerateEtiquetaTokenInput: DoczGenerateEtiquetaTokenInput, options?: RequestInit): Promise<generateTokenEtiquetaResponse> => {

  return customInstanceBpm<generateTokenEtiquetaResponse>(getGenerateTokenEtiquetaUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(doczGenerateEtiquetaTokenInput)
  }
);}




export const getGenerateTokenEtiquetaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTokenEtiqueta>>, TError,{tenant: string;data: DoczGenerateEtiquetaTokenInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof generateTokenEtiqueta>>, TError,{tenant: string;data: DoczGenerateEtiquetaTokenInput}, TContext> => {

const mutationKey = ['generateTokenEtiqueta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateTokenEtiqueta>>, {tenant: string;data: DoczGenerateEtiquetaTokenInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  generateTokenEtiqueta(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateTokenEtiquetaMutationResult = NonNullable<Awaited<ReturnType<typeof generateTokenEtiqueta>>>
    export type GenerateTokenEtiquetaMutationBody = DoczGenerateEtiquetaTokenInput
    export type GenerateTokenEtiquetaMutationError = unknown

    /**
 * @summary Gera token no docz
 */
export const useGenerateTokenEtiqueta = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTokenEtiqueta>>, TError,{tenant: string;data: DoczGenerateEtiquetaTokenInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateTokenEtiqueta>>,
        TError,
        {tenant: string;data: DoczGenerateEtiquetaTokenInput},
        TContext
      > => {
      return useMutation(getGenerateTokenEtiquetaMutationOptions(options), queryClient);
    }

export type listDataListResponse200 = {
  data: PageDataListDto
  status: 200
}

export type listDataListResponseSuccess = (listDataListResponse200) & {
  headers: Headers;
};
;

export type listDataListResponse = (listDataListResponseSuccess)

export const getListDataListUrl = (tenant: string,
    params?: ListDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list?${stringifiedParams}` : `/v1/${tenant}/data-list`
}

/**
 * @summary Lista as listas de dados
 */
export const listDataList = async (tenant: string,
    params?: ListDataListParams, options?: RequestInit): Promise<listDataListResponse> => {

  return customInstanceBpm<listDataListResponse>(getListDataListUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDataListQueryKey = (tenant: string,
    params?: ListDataListParams,) => {
    return [
    `/v1/${tenant}/data-list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDataListQueryOptions = <TData = Awaited<ReturnType<typeof listDataList>>, TError = unknown>(tenant: string,
    params?: ListDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDataListQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataList>>> = ({ signal }) => listDataList(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDataListQueryResult = NonNullable<Awaited<ReturnType<typeof listDataList>>>
export type ListDataListQueryError = unknown


export function useListDataList<TData = Awaited<ReturnType<typeof listDataList>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListDataListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataList>>,
          TError,
          Awaited<ReturnType<typeof listDataList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDataList<TData = Awaited<ReturnType<typeof listDataList>>, TError = unknown>(
 tenant: string,
    params?: ListDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataList>>,
          TError,
          Awaited<ReturnType<typeof listDataList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDataList<TData = Awaited<ReturnType<typeof listDataList>>, TError = unknown>(
 tenant: string,
    params?: ListDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as listas de dados
 */

export function useListDataList<TData = Awaited<ReturnType<typeof listDataList>>, TError = unknown>(
 tenant: string,
    params?: ListDataListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDataListQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createDataListResponse201 = {
  data: DataListDto
  status: 201
}

export type createDataListResponseSuccess = (createDataListResponse201) & {
  headers: Headers;
};
;

export type createDataListResponse = (createDataListResponseSuccess)

export const getCreateDataListUrl = (tenant: string,) => {




  return `/v1/${tenant}/data-list`
}

/**
 * @summary Cria uma lista de dados
 */
export const createDataList = async (tenant: string,
    dataListInput: DataListInput, options?: RequestInit): Promise<createDataListResponse> => {

  return customInstanceBpm<createDataListResponse>(getCreateDataListUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dataListInput)
  }
);}




export const getCreateDataListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataList>>, TError,{tenant: string;data: DataListInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createDataList>>, TError,{tenant: string;data: DataListInput}, TContext> => {

const mutationKey = ['createDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDataList>>, {tenant: string;data: DataListInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createDataList(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDataListMutationResult = NonNullable<Awaited<ReturnType<typeof createDataList>>>
    export type CreateDataListMutationBody = DataListInput
    export type CreateDataListMutationError = unknown

    /**
 * @summary Cria uma lista de dados
 */
export const useCreateDataList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataList>>, TError,{tenant: string;data: DataListInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDataList>>,
        TError,
        {tenant: string;data: DataListInput},
        TContext
      > => {
      return useMutation(getCreateDataListMutationOptions(options), queryClient);
    }

export type listDataListRowResponse200 = {
  data: DataListRowPageSwagger
  status: 200
}

export type listDataListRowResponseSuccess = (listDataListRowResponse200) & {
  headers: Headers;
};
;

export type listDataListRowResponse = (listDataListRowResponseSuccess)

export const getListDataListRowUrl = (tenant: string,
    dataListId: string,
    params?: ListDataListRowParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}/items?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}/items`
}

/**
 * @summary Lista os itens da listas de dados
 */
export const listDataListRow = async (tenant: string,
    dataListId: string,
    params?: ListDataListRowParams, options?: RequestInit): Promise<listDataListRowResponse> => {

  return customInstanceBpm<listDataListRowResponse>(getListDataListRowUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDataListRowQueryKey = (tenant: string,
    dataListId: string,
    params?: ListDataListRowParams,) => {
    return [
    `/v1/${tenant}/data-list/${dataListId}/items`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDataListRowQueryOptions = <TData = Awaited<ReturnType<typeof listDataListRow>>, TError = unknown>(tenant: string,
    dataListId: string,
    params?: ListDataListRowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDataListRowQueryKey(tenant,dataListId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataListRow>>> = ({ signal }) => listDataListRow(tenant,dataListId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && dataListId !== null && dataListId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDataListRowQueryResult = NonNullable<Awaited<ReturnType<typeof listDataListRow>>>
export type ListDataListRowQueryError = unknown


export function useListDataListRow<TData = Awaited<ReturnType<typeof listDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string,
    params: undefined |  ListDataListRowParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDataListRow<TData = Awaited<ReturnType<typeof listDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string,
    params?: ListDataListRowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDataListRow<TData = Awaited<ReturnType<typeof listDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string,
    params?: ListDataListRowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os itens da listas de dados
 */

export function useListDataListRow<TData = Awaited<ReturnType<typeof listDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string,
    params?: ListDataListRowParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDataListRowQueryOptions(tenant,dataListId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createDataListRowResponse201 = {
  data: DataListRowDtoSwagger
  status: 201
}

export type createDataListRowResponseSuccess = (createDataListRowResponse201) & {
  headers: Headers;
};
;

export type createDataListRowResponse = (createDataListRowResponseSuccess)

export const getCreateDataListRowUrl = (tenant: string,
    dataListId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items`
}

/**
 * @summary Adiciona um item na lista de dados
 */
export const createDataListRow = async (tenant: string,
    dataListId: string,
    jsonNode: JsonNode, options?: RequestInit): Promise<createDataListRowResponse> => {

  return customInstanceBpm<createDataListRowResponse>(getCreateDataListRowUrl(tenant,dataListId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jsonNode)
  }
);}




export const getCreateDataListRowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataListRow>>, TError,{tenant: string;dataListId: string;data: JsonNode}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createDataListRow>>, TError,{tenant: string;dataListId: string;data: JsonNode}, TContext> => {

const mutationKey = ['createDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDataListRow>>, {tenant: string;dataListId: string;data: JsonNode}> = (props) => {
          const {tenant,dataListId,data} = props ?? {};

          return  createDataListRow(tenant,dataListId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof createDataListRow>>>
    export type CreateDataListRowMutationBody = JsonNode
    export type CreateDataListRowMutationError = unknown

    /**
 * @summary Adiciona um item na lista de dados
 */
export const useCreateDataListRow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataListRow>>, TError,{tenant: string;dataListId: string;data: JsonNode}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDataListRow>>,
        TError,
        {tenant: string;dataListId: string;data: JsonNode},
        TContext
      > => {
      return useMutation(getCreateDataListRowMutationOptions(options), queryClient);
    }

export type cloneDataListRowResponse200 = {
  data: DataListRowDtoSwagger
  status: 200
}

export type cloneDataListRowResponse201 = {
  data: JsonNode
  status: 201
}

export type cloneDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type cloneDataListRowResponseSuccess = (cloneDataListRowResponse200 | cloneDataListRowResponse201) & {
  headers: Headers;
};
export type cloneDataListRowResponseError = (cloneDataListRowResponse404) & {
  headers: Headers;
};

export type cloneDataListRowResponse = (cloneDataListRowResponseSuccess | cloneDataListRowResponseError)

export const getCloneDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}/clone`
}

/**
 * @summary Cria uma cópia do item da lista de dados por ID
 */
export const cloneDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string, options?: RequestInit): Promise<cloneDataListRowResponse> => {

  return customInstanceBpm<cloneDataListRowResponse>(getCloneDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCloneDataListRowMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext> => {

const mutationKey = ['cloneDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneDataListRow>>, {tenant: string;dataListId: string;itemId: string}> = (props) => {
          const {tenant,dataListId,itemId} = props ?? {};

          return  cloneDataListRow(tenant,dataListId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof cloneDataListRow>>>

    export type CloneDataListRowMutationError = Problem

    /**
 * @summary Cria uma cópia do item da lista de dados por ID
 */
export const useCloneDataListRow = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneDataListRow>>,
        TError,
        {tenant: string;dataListId: string;itemId: string},
        TContext
      > => {
      return useMutation(getCloneDataListRowMutationOptions(options), queryClient);
    }

export type importDataListCsvResponse200 = {
  data: DataListImportResultDto
  status: 200
}

export type importDataListCsvResponseSuccess = (importDataListCsvResponse200) & {
  headers: Headers;
};
;

export type importDataListCsvResponse = (importDataListCsvResponseSuccess)

export const getImportDataListCsvUrl = (tenant: string,
    dataListId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/import`
}

/**
 * @summary Importa itens de um CSV para uma lista de dados
 */
export const importDataListCsv = async (tenant: string,
    dataListId: string,
    importDataListCsvBody?: ImportDataListCsvBody, options?: RequestInit): Promise<importDataListCsvResponse> => {
    const formData = new FormData();
if(importDataListCsvBody?.file !== undefined) {
 formData.append(`file`, importDataListCsvBody.file);
 }
if(importDataListCsvBody?.options !== undefined) {
 formData.append(`options`, JSON.stringify(importDataListCsvBody.options));
 }

  return customInstanceBpm<importDataListCsvResponse>(getImportDataListCsvUrl(tenant,dataListId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getImportDataListCsvMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDataListCsv>>, TError,{tenant: string;dataListId: string;data?: ImportDataListCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof importDataListCsv>>, TError,{tenant: string;dataListId: string;data?: ImportDataListCsvBody}, TContext> => {

const mutationKey = ['importDataListCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importDataListCsv>>, {tenant: string;dataListId: string;data?: ImportDataListCsvBody}> = (props) => {
          const {tenant,dataListId,data} = props ?? {};

          return  importDataListCsv(tenant,dataListId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportDataListCsvMutationResult = NonNullable<Awaited<ReturnType<typeof importDataListCsv>>>
    export type ImportDataListCsvMutationBody = ImportDataListCsvBody | undefined
    export type ImportDataListCsvMutationError = unknown

    /**
 * @summary Importa itens de um CSV para uma lista de dados
 */
export const useImportDataListCsv = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importDataListCsv>>, TError,{tenant: string;dataListId: string;data?: ImportDataListCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importDataListCsv>>,
        TError,
        {tenant: string;dataListId: string;data?: ImportDataListCsvBody},
        TContext
      > => {
      return useMutation(getImportDataListCsvMutationOptions(options), queryClient);
    }

export type cloneDataListResponse200 = {
  data: DataListDto
  status: 200
}

export type cloneDataListResponse201 = {
  data: DataListDto
  status: 201
}

export type cloneDataListResponse404 = {
  data: Problem
  status: 404
}

export type cloneDataListResponseSuccess = (cloneDataListResponse200 | cloneDataListResponse201) & {
  headers: Headers;
};
export type cloneDataListResponseError = (cloneDataListResponse404) & {
  headers: Headers;
};

export type cloneDataListResponse = (cloneDataListResponseSuccess | cloneDataListResponseError)

export const getCloneDataListUrl = (tenant: string,
    dataListId: string,
    params?: CloneDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}/clone?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}/clone`
}

/**
 * @summary Cria uma cópia da lista de dados por ID
 */
export const cloneDataList = async (tenant: string,
    dataListId: string,
    params?: CloneDataListParams, options?: RequestInit): Promise<cloneDataListResponse> => {

  return customInstanceBpm<cloneDataListResponse>(getCloneDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCloneDataListMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneDataList>>, TError,{tenant: string;dataListId: string;params?: CloneDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneDataList>>, TError,{tenant: string;dataListId: string;params?: CloneDataListParams}, TContext> => {

const mutationKey = ['cloneDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneDataList>>, {tenant: string;dataListId: string;params?: CloneDataListParams}> = (props) => {
          const {tenant,dataListId,params} = props ?? {};

          return  cloneDataList(tenant,dataListId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneDataListMutationResult = NonNullable<Awaited<ReturnType<typeof cloneDataList>>>

    export type CloneDataListMutationError = Problem

    /**
 * @summary Cria uma cópia da lista de dados por ID
 */
export const useCloneDataList = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneDataList>>, TError,{tenant: string;dataListId: string;params?: CloneDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneDataList>>,
        TError,
        {tenant: string;dataListId: string;params?: CloneDataListParams},
        TContext
      > => {
      return useMutation(getCloneDataListMutationOptions(options), queryClient);
    }

export type createDataListFromCsvResponse201 = {
  data: DataListImportResultDto
  status: 201
}

export type createDataListFromCsvResponseSuccess = (createDataListFromCsvResponse201) & {
  headers: Headers;
};
;

export type createDataListFromCsvResponse = (createDataListFromCsvResponseSuccess)

export const getCreateDataListFromCsvUrl = (tenant: string,) => {




  return `/v1/${tenant}/data-list/import`
}

/**
 * @summary Cria uma lista de dados a partir de um CSV
 */
export const createDataListFromCsv = async (tenant: string,
    createDataListFromCsvBody?: CreateDataListFromCsvBody, options?: RequestInit): Promise<createDataListFromCsvResponse> => {
    const formData = new FormData();
if(createDataListFromCsvBody?.file !== undefined) {
 formData.append(`file`, createDataListFromCsvBody.file);
 }
if(createDataListFromCsvBody?.options !== undefined) {
 formData.append(`options`, JSON.stringify(createDataListFromCsvBody.options));
 }

  return customInstanceBpm<createDataListFromCsvResponse>(getCreateDataListFromCsvUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateDataListFromCsvMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataListFromCsv>>, TError,{tenant: string;data?: CreateDataListFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createDataListFromCsv>>, TError,{tenant: string;data?: CreateDataListFromCsvBody}, TContext> => {

const mutationKey = ['createDataListFromCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDataListFromCsv>>, {tenant: string;data?: CreateDataListFromCsvBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createDataListFromCsv(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDataListFromCsvMutationResult = NonNullable<Awaited<ReturnType<typeof createDataListFromCsv>>>
    export type CreateDataListFromCsvMutationBody = CreateDataListFromCsvBody | undefined
    export type CreateDataListFromCsvMutationError = unknown

    /**
 * @summary Cria uma lista de dados a partir de um CSV
 */
export const useCreateDataListFromCsv = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataListFromCsv>>, TError,{tenant: string;data?: CreateDataListFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDataListFromCsv>>,
        TError,
        {tenant: string;data?: CreateDataListFromCsvBody},
        TContext
      > => {
      return useMutation(getCreateDataListFromCsvMutationOptions(options), queryClient);
    }

export type listCategoriesResponse200 = {
  data: CategoryDto[]
  status: 200
}

export type listCategoriesResponseSuccess = (listCategoriesResponse200) & {
  headers: Headers;
};
;

export type listCategoriesResponse = (listCategoriesResponseSuccess)

export const getListCategoriesUrl = (tenant: string,) => {




  return `/v1/${tenant}/categories`
}

/**
 * @summary Lista as categorias
 */
export const listCategories = async (tenant: string, options?: RequestInit): Promise<listCategoriesResponse> => {

  return customInstanceBpm<listCategoriesResponse>(getListCategoriesUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/categories`
    ] as const;
    }


export const getListCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCategories>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) => listCategories(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = unknown


export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as categorias
 */

export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCategoriesQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createCategoryResponse201 = {
  data: CategoryDto
  status: 201
}

export type createCategoryResponseSuccess = (createCategoryResponse201) & {
  headers: Headers;
};
;

export type createCategoryResponse = (createCategoryResponseSuccess)

export const getCreateCategoryUrl = (tenant: string,) => {




  return `/v1/${tenant}/categories`
}

/**
 * @summary Cria uma categoria
 */
export const createCategory = async (tenant: string,
    categoryInput: CategoryInput, options?: RequestInit): Promise<createCategoryResponse> => {

  return customInstanceBpm<createCategoryResponse>(getCreateCategoryUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryInput)
  }
);}




export const getCreateCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{tenant: string;data: CategoryInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{tenant: string;data: CategoryInput}, TContext> => {

const mutationKey = ['createCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, {tenant: string;data: CategoryInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createCategory(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = CategoryInput
    export type CreateCategoryMutationError = unknown

    /**
 * @summary Cria uma categoria
 */
export const useCreateCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{tenant: string;data: CategoryInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        {tenant: string;data: CategoryInput},
        TContext
      > => {
      return useMutation(getCreateCategoryMutationOptions(options), queryClient);
    }

export type reindexAuditIndexResponse200 = {
  data: string
  status: 200
}

export type reindexAuditIndexResponse403 = {
  data: string
  status: 403
}

export type reindexAuditIndexResponseSuccess = (reindexAuditIndexResponse200) & {
  headers: Headers;
};
export type reindexAuditIndexResponseError = (reindexAuditIndexResponse403) & {
  headers: Headers;
};

export type reindexAuditIndexResponse = (reindexAuditIndexResponseSuccess | reindexAuditIndexResponseError)

export const getReindexAuditIndexUrl = (tenant: string,) => {




  return `/v1/${tenant}/audit-index/reindex`
}

/**
 * @summary Recria o índice e reemite os eventos de auditoria
 */
export const reindexAuditIndex = async (tenant: string, options?: RequestInit): Promise<reindexAuditIndexResponse> => {

  return customInstanceBpm<reindexAuditIndexResponse>(getReindexAuditIndexUrl(tenant),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReindexAuditIndexMutationOptions = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAuditIndex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof reindexAuditIndex>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['reindexAuditIndex'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindexAuditIndex>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  reindexAuditIndex(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexAuditIndexMutationResult = NonNullable<Awaited<ReturnType<typeof reindexAuditIndex>>>

    export type ReindexAuditIndexMutationError = string

    /**
 * @summary Recria o índice e reemite os eventos de auditoria
 */
export const useReindexAuditIndex = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAuditIndex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindexAuditIndex>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getReindexAuditIndexMutationOptions(options), queryClient);
    }

export type recreateAuditIndexResponse200 = {
  data: string
  status: 200
}

export type recreateAuditIndexResponse403 = {
  data: string
  status: 403
}

export type recreateAuditIndexResponseSuccess = (recreateAuditIndexResponse200) & {
  headers: Headers;
};
export type recreateAuditIndexResponseError = (recreateAuditIndexResponse403) & {
  headers: Headers;
};

export type recreateAuditIndexResponse = (recreateAuditIndexResponseSuccess | recreateAuditIndexResponseError)

export const getRecreateAuditIndexUrl = (tenant: string,) => {




  return `/v1/${tenant}/audit-index/recreate`
}

/**
 * @summary Recria o índice de auditoria vazio
 */
export const recreateAuditIndex = async (tenant: string, options?: RequestInit): Promise<recreateAuditIndexResponse> => {

  return customInstanceBpm<recreateAuditIndexResponse>(getRecreateAuditIndexUrl(tenant),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRecreateAuditIndexMutationOptions = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateAuditIndex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof recreateAuditIndex>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['recreateAuditIndex'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recreateAuditIndex>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  recreateAuditIndex(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecreateAuditIndexMutationResult = NonNullable<Awaited<ReturnType<typeof recreateAuditIndex>>>

    export type RecreateAuditIndexMutationError = string

    /**
 * @summary Recria o índice de auditoria vazio
 */
export const useRecreateAuditIndex = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recreateAuditIndex>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recreateAuditIndex>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getRecreateAuditIndexMutationOptions(options), queryClient);
    }

export type listApiManagerResponse200 = {
  data: PageApiManagerDto
  status: 200
}

export type listApiManagerResponseSuccess = (listApiManagerResponse200) & {
  headers: Headers;
};
;

export type listApiManagerResponse = (listApiManagerResponseSuccess)

export const getListApiManagerUrl = (tenant: string,
    params?: ListApiManagerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/api_manager?${stringifiedParams}` : `/v1/${tenant}/api_manager`
}

/**
 * @summary Retorna uma lista de apis previamente cadastrada na plataforma
 */
export const listApiManager = async (tenant: string,
    params?: ListApiManagerParams, options?: RequestInit): Promise<listApiManagerResponse> => {

  return customInstanceBpm<listApiManagerResponse>(getListApiManagerUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListApiManagerQueryKey = (tenant: string,
    params?: ListApiManagerParams,) => {
    return [
    `/v1/${tenant}/api_manager`, ...(params ? [params] : [])
    ] as const;
    }


export const getListApiManagerQueryOptions = <TData = Awaited<ReturnType<typeof listApiManager>>, TError = unknown>(tenant: string,
    params?: ListApiManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApiManagerQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiManager>>> = ({ signal }) => listApiManager(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListApiManagerQueryResult = NonNullable<Awaited<ReturnType<typeof listApiManager>>>
export type ListApiManagerQueryError = unknown


export function useListApiManager<TData = Awaited<ReturnType<typeof listApiManager>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListApiManagerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApiManager>>,
          TError,
          Awaited<ReturnType<typeof listApiManager>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListApiManager<TData = Awaited<ReturnType<typeof listApiManager>>, TError = unknown>(
 tenant: string,
    params?: ListApiManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listApiManager>>,
          TError,
          Awaited<ReturnType<typeof listApiManager>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListApiManager<TData = Awaited<ReturnType<typeof listApiManager>>, TError = unknown>(
 tenant: string,
    params?: ListApiManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna uma lista de apis previamente cadastrada na plataforma
 */

export function useListApiManager<TData = Awaited<ReturnType<typeof listApiManager>>, TError = unknown>(
 tenant: string,
    params?: ListApiManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiManager>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListApiManagerQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createApiManagerResponse201 = {
  data: ApiManagerDto
  status: 201
}

export type createApiManagerResponseSuccess = (createApiManagerResponse201) & {
  headers: Headers;
};
;

export type createApiManagerResponse = (createApiManagerResponseSuccess)

export const getCreateApiManagerUrl = (tenant: string,) => {




  return `/v1/${tenant}/api_manager`
}

/**
 * @summary Cadastra uma nova api na plataforma
 */
export const createApiManager = async (tenant: string,
    apiManagerInput: ApiManagerInput, options?: RequestInit): Promise<createApiManagerResponse> => {

  return customInstanceBpm<createApiManagerResponse>(getCreateApiManagerUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(apiManagerInput)
  }
);}




export const getCreateApiManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiManager>>, TError,{tenant: string;data: ApiManagerInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createApiManager>>, TError,{tenant: string;data: ApiManagerInput}, TContext> => {

const mutationKey = ['createApiManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiManager>>, {tenant: string;data: ApiManagerInput}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createApiManager(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApiManagerMutationResult = NonNullable<Awaited<ReturnType<typeof createApiManager>>>
    export type CreateApiManagerMutationBody = ApiManagerInput
    export type CreateApiManagerMutationError = unknown

    /**
 * @summary Cadastra uma nova api na plataforma
 */
export const useCreateApiManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiManager>>, TError,{tenant: string;data: ApiManagerInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createApiManager>>,
        TError,
        {tenant: string;data: ApiManagerInput},
        TContext
      > => {
      return useMutation(getCreateApiManagerMutationOptions(options), queryClient);
    }

export type executeApiManagerResponse200 = {
  data: ApiExecutionResultDto
  status: 200
}

export type executeApiManagerResponseSuccess = (executeApiManagerResponse200) & {
  headers: Headers;
};
;

export type executeApiManagerResponse = (executeApiManagerResponseSuccess)

export const getExecuteApiManagerUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/api_manager/${id}/execute`
}

/**
 * @summary Execute uma api previamente cadastrada na plataforma
 */
export const executeApiManager = async (tenant: string,
    id: number,
    apiManagerExecuteInput?: ApiManagerExecuteInput, options?: RequestInit): Promise<executeApiManagerResponse> => {

  return customInstanceBpm<executeApiManagerResponse>(getExecuteApiManagerUrl(tenant,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(apiManagerExecuteInput)
  }
);}




export const getExecuteApiManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeApiManager>>, TError,{tenant: string;id: number;data?: ApiManagerExecuteInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof executeApiManager>>, TError,{tenant: string;id: number;data?: ApiManagerExecuteInput}, TContext> => {

const mutationKey = ['executeApiManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeApiManager>>, {tenant: string;id: number;data?: ApiManagerExecuteInput}> = (props) => {
          const {tenant,id,data} = props ?? {};

          return  executeApiManager(tenant,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteApiManagerMutationResult = NonNullable<Awaited<ReturnType<typeof executeApiManager>>>
    export type ExecuteApiManagerMutationBody = ApiManagerExecuteInput | undefined
    export type ExecuteApiManagerMutationError = unknown

    /**
 * @summary Execute uma api previamente cadastrada na plataforma
 */
export const useExecuteApiManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeApiManager>>, TError,{tenant: string;id: number;data?: ApiManagerExecuteInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeApiManager>>,
        TError,
        {tenant: string;id: number;data?: ApiManagerExecuteInput},
        TContext
      > => {
      return useMutation(getExecuteApiManagerMutationOptions(options), queryClient);
    }

export type listAccessProfilesResponse200 = {
  data: PageAccessProfileDto
  status: 200
}

export type listAccessProfilesResponseSuccess = (listAccessProfilesResponse200) & {
  headers: Headers;
};
;

export type listAccessProfilesResponse = (listAccessProfilesResponseSuccess)

export const getListAccessProfilesUrl = (tenant: string,
    params?: ListAccessProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/access-profiles?${stringifiedParams}` : `/v1/${tenant}/access-profiles`
}

/**
 * @summary Lista os perfis de acesso
 */
export const listAccessProfiles = async (tenant: string,
    params?: ListAccessProfilesParams, options?: RequestInit): Promise<listAccessProfilesResponse> => {

  return customInstanceBpm<listAccessProfilesResponse>(getListAccessProfilesUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccessProfilesQueryKey = (tenant: string,
    params?: ListAccessProfilesParams,) => {
    return [
    `/v1/${tenant}/access-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccessProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listAccessProfiles>>, TError = unknown>(tenant: string,
    params?: ListAccessProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessProfilesQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessProfiles>>> = ({ signal }) => listAccessProfiles(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccessProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessProfiles>>>
export type ListAccessProfilesQueryError = unknown


export function useListAccessProfiles<TData = Awaited<ReturnType<typeof listAccessProfiles>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListAccessProfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessProfiles>>,
          TError,
          Awaited<ReturnType<typeof listAccessProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessProfiles<TData = Awaited<ReturnType<typeof listAccessProfiles>>, TError = unknown>(
 tenant: string,
    params?: ListAccessProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessProfiles>>,
          TError,
          Awaited<ReturnType<typeof listAccessProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessProfiles<TData = Awaited<ReturnType<typeof listAccessProfiles>>, TError = unknown>(
 tenant: string,
    params?: ListAccessProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os perfis de acesso
 */

export function useListAccessProfiles<TData = Awaited<ReturnType<typeof listAccessProfiles>>, TError = unknown>(
 tenant: string,
    params?: ListAccessProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccessProfilesQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createAccessProfileResponse201 = {
  data: AccessProfileWithAllPropertiesDto
  status: 201
}

export type createAccessProfileResponseSuccess = (createAccessProfileResponse201) & {
  headers: Headers;
};
;

export type createAccessProfileResponse = (createAccessProfileResponseSuccess)

export const getCreateAccessProfileUrl = (tenant: string,) => {




  return `/v1/${tenant}/access-profiles`
}

/**
 * @summary Cria um perfil de acesso
 */
export const createAccessProfile = async (tenant: string,
    accessProfileInputCreate: AccessProfileInputCreate, options?: RequestInit): Promise<createAccessProfileResponse> => {

  return customInstanceBpm<createAccessProfileResponse>(getCreateAccessProfileUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accessProfileInputCreate)
  }
);}




export const getCreateAccessProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessProfile>>, TError,{tenant: string;data: AccessProfileInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessProfile>>, TError,{tenant: string;data: AccessProfileInputCreate}, TContext> => {

const mutationKey = ['createAccessProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessProfile>>, {tenant: string;data: AccessProfileInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createAccessProfile(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessProfile>>>
    export type CreateAccessProfileMutationBody = AccessProfileInputCreate
    export type CreateAccessProfileMutationError = unknown

    /**
 * @summary Cria um perfil de acesso
 */
export const useCreateAccessProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessProfile>>, TError,{tenant: string;data: AccessProfileInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccessProfile>>,
        TError,
        {tenant: string;data: AccessProfileInputCreate},
        TContext
      > => {
      return useMutation(getCreateAccessProfileMutationOptions(options), queryClient);
    }

export type acceptTermResponse204 = {
  data: void
  status: 204
}

export type acceptTermResponseSuccess = (acceptTermResponse204) & {
  headers: Headers;
};
;

export type acceptTermResponse = (acceptTermResponseSuccess)

export const getAcceptTermUrl = (id: string,) => {




  return `/v1/terms/${id}/accept`
}

/**
 * @summary Aceita um termo de uso
 */
export const acceptTerm = async (id: string, options?: RequestInit): Promise<acceptTermResponse> => {

  return customInstanceBpm<acceptTermResponse>(getAcceptTermUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptTermMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptTerm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTerm>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptTerm(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTerm>>>

    export type AcceptTermMutationError = unknown

    /**
 * @summary Aceita um termo de uso
 */
export const useAcceptTerm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTerm>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAcceptTermMutationOptions(options), queryClient);
    }

export type createTermResponse201 = {
  data: TermsOfUseDto
  status: 201
}

export type createTermResponseSuccess = (createTermResponse201) & {
  headers: Headers;
};
;

export type createTermResponse = (createTermResponseSuccess)

export const getCreateTermUrl = () => {




  return `/v1/terms`
}

/**
 * @summary Cria um termo de uso
 */
export const createTerm = async (createTermBody?: CreateTermBody, options?: RequestInit): Promise<createTermResponse> => {
    const formData = new FormData();
if(createTermBody?.input !== undefined) {
 formData.append(`input`, JSON.stringify(createTermBody.input));
 }
if(createTermBody?.file !== undefined) {
 formData.append(`file`, createTermBody.file);
 }

  return customInstanceBpm<createTermResponse>(getCreateTermUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateTermMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTerm>>, TError,{data?: CreateTermBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createTerm>>, TError,{data?: CreateTermBody}, TContext> => {

const mutationKey = ['createTerm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTerm>>, {data?: CreateTermBody}> = (props) => {
          const {data} = props ?? {};

          return  createTerm(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTermMutationResult = NonNullable<Awaited<ReturnType<typeof createTerm>>>
    export type CreateTermMutationBody = CreateTermBody | undefined
    export type CreateTermMutationError = unknown

    /**
 * @summary Cria um termo de uso
 */
export const useCreateTerm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTerm>>, TError,{data?: CreateTermBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTerm>>,
        TError,
        {data?: CreateTermBody},
        TContext
      > => {
      return useMutation(getCreateTermMutationOptions(options), queryClient);
    }

export type listAllTenantResponse200 = {
  data: SmartTenantDto[]
  status: 200
}

export type listAllTenantResponseSuccess = (listAllTenantResponse200) & {
  headers: Headers;
};
;

export type listAllTenantResponse = (listAllTenantResponseSuccess)

export const getListAllTenantUrl = () => {




  return `/v1/tenants`
}

/**
 * @summary Lista todos os tenants da plataforma que o usuário tem acesso
 */
export const listAllTenant = async ( options?: RequestInit): Promise<listAllTenantResponse> => {

  return customInstanceBpm<listAllTenantResponse>(getListAllTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllTenantQueryKey = () => {
    return [
    `/v1/tenants`
    ] as const;
    }


export const getListAllTenantQueryOptions = <TData = Awaited<ReturnType<typeof listAllTenant>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllTenantQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllTenant>>> = ({ signal }) => listAllTenant({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listAllTenant>>>
export type ListAllTenantQueryError = unknown


export function useListAllTenant<TData = Awaited<ReturnType<typeof listAllTenant>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTenant>>,
          TError,
          Awaited<ReturnType<typeof listAllTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllTenant<TData = Awaited<ReturnType<typeof listAllTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTenant>>,
          TError,
          Awaited<ReturnType<typeof listAllTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllTenant<TData = Awaited<ReturnType<typeof listAllTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todos os tenants da plataforma que o usuário tem acesso
 */

export function useListAllTenant<TData = Awaited<ReturnType<typeof listAllTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllTenantQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createTenantResponse201 = {
  data: SmartTenantWithAllPropertiesDto
  status: 201
}

export type createTenantResponseSuccess = (createTenantResponse201) & {
  headers: Headers;
};
;

export type createTenantResponse = (createTenantResponseSuccess)

export const getCreateTenantUrl = () => {




  return `/v1/tenants`
}

/**
 * @summary Cria um tenant
 */
export const createTenant = async (smartTenantInputCreate: SmartTenantInputCreate, options?: RequestInit): Promise<createTenantResponse> => {

  return customInstanceBpm<createTenantResponse>(getCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartTenantInputCreate)
  }
);}




export const getCreateTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: SmartTenantInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: SmartTenantInputCreate}, TContext> => {

const mutationKey = ['createTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenant>>, {data: SmartTenantInputCreate}> = (props) => {
          const {data} = props ?? {};

          return  createTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createTenant>>>
    export type CreateTenantMutationBody = SmartTenantInputCreate
    export type CreateTenantMutationError = unknown

    /**
 * @summary Cria um tenant
 */
export const useCreateTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,{data: SmartTenantInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTenant>>,
        TError,
        {data: SmartTenantInputCreate},
        TContext
      > => {
      return useMutation(getCreateTenantMutationOptions(options), queryClient);
    }

export type convertToSfdtResponse200 = {
  data: SyncfusionDto
  status: 200
}

export type convertToSfdtResponseSuccess = (convertToSfdtResponse200) & {
  headers: Headers;
};
;

export type convertToSfdtResponse = (convertToSfdtResponseSuccess)

export const getConvertToSfdtUrl = () => {




  return `/v1/syncfusion/convert-to-sfdt`
}

/**
 * @summary Converte um docx para SFDT
 */
export const convertToSfdt = async (convertToSfdtBody?: ConvertToSfdtBody, options?: RequestInit): Promise<convertToSfdtResponse> => {
    const formData = new FormData();
if(convertToSfdtBody?.file !== undefined) {
 formData.append(`file`, convertToSfdtBody.file);
 }

  return customInstanceBpm<convertToSfdtResponse>(getConvertToSfdtUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getConvertToSfdtMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertToSfdt>>, TError,{data?: ConvertToSfdtBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof convertToSfdt>>, TError,{data?: ConvertToSfdtBody}, TContext> => {

const mutationKey = ['convertToSfdt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertToSfdt>>, {data?: ConvertToSfdtBody}> = (props) => {
          const {data} = props ?? {};

          return  convertToSfdt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertToSfdtMutationResult = NonNullable<Awaited<ReturnType<typeof convertToSfdt>>>
    export type ConvertToSfdtMutationBody = ConvertToSfdtBody | undefined
    export type ConvertToSfdtMutationError = unknown

    /**
 * @summary Converte um docx para SFDT
 */
export const useConvertToSfdt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertToSfdt>>, TError,{data?: ConvertToSfdtBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof convertToSfdt>>,
        TError,
        {data?: ConvertToSfdtBody},
        TContext
      > => {
      return useMutation(getConvertToSfdtMutationOptions(options), queryClient);
    }

export type convertToDocxResponse200 = {
  data: ConvertToDocx200
  status: 200
}

export type convertToDocxResponseSuccess = (convertToDocxResponse200) & {
  headers: Headers;
};
;

export type convertToDocxResponse = (convertToDocxResponseSuccess)

export const getConvertToDocxUrl = () => {




  return `/v1/syncfusion/convert-to-docx`
}

/**
 * @summary Converte um SFDT para docx
 */
export const convertToDocx = async (syncfusionDto: SyncfusionDto, options?: RequestInit): Promise<convertToDocxResponse> => {

  return customInstanceBpm<convertToDocxResponse>(getConvertToDocxUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncfusionDto)
  }
);}




export const getConvertToDocxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertToDocx>>, TError,{data: SyncfusionDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof convertToDocx>>, TError,{data: SyncfusionDto}, TContext> => {

const mutationKey = ['convertToDocx'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertToDocx>>, {data: SyncfusionDto}> = (props) => {
          const {data} = props ?? {};

          return  convertToDocx(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertToDocxMutationResult = NonNullable<Awaited<ReturnType<typeof convertToDocx>>>
    export type ConvertToDocxMutationBody = SyncfusionDto
    export type ConvertToDocxMutationError = unknown

    /**
 * @summary Converte um SFDT para docx
 */
export const useConvertToDocx = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertToDocx>>, TError,{data: SyncfusionDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof convertToDocx>>,
        TError,
        {data: SyncfusionDto},
        TContext
      > => {
      return useMutation(getConvertToDocxMutationOptions(options), queryClient);
    }

export type getSmtpConfigByTenantResponse200 = {
  data: SmtpConfigDto
  status: 200
}

export type getSmtpConfigByTenantResponseSuccess = (getSmtpConfigByTenantResponse200) & {
  headers: Headers;
};
;

export type getSmtpConfigByTenantResponse = (getSmtpConfigByTenantResponseSuccess)

export const getGetSmtpConfigByTenantUrl = (tenant: string,) => {




  return `/v1/smtp-configs/tenant/${tenant}`
}

/**
 * @summary Retorna configuração Smtp do Tenant
 */
export const getSmtpConfigByTenant = async (tenant: string, options?: RequestInit): Promise<getSmtpConfigByTenantResponse> => {

  return customInstanceBpm<getSmtpConfigByTenantResponse>(getGetSmtpConfigByTenantUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSmtpConfigByTenantQueryKey = (tenant: string,) => {
    return [
    `/v1/smtp-configs/tenant/${tenant}`
    ] as const;
    }


export const getGetSmtpConfigByTenantQueryOptions = <TData = Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmtpConfigByTenantQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmtpConfigByTenant>>> = ({ signal }) => getSmtpConfigByTenant(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSmtpConfigByTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getSmtpConfigByTenant>>>
export type GetSmtpConfigByTenantQueryError = unknown


export function useGetSmtpConfigByTenant<TData = Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmtpConfigByTenant>>,
          TError,
          Awaited<ReturnType<typeof getSmtpConfigByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmtpConfigByTenant<TData = Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmtpConfigByTenant>>,
          TError,
          Awaited<ReturnType<typeof getSmtpConfigByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmtpConfigByTenant<TData = Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna configuração Smtp do Tenant
 */

export function useGetSmtpConfigByTenant<TData = Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSmtpConfigByTenantQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createUpdateSmtpConfigByTenantResponse200 = {
  data: SmtpConfigDto
  status: 200
}

export type createUpdateSmtpConfigByTenantResponseSuccess = (createUpdateSmtpConfigByTenantResponse200) & {
  headers: Headers;
};
;

export type createUpdateSmtpConfigByTenantResponse = (createUpdateSmtpConfigByTenantResponseSuccess)

export const getCreateUpdateSmtpConfigByTenantUrl = (tenant: string,) => {




  return `/v1/smtp-configs/tenant/${tenant}`
}

/**
 * @summary Cria/atualiza configuração Smtp do Tenant
 */
export const createUpdateSmtpConfigByTenant = async (tenant: string,
    smtpConfigCreateEditRequest: SmtpConfigCreateEditRequest, options?: RequestInit): Promise<createUpdateSmtpConfigByTenantResponse> => {

  return customInstanceBpm<createUpdateSmtpConfigByTenantResponse>(getCreateUpdateSmtpConfigByTenantUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smtpConfigCreateEditRequest)
  }
);}




export const getCreateUpdateSmtpConfigByTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>, TError,{tenant: string;data: SmtpConfigCreateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>, TError,{tenant: string;data: SmtpConfigCreateEditRequest}, TContext> => {

const mutationKey = ['createUpdateSmtpConfigByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>, {tenant: string;data: SmtpConfigCreateEditRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createUpdateSmtpConfigByTenant(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUpdateSmtpConfigByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>>
    export type CreateUpdateSmtpConfigByTenantMutationBody = SmtpConfigCreateEditRequest
    export type CreateUpdateSmtpConfigByTenantMutationError = unknown

    /**
 * @summary Cria/atualiza configuração Smtp do Tenant
 */
export const useCreateUpdateSmtpConfigByTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>, TError,{tenant: string;data: SmtpConfigCreateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUpdateSmtpConfigByTenant>>,
        TError,
        {tenant: string;data: SmtpConfigCreateEditRequest},
        TContext
      > => {
      return useMutation(getCreateUpdateSmtpConfigByTenantMutationOptions(options), queryClient);
    }

export type deleteSmtpConfigByTenantResponse204 = {
  data: void
  status: 204
}

export type deleteSmtpConfigByTenantResponseSuccess = (deleteSmtpConfigByTenantResponse204) & {
  headers: Headers;
};
;

export type deleteSmtpConfigByTenantResponse = (deleteSmtpConfigByTenantResponseSuccess)

export const getDeleteSmtpConfigByTenantUrl = (tenant: string,) => {




  return `/v1/smtp-configs/tenant/${tenant}`
}

/**
 * @summary Exclui configuração Smtp do Tenant
 */
export const deleteSmtpConfigByTenant = async (tenant: string, options?: RequestInit): Promise<deleteSmtpConfigByTenantResponse> => {

  return customInstanceBpm<deleteSmtpConfigByTenantResponse>(getDeleteSmtpConfigByTenantUrl(tenant),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSmtpConfigByTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['deleteSmtpConfigByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  deleteSmtpConfigByTenant(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSmtpConfigByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>>

    export type DeleteSmtpConfigByTenantMutationError = unknown

    /**
 * @summary Exclui configuração Smtp do Tenant
 */
export const useDeleteSmtpConfigByTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSmtpConfigByTenant>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getDeleteSmtpConfigByTenantMutationOptions(options), queryClient);
    }

export type testSmtpConnectionByTenantResponse200 = {
  data: NotificationSmtpConfigTestConnectionDto
  status: 200
}

export type testSmtpConnectionByTenantResponseSuccess = (testSmtpConnectionByTenantResponse200) & {
  headers: Headers;
};
;

export type testSmtpConnectionByTenantResponse = (testSmtpConnectionByTenantResponseSuccess)

export const getTestSmtpConnectionByTenantUrl = (tenant: string,) => {




  return `/v1/smtp-configs/tenant/${tenant}/test-connection`
}

/**
 * @summary Testa configuração Smtp do Tenant
 */
export const testSmtpConnectionByTenant = async (tenant: string,
    smtpConfigTestRequest: SmtpConfigTestRequest, options?: RequestInit): Promise<testSmtpConnectionByTenantResponse> => {

  return customInstanceBpm<testSmtpConnectionByTenantResponse>(getTestSmtpConnectionByTenantUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smtpConfigTestRequest)
  }
);}




export const getTestSmtpConnectionByTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByTenant>>, TError,{tenant: string;data: SmtpConfigTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByTenant>>, TError,{tenant: string;data: SmtpConfigTestRequest}, TContext> => {

const mutationKey = ['testSmtpConnectionByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testSmtpConnectionByTenant>>, {tenant: string;data: SmtpConfigTestRequest}> = (props) => {
          const {tenant,data} = props ?? {};

          return  testSmtpConnectionByTenant(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestSmtpConnectionByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof testSmtpConnectionByTenant>>>
    export type TestSmtpConnectionByTenantMutationBody = SmtpConfigTestRequest
    export type TestSmtpConnectionByTenantMutationError = unknown

    /**
 * @summary Testa configuração Smtp do Tenant
 */
export const useTestSmtpConnectionByTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByTenant>>, TError,{tenant: string;data: SmtpConfigTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testSmtpConnectionByTenant>>,
        TError,
        {tenant: string;data: SmtpConfigTestRequest},
        TContext
      > => {
      return useMutation(getTestSmtpConnectionByTenantMutationOptions(options), queryClient);
    }

export type getSmtpConfigByOrganizationResponse200 = {
  data: SmtpConfigDto
  status: 200
}

export type getSmtpConfigByOrganizationResponseSuccess = (getSmtpConfigByOrganizationResponse200) & {
  headers: Headers;
};
;

export type getSmtpConfigByOrganizationResponse = (getSmtpConfigByOrganizationResponseSuccess)

export const getGetSmtpConfigByOrganizationUrl = (organization: string,) => {




  return `/v1/smtp-configs/organization/${organization}`
}

/**
 * @summary Retorna configuração Smtp do Tenant
 */
export const getSmtpConfigByOrganization = async (organization: string, options?: RequestInit): Promise<getSmtpConfigByOrganizationResponse> => {

  return customInstanceBpm<getSmtpConfigByOrganizationResponse>(getGetSmtpConfigByOrganizationUrl(organization),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSmtpConfigByOrganizationQueryKey = (organization: string,) => {
    return [
    `/v1/smtp-configs/organization/${organization}`
    ] as const;
    }


export const getGetSmtpConfigByOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError = unknown>(organization: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmtpConfigByOrganizationQueryKey(organization);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>> = ({ signal }) => getSmtpConfigByOrganization(organization, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: organization !== null && organization !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSmtpConfigByOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>>
export type GetSmtpConfigByOrganizationQueryError = unknown


export function useGetSmtpConfigByOrganization<TData = Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError = unknown>(
 organization: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmtpConfigByOrganization>>,
          TError,
          Awaited<ReturnType<typeof getSmtpConfigByOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmtpConfigByOrganization<TData = Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError = unknown>(
 organization: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmtpConfigByOrganization>>,
          TError,
          Awaited<ReturnType<typeof getSmtpConfigByOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmtpConfigByOrganization<TData = Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError = unknown>(
 organization: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna configuração Smtp do Tenant
 */

export function useGetSmtpConfigByOrganization<TData = Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError = unknown>(
 organization: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmtpConfigByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSmtpConfigByOrganizationQueryOptions(organization,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createUpdateSmtpConfigByOrganizationResponse200 = {
  data: SmtpConfigDto
  status: 200
}

export type createUpdateSmtpConfigByOrganizationResponseSuccess = (createUpdateSmtpConfigByOrganizationResponse200) & {
  headers: Headers;
};
;

export type createUpdateSmtpConfigByOrganizationResponse = (createUpdateSmtpConfigByOrganizationResponseSuccess)

export const getCreateUpdateSmtpConfigByOrganizationUrl = (organization: string,) => {




  return `/v1/smtp-configs/organization/${organization}`
}

/**
 * @summary Cria/atualiza configuração Smtp da Organização
 */
export const createUpdateSmtpConfigByOrganization = async (organization: string,
    smtpConfigCreateEditRequest: SmtpConfigCreateEditRequest, options?: RequestInit): Promise<createUpdateSmtpConfigByOrganizationResponse> => {

  return customInstanceBpm<createUpdateSmtpConfigByOrganizationResponse>(getCreateUpdateSmtpConfigByOrganizationUrl(organization),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smtpConfigCreateEditRequest)
  }
);}




export const getCreateUpdateSmtpConfigByOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>, TError,{organization: string;data: SmtpConfigCreateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>, TError,{organization: string;data: SmtpConfigCreateEditRequest}, TContext> => {

const mutationKey = ['createUpdateSmtpConfigByOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>, {organization: string;data: SmtpConfigCreateEditRequest}> = (props) => {
          const {organization,data} = props ?? {};

          return  createUpdateSmtpConfigByOrganization(organization,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUpdateSmtpConfigByOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>>
    export type CreateUpdateSmtpConfigByOrganizationMutationBody = SmtpConfigCreateEditRequest
    export type CreateUpdateSmtpConfigByOrganizationMutationError = unknown

    /**
 * @summary Cria/atualiza configuração Smtp da Organização
 */
export const useCreateUpdateSmtpConfigByOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>, TError,{organization: string;data: SmtpConfigCreateEditRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUpdateSmtpConfigByOrganization>>,
        TError,
        {organization: string;data: SmtpConfigCreateEditRequest},
        TContext
      > => {
      return useMutation(getCreateUpdateSmtpConfigByOrganizationMutationOptions(options), queryClient);
    }

export type deleteSmtpConfigByOrganizationResponse204 = {
  data: void
  status: 204
}

export type deleteSmtpConfigByOrganizationResponseSuccess = (deleteSmtpConfigByOrganizationResponse204) & {
  headers: Headers;
};
;

export type deleteSmtpConfigByOrganizationResponse = (deleteSmtpConfigByOrganizationResponseSuccess)

export const getDeleteSmtpConfigByOrganizationUrl = (organization: string,) => {




  return `/v1/smtp-configs/organization/${organization}`
}

/**
 * @summary Exclui configuração Smtp do Tenant
 */
export const deleteSmtpConfigByOrganization = async (organization: string, options?: RequestInit): Promise<deleteSmtpConfigByOrganizationResponse> => {

  return customInstanceBpm<deleteSmtpConfigByOrganizationResponse>(getDeleteSmtpConfigByOrganizationUrl(organization),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSmtpConfigByOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>, TError,{organization: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>, TError,{organization: string}, TContext> => {

const mutationKey = ['deleteSmtpConfigByOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>, {organization: string}> = (props) => {
          const {organization} = props ?? {};

          return  deleteSmtpConfigByOrganization(organization,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSmtpConfigByOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>>

    export type DeleteSmtpConfigByOrganizationMutationError = unknown

    /**
 * @summary Exclui configuração Smtp do Tenant
 */
export const useDeleteSmtpConfigByOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>, TError,{organization: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSmtpConfigByOrganization>>,
        TError,
        {organization: string},
        TContext
      > => {
      return useMutation(getDeleteSmtpConfigByOrganizationMutationOptions(options), queryClient);
    }

export type testSmtpConnectionByOrganizationResponse200 = {
  data: NotificationSmtpConfigTestConnectionDto
  status: 200
}

export type testSmtpConnectionByOrganizationResponseSuccess = (testSmtpConnectionByOrganizationResponse200) & {
  headers: Headers;
};
;

export type testSmtpConnectionByOrganizationResponse = (testSmtpConnectionByOrganizationResponseSuccess)

export const getTestSmtpConnectionByOrganizationUrl = (organization: string,) => {




  return `/v1/smtp-configs/organization/${organization}/test-connection`
}

/**
 * @summary Testa configuração Smtp da Organização
 */
export const testSmtpConnectionByOrganization = async (organization: string,
    smtpConfigTestRequest: SmtpConfigTestRequest, options?: RequestInit): Promise<testSmtpConnectionByOrganizationResponse> => {

  return customInstanceBpm<testSmtpConnectionByOrganizationResponse>(getTestSmtpConnectionByOrganizationUrl(organization),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smtpConfigTestRequest)
  }
);}




export const getTestSmtpConnectionByOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>, TError,{organization: string;data: SmtpConfigTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>, TError,{organization: string;data: SmtpConfigTestRequest}, TContext> => {

const mutationKey = ['testSmtpConnectionByOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>, {organization: string;data: SmtpConfigTestRequest}> = (props) => {
          const {organization,data} = props ?? {};

          return  testSmtpConnectionByOrganization(organization,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestSmtpConnectionByOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>>
    export type TestSmtpConnectionByOrganizationMutationBody = SmtpConfigTestRequest
    export type TestSmtpConnectionByOrganizationMutationError = unknown

    /**
 * @summary Testa configuração Smtp da Organização
 */
export const useTestSmtpConnectionByOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>, TError,{organization: string;data: SmtpConfigTestRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testSmtpConnectionByOrganization>>,
        TError,
        {organization: string;data: SmtpConfigTestRequest},
        TContext
      > => {
      return useMutation(getTestSmtpConnectionByOrganizationMutationOptions(options), queryClient);
    }

export type getIncidentStackTraceResponse200 = {
  data: string
  status: 200
}

export type getIncidentStackTraceResponseSuccess = (getIncidentStackTraceResponse200) & {
  headers: Headers;
};
;

export type getIncidentStackTraceResponse = (getIncidentStackTraceResponseSuccess)

export const getGetIncidentStackTraceUrl = (processInstanceId: string,
    incidentId: string,) => {




  return `/v1/process-instances/${processInstanceId}/incidents/${incidentId}/stacktrace`
}

/**
 * @summary Retorna o log detalhado do incidente da instância do processo
 */
export const getIncidentStackTrace = async (processInstanceId: string,
    incidentId: string, options?: RequestInit): Promise<getIncidentStackTraceResponse> => {

  return customInstanceBpm<getIncidentStackTraceResponse>(getGetIncidentStackTraceUrl(processInstanceId,incidentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetIncidentStackTraceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIncidentStackTrace>>, TError,{processInstanceId: string;incidentId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof getIncidentStackTrace>>, TError,{processInstanceId: string;incidentId: string}, TContext> => {

const mutationKey = ['getIncidentStackTrace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getIncidentStackTrace>>, {processInstanceId: string;incidentId: string}> = (props) => {
          const {processInstanceId,incidentId} = props ?? {};

          return  getIncidentStackTrace(processInstanceId,incidentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetIncidentStackTraceMutationResult = NonNullable<Awaited<ReturnType<typeof getIncidentStackTrace>>>

    export type GetIncidentStackTraceMutationError = unknown

    /**
 * @summary Retorna o log detalhado do incidente da instância do processo
 */
export const useGetIncidentStackTrace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIncidentStackTrace>>, TError,{processInstanceId: string;incidentId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getIncidentStackTrace>>,
        TError,
        {processInstanceId: string;incidentId: string},
        TContext
      > => {
      return useMutation(getGetIncidentStackTraceMutationOptions(options), queryClient);
    }

export type retryIncidentResponse204 = {
  data: void
  status: 204
}

export type retryIncidentResponseSuccess = (retryIncidentResponse204) & {
  headers: Headers;
};
;

export type retryIncidentResponse = (retryIncidentResponseSuccess)

export const getRetryIncidentUrl = (processInstanceId: string,
    incidentId: string,) => {




  return `/v1/process-instances/${processInstanceId}/incidents/${incidentId}/retry`
}

/**
 * @summary Reprocessa um incidente da instância do processo
 */
export const retryIncident = async (processInstanceId: string,
    incidentId: string, options?: RequestInit): Promise<retryIncidentResponse> => {

  return customInstanceBpm<retryIncidentResponse>(getRetryIncidentUrl(processInstanceId,incidentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRetryIncidentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryIncident>>, TError,{processInstanceId: string;incidentId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof retryIncident>>, TError,{processInstanceId: string;incidentId: string}, TContext> => {

const mutationKey = ['retryIncident'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryIncident>>, {processInstanceId: string;incidentId: string}> = (props) => {
          const {processInstanceId,incidentId} = props ?? {};

          return  retryIncident(processInstanceId,incidentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryIncidentMutationResult = NonNullable<Awaited<ReturnType<typeof retryIncident>>>

    export type RetryIncidentMutationError = unknown

    /**
 * @summary Reprocessa um incidente da instância do processo
 */
export const useRetryIncident = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryIncident>>, TError,{processInstanceId: string;incidentId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryIncident>>,
        TError,
        {processInstanceId: string;incidentId: string},
        TContext
      > => {
      return useMutation(getRetryIncidentMutationOptions(options), queryClient);
    }

export type startExternalPortalProcessDefinitionResponse200 = {
  data: ProcessInstanceDto
  status: 200
}

export type startExternalPortalProcessDefinitionResponseSuccess = (startExternalPortalProcessDefinitionResponse200) & {
  headers: Headers;
};
;

export type startExternalPortalProcessDefinitionResponse = (startExternalPortalProcessDefinitionResponseSuccess)

export const getStartExternalPortalProcessDefinitionUrl = (processDefinitionId: string,) => {




  return `/v1/process-definitions/portal-externo/${processDefinitionId}/start`
}

/**
 * @summary Inicia processo disponivel no portal externo
 */
export const startExternalPortalProcessDefinition = async (processDefinitionId: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<startExternalPortalProcessDefinitionResponse> => {

  return customInstanceBpm<startExternalPortalProcessDefinitionResponse>(getStartExternalPortalProcessDefinitionUrl(processDefinitionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getStartExternalPortalProcessDefinitionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>, TError,{processDefinitionId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>, TError,{processDefinitionId: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['startExternalPortalProcessDefinition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>, {processDefinitionId: string;data: CompleteTaskInput}> = (props) => {
          const {processDefinitionId,data} = props ?? {};

          return  startExternalPortalProcessDefinition(processDefinitionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartExternalPortalProcessDefinitionMutationResult = NonNullable<Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>>
    export type StartExternalPortalProcessDefinitionMutationBody = CompleteTaskInput
    export type StartExternalPortalProcessDefinitionMutationError = unknown

    /**
 * @summary Inicia processo disponivel no portal externo
 */
export const useStartExternalPortalProcessDefinition = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>, TError,{processDefinitionId: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startExternalPortalProcessDefinition>>,
        TError,
        {processDefinitionId: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getStartExternalPortalProcessDefinitionMutationOptions(options), queryClient);
    }

export type importClientesDoczResponse202 = {
  data: string[]
  status: 202
}

export type importClientesDoczResponseSuccess = (importClientesDoczResponse202) & {
  headers: Headers;
};
;

export type importClientesDoczResponse = (importClientesDoczResponseSuccess)

export const getImportClientesDoczUrl = () => {




  return `/v1/docz/import-clientes`
}

/**
 * @summary Importar Id dos clientes do Docz
 */
export const importClientesDocz = async (importClientesDoczBody: string, options?: RequestInit): Promise<importClientesDoczResponse> => {

  return customInstanceBpm<importClientesDoczResponse>(getImportClientesDoczUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'text/plain', ...options?.headers },
    body: importClientesDoczBody
  }
);}




export const getImportClientesDoczMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importClientesDocz>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof importClientesDocz>>, TError,{data: string}, TContext> => {

const mutationKey = ['importClientesDocz'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importClientesDocz>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  importClientesDocz(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportClientesDoczMutationResult = NonNullable<Awaited<ReturnType<typeof importClientesDocz>>>
    export type ImportClientesDoczMutationBody = string
    export type ImportClientesDoczMutationError = unknown

    /**
 * @summary Importar Id dos clientes do Docz
 */
export const useImportClientesDocz = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importClientesDocz>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importClientesDocz>>,
        TError,
        {data: string},
        TContext
      > => {
      return useMutation(getImportClientesDoczMutationOptions(options), queryClient);
    }

export type createUserFromCsvResponse202 = {
  data: string[]
  status: 202
}

export type createUserFromCsvResponseSuccess = (createUserFromCsvResponse202) & {
  headers: Headers;
};
;

export type createUserFromCsvResponse = (createUserFromCsvResponseSuccess)

export const getCreateUserFromCsvUrl = (tenant: string,) => {




  return `/v1/batch/${tenant}/users`
}

/**
 * @summary Cria usuários em lote
 */
export const createUserFromCsv = async (tenant: string,
    createUserFromCsvBody?: CreateUserFromCsvBody, options?: RequestInit): Promise<createUserFromCsvResponse> => {
    const formData = new FormData();
if(createUserFromCsvBody?.file !== undefined) {
 formData.append(`file`, createUserFromCsvBody.file);
 }

  return customInstanceBpm<createUserFromCsvResponse>(getCreateUserFromCsvUrl(tenant),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateUserFromCsvMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsv>>, TError,{tenant: string;data?: CreateUserFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsv>>, TError,{tenant: string;data?: CreateUserFromCsvBody}, TContext> => {

const mutationKey = ['createUserFromCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserFromCsv>>, {tenant: string;data?: CreateUserFromCsvBody}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createUserFromCsv(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserFromCsvMutationResult = NonNullable<Awaited<ReturnType<typeof createUserFromCsv>>>
    export type CreateUserFromCsvMutationBody = CreateUserFromCsvBody | undefined
    export type CreateUserFromCsvMutationError = unknown

    /**
 * @summary Cria usuários em lote
 */
export const useCreateUserFromCsv = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserFromCsv>>, TError,{tenant: string;data?: CreateUserFromCsvBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserFromCsv>>,
        TError,
        {tenant: string;data?: CreateUserFromCsvBody},
        TContext
      > => {
      return useMutation(getCreateUserFromCsvMutationOptions(options), queryClient);
    }

export type getIsSignUpActivateResponse200 = {
  data: SignUpStateDto
  status: 200
}

export type getIsSignUpActivateResponseSuccess = (getIsSignUpActivateResponse200) & {
  headers: Headers;
};
;

export type getIsSignUpActivateResponse = (getIsSignUpActivateResponseSuccess)

export const getGetIsSignUpActivateUrl = () => {




  return `/smart-bpm/sign-up-state`
}

/**
 * @summary Retorna os recusrso de cadastra-se está habilitado na plataforma
 */
export const getIsSignUpActivate = async ( options?: RequestInit): Promise<getIsSignUpActivateResponse> => {

  return customInstanceBpm<getIsSignUpActivateResponse>(getGetIsSignUpActivateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetIsSignUpActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIsSignUpActivate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof getIsSignUpActivate>>, TError,void, TContext> => {

const mutationKey = ['getIsSignUpActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getIsSignUpActivate>>, void> = () => {


          return  getIsSignUpActivate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetIsSignUpActivateMutationResult = NonNullable<Awaited<ReturnType<typeof getIsSignUpActivate>>>

    export type GetIsSignUpActivateMutationError = unknown

    /**
 * @summary Retorna os recusrso de cadastra-se está habilitado na plataforma
 */
export const useGetIsSignUpActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIsSignUpActivate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getIsSignUpActivate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetIsSignUpActivateMutationOptions(options), queryClient);
    }

export type saveThemeConfigurationResponse200 = {
  data: ThemeConfigurationDownloadDto
  status: 200
}

export type saveThemeConfigurationResponseSuccess = (saveThemeConfigurationResponse200) & {
  headers: Headers;
};
;

export type saveThemeConfigurationResponse = (saveThemeConfigurationResponseSuccess)

export const getSaveThemeConfigurationUrl = (params: SaveThemeConfigurationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/theme/save?${stringifiedParams}` : `/smart-bpm/rest/theme/save`
}

/**
 * @summary Cria um tema pelo tenant
 */
export const saveThemeConfiguration = async (params: SaveThemeConfigurationParams,
    saveThemeConfigurationBody?: SaveThemeConfigurationBody, options?: RequestInit): Promise<saveThemeConfigurationResponse> => {

  return customInstanceBpm<saveThemeConfigurationResponse>(getSaveThemeConfigurationUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveThemeConfigurationBody)
  }
);}




export const getSaveThemeConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveThemeConfiguration>>, TError,{params: SaveThemeConfigurationParams;data?: SaveThemeConfigurationBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof saveThemeConfiguration>>, TError,{params: SaveThemeConfigurationParams;data?: SaveThemeConfigurationBody}, TContext> => {

const mutationKey = ['saveThemeConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveThemeConfiguration>>, {params: SaveThemeConfigurationParams;data?: SaveThemeConfigurationBody}> = (props) => {
          const {params,data} = props ?? {};

          return  saveThemeConfiguration(params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveThemeConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof saveThemeConfiguration>>>
    export type SaveThemeConfigurationMutationBody = SaveThemeConfigurationBody | undefined
    export type SaveThemeConfigurationMutationError = unknown

    /**
 * @summary Cria um tema pelo tenant
 */
export const useSaveThemeConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveThemeConfiguration>>, TError,{params: SaveThemeConfigurationParams;data?: SaveThemeConfigurationBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveThemeConfiguration>>,
        TError,
        {params: SaveThemeConfigurationParams;data?: SaveThemeConfigurationBody},
        TContext
      > => {
      return useMutation(getSaveThemeConfigurationMutationOptions(options), queryClient);
    }

export type completeTaskResponse204 = {
  data: void
  status: 204
}

export type completeTaskResponseSuccess = (completeTaskResponse204) & {
  headers: Headers;
};
;

export type completeTaskResponse = (completeTaskResponseSuccess)

export const getCompleteTaskUrl = (id: string,) => {




  return `/smart-bpm/rest/task/${id}/complete`
}

/**
 * @summary Conclui tarefa por ID
 */
export const completeTask = async (id: string,
    completeTaskDto: CompleteTaskDto, options?: RequestInit): Promise<completeTaskResponse> => {

  return customInstanceBpm<completeTaskResponse>(getCompleteTaskUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskDto)
  }
);}




export const getCompleteTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string;data: CompleteTaskDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string;data: CompleteTaskDto}, TContext> => {

const mutationKey = ['completeTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTask>>, {id: string;data: CompleteTaskDto}> = (props) => {
          const {id,data} = props ?? {};

          return  completeTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof completeTask>>>
    export type CompleteTaskMutationBody = CompleteTaskDto
    export type CompleteTaskMutationError = unknown

    /**
 * @summary Conclui tarefa por ID
 */
export const useCompleteTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTask>>, TError,{id: string;data: CompleteTaskDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeTask>>,
        TError,
        {id: string;data: CompleteTaskDto},
        TContext
      > => {
      return useMutation(getCompleteTaskMutationOptions(options), queryClient);
    }

export type batchTaskApprovalResponse200 = {
  data: ResponseTaskBpmDto[]
  status: 200
}

export type batchTaskApprovalResponseSuccess = (batchTaskApprovalResponse200) & {
  headers: Headers;
};
;

export type batchTaskApprovalResponse = (batchTaskApprovalResponseSuccess)

export const getBatchTaskApprovalUrl = () => {




  return `/smart-bpm/rest/task/batch-approval`
}

/**
 * @summary Conclui tarefas em lote
 */
export const batchTaskApproval = async (completeTaskBpmDto: CompleteTaskBpmDto[], options?: RequestInit): Promise<batchTaskApprovalResponse> => {

  return customInstanceBpm<batchTaskApprovalResponse>(getBatchTaskApprovalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskBpmDto)
  }
);}




export const getBatchTaskApprovalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchTaskApproval>>, TError,{data: CompleteTaskBpmDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof batchTaskApproval>>, TError,{data: CompleteTaskBpmDto[]}, TContext> => {

const mutationKey = ['batchTaskApproval'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchTaskApproval>>, {data: CompleteTaskBpmDto[]}> = (props) => {
          const {data} = props ?? {};

          return  batchTaskApproval(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchTaskApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof batchTaskApproval>>>
    export type BatchTaskApprovalMutationBody = CompleteTaskBpmDto[]
    export type BatchTaskApprovalMutationError = unknown

    /**
 * @summary Conclui tarefas em lote
 */
export const useBatchTaskApproval = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchTaskApproval>>, TError,{data: CompleteTaskBpmDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchTaskApproval>>,
        TError,
        {data: CompleteTaskBpmDto[]},
        TContext
      > => {
      return useMutation(getBatchTaskApprovalMutationOptions(options), queryClient);
    }

export type startProcessByProcessDefinitionIdOldResponse200 = {
  data: ProcessInstanceDto
  status: 200
}

export type startProcessByProcessDefinitionIdOldResponseSuccess = (startProcessByProcessDefinitionIdOldResponse200) & {
  headers: Headers;
};
;

export type startProcessByProcessDefinitionIdOldResponse = (startProcessByProcessDefinitionIdOldResponseSuccess)

export const getStartProcessByProcessDefinitionIdOldUrl = (processDefinitionId: string,) => {




  return `/smart-bpm/rest/process-definition/${processDefinitionId}/start`
}

/**
 * @summary Inicia uma instância de processo por ID
 */
export const startProcessByProcessDefinitionIdOld = async (processDefinitionId: string,
    completeTaskDto: CompleteTaskDto, options?: RequestInit): Promise<startProcessByProcessDefinitionIdOldResponse> => {

  return customInstanceBpm<startProcessByProcessDefinitionIdOldResponse>(getStartProcessByProcessDefinitionIdOldUrl(processDefinitionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskDto)
  }
);}




export const getStartProcessByProcessDefinitionIdOldMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>, TError,{processDefinitionId: string;data: CompleteTaskDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>, TError,{processDefinitionId: string;data: CompleteTaskDto}, TContext> => {

const mutationKey = ['startProcessByProcessDefinitionIdOld'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>, {processDefinitionId: string;data: CompleteTaskDto}> = (props) => {
          const {processDefinitionId,data} = props ?? {};

          return  startProcessByProcessDefinitionIdOld(processDefinitionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProcessByProcessDefinitionIdOldMutationResult = NonNullable<Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>>
    export type StartProcessByProcessDefinitionIdOldMutationBody = CompleteTaskDto
    export type StartProcessByProcessDefinitionIdOldMutationError = unknown

    /**
 * @summary Inicia uma instância de processo por ID
 */
export const useStartProcessByProcessDefinitionIdOld = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>, TError,{processDefinitionId: string;data: CompleteTaskDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startProcessByProcessDefinitionIdOld>>,
        TError,
        {processDefinitionId: string;data: CompleteTaskDto},
        TContext
      > => {
      return useMutation(getStartProcessByProcessDefinitionIdOldMutationOptions(options), queryClient);
    }

export type createNotificationResponse200 = {
  data: NotificationDto
  status: 200
}

export type createNotificationResponseSuccess = (createNotificationResponse200) & {
  headers: Headers;
};
;

export type createNotificationResponse = (createNotificationResponseSuccess)

export const getCreateNotificationUrl = () => {




  return `/smart-bpm/rest/notification/save`
}

/**
 * @summary Cria uma notificação
 */
export const createNotification = async (notificationDto: NotificationDto, options?: RequestInit): Promise<createNotificationResponse> => {

  return customInstanceBpm<createNotificationResponse>(getCreateNotificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationDto)
  }
);}




export const getCreateNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: NotificationDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: NotificationDto}, TContext> => {

const mutationKey = ['createNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotification>>, {data: NotificationDto}> = (props) => {
          const {data} = props ?? {};

          return  createNotification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof createNotification>>>
    export type CreateNotificationMutationBody = NotificationDto
    export type CreateNotificationMutationError = unknown

    /**
 * @summary Cria uma notificação
 */
export const useCreateNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotification>>, TError,{data: NotificationDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotification>>,
        TError,
        {data: NotificationDto},
        TContext
      > => {
      return useMutation(getCreateNotificationMutationOptions(options), queryClient);
    }

export type createNotificationToAllUsersResponse200 = {
  data: NotificationDto
  status: 200
}

export type createNotificationToAllUsersResponseSuccess = (createNotificationToAllUsersResponse200) & {
  headers: Headers;
};
;

export type createNotificationToAllUsersResponse = (createNotificationToAllUsersResponseSuccess)

export const getCreateNotificationToAllUsersUrl = () => {




  return `/smart-bpm/rest/notification/save-to-all`
}

/**
 * @summary Cria uma notificação para todos os usuários
 */
export const createNotificationToAllUsers = async (notificationDto: NotificationDto, options?: RequestInit): Promise<createNotificationToAllUsersResponse> => {

  return customInstanceBpm<createNotificationToAllUsersResponse>(getCreateNotificationToAllUsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationDto)
  }
);}




export const getCreateNotificationToAllUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationToAllUsers>>, TError,{data: NotificationDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotificationToAllUsers>>, TError,{data: NotificationDto}, TContext> => {

const mutationKey = ['createNotificationToAllUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotificationToAllUsers>>, {data: NotificationDto}> = (props) => {
          const {data} = props ?? {};

          return  createNotificationToAllUsers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationToAllUsersMutationResult = NonNullable<Awaited<ReturnType<typeof createNotificationToAllUsers>>>
    export type CreateNotificationToAllUsersMutationBody = NotificationDto
    export type CreateNotificationToAllUsersMutationError = unknown

    /**
 * @summary Cria uma notificação para todos os usuários
 */
export const useCreateNotificationToAllUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationToAllUsers>>, TError,{data: NotificationDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotificationToAllUsers>>,
        TError,
        {data: NotificationDto},
        TContext
      > => {
      return useMutation(getCreateNotificationToAllUsersMutationOptions(options), queryClient);
    }

export type markNotificationAsUnreadedResponse200 = {
  data: void
  status: 200
}

export type markNotificationAsUnreadedResponseSuccess = (markNotificationAsUnreadedResponse200) & {
  headers: Headers;
};
;

export type markNotificationAsUnreadedResponse = (markNotificationAsUnreadedResponseSuccess)

export const getMarkNotificationAsUnreadedUrl = () => {




  return `/smart-bpm/rest/notification/mark-as-unreaded`
}

/**
 * @summary Marca notificações como não lida
 */
export const markNotificationAsUnreaded = async (notificationDto: NotificationDto[], options?: RequestInit): Promise<markNotificationAsUnreadedResponse> => {

  return customInstanceBpm<markNotificationAsUnreadedResponse>(getMarkNotificationAsUnreadedUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationDto)
  }
);}




export const getMarkNotificationAsUnreadedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsUnreaded>>, TError,{data: NotificationDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsUnreaded>>, TError,{data: NotificationDto[]}, TContext> => {

const mutationKey = ['markNotificationAsUnreaded'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationAsUnreaded>>, {data: NotificationDto[]}> = (props) => {
          const {data} = props ?? {};

          return  markNotificationAsUnreaded(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationAsUnreadedMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationAsUnreaded>>>
    export type MarkNotificationAsUnreadedMutationBody = NotificationDto[]
    export type MarkNotificationAsUnreadedMutationError = unknown

    /**
 * @summary Marca notificações como não lida
 */
export const useMarkNotificationAsUnreaded = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsUnreaded>>, TError,{data: NotificationDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationAsUnreaded>>,
        TError,
        {data: NotificationDto[]},
        TContext
      > => {
      return useMutation(getMarkNotificationAsUnreadedMutationOptions(options), queryClient);
    }

export type markNotificationAsReadedResponse200 = {
  data: void
  status: 200
}

export type markNotificationAsReadedResponseSuccess = (markNotificationAsReadedResponse200) & {
  headers: Headers;
};
;

export type markNotificationAsReadedResponse = (markNotificationAsReadedResponseSuccess)

export const getMarkNotificationAsReadedUrl = () => {




  return `/smart-bpm/rest/notification/mark-as-readed`
}

/**
 * @summary Marca notificações como lida
 */
export const markNotificationAsReaded = async (notificationDto: NotificationDto[], options?: RequestInit): Promise<markNotificationAsReadedResponse> => {

  return customInstanceBpm<markNotificationAsReadedResponse>(getMarkNotificationAsReadedUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationDto)
  }
);}




export const getMarkNotificationAsReadedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsReaded>>, TError,{data: NotificationDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsReaded>>, TError,{data: NotificationDto[]}, TContext> => {

const mutationKey = ['markNotificationAsReaded'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationAsReaded>>, {data: NotificationDto[]}> = (props) => {
          const {data} = props ?? {};

          return  markNotificationAsReaded(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationAsReadedMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationAsReaded>>>
    export type MarkNotificationAsReadedMutationBody = NotificationDto[]
    export type MarkNotificationAsReadedMutationError = unknown

    /**
 * @summary Marca notificações como lida
 */
export const useMarkNotificationAsReaded = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationAsReaded>>, TError,{data: NotificationDto[]}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationAsReaded>>,
        TError,
        {data: NotificationDto[]},
        TContext
      > => {
      return useMutation(getMarkNotificationAsReadedMutationOptions(options), queryClient);
    }

export type saveSystemLogResponse204 = {
  data: void
  status: 204
}

export type saveSystemLogResponseSuccess = (saveSystemLogResponse204) & {
  headers: Headers;
};
;

export type saveSystemLogResponse = (saveSystemLogResponseSuccess)

export const getSaveSystemLogUrl = () => {




  return `/smart-bpm/rest/log/create`
}

/**
 * @summary Salva log
 */
export const saveSystemLog = async (smartLogDto: SmartLogDto, options?: RequestInit): Promise<saveSystemLogResponse> => {

  return customInstanceBpm<saveSystemLogResponse>(getSaveSystemLogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartLogDto)
  }
);}




export const getSaveSystemLogMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSystemLog>>, TError,{data: SmartLogDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof saveSystemLog>>, TError,{data: SmartLogDto}, TContext> => {

const mutationKey = ['saveSystemLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSystemLog>>, {data: SmartLogDto}> = (props) => {
          const {data} = props ?? {};

          return  saveSystemLog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveSystemLogMutationResult = NonNullable<Awaited<ReturnType<typeof saveSystemLog>>>
    export type SaveSystemLogMutationBody = SmartLogDto
    export type SaveSystemLogMutationError = unknown

    /**
 * @summary Salva log
 */
export const useSaveSystemLog = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSystemLog>>, TError,{data: SmartLogDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveSystemLog>>,
        TError,
        {data: SmartLogDto},
        TContext
      > => {
      return useMutation(getSaveSystemLogMutationOptions(options), queryClient);
    }

export type addFileResponse200 = {
  data: UploadFileDto
  status: 200
}

export type addFileResponseSuccess = (addFileResponse200) & {
  headers: Headers;
};
;

export type addFileResponse = (addFileResponseSuccess)

export const getAddFileUrl = () => {




  return `/smart-bpm/rest/attachment/new`
}

/**
 * @summary Faz uplaod de um arquivo
 */
export const addFile = async (addFileBody?: AddFileBody, options?: RequestInit): Promise<addFileResponse> => {
    const formData = new FormData();
if(addFileBody?.RemoteFile !== undefined) {
 formData.append(`RemoteFile`, addFileBody.RemoteFile);
 }
if(addFileBody?.file !== undefined) {
 formData.append(`file`, addFileBody.file);
 }

  return customInstanceBpm<addFileResponse>(getAddFileUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getAddFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFile>>, TError,{data?: AddFileBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof addFile>>, TError,{data?: AddFileBody}, TContext> => {

const mutationKey = ['addFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFile>>, {data?: AddFileBody}> = (props) => {
          const {data} = props ?? {};

          return  addFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFileMutationResult = NonNullable<Awaited<ReturnType<typeof addFile>>>
    export type AddFileMutationBody = AddFileBody | undefined
    export type AddFileMutationError = unknown

    /**
 * @summary Faz uplaod de um arquivo
 */
export const useAddFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFile>>, TError,{data?: AddFileBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFile>>,
        TError,
        {data?: AddFileBody},
        TContext
      > => {
      return useMutation(getAddFileMutationOptions(options), queryClient);
    }

export type getEnabledServicesResponse200 = {
  data: ActiveServicesDto
  status: 200
}

export type getEnabledServicesResponseSuccess = (getEnabledServicesResponse200) & {
  headers: Headers;
};
;

export type getEnabledServicesResponse = (getEnabledServicesResponseSuccess)

export const getGetEnabledServicesUrl = () => {




  return `/smart-bpm/enabled-services`
}

/**
 * @summary Retorna os recusrsos que estão habilitados na plataforma
 */
export const getEnabledServices = async ( options?: RequestInit): Promise<getEnabledServicesResponse> => {

  return customInstanceBpm<getEnabledServicesResponse>(getGetEnabledServicesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetEnabledServicesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEnabledServices>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof getEnabledServices>>, TError,void, TContext> => {

const mutationKey = ['getEnabledServices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEnabledServices>>, void> = () => {


          return  getEnabledServices(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetEnabledServicesMutationResult = NonNullable<Awaited<ReturnType<typeof getEnabledServices>>>

    export type GetEnabledServicesMutationError = unknown

    /**
 * @summary Retorna os recusrsos que estão habilitados na plataforma
 */
export const useGetEnabledServices = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEnabledServices>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEnabledServices>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetEnabledServicesMutationOptions(options), queryClient);
    }

export type cadastrarSgePessoaResponse200 = {
  data: PessoaResult
  status: 200
}

export type cadastrarSgePessoaResponseSuccess = (cadastrarSgePessoaResponse200) & {
  headers: Headers;
};
;

export type cadastrarSgePessoaResponse = (cadastrarSgePessoaResponseSuccess)

export const getCadastrarSgePessoaUrl = (params?: CadastrarSgePessoaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/pessoa?${stringifiedParams}` : `/sge/pessoa`
}

/**
 * @summary Cadastra pessoa no SGE
 */
export const cadastrarSgePessoa = async (cadastroPessoaInput: CadastroPessoaInput,
    params?: CadastrarSgePessoaParams, options?: RequestInit): Promise<cadastrarSgePessoaResponse> => {

  return customInstanceBpm<cadastrarSgePessoaResponse>(getCadastrarSgePessoaUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cadastroPessoaInput)
  }
);}




export const getCadastrarSgePessoaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgePessoa>>, TError,{data: CadastroPessoaInput;params?: CadastrarSgePessoaParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgePessoa>>, TError,{data: CadastroPessoaInput;params?: CadastrarSgePessoaParams}, TContext> => {

const mutationKey = ['cadastrarSgePessoa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cadastrarSgePessoa>>, {data: CadastroPessoaInput;params?: CadastrarSgePessoaParams}> = (props) => {
          const {data,params} = props ?? {};

          return  cadastrarSgePessoa(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CadastrarSgePessoaMutationResult = NonNullable<Awaited<ReturnType<typeof cadastrarSgePessoa>>>
    export type CadastrarSgePessoaMutationBody = CadastroPessoaInput
    export type CadastrarSgePessoaMutationError = unknown

    /**
 * @summary Cadastra pessoa no SGE
 */
export const useCadastrarSgePessoa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgePessoa>>, TError,{data: CadastroPessoaInput;params?: CadastrarSgePessoaParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cadastrarSgePessoa>>,
        TError,
        {data: CadastroPessoaInput;params?: CadastrarSgePessoaParams},
        TContext
      > => {
      return useMutation(getCadastrarSgePessoaMutationOptions(options), queryClient);
    }

export type importSesiIpaasUrlsResponse200 = {
  data: string[]
  status: 200
}

export type importSesiIpaasUrlsResponseSuccess = (importSesiIpaasUrlsResponse200) & {
  headers: Headers;
};
;

export type importSesiIpaasUrlsResponse = (importSesiIpaasUrlsResponseSuccess)

export const getImportSesiIpaasUrlsUrl = () => {




  return `/sge/ipaas/import-ipaas-urls`
}

/**
 * @summary Importar Urls do Ipaas
 */
export const importSesiIpaasUrls = async (importSesiIpaasUrlsBody?: ImportSesiIpaasUrlsBody, options?: RequestInit): Promise<importSesiIpaasUrlsResponse> => {
    const formData = new FormData();
if(importSesiIpaasUrlsBody?.file !== undefined) {
 formData.append(`file`, importSesiIpaasUrlsBody.file);
 }

  return customInstanceBpm<importSesiIpaasUrlsResponse>(getImportSesiIpaasUrlsUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getImportSesiIpaasUrlsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSesiIpaasUrls>>, TError,{data?: ImportSesiIpaasUrlsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof importSesiIpaasUrls>>, TError,{data?: ImportSesiIpaasUrlsBody}, TContext> => {

const mutationKey = ['importSesiIpaasUrls'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importSesiIpaasUrls>>, {data?: ImportSesiIpaasUrlsBody}> = (props) => {
          const {data} = props ?? {};

          return  importSesiIpaasUrls(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportSesiIpaasUrlsMutationResult = NonNullable<Awaited<ReturnType<typeof importSesiIpaasUrls>>>
    export type ImportSesiIpaasUrlsMutationBody = ImportSesiIpaasUrlsBody | undefined
    export type ImportSesiIpaasUrlsMutationError = unknown

    /**
 * @summary Importar Urls do Ipaas
 */
export const useImportSesiIpaasUrls = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSesiIpaasUrls>>, TError,{data?: ImportSesiIpaasUrlsBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importSesiIpaasUrls>>,
        TError,
        {data?: ImportSesiIpaasUrlsBody},
        TContext
      > => {
      return useMutation(getImportSesiIpaasUrlsMutationOptions(options), queryClient);
    }

export type cadastrarSgeIntegracaoMatriculaResponse200 = {
  data: MatriculaResult
  status: 200
}

export type cadastrarSgeIntegracaoMatriculaResponseSuccess = (cadastrarSgeIntegracaoMatriculaResponse200) & {
  headers: Headers;
};
;

export type cadastrarSgeIntegracaoMatriculaResponse = (cadastrarSgeIntegracaoMatriculaResponseSuccess)

export const getCadastrarSgeIntegracaoMatriculaUrl = (params?: CadastrarSgeIntegracaoMatriculaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/integracao-matricula?${stringifiedParams}` : `/sge/integracao-matricula`
}

/**
 * @summary Faz matricula no SGE
 */
export const cadastrarSgeIntegracaoMatricula = async (integracaoMatriculaInput: IntegracaoMatriculaInput,
    params?: CadastrarSgeIntegracaoMatriculaParams, options?: RequestInit): Promise<cadastrarSgeIntegracaoMatriculaResponse> => {

  return customInstanceBpm<cadastrarSgeIntegracaoMatriculaResponse>(getCadastrarSgeIntegracaoMatriculaUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(integracaoMatriculaInput)
  }
);}




export const getCadastrarSgeIntegracaoMatriculaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>, TError,{data: IntegracaoMatriculaInput;params?: CadastrarSgeIntegracaoMatriculaParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>, TError,{data: IntegracaoMatriculaInput;params?: CadastrarSgeIntegracaoMatriculaParams}, TContext> => {

const mutationKey = ['cadastrarSgeIntegracaoMatricula'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>, {data: IntegracaoMatriculaInput;params?: CadastrarSgeIntegracaoMatriculaParams}> = (props) => {
          const {data,params} = props ?? {};

          return  cadastrarSgeIntegracaoMatricula(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CadastrarSgeIntegracaoMatriculaMutationResult = NonNullable<Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>>
    export type CadastrarSgeIntegracaoMatriculaMutationBody = IntegracaoMatriculaInput
    export type CadastrarSgeIntegracaoMatriculaMutationError = unknown

    /**
 * @summary Faz matricula no SGE
 */
export const useCadastrarSgeIntegracaoMatricula = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>, TError,{data: IntegracaoMatriculaInput;params?: CadastrarSgeIntegracaoMatriculaParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cadastrarSgeIntegracaoMatricula>>,
        TError,
        {data: IntegracaoMatriculaInput;params?: CadastrarSgeIntegracaoMatriculaParams},
        TContext
      > => {
      return useMutation(getCadastrarSgeIntegracaoMatriculaMutationOptions(options), queryClient);
    }

export type cadastrarSgeClienteFornecedorResponse200 = {
  data: ClientFornecedorResult
  status: 200
}

export type cadastrarSgeClienteFornecedorResponseSuccess = (cadastrarSgeClienteFornecedorResponse200) & {
  headers: Headers;
};
;

export type cadastrarSgeClienteFornecedorResponse = (cadastrarSgeClienteFornecedorResponseSuccess)

export const getCadastrarSgeClienteFornecedorUrl = (params?: CadastrarSgeClienteFornecedorParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/cliente-fornecedor?${stringifiedParams}` : `/sge/cliente-fornecedor`
}

/**
 * @summary Cadastra cliente fornecedor no SGE
 */
export const cadastrarSgeClienteFornecedor = async (cadastroClienteFornecedorInput: CadastroClienteFornecedorInput,
    params?: CadastrarSgeClienteFornecedorParams, options?: RequestInit): Promise<cadastrarSgeClienteFornecedorResponse> => {

  return customInstanceBpm<cadastrarSgeClienteFornecedorResponse>(getCadastrarSgeClienteFornecedorUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cadastroClienteFornecedorInput)
  }
);}




export const getCadastrarSgeClienteFornecedorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>, TError,{data: CadastroClienteFornecedorInput;params?: CadastrarSgeClienteFornecedorParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>, TError,{data: CadastroClienteFornecedorInput;params?: CadastrarSgeClienteFornecedorParams}, TContext> => {

const mutationKey = ['cadastrarSgeClienteFornecedor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>, {data: CadastroClienteFornecedorInput;params?: CadastrarSgeClienteFornecedorParams}> = (props) => {
          const {data,params} = props ?? {};

          return  cadastrarSgeClienteFornecedor(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CadastrarSgeClienteFornecedorMutationResult = NonNullable<Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>>
    export type CadastrarSgeClienteFornecedorMutationBody = CadastroClienteFornecedorInput
    export type CadastrarSgeClienteFornecedorMutationError = unknown

    /**
 * @summary Cadastra cliente fornecedor no SGE
 */
export const useCadastrarSgeClienteFornecedor = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>, TError,{data: CadastroClienteFornecedorInput;params?: CadastrarSgeClienteFornecedorParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cadastrarSgeClienteFornecedor>>,
        TError,
        {data: CadastroClienteFornecedorInput;params?: CadastrarSgeClienteFornecedorParams},
        TContext
      > => {
      return useMutation(getCadastrarSgeClienteFornecedorMutationOptions(options), queryClient);
    }

export type cadastrarSgeAlunoResponse200 = {
  data: AlunoResult
  status: 200
}

export type cadastrarSgeAlunoResponseSuccess = (cadastrarSgeAlunoResponse200) & {
  headers: Headers;
};
;

export type cadastrarSgeAlunoResponse = (cadastrarSgeAlunoResponseSuccess)

export const getCadastrarSgeAlunoUrl = (params?: CadastrarSgeAlunoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/aluno?${stringifiedParams}` : `/sge/aluno`
}

/**
 * @summary Cadastra aluno no SGE
 */
export const cadastrarSgeAluno = async (cadastroAlunoInput: CadastroAlunoInput,
    params?: CadastrarSgeAlunoParams, options?: RequestInit): Promise<cadastrarSgeAlunoResponse> => {

  return customInstanceBpm<cadastrarSgeAlunoResponse>(getCadastrarSgeAlunoUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cadastroAlunoInput)
  }
);}




export const getCadastrarSgeAlunoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeAluno>>, TError,{data: CadastroAlunoInput;params?: CadastrarSgeAlunoParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeAluno>>, TError,{data: CadastroAlunoInput;params?: CadastrarSgeAlunoParams}, TContext> => {

const mutationKey = ['cadastrarSgeAluno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cadastrarSgeAluno>>, {data: CadastroAlunoInput;params?: CadastrarSgeAlunoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  cadastrarSgeAluno(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CadastrarSgeAlunoMutationResult = NonNullable<Awaited<ReturnType<typeof cadastrarSgeAluno>>>
    export type CadastrarSgeAlunoMutationBody = CadastroAlunoInput
    export type CadastrarSgeAlunoMutationError = unknown

    /**
 * @summary Cadastra aluno no SGE
 */
export const useCadastrarSgeAluno = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cadastrarSgeAluno>>, TError,{data: CadastroAlunoInput;params?: CadastrarSgeAlunoParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cadastrarSgeAluno>>,
        TError,
        {data: CadastroAlunoInput;params?: CadastrarSgeAlunoParams},
        TContext
      > => {
      return useMutation(getCadastrarSgeAlunoMutationOptions(options), queryClient);
    }

export type processSebraeContractResponse200 = {
  data: DocumentWithAllPropertiesDto
  status: 200
}

export type processSebraeContractResponseSuccess = (processSebraeContractResponse200) & {
  headers: Headers;
};
;

export type processSebraeContractResponse = (processSebraeContractResponseSuccess)

export const getProcessSebraeContractUrl = (params: ProcessSebraeContractParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sebrae/contrato?${stringifiedParams}` : `/sebrae/contrato`
}

/**
 * @summary Processa um contrato do Sebrae e cria documento
 */
export const processSebraeContract = async (params: ProcessSebraeContractParams, options?: RequestInit): Promise<processSebraeContractResponse> => {

  return customInstanceBpm<processSebraeContractResponse>(getProcessSebraeContractUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}




export const getProcessSebraeContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processSebraeContract>>, TError,{params: ProcessSebraeContractParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof processSebraeContract>>, TError,{params: ProcessSebraeContractParams}, TContext> => {

const mutationKey = ['processSebraeContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processSebraeContract>>, {params: ProcessSebraeContractParams}> = (props) => {
          const {params} = props ?? {};

          return  processSebraeContract(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessSebraeContractMutationResult = NonNullable<Awaited<ReturnType<typeof processSebraeContract>>>

    export type ProcessSebraeContractMutationError = unknown

    /**
 * @summary Processa um contrato do Sebrae e cria documento
 */
export const useProcessSebraeContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processSebraeContract>>, TError,{params: ProcessSebraeContractParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processSebraeContract>>,
        TError,
        {params: ProcessSebraeContractParams},
        TContext
      > => {
      return useMutation(getProcessSebraeContractMutationOptions(options), queryClient);
    }

export type replyResponse200 = {
  data: void
  status: 200
}

export type replyResponseSuccess = (replyResponse200) & {
  headers: Headers;
};
;

export type replyResponse = (replyResponseSuccess)

export const getReplyUrl = (tenant: string,
    processInstanceId: string,) => {




  return `/public/v1/${tenant}/email-process/process-instances/${processInstanceId}/reply`
}

export const reply = async (tenant: string,
    processInstanceId: string,
    emailProcessEventDto: EmailProcessEventDto, options?: RequestInit): Promise<replyResponse> => {

  return customInstanceBpm<replyResponse>(getReplyUrl(tenant,processInstanceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessEventDto)
  }
);}




export const getReplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reply>>, TError,{tenant: string;processInstanceId: string;data: EmailProcessEventDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof reply>>, TError,{tenant: string;processInstanceId: string;data: EmailProcessEventDto}, TContext> => {

const mutationKey = ['reply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reply>>, {tenant: string;processInstanceId: string;data: EmailProcessEventDto}> = (props) => {
          const {tenant,processInstanceId,data} = props ?? {};

          return  reply(tenant,processInstanceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyMutationResult = NonNullable<Awaited<ReturnType<typeof reply>>>
    export type ReplyMutationBody = EmailProcessEventDto
    export type ReplyMutationError = unknown

    export const useReply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reply>>, TError,{tenant: string;processInstanceId: string;data: EmailProcessEventDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reply>>,
        TError,
        {tenant: string;processInstanceId: string;data: EmailProcessEventDto},
        TContext
      > => {
      return useMutation(getReplyMutationOptions(options), queryClient);
    }

export type startProcessResponse200 = {
  data: EmailProcessStartedEventDto
  status: 200
}

export type startProcessResponseSuccess = (startProcessResponse200) & {
  headers: Headers;
};
;

export type startProcessResponse = (startProcessResponseSuccess)

export const getStartProcessUrl = (tenant: string,
    processDefinitionKey: string,) => {




  return `/public/v1/${tenant}/email-process/process-definitions/key/${processDefinitionKey}/start`
}

export const startProcess = async (tenant: string,
    processDefinitionKey: string,
    emailProcessEventDto: EmailProcessEventDto, options?: RequestInit): Promise<startProcessResponse> => {

  return customInstanceBpm<startProcessResponse>(getStartProcessUrl(tenant,processDefinitionKey),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailProcessEventDto)
  }
);}




export const getStartProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcess>>, TError,{tenant: string;processDefinitionKey: string;data: EmailProcessEventDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startProcess>>, TError,{tenant: string;processDefinitionKey: string;data: EmailProcessEventDto}, TContext> => {

const mutationKey = ['startProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProcess>>, {tenant: string;processDefinitionKey: string;data: EmailProcessEventDto}> = (props) => {
          const {tenant,processDefinitionKey,data} = props ?? {};

          return  startProcess(tenant,processDefinitionKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProcessMutationResult = NonNullable<Awaited<ReturnType<typeof startProcess>>>
    export type StartProcessMutationBody = EmailProcessEventDto
    export type StartProcessMutationError = unknown

    export const useStartProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProcess>>, TError,{tenant: string;processDefinitionKey: string;data: EmailProcessEventDto}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startProcess>>,
        TError,
        {tenant: string;processDefinitionKey: string;data: EmailProcessEventDto},
        TContext
      > => {
      return useMutation(getStartProcessMutationOptions(options), queryClient);
    }

export type uploadFileByLinkResponse200 = {
  data: UploadFileDto
  status: 200
}

export type uploadFileByLinkResponseSuccess = (uploadFileByLinkResponse200) & {
  headers: Headers;
};
;

export type uploadFileByLinkResponse = (uploadFileByLinkResponseSuccess)

export const getUploadFileByLinkUrl = (linkCode: string,) => {




  return `/public/v1/upload/link/${linkCode}`
}

/**
 * @summary Faz uplaod de um arquivo utilizando o link publico
 */
export const uploadFileByLink = async (linkCode: string,
    uploadFileByLinkBody?: UploadFileByLinkBody, options?: RequestInit): Promise<uploadFileByLinkResponse> => {
    const formData = new FormData();
if(uploadFileByLinkBody?.file !== undefined) {
 formData.append(`file`, uploadFileByLinkBody.file);
 }

  return customInstanceBpm<uploadFileByLinkResponse>(getUploadFileByLinkUrl(linkCode),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getUploadFileByLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFileByLink>>, TError,{linkCode: string;data?: UploadFileByLinkBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadFileByLink>>, TError,{linkCode: string;data?: UploadFileByLinkBody}, TContext> => {

const mutationKey = ['uploadFileByLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFileByLink>>, {linkCode: string;data?: UploadFileByLinkBody}> = (props) => {
          const {linkCode,data} = props ?? {};

          return  uploadFileByLink(linkCode,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadFileByLinkMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFileByLink>>>
    export type UploadFileByLinkMutationBody = UploadFileByLinkBody | undefined
    export type UploadFileByLinkMutationError = unknown

    /**
 * @summary Faz uplaod de um arquivo utilizando o link publico
 */
export const useUploadFileByLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFileByLink>>, TError,{linkCode: string;data?: UploadFileByLinkBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadFileByLink>>,
        TError,
        {linkCode: string;data?: UploadFileByLinkBody},
        TContext
      > => {
      return useMutation(getUploadFileByLinkMutationOptions(options), queryClient);
    }

export type startPublicProcessResponse200 = {
  data: ProcessInstanceNupDto
  status: 200
}

export type startPublicProcessResponseSuccess = (startPublicProcessResponse200) & {
  headers: Headers;
};
;

export type startPublicProcessResponse = (startPublicProcessResponseSuccess)

export const getStartPublicProcessUrl = (linkCode: string,) => {




  return `/public/v1/process-definitions/link/${linkCode}/start`
}

/**
 * @summary Inicia uma instância de processo pelo link publico do processo
 */
export const startPublicProcess = async (linkCode: string,
    completeTaskInput: CompleteTaskInput, options?: RequestInit): Promise<startPublicProcessResponse> => {

  return customInstanceBpm<startPublicProcessResponse>(getStartPublicProcessUrl(linkCode),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeTaskInput)
  }
);}




export const getStartPublicProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPublicProcess>>, TError,{linkCode: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof startPublicProcess>>, TError,{linkCode: string;data: CompleteTaskInput}, TContext> => {

const mutationKey = ['startPublicProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPublicProcess>>, {linkCode: string;data: CompleteTaskInput}> = (props) => {
          const {linkCode,data} = props ?? {};

          return  startPublicProcess(linkCode,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPublicProcessMutationResult = NonNullable<Awaited<ReturnType<typeof startPublicProcess>>>
    export type StartPublicProcessMutationBody = CompleteTaskInput
    export type StartPublicProcessMutationError = unknown

    /**
 * @summary Inicia uma instância de processo pelo link publico do processo
 */
export const useStartPublicProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPublicProcess>>, TError,{linkCode: string;data: CompleteTaskInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPublicProcess>>,
        TError,
        {linkCode: string;data: CompleteTaskInput},
        TContext
      > => {
      return useMutation(getStartPublicProcessMutationOptions(options), queryClient);
    }

export type loginResponse200 = {
  data: SimpleTokenResponseDto
  status: 200
}

export type loginResponse401 = {
  data: SimpleTokenResponseDto
  status: 401
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
export type loginResponseError = (loginResponse401) & {
  headers: Headers;
};

export type loginResponse = (loginResponseSuccess | loginResponseError)

export const getLoginUrl = () => {




  return `/public/v1/auth/login`
}

/**
 * @summary Gera um novo access token
 */
export const login = async (loginInput: LoginInput, options?: RequestInit): Promise<loginResponse> => {

  return customInstanceBpm<loginResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginInput)
  }
);}




export const getLoginMutationOptions = <TError = SimpleTokenResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginInput}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginInput}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginInput
    export type LoginMutationError = SimpleTokenResponseDto

    /**
 * @summary Gera um novo access token
 */
export const useLogin = <TError = SimpleTokenResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginInput},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

export type loginWithKeycloakTokenResponse200 = {
  data: AccessTokenSwagger
  status: 200
}

export type loginWithKeycloakTokenResponse401 = {
  data: LoginWithKeycloakToken401
  status: 401
}

export type loginWithKeycloakTokenResponseSuccess = (loginWithKeycloakTokenResponse200) & {
  headers: Headers;
};
export type loginWithKeycloakTokenResponseError = (loginWithKeycloakTokenResponse401) & {
  headers: Headers;
};

export type loginWithKeycloakTokenResponse = (loginWithKeycloakTokenResponseSuccess | loginWithKeycloakTokenResponseError)

export const getLoginWithKeycloakTokenUrl = () => {




  return `/public/v1/auth/keycloak/login`
}

/**
 * @summary Gera um novo access token utilizando um token do Keycloak
 */
export const loginWithKeycloakToken = async (tokenLoginKeycloakInput: TokenLoginKeycloakInput, options?: RequestInit): Promise<loginWithKeycloakTokenResponse> => {

  return customInstanceBpm<loginWithKeycloakTokenResponse>(getLoginWithKeycloakTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tokenLoginKeycloakInput)
  }
);}




export const getLoginWithKeycloakTokenMutationOptions = <TError = LoginWithKeycloakToken401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithKeycloakToken>>, TError,{data: TokenLoginKeycloakInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof loginWithKeycloakToken>>, TError,{data: TokenLoginKeycloakInput}, TContext> => {

const mutationKey = ['loginWithKeycloakToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWithKeycloakToken>>, {data: TokenLoginKeycloakInput}> = (props) => {
          const {data} = props ?? {};

          return  loginWithKeycloakToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginWithKeycloakTokenMutationResult = NonNullable<Awaited<ReturnType<typeof loginWithKeycloakToken>>>
    export type LoginWithKeycloakTokenMutationBody = TokenLoginKeycloakInput
    export type LoginWithKeycloakTokenMutationError = LoginWithKeycloakToken401

    /**
 * @summary Gera um novo access token utilizando um token do Keycloak
 */
export const useLoginWithKeycloakToken = <TError = LoginWithKeycloakToken401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithKeycloakToken>>, TError,{data: TokenLoginKeycloakInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginWithKeycloakToken>>,
        TError,
        {data: TokenLoginKeycloakInput},
        TContext
      > => {
      return useMutation(getLoginWithKeycloakTokenMutationOptions(options), queryClient);
    }

export type loginWithDoczTokenResponse200 = {
  data: AccessTokenSwagger
  status: 200
}

export type loginWithDoczTokenResponse401 = {
  data: LoginWithDoczToken401
  status: 401
}

export type loginWithDoczTokenResponseSuccess = (loginWithDoczTokenResponse200) & {
  headers: Headers;
};
export type loginWithDoczTokenResponseError = (loginWithDoczTokenResponse401) & {
  headers: Headers;
};

export type loginWithDoczTokenResponse = (loginWithDoczTokenResponseSuccess | loginWithDoczTokenResponseError)

export const getLoginWithDoczTokenUrl = () => {




  return `/public/v1/auth/docz/login`
}

/**
 * @summary Gera um novo access token utilizando um token do Docz
 */
export const loginWithDoczToken = async (tokenLoginInput: TokenLoginInput, options?: RequestInit): Promise<loginWithDoczTokenResponse> => {

  return customInstanceBpm<loginWithDoczTokenResponse>(getLoginWithDoczTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tokenLoginInput)
  }
);}




export const getLoginWithDoczTokenMutationOptions = <TError = LoginWithDoczToken401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithDoczToken>>, TError,{data: TokenLoginInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof loginWithDoczToken>>, TError,{data: TokenLoginInput}, TContext> => {

const mutationKey = ['loginWithDoczToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWithDoczToken>>, {data: TokenLoginInput}> = (props) => {
          const {data} = props ?? {};

          return  loginWithDoczToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginWithDoczTokenMutationResult = NonNullable<Awaited<ReturnType<typeof loginWithDoczToken>>>
    export type LoginWithDoczTokenMutationBody = TokenLoginInput
    export type LoginWithDoczTokenMutationError = LoginWithDoczToken401

    /**
 * @summary Gera um novo access token utilizando um token do Docz
 */
export const useLoginWithDoczToken = <TError = LoginWithDoczToken401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWithDoczToken>>, TError,{data: TokenLoginInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginWithDoczToken>>,
        TError,
        {data: TokenLoginInput},
        TContext
      > => {
      return useMutation(getLoginWithDoczTokenMutationOptions(options), queryClient);
    }

export type authenticateResponse200 = {
  data: AccessTokenSwagger
  status: 200
}

export type authenticateResponse401 = {
  data: Authenticate401
  status: 401
}

export type authenticateResponseSuccess = (authenticateResponse200) & {
  headers: Headers;
};
export type authenticateResponseError = (authenticateResponse401) & {
  headers: Headers;
};

export type authenticateResponse = (authenticateResponseSuccess | authenticateResponseError)

export const getAuthenticateUrl = () => {




  return `/oauth/token`
}

/**
 * @summary Gera um novo access token
 */
export const authenticate = async (authenticateRequest?: AuthenticateRequest, options?: RequestInit): Promise<authenticateResponse> => {
    const formUrlEncoded = new URLSearchParams();
if(authenticateRequest?.client !== undefined) {
 formUrlEncoded.append(`client`, authenticateRequest.client);
 }
if(authenticateRequest?.grant_type !== undefined) {
 formUrlEncoded.append(`grant_type`, authenticateRequest.grant_type);
 }
if(authenticateRequest?.username !== undefined) {
 formUrlEncoded.append(`username`, authenticateRequest.username);
 }
if(authenticateRequest?.password !== undefined) {
 formUrlEncoded.append(`password`, authenticateRequest.password);
 }
if(authenticateRequest?.refresh_token !== undefined) {
 formUrlEncoded.append(`refresh_token`, authenticateRequest.refresh_token);
 }

  return customInstanceBpm<authenticateResponse>(getAuthenticateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
    body: formUrlEncoded
  }
);}




export const getAuthenticateMutationOptions = <TError = Authenticate401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticate>>, TError,{data?: AuthenticateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof authenticate>>, TError,{data?: AuthenticateRequest}, TContext> => {

const mutationKey = ['authenticate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticate>>, {data?: AuthenticateRequest}> = (props) => {
          const {data} = props ?? {};

          return  authenticate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateMutationResult = NonNullable<Awaited<ReturnType<typeof authenticate>>>
    export type AuthenticateMutationBody = AuthenticateRequest | undefined
    export type AuthenticateMutationError = Authenticate401

    /**
 * @summary Gera um novo access token
 */
export const useAuthenticate = <TError = Authenticate401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticate>>, TError,{data?: AuthenticateRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authenticate>>,
        TError,
        {data?: AuthenticateRequest},
        TContext
      > => {
      return useMutation(getAuthenticateMutationOptions(options), queryClient);
    }

export type checkTokenResponse200 = {
  data: CheckTokenSwagger
  status: 200
}

export type checkTokenResponse400 = {
  data: CheckToken400
  status: 400
}

export type checkTokenResponseSuccess = (checkTokenResponse200) & {
  headers: Headers;
};
export type checkTokenResponseError = (checkTokenResponse400) & {
  headers: Headers;
};

export type checkTokenResponse = (checkTokenResponseSuccess | checkTokenResponseError)

export const getCheckTokenUrl = () => {




  return `/oauth/check_token`
}

/**
 * @summary Verifica se o access token é válido
 */
export const checkToken = async (checkTokenRequest?: CheckTokenRequest, options?: RequestInit): Promise<checkTokenResponse> => {
    const formUrlEncoded = new URLSearchParams();
if(checkTokenRequest?.grant_type !== undefined) {
 formUrlEncoded.append(`grant_type`, checkTokenRequest.grant_type);
 }
if(checkTokenRequest?.token !== undefined) {
 formUrlEncoded.append(`token`, checkTokenRequest.token);
 }

  return customInstanceBpm<checkTokenResponse>(getCheckTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
    body: formUrlEncoded
  }
);}




export const getCheckTokenMutationOptions = <TError = CheckToken400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkToken>>, TError,{data?: CheckTokenRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof checkToken>>, TError,{data?: CheckTokenRequest}, TContext> => {

const mutationKey = ['checkToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkToken>>, {data?: CheckTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  checkToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckTokenMutationResult = NonNullable<Awaited<ReturnType<typeof checkToken>>>
    export type CheckTokenMutationBody = CheckTokenRequest | undefined
    export type CheckTokenMutationError = CheckToken400

    /**
 * @summary Verifica se o access token é válido
 */
export const useCheckToken = <TError = CheckToken400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkToken>>, TError,{data?: CheckTokenRequest}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkToken>>,
        TError,
        {data?: CheckTokenRequest},
        TContext
      > => {
      return useMutation(getCheckTokenMutationOptions(options), queryClient);
    }

export type listTemplateResponse200 = {
  data: PageTemplateDto
  status: 200
}

export type listTemplateResponseSuccess = (listTemplateResponse200) & {
  headers: Headers;
};
;

export type listTemplateResponse = (listTemplateResponseSuccess)

export const getListTemplateUrl = (tenant: string,
    params?: ListTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/rest/${tenant}/templates?${stringifiedParams}` : `/documents/rest/${tenant}/templates`
}

/**
 * @summary Lista os templates
 */
export const listTemplate = async (tenant: string,
    params?: ListTemplateParams, options?: RequestInit): Promise<listTemplateResponse> => {

  return customInstanceBpm<listTemplateResponse>(getListTemplateUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateQueryKey = (tenant: string,
    params?: ListTemplateParams,) => {
    return [
    `/documents/rest/${tenant}/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplateQueryOptions = <TData = Awaited<ReturnType<typeof listTemplate>>, TError = unknown>(tenant: string,
    params?: ListTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplate>>> = ({ signal }) => listTemplate(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplate>>>
export type ListTemplateQueryError = unknown


export function useListTemplate<TData = Awaited<ReturnType<typeof listTemplate>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplate>>,
          TError,
          Awaited<ReturnType<typeof listTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplate<TData = Awaited<ReturnType<typeof listTemplate>>, TError = unknown>(
 tenant: string,
    params?: ListTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplate>>,
          TError,
          Awaited<ReturnType<typeof listTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplate<TData = Awaited<ReturnType<typeof listTemplate>>, TError = unknown>(
 tenant: string,
    params?: ListTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os templates
 */

export function useListTemplate<TData = Awaited<ReturnType<typeof listTemplate>>, TError = unknown>(
 tenant: string,
    params?: ListTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createTemplateResponse201 = {
  data: TemplateDto
  status: 201
}

export type createTemplateResponseSuccess = (createTemplateResponse201) & {
  headers: Headers;
};
;

export type createTemplateResponse = (createTemplateResponseSuccess)

export const getCreateTemplateUrl = (tenant: string,) => {




  return `/documents/rest/${tenant}/templates`
}

/**
 * @summary Cria um template
 */
export const createTemplate = async (tenant: string,
    templateDtoInputCreate: TemplateDtoInputCreate, options?: RequestInit): Promise<createTemplateResponse> => {

  return customInstanceBpm<createTemplateResponse>(getCreateTemplateUrl(tenant),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(templateDtoInputCreate)
  }
);}




export const getCreateTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{tenant: string;data: TemplateDtoInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{tenant: string;data: TemplateDtoInputCreate}, TContext> => {

const mutationKey = ['createTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, {tenant: string;data: TemplateDtoInputCreate}> = (props) => {
          const {tenant,data} = props ?? {};

          return  createTemplate(tenant,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>
    export type CreateTemplateMutationBody = TemplateDtoInputCreate
    export type CreateTemplateMutationError = unknown

    /**
 * @summary Cria um template
 */
export const useCreateTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{tenant: string;data: TemplateDtoInputCreate}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplate>>,
        TError,
        {tenant: string;data: TemplateDtoInputCreate},
        TContext
      > => {
      return useMutation(getCreateTemplateMutationOptions(options), queryClient);
    }

export type generateTemplateVersionResponse201 = {
  data: TemplateDto
  status: 201
}

export type generateTemplateVersionResponse404 = {
  data: Problem
  status: 404
}

export type generateTemplateVersionResponseSuccess = (generateTemplateVersionResponse201) & {
  headers: Headers;
};
export type generateTemplateVersionResponseError = (generateTemplateVersionResponse404) & {
  headers: Headers;
};

export type generateTemplateVersionResponse = (generateTemplateVersionResponseSuccess | generateTemplateVersionResponseError)

export const getGenerateTemplateVersionUrl = (tenant: string,
    templateId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/generate-version`
}

/**
 * @summary Gera uma nova versão do template por ID
 */
export const generateTemplateVersion = async (tenant: string,
    templateId: number, options?: RequestInit): Promise<generateTemplateVersionResponse> => {

  return customInstanceBpm<generateTemplateVersionResponse>(getGenerateTemplateVersionUrl(tenant,templateId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGenerateTemplateVersionMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTemplateVersion>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof generateTemplateVersion>>, TError,{tenant: string;templateId: number}, TContext> => {

const mutationKey = ['generateTemplateVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateTemplateVersion>>, {tenant: string;templateId: number}> = (props) => {
          const {tenant,templateId} = props ?? {};

          return  generateTemplateVersion(tenant,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateTemplateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof generateTemplateVersion>>>

    export type GenerateTemplateVersionMutationError = Problem

    /**
 * @summary Gera uma nova versão do template por ID
 */
export const useGenerateTemplateVersion = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateTemplateVersion>>, TError,{tenant: string;templateId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateTemplateVersion>>,
        TError,
        {tenant: string;templateId: number},
        TContext
      > => {
      return useMutation(getGenerateTemplateVersionMutationOptions(options), queryClient);
    }

export type createDeploymentResponse201 = {
  data: DeploymentWithDefinitionsDto
  status: 201
}

export type createDeploymentResponseSuccess = (createDeploymentResponse201) & {
  headers: Headers;
};
;

export type createDeploymentResponse = (createDeploymentResponseSuccess)

export const getCreateDeploymentUrl = () => {




  return `/deployments`
}

/**
 * @summary Publica um novo processo
 */
export const createDeployment = async (createDeploymentBody?: CreateDeploymentBody, options?: RequestInit): Promise<createDeploymentResponse> => {
    const formData = new FormData();
if(createDeploymentBody?.['tenant-id'] !== undefined) {
 formData.append(`tenant-id`, createDeploymentBody['tenant-id']);
 }
if(createDeploymentBody?.['deployment-name'] !== undefined) {
 formData.append(`deployment-name`, createDeploymentBody['deployment-name']);
 }
if(createDeploymentBody?.data !== undefined) {
 formData.append(`data`, createDeploymentBody.data);
 }
if(createDeploymentBody?.forms !== undefined) {
 formData.append(`forms`, createDeploymentBody.forms);
 }
if(createDeploymentBody?.documents !== undefined) {
 formData.append(`documents`, createDeploymentBody.documents);
 }
if(createDeploymentBody?.templates !== undefined) {
 formData.append(`templates`, createDeploymentBody.templates);
 }

  return customInstanceBpm<createDeploymentResponse>(getCreateDeploymentUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}




export const getCreateDeploymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeployment>>, TError,{data?: CreateDeploymentBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createDeployment>>, TError,{data?: CreateDeploymentBody}, TContext> => {

const mutationKey = ['createDeployment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeployment>>, {data?: CreateDeploymentBody}> = (props) => {
          const {data} = props ?? {};

          return  createDeployment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDeploymentMutationResult = NonNullable<Awaited<ReturnType<typeof createDeployment>>>
    export type CreateDeploymentMutationBody = CreateDeploymentBody | undefined
    export type CreateDeploymentMutationError = unknown

    /**
 * @summary Publica um novo processo
 */
export const useCreateDeployment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeployment>>, TError,{data?: CreateDeploymentBody}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDeployment>>,
        TError,
        {data?: CreateDeploymentBody},
        TContext
      > => {
      return useMutation(getCreateDeploymentMutationOptions(options), queryClient);
    }

export type applyConfigResponse204 = {
  data: Problem
  status: 204
}

export type applyConfigResponseSuccess = (applyConfigResponse204) & {
  headers: Headers;
};
;

export type applyConfigResponse = (applyConfigResponseSuccess)

export const getApplyConfigUrl = () => {




  return `/administrative/apply-config`
}

/**
 * @summary Reseta tabela de configuração inicial
 */
export const applyConfig = async ( options?: RequestInit): Promise<applyConfigResponse> => {

  return customInstanceBpm<applyConfigResponse>(getApplyConfigUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApplyConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyConfig>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof applyConfig>>, TError,void, TContext> => {

const mutationKey = ['applyConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyConfig>>, void> = () => {


          return  applyConfig(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyConfigMutationResult = NonNullable<Awaited<ReturnType<typeof applyConfig>>>

    export type ApplyConfigMutationError = unknown

    /**
 * @summary Reseta tabela de configuração inicial
 */
export const useApplyConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyConfig>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyConfig>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getApplyConfigMutationOptions(options), queryClient);
    }

export type createPasswordLinkResponse204 = {
  data: void
  status: 204
}

export type createPasswordLinkResponseSuccess = (createPasswordLinkResponse204) & {
  headers: Headers;
};
;

export type createPasswordLinkResponse = (createPasswordLinkResponseSuccess)

export const getCreatePasswordLinkUrl = (userId: string,) => {




  return `/account/${userId}/forgot-password`
}

/**
 * @summary Cria link de redefinição de senha
 */
export const createPasswordLink = async (userId: string, options?: RequestInit): Promise<createPasswordLinkResponse> => {

  return customInstanceBpm<createPasswordLinkResponse>(getCreatePasswordLinkUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreatePasswordLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPasswordLink>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createPasswordLink>>, TError,{userId: string}, TContext> => {

const mutationKey = ['createPasswordLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPasswordLink>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  createPasswordLink(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePasswordLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createPasswordLink>>>

    export type CreatePasswordLinkMutationError = unknown

    /**
 * @summary Cria link de redefinição de senha
 */
export const useCreatePasswordLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPasswordLink>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPasswordLink>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getCreatePasswordLinkMutationOptions(options), queryClient);
    }

export type signupResponse201 = {
  data: SmartUserDto
  status: 201
}

export type signupResponse404 = {
  data: Problem
  status: 404
}

export type signupResponseSuccess = (signupResponse201) & {
  headers: Headers;
};
export type signupResponseError = (signupResponse404) & {
  headers: Headers;
};

export type signupResponse = (signupResponseSuccess | signupResponseError)

export const getSignupUrl = (tenant: string,
    params: SignupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account/signup/${tenant}?${stringifiedParams}` : `/account/signup/${tenant}`
}

/**
 * @summary Cria conta do usuário
 */
export const signup = async (tenant: string,
    smartUserInputSignup: SmartUserInputSignup,
    params: SignupParams, options?: RequestInit): Promise<signupResponse> => {

  return customInstanceBpm<signupResponse>(getSignupUrl(tenant,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smartUserInputSignup)
  }
);}




export const getSignupMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{tenant: string;data: SmartUserInputSignup;params: SignupParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{tenant: string;data: SmartUserInputSignup;params: SignupParams}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {tenant: string;data: SmartUserInputSignup;params: SignupParams}> = (props) => {
          const {tenant,data,params} = props ?? {};

          return  signup(tenant,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = SmartUserInputSignup
    export type SignupMutationError = Problem

    /**
 * @summary Cria conta do usuário
 */
export const useSignup = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{tenant: string;data: SmartUserInputSignup;params: SignupParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {tenant: string;data: SmartUserInputSignup;params: SignupParams},
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options), queryClient);
    }

export type createConfirmationLinkResponse204 = {
  data: void
  status: 204
}

export type createConfirmationLinkResponseSuccess = (createConfirmationLinkResponse204) & {
  headers: Headers;
};
;

export type createConfirmationLinkResponse = (createConfirmationLinkResponseSuccess)

export const getCreateConfirmationLinkUrl = () => {




  return `/account/create-link`
}

/**
 * @summary Cria link de criação de conta
 */
export const createConfirmationLink = async (confirmationLinkInput: ConfirmationLinkInput, options?: RequestInit): Promise<createConfirmationLinkResponse> => {

  return customInstanceBpm<createConfirmationLinkResponse>(getCreateConfirmationLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmationLinkInput)
  }
);}




export const getCreateConfirmationLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfirmationLink>>, TError,{data: ConfirmationLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof createConfirmationLink>>, TError,{data: ConfirmationLinkInput}, TContext> => {

const mutationKey = ['createConfirmationLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConfirmationLink>>, {data: ConfirmationLinkInput}> = (props) => {
          const {data} = props ?? {};

          return  createConfirmationLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConfirmationLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createConfirmationLink>>>
    export type CreateConfirmationLinkMutationBody = ConfirmationLinkInput
    export type CreateConfirmationLinkMutationError = unknown

    /**
 * @summary Cria link de criação de conta
 */
export const useCreateConfirmationLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfirmationLink>>, TError,{data: ConfirmationLinkInput}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConfirmationLink>>,
        TError,
        {data: ConfirmationLinkInput},
        TContext
      > => {
      return useMutation(getCreateConfirmationLinkMutationOptions(options), queryClient);
    }

export type markNotificationCenterAsReadResponse200 = {
  data: NotificationCenterDto
  status: 200
}

export type markNotificationCenterAsReadResponseSuccess = (markNotificationCenterAsReadResponse200) & {
  headers: Headers;
};
;

export type markNotificationCenterAsReadResponse = (markNotificationCenterAsReadResponseSuccess)

export const getMarkNotificationCenterAsReadUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/notification-center/notifications/${id}/read`
}

/**
 * @summary Marca notificacao como lida para o usuario logado
 */
export const markNotificationCenterAsRead = async (tenant: string,
    id: number, options?: RequestInit): Promise<markNotificationCenterAsReadResponse> => {

  return customInstanceBpm<markNotificationCenterAsReadResponse>(getMarkNotificationCenterAsReadUrl(tenant,id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkNotificationCenterAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationCenterAsRead>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationCenterAsRead>>, TError,{tenant: string;id: number}, TContext> => {

const mutationKey = ['markNotificationCenterAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationCenterAsRead>>, {tenant: string;id: number}> = (props) => {
          const {tenant,id} = props ?? {};

          return  markNotificationCenterAsRead(tenant,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationCenterAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationCenterAsRead>>>

    export type MarkNotificationCenterAsReadMutationError = unknown

    /**
 * @summary Marca notificacao como lida para o usuario logado
 */
export const useMarkNotificationCenterAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationCenterAsRead>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationCenterAsRead>>,
        TError,
        {tenant: string;id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationCenterAsReadMutationOptions(options), queryClient);
    }

export type markAllNotificationCenterAsReadResponse204 = {
  data: void
  status: 204
}

export type markAllNotificationCenterAsReadResponseSuccess = (markAllNotificationCenterAsReadResponse204) & {
  headers: Headers;
};
;

export type markAllNotificationCenterAsReadResponse = (markAllNotificationCenterAsReadResponseSuccess)

export const getMarkAllNotificationCenterAsReadUrl = (tenant: string,) => {




  return `/v1/${tenant}/notification-center/notifications/read`
}

/**
 * @summary Marca todas as notificacoes como lidas para o usuario logado
 */
export const markAllNotificationCenterAsRead = async (tenant: string, options?: RequestInit): Promise<markAllNotificationCenterAsReadResponse> => {

  return customInstanceBpm<markAllNotificationCenterAsReadResponse>(getMarkAllNotificationCenterAsReadUrl(tenant),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getMarkAllNotificationCenterAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['markAllNotificationCenterAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  markAllNotificationCenterAsRead(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationCenterAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>>

    export type MarkAllNotificationCenterAsReadMutationError = unknown

    /**
 * @summary Marca todas as notificacoes como lidas para o usuario logado
 */
export const useMarkAllNotificationCenterAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationCenterAsRead>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getMarkAllNotificationCenterAsReadMutationOptions(options), queryClient);
    }

export type enableResponse204 = {
  data: void
  status: 204
}

export type enableResponseSuccess = (enableResponse204) & {
  headers: Headers;
};
;

export type enableResponse = (enableResponseSuccess)

export const getEnableUrl = (tenant: string,
    routeId: string,) => {




  return `/v1/${tenant}/email-process/configurations/${routeId}/enable`
}

/**
 * @summary Ativa uma configuracao do email-process
 */
export const enable = async (tenant: string,
    routeId: string, options?: RequestInit): Promise<enableResponse> => {

  return customInstanceBpm<enableResponse>(getEnableUrl(tenant,routeId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getEnableMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{tenant: string;routeId: string}, TContext> => {

const mutationKey = ['enable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enable>>, {tenant: string;routeId: string}> = (props) => {
          const {tenant,routeId} = props ?? {};

          return  enable(tenant,routeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableMutationResult = NonNullable<Awaited<ReturnType<typeof enable>>>

    export type EnableMutationError = unknown

    /**
 * @summary Ativa uma configuracao do email-process
 */
export const useEnable = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enable>>,
        TError,
        {tenant: string;routeId: string},
        TContext
      > => {
      return useMutation(getEnableMutationOptions(options), queryClient);
    }

export type disableResponse204 = {
  data: void
  status: 204
}

export type disableResponseSuccess = (disableResponse204) & {
  headers: Headers;
};
;

export type disableResponse = (disableResponseSuccess)

export const getDisableUrl = (tenant: string,
    routeId: string,) => {




  return `/v1/${tenant}/email-process/configurations/${routeId}/disable`
}

/**
 * @summary Desativa uma configuração do email-process
 */
export const disable = async (tenant: string,
    routeId: string, options?: RequestInit): Promise<disableResponse> => {

  return customInstanceBpm<disableResponse>(getDisableUrl(tenant,routeId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getDisableMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disable>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disable>>, TError,{tenant: string;routeId: string}, TContext> => {

const mutationKey = ['disable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disable>>, {tenant: string;routeId: string}> = (props) => {
          const {tenant,routeId} = props ?? {};

          return  disable(tenant,routeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableMutationResult = NonNullable<Awaited<ReturnType<typeof disable>>>

    export type DisableMutationError = unknown

    /**
 * @summary Desativa uma configuração do email-process
 */
export const useDisable = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disable>>, TError,{tenant: string;routeId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disable>>,
        TError,
        {tenant: string;routeId: string},
        TContext
      > => {
      return useMutation(getDisableMutationOptions(options), queryClient);
    }

export type downloadExportResponse200 = {
  data: Blob
  status: 200
}

export type downloadExportResponseSuccess = (downloadExportResponse200) & {
  headers: Headers;
};
;

export type downloadExportResponse = (downloadExportResponseSuccess)

export const getDownloadExportUrl = (id: number,) => {




  return `/admin/export/${id}/download`
}

export const downloadExport = async (id: number, options?: RequestInit): Promise<downloadExportResponse> => {

  return customInstanceBpm<downloadExportResponse>(getDownloadExportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadExportQueryKey = (id: number,) => {
    return [
    `/admin/export/${id}/download`
    ] as const;
    }


export const getDownloadExportQueryOptions = <TData = Awaited<ReturnType<typeof downloadExport>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadExportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadExport>>> = ({ signal }) => downloadExport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadExportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadExport>>>
export type DownloadExportQueryError = unknown


export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadExport<TData = Awaited<ReturnType<typeof downloadExport>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadExportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadExport1Response200 = {
  data: Blob
  status: 200
}

export type downloadExport1ResponseSuccess = (downloadExport1Response200) & {
  headers: Headers;
};
;

export type downloadExport1Response = (downloadExport1ResponseSuccess)

export const getDownloadExport1Url = (id: number,) => {




  return `/v1/admin/export/${id}/download`
}

export const downloadExport1 = async (id: number, options?: RequestInit): Promise<downloadExport1Response> => {

  return customInstanceBpm<downloadExport1Response>(getDownloadExport1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadExport1QueryKey = (id: number,) => {
    return [
    `/v1/admin/export/${id}/download`
    ] as const;
    }


export const getDownloadExport1QueryOptions = <TData = Awaited<ReturnType<typeof downloadExport1>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadExport1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadExport1>>> = ({ signal }) => downloadExport1(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadExport1QueryResult = NonNullable<Awaited<ReturnType<typeof downloadExport1>>>
export type DownloadExport1QueryError = unknown


export function useDownloadExport1<TData = Awaited<ReturnType<typeof downloadExport1>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport1>>,
          TError,
          Awaited<ReturnType<typeof downloadExport1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport1<TData = Awaited<ReturnType<typeof downloadExport1>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport1>>,
          TError,
          Awaited<ReturnType<typeof downloadExport1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadExport1<TData = Awaited<ReturnType<typeof downloadExport1>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadExport1<TData = Awaited<ReturnType<typeof downloadExport1>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport1>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadExport1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getVersionResponse200 = {
  data: string
  status: 200
}

export type getVersionResponseSuccess = (getVersionResponse200) & {
  headers: Headers;
};
;

export type getVersionResponse = (getVersionResponseSuccess)

export const getGetVersionUrl = () => {




  return `/version`
}

/**
 * @summary Retorna a versão atual da api
 */
export const getVersion = async ( options?: RequestInit): Promise<getVersionResponse> => {

  return customInstanceBpm<getVersionResponse>(getGetVersionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = unknown


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna a versão atual da api
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUserTenantsResponse200 = {
  data: string[]
  status: 200
}

export type listUserTenantsResponseSuccess = (listUserTenantsResponse200) & {
  headers: Headers;
};
;

export type listUserTenantsResponse = (listUserTenantsResponseSuccess)

export const getListUserTenantsUrl = (tenant: string,
    userId: string,) => {




  return `/v1/${tenant}/users/${userId}/tenants`
}

/**
 * @summary Lista os tenants do usuário por ID
 */
export const listUserTenants = async (tenant: string,
    userId: string, options?: RequestInit): Promise<listUserTenantsResponse> => {

  return customInstanceBpm<listUserTenantsResponse>(getListUserTenantsUrl(tenant,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserTenantsQueryKey = (tenant: string,
    userId: string,) => {
    return [
    `/v1/${tenant}/users/${userId}/tenants`
    ] as const;
    }


export const getListUserTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listUserTenants>>, TError = unknown>(tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserTenantsQueryKey(tenant,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserTenants>>> = ({ signal }) => listUserTenants(tenant,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserTenants>>>
export type ListUserTenantsQueryError = unknown


export function useListUserTenants<TData = Awaited<ReturnType<typeof listUserTenants>>, TError = unknown>(
 tenant: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserTenants>>,
          TError,
          Awaited<ReturnType<typeof listUserTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserTenants<TData = Awaited<ReturnType<typeof listUserTenants>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserTenants>>,
          TError,
          Awaited<ReturnType<typeof listUserTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserTenants<TData = Awaited<ReturnType<typeof listUserTenants>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os tenants do usuário por ID
 */

export function useListUserTenants<TData = Awaited<ReturnType<typeof listUserTenants>>, TError = unknown>(
 tenant: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserTenantsQueryOptions(tenant,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUserPermissionsResponse200 = {
  data: SmartPermissionDtoApi[]
  status: 200
}

export type listUserPermissionsResponseSuccess = (listUserPermissionsResponse200) & {
  headers: Headers;
};
;

export type listUserPermissionsResponse = (listUserPermissionsResponseSuccess)

export const getListUserPermissionsUrl = (tenant: string,
    userId: string,
    params?: ListUserPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/users/${userId}/permissions?${stringifiedParams}` : `/v1/${tenant}/users/${userId}/permissions`
}

/**
 * @summary Lista as permissões do usuário
 */
export const listUserPermissions = async (tenant: string,
    userId: string,
    params?: ListUserPermissionsParams, options?: RequestInit): Promise<listUserPermissionsResponse> => {

  return customInstanceBpm<listUserPermissionsResponse>(getListUserPermissionsUrl(tenant,userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserPermissionsQueryKey = (tenant: string,
    userId: string,
    params?: ListUserPermissionsParams,) => {
    return [
    `/v1/${tenant}/users/${userId}/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUserPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof listUserPermissions>>, TError = unknown>(tenant: string,
    userId: string,
    params?: ListUserPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserPermissionsQueryKey(tenant,userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserPermissions>>> = ({ signal }) => listUserPermissions(tenant,userId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserPermissions>>>
export type ListUserPermissionsQueryError = unknown


export function useListUserPermissions<TData = Awaited<ReturnType<typeof listUserPermissions>>, TError = unknown>(
 tenant: string,
    userId: string,
    params: undefined |  ListUserPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof listUserPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserPermissions<TData = Awaited<ReturnType<typeof listUserPermissions>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListUserPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof listUserPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserPermissions<TData = Awaited<ReturnType<typeof listUserPermissions>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListUserPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as permissões do usuário
 */

export function useListUserPermissions<TData = Awaited<ReturnType<typeof listUserPermissions>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListUserPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserPermissionsQueryOptions(tenant,userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSmartUserLogsResponse200 = {
  data: PageSmartUserLogDto
  status: 200
}

export type listSmartUserLogsResponseSuccess = (listSmartUserLogsResponse200) & {
  headers: Headers;
};
;

export type listSmartUserLogsResponse = (listSmartUserLogsResponseSuccess)

export const getListSmartUserLogsUrl = (tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/users/${userId}/logs?${stringifiedParams}` : `/v1/${tenant}/users/${userId}/logs`
}

/**
 * @summary Lista os logs do usuário
 */
export const listSmartUserLogs = async (tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams, options?: RequestInit): Promise<listSmartUserLogsResponse> => {

  return customInstanceBpm<listSmartUserLogsResponse>(getListSmartUserLogsUrl(tenant,userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSmartUserLogsQueryKey = (tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams,) => {
    return [
    `/v1/${tenant}/users/${userId}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSmartUserLogsQueryOptions = <TData = Awaited<ReturnType<typeof listSmartUserLogs>>, TError = unknown>(tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSmartUserLogsQueryKey(tenant,userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSmartUserLogs>>> = ({ signal }) => listSmartUserLogs(tenant,userId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSmartUserLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listSmartUserLogs>>>
export type ListSmartUserLogsQueryError = unknown


export function useListSmartUserLogs<TData = Awaited<ReturnType<typeof listSmartUserLogs>>, TError = unknown>(
 tenant: string,
    userId: string,
    params: undefined |  ListSmartUserLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartUserLogs>>,
          TError,
          Awaited<ReturnType<typeof listSmartUserLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartUserLogs<TData = Awaited<ReturnType<typeof listSmartUserLogs>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartUserLogs>>,
          TError,
          Awaited<ReturnType<typeof listSmartUserLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartUserLogs<TData = Awaited<ReturnType<typeof listSmartUserLogs>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os logs do usuário
 */

export function useListSmartUserLogs<TData = Awaited<ReturnType<typeof listSmartUserLogs>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListSmartUserLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartUserLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSmartUserLogsQueryOptions(tenant,userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listGroupsByUserResponse200 = {
  data: SmartGroupDto[]
  status: 200
}

export type listGroupsByUserResponseSuccess = (listGroupsByUserResponse200) & {
  headers: Headers;
};
;

export type listGroupsByUserResponse = (listGroupsByUserResponseSuccess)

export const getListGroupsByUserUrl = (tenant: string,
    userId: string,
    params?: ListGroupsByUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/users/${userId}/groups?${stringifiedParams}` : `/v1/${tenant}/users/${userId}/groups`
}

/**
 * @summary Lista os grupos do usuário
 */
export const listGroupsByUser = async (tenant: string,
    userId: string,
    params?: ListGroupsByUserParams, options?: RequestInit): Promise<listGroupsByUserResponse> => {

  return customInstanceBpm<listGroupsByUserResponse>(getListGroupsByUserUrl(tenant,userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGroupsByUserQueryKey = (tenant: string,
    userId: string,
    params?: ListGroupsByUserParams,) => {
    return [
    `/v1/${tenant}/users/${userId}/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGroupsByUserQueryOptions = <TData = Awaited<ReturnType<typeof listGroupsByUser>>, TError = unknown>(tenant: string,
    userId: string,
    params?: ListGroupsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupsByUserQueryKey(tenant,userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupsByUser>>> = ({ signal }) => listGroupsByUser(tenant,userId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupsByUserQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupsByUser>>>
export type ListGroupsByUserQueryError = unknown


export function useListGroupsByUser<TData = Awaited<ReturnType<typeof listGroupsByUser>>, TError = unknown>(
 tenant: string,
    userId: string,
    params: undefined |  ListGroupsByUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupsByUser>>,
          TError,
          Awaited<ReturnType<typeof listGroupsByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupsByUser<TData = Awaited<ReturnType<typeof listGroupsByUser>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListGroupsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupsByUser>>,
          TError,
          Awaited<ReturnType<typeof listGroupsByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupsByUser<TData = Awaited<ReturnType<typeof listGroupsByUser>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListGroupsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os grupos do usuário
 */

export function useListGroupsByUser<TData = Awaited<ReturnType<typeof listGroupsByUser>>, TError = unknown>(
 tenant: string,
    userId: string,
    params?: ListGroupsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupsByUserQueryOptions(tenant,userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUsersAndGroupsResponse200 = {
  data: UserGroupListDto
  status: 200
}

export type listUsersAndGroupsResponseSuccess = (listUsersAndGroupsResponse200) & {
  headers: Headers;
};
;

export type listUsersAndGroupsResponse = (listUsersAndGroupsResponseSuccess)

export const getListUsersAndGroupsUrl = (tenant: string,) => {




  return `/v1/${tenant}/users/list-users-and-groups`
}

/**
 * @summary Lista todos os usuários e grupos pelo tenant
 */
export const listUsersAndGroups = async (tenant: string, options?: RequestInit): Promise<listUsersAndGroupsResponse> => {

  return customInstanceBpm<listUsersAndGroupsResponse>(getListUsersAndGroupsUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersAndGroupsQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/users/list-users-and-groups`
    ] as const;
    }


export const getListUsersAndGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listUsersAndGroups>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersAndGroupsQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersAndGroups>>> = ({ signal }) => listUsersAndGroups(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersAndGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersAndGroups>>>
export type ListUsersAndGroupsQueryError = unknown


export function useListUsersAndGroups<TData = Awaited<ReturnType<typeof listUsersAndGroups>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersAndGroups>>,
          TError,
          Awaited<ReturnType<typeof listUsersAndGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersAndGroups<TData = Awaited<ReturnType<typeof listUsersAndGroups>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersAndGroups>>,
          TError,
          Awaited<ReturnType<typeof listUsersAndGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersAndGroups<TData = Awaited<ReturnType<typeof listUsersAndGroups>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todos os usuários e grupos pelo tenant
 */

export function useListUsersAndGroups<TData = Awaited<ReturnType<typeof listUsersAndGroups>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAndGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersAndGroupsQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTaskVariablesResponse200 = {
  data: GetTaskVariables200
  status: 200
}

export type getTaskVariablesResponseSuccess = (getTaskVariablesResponse200) & {
  headers: Headers;
};
;

export type getTaskVariablesResponse = (getTaskVariablesResponseSuccess)

export const getGetTaskVariablesUrl = (tenant: string,
    id: string,) => {




  return `/v1/${tenant}/tasks/${id}/variables`
}

/**
 * @summary Retorna as variavies da tarefa por ID
 */
export const getTaskVariables = async (tenant: string,
    id: string, options?: RequestInit): Promise<getTaskVariablesResponse> => {

  return customInstanceBpm<getTaskVariablesResponse>(getGetTaskVariablesUrl(tenant,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskVariablesQueryKey = (tenant: string,
    id: string,) => {
    return [
    `/v1/${tenant}/tasks/${id}/variables`
    ] as const;
    }


export const getGetTaskVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = unknown>(tenant: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskVariablesQueryKey(tenant,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskVariables>>> = ({ signal }) => getTaskVariables(tenant,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskVariables>>>
export type GetTaskVariablesQueryError = unknown


export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = unknown>(
 tenant: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = unknown>(
 tenant: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = unknown>(
 tenant: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna as variavies da tarefa por ID
 */

export function useGetTaskVariables<TData = Awaited<ReturnType<typeof getTaskVariables>>, TError = unknown>(
 tenant: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskVariablesQueryOptions(tenant,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listStorageReportsResponse200 = {
  data: PageStorageUsageReportDto
  status: 200
}

export type listStorageReportsResponseSuccess = (listStorageReportsResponse200) & {
  headers: Headers;
};
;

export type listStorageReportsResponse = (listStorageReportsResponseSuccess)

export const getListStorageReportsUrl = (tenant: string,
    params?: ListStorageReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/storage/reports?${stringifiedParams}` : `/v1/${tenant}/storage/reports`
}

/**
 * @summary Lista relatórios de consumo de dados gerados
 */
export const listStorageReports = async (tenant: string,
    params?: ListStorageReportsParams, options?: RequestInit): Promise<listStorageReportsResponse> => {

  return customInstanceBpm<listStorageReportsResponse>(getListStorageReportsUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStorageReportsQueryKey = (tenant: string,
    params?: ListStorageReportsParams,) => {
    return [
    `/v1/${tenant}/storage/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStorageReportsQueryOptions = <TData = Awaited<ReturnType<typeof listStorageReports>>, TError = unknown>(tenant: string,
    params?: ListStorageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStorageReportsQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStorageReports>>> = ({ signal }) => listStorageReports(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStorageReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listStorageReports>>>
export type ListStorageReportsQueryError = unknown


export function useListStorageReports<TData = Awaited<ReturnType<typeof listStorageReports>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListStorageReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStorageReports>>,
          TError,
          Awaited<ReturnType<typeof listStorageReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStorageReports<TData = Awaited<ReturnType<typeof listStorageReports>>, TError = unknown>(
 tenant: string,
    params?: ListStorageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStorageReports>>,
          TError,
          Awaited<ReturnType<typeof listStorageReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStorageReports<TData = Awaited<ReturnType<typeof listStorageReports>>, TError = unknown>(
 tenant: string,
    params?: ListStorageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista relatórios de consumo de dados gerados
 */

export function useListStorageReports<TData = Awaited<ReturnType<typeof listStorageReports>>, TError = unknown>(
 tenant: string,
    params?: ListStorageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStorageReports>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStorageReportsQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadStorageReportCsvResponse200 = {
  data: string
  status: 200
}

export type downloadStorageReportCsvResponseSuccess = (downloadStorageReportCsvResponse200) & {
  headers: Headers;
};
;

export type downloadStorageReportCsvResponse = (downloadStorageReportCsvResponseSuccess)

export const getDownloadStorageReportCsvUrl = (tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/storage/reports/${id}/download?${stringifiedParams}` : `/v1/${tenant}/storage/reports/${id}/download`
}

/**
 * @summary Baixa o CSV de um relatório de consumo de dados
 */
export const downloadStorageReportCsv = async (tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams, options?: RequestInit): Promise<downloadStorageReportCsvResponse> => {

  return customInstanceBpm<downloadStorageReportCsvResponse>(getDownloadStorageReportCsvUrl(tenant,id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadStorageReportCsvQueryKey = (tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams,) => {
    return [
    `/v1/${tenant}/storage/reports/${id}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadStorageReportCsvQueryOptions = <TData = Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError = unknown>(tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadStorageReportCsvQueryKey(tenant,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadStorageReportCsv>>> = ({ signal }) => downloadStorageReportCsv(tenant,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadStorageReportCsvQueryResult = NonNullable<Awaited<ReturnType<typeof downloadStorageReportCsv>>>
export type DownloadStorageReportCsvQueryError = unknown


export function useDownloadStorageReportCsv<TData = Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError = unknown>(
 tenant: string,
    id: number,
    params: undefined |  DownloadStorageReportCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadStorageReportCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadStorageReportCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadStorageReportCsv<TData = Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError = unknown>(
 tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadStorageReportCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadStorageReportCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadStorageReportCsv<TData = Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError = unknown>(
 tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Baixa o CSV de um relatório de consumo de dados
 */

export function useDownloadStorageReportCsv<TData = Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError = unknown>(
 tenant: string,
    id: number,
    params?: DownloadStorageReportCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadStorageReportCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadStorageReportCsvQueryOptions(tenant,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessInstanceByIdResponse200 = {
  data: CustomHistoricProcessInstanceDto
  status: 200
}

export type getProcessInstanceByIdResponseSuccess = (getProcessInstanceByIdResponse200) & {
  headers: Headers;
};
;

export type getProcessInstanceByIdResponse = (getProcessInstanceByIdResponseSuccess)

export const getGetProcessInstanceByIdUrl = (tenant: string,
    processInstanceId: string,) => {




  return `/v1/${tenant}/process-instances/${processInstanceId}`
}

/**
 * @summary Busca instância do processo por ID
 */
export const getProcessInstanceById = async (tenant: string,
    processInstanceId: string, options?: RequestInit): Promise<getProcessInstanceByIdResponse> => {

  return customInstanceBpm<getProcessInstanceByIdResponse>(getGetProcessInstanceByIdUrl(tenant,processInstanceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessInstanceByIdQueryKey = (tenant: string,
    processInstanceId: string,) => {
    return [
    `/v1/${tenant}/process-instances/${processInstanceId}`
    ] as const;
    }


export const getGetProcessInstanceByIdQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceByIdQueryKey(tenant,processInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceById>>> = ({ signal }) => getProcessInstanceById(tenant,processInstanceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceById>>>
export type GetProcessInstanceByIdQueryError = unknown


export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceById>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceById>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca instância do processo por ID
 */

export function useGetProcessInstanceById<TData = Awaited<ReturnType<typeof getProcessInstanceById>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceByIdQueryOptions(tenant,processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDocumentVariablesResponse200 = {
  data: SmartVariableValueHistoryDto[]
  status: 200
}

export type listDocumentVariablesResponseSuccess = (listDocumentVariablesResponse200) & {
  headers: Headers;
};
;

export type listDocumentVariablesResponse = (listDocumentVariablesResponseSuccess)

export const getListDocumentVariablesUrl = (tenant: string,
    processInstanceId: string,) => {




  return `/v1/${tenant}/process-instances/${processInstanceId}/document-variables-history`
}

/**
 * @summary Lista o histórico de variaveis do tipo documento
 */
export const listDocumentVariables = async (tenant: string,
    processInstanceId: string, options?: RequestInit): Promise<listDocumentVariablesResponse> => {

  return customInstanceBpm<listDocumentVariablesResponse>(getListDocumentVariablesUrl(tenant,processInstanceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentVariablesQueryKey = (tenant: string,
    processInstanceId: string,) => {
    return [
    `/v1/${tenant}/process-instances/${processInstanceId}/document-variables-history`
    ] as const;
    }


export const getListDocumentVariablesQueryOptions = <TData = Awaited<ReturnType<typeof listDocumentVariables>>, TError = unknown>(tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentVariablesQueryKey(tenant,processInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentVariables>>> = ({ signal }) => listDocumentVariables(tenant,processInstanceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof listDocumentVariables>>>
export type ListDocumentVariablesQueryError = unknown


export function useListDocumentVariables<TData = Awaited<ReturnType<typeof listDocumentVariables>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentVariables>>,
          TError,
          Awaited<ReturnType<typeof listDocumentVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentVariables<TData = Awaited<ReturnType<typeof listDocumentVariables>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocumentVariables>>,
          TError,
          Awaited<ReturnType<typeof listDocumentVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocumentVariables<TData = Awaited<ReturnType<typeof listDocumentVariables>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o histórico de variaveis do tipo documento
 */

export function useListDocumentVariables<TData = Awaited<ReturnType<typeof listDocumentVariables>>, TError = unknown>(
 tenant: string,
    processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocumentVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentVariablesQueryOptions(tenant,processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listActivityInstancesResponse200 = {
  data: PageActivityInstanceDto
  status: 200
}

export type listActivityInstancesResponseSuccess = (listActivityInstancesResponse200) & {
  headers: Headers;
};
;

export type listActivityInstancesResponse = (listActivityInstancesResponseSuccess)

export const getListActivityInstancesUrl = (tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-instances/${processInstanceId}/activity-instances?${stringifiedParams}` : `/v1/${tenant}/process-instances/${processInstanceId}/activity-instances`
}

/**
 * @summary Lista as atividade da instância do processo
 */
export const listActivityInstances = async (tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams, options?: RequestInit): Promise<listActivityInstancesResponse> => {

  return customInstanceBpm<listActivityInstancesResponse>(getListActivityInstancesUrl(tenant,processInstanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActivityInstancesQueryKey = (tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams,) => {
    return [
    `/v1/${tenant}/process-instances/${processInstanceId}/activity-instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getListActivityInstancesQueryOptions = <TData = Awaited<ReturnType<typeof listActivityInstances>>, TError = unknown>(tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityInstancesQueryKey(tenant,processInstanceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityInstances>>> = ({ signal }) => listActivityInstances(tenant,processInstanceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActivityInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityInstances>>>
export type ListActivityInstancesQueryError = unknown


export function useListActivityInstances<TData = Awaited<ReturnType<typeof listActivityInstances>>, TError = unknown>(
 tenant: string,
    processInstanceId: string,
    params: undefined |  ListActivityInstancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof listActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityInstances<TData = Awaited<ReturnType<typeof listActivityInstances>>, TError = unknown>(
 tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof listActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityInstances<TData = Awaited<ReturnType<typeof listActivityInstances>>, TError = unknown>(
 tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as atividade da instância do processo
 */

export function useListActivityInstances<TData = Awaited<ReturnType<typeof listActivityInstances>>, TError = unknown>(
 tenant: string,
    processInstanceId: string,
    params?: ListActivityInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActivityInstancesQueryOptions(tenant,processInstanceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listLastActivityResponse200 = {
  data: ActivityInstanceDto[]
  status: 200
}

export type listLastActivityResponseSuccess = (listLastActivityResponse200) & {
  headers: Headers;
};
;

export type listLastActivityResponse = (listLastActivityResponseSuccess)

export const getListLastActivityUrl = (tenant: string,
    params: ListLastActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-instances/last-activity?${stringifiedParams}` : `/v1/${tenant}/process-instances/last-activity`
}

/**
 * @summary Lista ultima atividade das instâncias do processo
 */
export const listLastActivity = async (tenant: string,
    params: ListLastActivityParams, options?: RequestInit): Promise<listLastActivityResponse> => {

  return customInstanceBpm<listLastActivityResponse>(getListLastActivityUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLastActivityQueryKey = (tenant: string,
    params?: ListLastActivityParams,) => {
    return [
    `/v1/${tenant}/process-instances/last-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLastActivityQueryOptions = <TData = Awaited<ReturnType<typeof listLastActivity>>, TError = unknown>(tenant: string,
    params: ListLastActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLastActivityQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLastActivity>>> = ({ signal }) => listLastActivity(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLastActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listLastActivity>>>
export type ListLastActivityQueryError = unknown


export function useListLastActivity<TData = Awaited<ReturnType<typeof listLastActivity>>, TError = unknown>(
 tenant: string,
    params: ListLastActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLastActivity>>,
          TError,
          Awaited<ReturnType<typeof listLastActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLastActivity<TData = Awaited<ReturnType<typeof listLastActivity>>, TError = unknown>(
 tenant: string,
    params: ListLastActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLastActivity>>,
          TError,
          Awaited<ReturnType<typeof listLastActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLastActivity<TData = Awaited<ReturnType<typeof listLastActivity>>, TError = unknown>(
 tenant: string,
    params: ListLastActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista ultima atividade das instâncias do processo
 */

export function useListLastActivity<TData = Awaited<ReturnType<typeof listLastActivity>>, TError = unknown>(
 tenant: string,
    params: ListLastActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLastActivityQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findAllByVariableTextValueIgnoreCaseResponse200 = {
  data: CustomHistoricProcessInstanceDto[]
  status: 200
}

export type findAllByVariableTextValueIgnoreCaseResponseSuccess = (findAllByVariableTextValueIgnoreCaseResponse200) & {
  headers: Headers;
};
;

export type findAllByVariableTextValueIgnoreCaseResponse = (findAllByVariableTextValueIgnoreCaseResponseSuccess)

export const getFindAllByVariableTextValueIgnoreCaseUrl = (tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-instances/etiqueta?${stringifiedParams}` : `/v1/${tenant}/process-instances/etiqueta`
}

/**
 * @summary Busca instância do processo por ID
 */
export const findAllByVariableTextValueIgnoreCase = async (tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options?: RequestInit): Promise<findAllByVariableTextValueIgnoreCaseResponse> => {

  return customInstanceBpm<findAllByVariableTextValueIgnoreCaseResponse>(getFindAllByVariableTextValueIgnoreCaseUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindAllByVariableTextValueIgnoreCaseQueryKey = (tenant: string,
    params?: FindAllByVariableTextValueIgnoreCaseParams,) => {
    return [
    `/v1/${tenant}/process-instances/etiqueta`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllByVariableTextValueIgnoreCaseQueryOptions = <TData = Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError = unknown>(tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllByVariableTextValueIgnoreCaseQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>> = ({ signal }) => findAllByVariableTextValueIgnoreCase(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllByVariableTextValueIgnoreCaseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>>
export type FindAllByVariableTextValueIgnoreCaseQueryError = unknown


export function useFindAllByVariableTextValueIgnoreCase<TData = Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError = unknown>(
 tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>,
          TError,
          Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllByVariableTextValueIgnoreCase<TData = Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError = unknown>(
 tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>,
          TError,
          Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllByVariableTextValueIgnoreCase<TData = Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError = unknown>(
 tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca instância do processo por ID
 */

export function useFindAllByVariableTextValueIgnoreCase<TData = Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError = unknown>(
 tenant: string,
    params: FindAllByVariableTextValueIgnoreCaseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllByVariableTextValueIgnoreCase>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllByVariableTextValueIgnoreCaseQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessDefinitionResponse200 = {
  data: PageProcessDefinitionDto
  status: 200
}

export type listProcessDefinitionResponseSuccess = (listProcessDefinitionResponse200) & {
  headers: Headers;
};
;

export type listProcessDefinitionResponse = (listProcessDefinitionResponseSuccess)

export const getListProcessDefinitionUrl = (tenant: string,
    params?: ListProcessDefinitionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions?${stringifiedParams}` : `/v1/${tenant}/process-definitions`
}

/**
 * @summary Lista as definições do processo
 */
export const listProcessDefinition = async (tenant: string,
    params?: ListProcessDefinitionParams, options?: RequestInit): Promise<listProcessDefinitionResponse> => {

  return customInstanceBpm<listProcessDefinitionResponse>(getListProcessDefinitionUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessDefinitionQueryKey = (tenant: string,
    params?: ListProcessDefinitionParams,) => {
    return [
    `/v1/${tenant}/process-definitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessDefinitionQueryOptions = <TData = Awaited<ReturnType<typeof listProcessDefinition>>, TError = unknown>(tenant: string,
    params?: ListProcessDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessDefinitionQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessDefinition>>> = ({ signal }) => listProcessDefinition(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessDefinitionQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessDefinition>>>
export type ListProcessDefinitionQueryError = unknown


export function useListProcessDefinition<TData = Awaited<ReturnType<typeof listProcessDefinition>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListProcessDefinitionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinition>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinition<TData = Awaited<ReturnType<typeof listProcessDefinition>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinition>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinition<TData = Awaited<ReturnType<typeof listProcessDefinition>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as definições do processo
 */

export function useListProcessDefinition<TData = Awaited<ReturnType<typeof listProcessDefinition>>, TError = unknown>(
 tenant: string,
    params?: ListProcessDefinitionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessDefinitionQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteProcessDefinitionByKeyResponse204 = {
  data: void
  status: 204
}

export type deleteProcessDefinitionByKeyResponse404 = {
  data: Problem
  status: 404
}

export type deleteProcessDefinitionByKeyResponseSuccess = (deleteProcessDefinitionByKeyResponse204) & {
  headers: Headers;
};
export type deleteProcessDefinitionByKeyResponseError = (deleteProcessDefinitionByKeyResponse404) & {
  headers: Headers;
};

export type deleteProcessDefinitionByKeyResponse = (deleteProcessDefinitionByKeyResponseSuccess | deleteProcessDefinitionByKeyResponseError)

export const getDeleteProcessDefinitionByKeyUrl = (tenant: string,
    params: DeleteProcessDefinitionByKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions?${stringifiedParams}` : `/v1/${tenant}/process-definitions`
}

/**
 * @summary Remove definição do processo pela chave
 */
export const deleteProcessDefinitionByKey = async (tenant: string,
    params: DeleteProcessDefinitionByKeyParams, options?: RequestInit): Promise<deleteProcessDefinitionByKeyResponse> => {

  return customInstanceBpm<deleteProcessDefinitionByKeyResponse>(getDeleteProcessDefinitionByKeyUrl(tenant,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProcessDefinitionByKeyMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>, TError,{tenant: string;params: DeleteProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>, TError,{tenant: string;params: DeleteProcessDefinitionByKeyParams}, TContext> => {

const mutationKey = ['deleteProcessDefinitionByKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>, {tenant: string;params: DeleteProcessDefinitionByKeyParams}> = (props) => {
          const {tenant,params} = props ?? {};

          return  deleteProcessDefinitionByKey(tenant,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProcessDefinitionByKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>>

    export type DeleteProcessDefinitionByKeyMutationError = Problem

    /**
 * @summary Remove definição do processo pela chave
 */
export const useDeleteProcessDefinitionByKey = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>, TError,{tenant: string;params: DeleteProcessDefinitionByKeyParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProcessDefinitionByKey>>,
        TError,
        {tenant: string;params: DeleteProcessDefinitionByKeyParams},
        TContext
      > => {
      return useMutation(getDeleteProcessDefinitionByKeyMutationOptions(options), queryClient);
    }

export type getBpmnTaskByProcessDefinitionResponse200 = {
  data: BpmnActivityDto[]
  status: 200
}

export type getBpmnTaskByProcessDefinitionResponseSuccess = (getBpmnTaskByProcessDefinitionResponse200) & {
  headers: Headers;
};
;

export type getBpmnTaskByProcessDefinitionResponse = (getBpmnTaskByProcessDefinitionResponseSuccess)

export const getGetBpmnTaskByProcessDefinitionUrl = (tenant: string,
    processDefinitionId: string,) => {




  return `/v1/${tenant}/process-definitions/${processDefinitionId}/extract-tasks`
}

/**
 * @summary Retorna as tarefas de usuarios do diagrama BPMN
 */
export const getBpmnTaskByProcessDefinition = async (tenant: string,
    processDefinitionId: string, options?: RequestInit): Promise<getBpmnTaskByProcessDefinitionResponse> => {

  return customInstanceBpm<getBpmnTaskByProcessDefinitionResponse>(getGetBpmnTaskByProcessDefinitionUrl(tenant,processDefinitionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBpmnTaskByProcessDefinitionQueryKey = (tenant: string,
    processDefinitionId: string,) => {
    return [
    `/v1/${tenant}/process-definitions/${processDefinitionId}/extract-tasks`
    ] as const;
    }


export const getGetBpmnTaskByProcessDefinitionQueryOptions = <TData = Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError = unknown>(tenant: string,
    processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBpmnTaskByProcessDefinitionQueryKey(tenant,processDefinitionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>> = ({ signal }) => getBpmnTaskByProcessDefinition(tenant,processDefinitionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && processDefinitionId !== null && processDefinitionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBpmnTaskByProcessDefinitionQueryResult = NonNullable<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>>
export type GetBpmnTaskByProcessDefinitionQueryError = unknown


export function useGetBpmnTaskByProcessDefinition<TData = Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError = unknown>(
 tenant: string,
    processDefinitionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>,
          TError,
          Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBpmnTaskByProcessDefinition<TData = Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError = unknown>(
 tenant: string,
    processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>,
          TError,
          Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBpmnTaskByProcessDefinition<TData = Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError = unknown>(
 tenant: string,
    processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna as tarefas de usuarios do diagrama BPMN
 */

export function useGetBpmnTaskByProcessDefinition<TData = Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError = unknown>(
 tenant: string,
    processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpmnTaskByProcessDefinition>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBpmnTaskByProcessDefinitionQueryOptions(tenant,processDefinitionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadProcessDefinitionDraftResponse200 = {
  data: DownloadProcessDefinitionDraft200
  status: 200
}

export type downloadProcessDefinitionDraftResponseSuccess = (downloadProcessDefinitionDraftResponse200) & {
  headers: Headers;
};
;

export type downloadProcessDefinitionDraftResponse = (downloadProcessDefinitionDraftResponseSuccess)

export const getDownloadProcessDefinitionDraftUrl = (tenant: string,
    draftId: number,) => {




  return `/v1/${tenant}/process-definition-drafts/${draftId}/download`
}

/**
 * @summary Faz download do rascunho
 */
export const downloadProcessDefinitionDraft = async (tenant: string,
    draftId: number, options?: RequestInit): Promise<downloadProcessDefinitionDraftResponse> => {

  return customInstanceBpm<downloadProcessDefinitionDraftResponse>(getDownloadProcessDefinitionDraftUrl(tenant,draftId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadProcessDefinitionDraftQueryKey = (tenant: string,
    draftId: number,) => {
    return [
    `/v1/${tenant}/process-definition-drafts/${draftId}/download`
    ] as const;
    }


export const getDownloadProcessDefinitionDraftQueryOptions = <TData = Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError = unknown>(tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadProcessDefinitionDraftQueryKey(tenant,draftId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>> = ({ signal }) => downloadProcessDefinitionDraft(tenant,draftId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && draftId !== null && draftId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadProcessDefinitionDraftQueryResult = NonNullable<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>>
export type DownloadProcessDefinitionDraftQueryError = unknown


export function useDownloadProcessDefinitionDraft<TData = Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    draftId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProcessDefinitionDraft<TData = Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>,
          TError,
          Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProcessDefinitionDraft<TData = Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do rascunho
 */

export function useDownloadProcessDefinitionDraft<TData = Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError = unknown>(
 tenant: string,
    draftId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProcessDefinitionDraft>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadProcessDefinitionDraftQueryOptions(tenant,draftId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUsersPortalExternoResponse200 = {
  data: PagePortalExternoUsuarioDto
  status: 200
}

export type listUsersPortalExternoResponseSuccess = (listUsersPortalExternoResponse200) & {
  headers: Headers;
};
;

export type listUsersPortalExternoResponse = (listUsersPortalExternoResponseSuccess)

export const getListUsersPortalExternoUrl = (tenant: string,
    params?: ListUsersPortalExternoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/portal-externo/users?${stringifiedParams}` : `/v1/${tenant}/portal-externo/users`
}

/**
 * @summary Lista usuários do portal externo com filtros dinâmicos
 */
export const listUsersPortalExterno = async (tenant: string,
    params?: ListUsersPortalExternoParams, options?: RequestInit): Promise<listUsersPortalExternoResponse> => {

  return customInstanceBpm<listUsersPortalExternoResponse>(getListUsersPortalExternoUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersPortalExternoQueryKey = (tenant: string,
    params?: ListUsersPortalExternoParams,) => {
    return [
    `/v1/${tenant}/portal-externo/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersPortalExternoQueryOptions = <TData = Awaited<ReturnType<typeof listUsersPortalExterno>>, TError = unknown>(tenant: string,
    params?: ListUsersPortalExternoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersPortalExternoQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersPortalExterno>>> = ({ signal }) => listUsersPortalExterno(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersPortalExternoQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersPortalExterno>>>
export type ListUsersPortalExternoQueryError = unknown


export function useListUsersPortalExterno<TData = Awaited<ReturnType<typeof listUsersPortalExterno>>, TError = unknown>(
 tenant: string,
    params: undefined |  ListUsersPortalExternoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersPortalExterno>>,
          TError,
          Awaited<ReturnType<typeof listUsersPortalExterno>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersPortalExterno<TData = Awaited<ReturnType<typeof listUsersPortalExterno>>, TError = unknown>(
 tenant: string,
    params?: ListUsersPortalExternoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersPortalExterno>>,
          TError,
          Awaited<ReturnType<typeof listUsersPortalExterno>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersPortalExterno<TData = Awaited<ReturnType<typeof listUsersPortalExterno>>, TError = unknown>(
 tenant: string,
    params?: ListUsersPortalExternoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista usuários do portal externo com filtros dinâmicos
 */

export function useListUsersPortalExterno<TData = Awaited<ReturnType<typeof listUsersPortalExterno>>, TError = unknown>(
 tenant: string,
    params?: ListUsersPortalExternoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersPortalExterno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersPortalExternoQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type countUnreadNotificationCenterResponse200 = {
  data: number
  status: 200
}

export type countUnreadNotificationCenterResponseSuccess = (countUnreadNotificationCenterResponse200) & {
  headers: Headers;
};
;

export type countUnreadNotificationCenterResponse = (countUnreadNotificationCenterResponseSuccess)

export const getCountUnreadNotificationCenterUrl = (tenant: string,) => {




  return `/v1/${tenant}/notification-center/notifications/unread-count`
}

/**
 * @summary Conta notificacoes nao lidas do usuario logado
 */
export const countUnreadNotificationCenter = async (tenant: string, options?: RequestInit): Promise<countUnreadNotificationCenterResponse> => {

  return customInstanceBpm<countUnreadNotificationCenterResponse>(getCountUnreadNotificationCenterUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountUnreadNotificationCenterQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/notification-center/notifications/unread-count`
    ] as const;
    }


export const getCountUnreadNotificationCenterQueryOptions = <TData = Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountUnreadNotificationCenterQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countUnreadNotificationCenter>>> = ({ signal }) => countUnreadNotificationCenter(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountUnreadNotificationCenterQueryResult = NonNullable<Awaited<ReturnType<typeof countUnreadNotificationCenter>>>
export type CountUnreadNotificationCenterQueryError = unknown


export function useCountUnreadNotificationCenter<TData = Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUnreadNotificationCenter>>,
          TError,
          Awaited<ReturnType<typeof countUnreadNotificationCenter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUnreadNotificationCenter<TData = Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUnreadNotificationCenter>>,
          TError,
          Awaited<ReturnType<typeof countUnreadNotificationCenter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUnreadNotificationCenter<TData = Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Conta notificacoes nao lidas do usuario logado
 */

export function useCountUnreadNotificationCenter<TData = Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadNotificationCenter>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountUnreadNotificationCenterQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listGroupPermissionsResponse200 = {
  data: SmartPermissionDtoApi[]
  status: 200
}

export type listGroupPermissionsResponseSuccess = (listGroupPermissionsResponse200) & {
  headers: Headers;
};
;

export type listGroupPermissionsResponse = (listGroupPermissionsResponseSuccess)

export const getListGroupPermissionsUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/permissions`
}

/**
 * @summary Lista as permissões do grupo
 */
export const listGroupPermissions = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<listGroupPermissionsResponse> => {

  return customInstanceBpm<listGroupPermissionsResponse>(getListGroupPermissionsUrl(tenant,groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGroupPermissionsQueryKey = (tenant: string,
    groupId: string,) => {
    return [
    `/v1/${tenant}/groups/${groupId}/permissions`
    ] as const;
    }


export const getListGroupPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof listGroupPermissions>>, TError = unknown>(tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupPermissionsQueryKey(tenant,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupPermissions>>> = ({ signal }) => listGroupPermissions(tenant,groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupPermissions>>>
export type ListGroupPermissionsQueryError = unknown


export function useListGroupPermissions<TData = Awaited<ReturnType<typeof listGroupPermissions>>, TError = unknown>(
 tenant: string,
    groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof listGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupPermissions<TData = Awaited<ReturnType<typeof listGroupPermissions>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof listGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupPermissions<TData = Awaited<ReturnType<typeof listGroupPermissions>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as permissões do grupo
 */

export function useListGroupPermissions<TData = Awaited<ReturnType<typeof listGroupPermissions>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupPermissionsQueryOptions(tenant,groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listGroupMembersResponse200 = {
  data: SmartUserDto[]
  status: 200
}

export type listGroupMembersResponseSuccess = (listGroupMembersResponse200) & {
  headers: Headers;
};
;

export type listGroupMembersResponse = (listGroupMembersResponseSuccess)

export const getListGroupMembersUrl = (tenant: string,
    groupId: string,) => {




  return `/v1/${tenant}/groups/${groupId}/members`
}

/**
 * @summary Lista os usuários do grupo por ID
 */
export const listGroupMembers = async (tenant: string,
    groupId: string, options?: RequestInit): Promise<listGroupMembersResponse> => {

  return customInstanceBpm<listGroupMembersResponse>(getListGroupMembersUrl(tenant,groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGroupMembersQueryKey = (tenant: string,
    groupId: string,) => {
    return [
    `/v1/${tenant}/groups/${groupId}/members`
    ] as const;
    }


export const getListGroupMembersQueryOptions = <TData = Awaited<ReturnType<typeof listGroupMembers>>, TError = unknown>(tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupMembersQueryKey(tenant,groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupMembers>>> = ({ signal }) => listGroupMembers(tenant,groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupMembers>>>
export type ListGroupMembersQueryError = unknown


export function useListGroupMembers<TData = Awaited<ReturnType<typeof listGroupMembers>>, TError = unknown>(
 tenant: string,
    groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupMembers>>,
          TError,
          Awaited<ReturnType<typeof listGroupMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupMembers<TData = Awaited<ReturnType<typeof listGroupMembers>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupMembers>>,
          TError,
          Awaited<ReturnType<typeof listGroupMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupMembers<TData = Awaited<ReturnType<typeof listGroupMembers>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os usuários do grupo por ID
 */

export function useListGroupMembers<TData = Awaited<ReturnType<typeof listGroupMembers>>, TError = unknown>(
 tenant: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupMembersQueryOptions(tenant,groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadEmailTemplateResponse200 = {
  data: DownloadEmailTemplate200
  status: 200
}

export type downloadEmailTemplateResponseSuccess = (downloadEmailTemplateResponse200) & {
  headers: Headers;
};
;

export type downloadEmailTemplateResponse = (downloadEmailTemplateResponseSuccess)

export const getDownloadEmailTemplateUrl = (tenant: string,
    templateId: string,) => {




  return `/v1/${tenant}/email-templates/${templateId}/download`
}

/**
 * @summary Faz download template de email por ID
 */
export const downloadEmailTemplate = async (tenant: string,
    templateId: string, options?: RequestInit): Promise<downloadEmailTemplateResponse> => {

  return customInstanceBpm<downloadEmailTemplateResponse>(getDownloadEmailTemplateUrl(tenant,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadEmailTemplateQueryKey = (tenant: string,
    templateId: string,) => {
    return [
    `/v1/${tenant}/email-templates/${templateId}/download`
    ] as const;
    }


export const getDownloadEmailTemplateQueryOptions = <TData = Awaited<ReturnType<typeof downloadEmailTemplate>>, TError = unknown>(tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadEmailTemplateQueryKey(tenant,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadEmailTemplate>>> = ({ signal }) => downloadEmailTemplate(tenant,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadEmailTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof downloadEmailTemplate>>>
export type DownloadEmailTemplateQueryError = unknown


export function useDownloadEmailTemplate<TData = Awaited<ReturnType<typeof downloadEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadEmailTemplate<TData = Awaited<ReturnType<typeof downloadEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadEmailTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadEmailTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadEmailTemplate<TData = Awaited<ReturnType<typeof downloadEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download template de email por ID
 */

export function useDownloadEmailTemplate<TData = Awaited<ReturnType<typeof downloadEmailTemplate>>, TError = unknown>(
 tenant: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadEmailTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadEmailTemplateQueryOptions(tenant,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessedEmailsResponse200 = {
  data: PageEmailProcessProcessedEmailDto
  status: 200
}

export type listProcessedEmailsResponseSuccess = (listProcessedEmailsResponse200) & {
  headers: Headers;
};
;

export type listProcessedEmailsResponse = (listProcessedEmailsResponseSuccess)

export const getListProcessedEmailsUrl = (tenant: string,
    params: ListProcessedEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/email-process/configurations/processed-emails?${stringifiedParams}` : `/v1/${tenant}/email-process/configurations/processed-emails`
}

/**
 * @summary Lista emails processados por gatilho de email
 */
export const listProcessedEmails = async (tenant: string,
    params: ListProcessedEmailsParams, options?: RequestInit): Promise<listProcessedEmailsResponse> => {

  return customInstanceBpm<listProcessedEmailsResponse>(getListProcessedEmailsUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessedEmailsQueryKey = (tenant: string,
    params?: ListProcessedEmailsParams,) => {
    return [
    `/v1/${tenant}/email-process/configurations/processed-emails`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessedEmailsQueryOptions = <TData = Awaited<ReturnType<typeof listProcessedEmails>>, TError = unknown>(tenant: string,
    params: ListProcessedEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessedEmailsQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessedEmails>>> = ({ signal }) => listProcessedEmails(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessedEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessedEmails>>>
export type ListProcessedEmailsQueryError = unknown


export function useListProcessedEmails<TData = Awaited<ReturnType<typeof listProcessedEmails>>, TError = unknown>(
 tenant: string,
    params: ListProcessedEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessedEmails>>,
          TError,
          Awaited<ReturnType<typeof listProcessedEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessedEmails<TData = Awaited<ReturnType<typeof listProcessedEmails>>, TError = unknown>(
 tenant: string,
    params: ListProcessedEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessedEmails>>,
          TError,
          Awaited<ReturnType<typeof listProcessedEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessedEmails<TData = Awaited<ReturnType<typeof listProcessedEmails>>, TError = unknown>(
 tenant: string,
    params: ListProcessedEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista emails processados por gatilho de email
 */

export function useListProcessedEmails<TData = Awaited<ReturnType<typeof listProcessedEmails>>, TError = unknown>(
 tenant: string,
    params: ListProcessedEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessedEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessedEmailsQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessDefinitionsResponse200 = {
  data: EmailProcessDefinitionOptionDto[]
  status: 200
}

export type listProcessDefinitionsResponseSuccess = (listProcessDefinitionsResponse200) & {
  headers: Headers;
};
;

export type listProcessDefinitionsResponse = (listProcessDefinitionsResponseSuccess)

export const getListProcessDefinitionsUrl = (tenant: string,) => {




  return `/v1/${tenant}/email-process/configurations/process-definitions`
}

/**
 * @summary Lista processos disponiveis para vinculo com gatilho de email
 */
export const listProcessDefinitions = async (tenant: string, options?: RequestInit): Promise<listProcessDefinitionsResponse> => {

  return customInstanceBpm<listProcessDefinitionsResponse>(getListProcessDefinitionsUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessDefinitionsQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/email-process/configurations/process-definitions`
    ] as const;
    }


export const getListProcessDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof listProcessDefinitions>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessDefinitionsQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessDefinitions>>> = ({ signal }) => listProcessDefinitions(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessDefinitions>>>
export type ListProcessDefinitionsQueryError = unknown


export function useListProcessDefinitions<TData = Awaited<ReturnType<typeof listProcessDefinitions>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitions<TData = Awaited<ReturnType<typeof listProcessDefinitions>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitions<TData = Awaited<ReturnType<typeof listProcessDefinitions>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista processos disponiveis para vinculo com gatilho de email
 */

export function useListProcessDefinitions<TData = Awaited<ReturnType<typeof listProcessDefinitions>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessDefinitionsQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listAllDataListRowResponse200 = {
  data: DataListRowPageSwagger
  status: 200
}

export type listAllDataListRowResponseSuccess = (listAllDataListRowResponse200) & {
  headers: Headers;
};
;

export type listAllDataListRowResponse = (listAllDataListRowResponseSuccess)

export const getListAllDataListRowUrl = (tenant: string,
    dataListId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/all`
}

/**
 * @summary Lista os itens ativos da listas de dados
 */
export const listAllDataListRow = async (tenant: string,
    dataListId: string, options?: RequestInit): Promise<listAllDataListRowResponse> => {

  return customInstanceBpm<listAllDataListRowResponse>(getListAllDataListRowUrl(tenant,dataListId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllDataListRowQueryKey = (tenant: string,
    dataListId: string,) => {
    return [
    `/v1/${tenant}/data-list/${dataListId}/items/all`
    ] as const;
    }


export const getListAllDataListRowQueryOptions = <TData = Awaited<ReturnType<typeof listAllDataListRow>>, TError = unknown>(tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllDataListRowQueryKey(tenant,dataListId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllDataListRow>>> = ({ signal }) => listAllDataListRow(tenant,dataListId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && dataListId !== null && dataListId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllDataListRowQueryResult = NonNullable<Awaited<ReturnType<typeof listAllDataListRow>>>
export type ListAllDataListRowQueryError = unknown


export function useListAllDataListRow<TData = Awaited<ReturnType<typeof listAllDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listAllDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllDataListRow<TData = Awaited<ReturnType<typeof listAllDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listAllDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllDataListRow<TData = Awaited<ReturnType<typeof listAllDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os itens ativos da listas de dados
 */

export function useListAllDataListRow<TData = Awaited<ReturnType<typeof listAllDataListRow>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllDataListRowQueryOptions(tenant,dataListId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type exportDataListCsvResponse200 = {
  data: string[]
  status: 200
}

export type exportDataListCsvResponseSuccess = (exportDataListCsvResponse200) & {
  headers: Headers;
};
;

export type exportDataListCsvResponse = (exportDataListCsvResponseSuccess)

export const getExportDataListCsvUrl = (tenant: string,
    dataListId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/export`
}

/**
 * @summary Exporta os itens de uma lista de dados em CSV
 */
export const exportDataListCsv = async (tenant: string,
    dataListId: string, options?: RequestInit): Promise<exportDataListCsvResponse> => {

  return customInstanceBpm<exportDataListCsvResponse>(getExportDataListCsvUrl(tenant,dataListId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportDataListCsvQueryKey = (tenant: string,
    dataListId: string,) => {
    return [
    `/v1/${tenant}/data-list/${dataListId}/export`
    ] as const;
    }


export const getExportDataListCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportDataListCsv>>, TError = unknown>(tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportDataListCsvQueryKey(tenant,dataListId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportDataListCsv>>> = ({ signal }) => exportDataListCsv(tenant,dataListId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && dataListId !== null && dataListId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportDataListCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportDataListCsv>>>
export type ExportDataListCsvQueryError = unknown


export function useExportDataListCsv<TData = Awaited<ReturnType<typeof exportDataListCsv>>, TError = unknown>(
 tenant: string,
    dataListId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportDataListCsv>>,
          TError,
          Awaited<ReturnType<typeof exportDataListCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportDataListCsv<TData = Awaited<ReturnType<typeof exportDataListCsv>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportDataListCsv>>,
          TError,
          Awaited<ReturnType<typeof exportDataListCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportDataListCsv<TData = Awaited<ReturnType<typeof exportDataListCsv>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta os itens de uma lista de dados em CSV
 */

export function useExportDataListCsv<TData = Awaited<ReturnType<typeof exportDataListCsv>>, TError = unknown>(
 tenant: string,
    dataListId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDataListCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportDataListCsvQueryOptions(tenant,dataListId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findCategoryByNameResponse200 = {
  data: CategoryDto
  status: 200
}

export type findCategoryByNameResponseSuccess = (findCategoryByNameResponse200) & {
  headers: Headers;
};
;

export type findCategoryByNameResponse = (findCategoryByNameResponseSuccess)

export const getFindCategoryByNameUrl = (tenant: string,
    categoryName: string,) => {




  return `/v1/${tenant}/categories/name/${categoryName}`
}

/**
 * @summary Busca uma categoria pelo nome
 */
export const findCategoryByName = async (tenant: string,
    categoryName: string, options?: RequestInit): Promise<findCategoryByNameResponse> => {

  return customInstanceBpm<findCategoryByNameResponse>(getFindCategoryByNameUrl(tenant,categoryName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindCategoryByNameQueryKey = (tenant: string,
    categoryName: string,) => {
    return [
    `/v1/${tenant}/categories/name/${categoryName}`
    ] as const;
    }


export const getFindCategoryByNameQueryOptions = <TData = Awaited<ReturnType<typeof findCategoryByName>>, TError = unknown>(tenant: string,
    categoryName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCategoryByNameQueryKey(tenant,categoryName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCategoryByName>>> = ({ signal }) => findCategoryByName(tenant,categoryName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && categoryName !== null && categoryName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCategoryByNameQueryResult = NonNullable<Awaited<ReturnType<typeof findCategoryByName>>>
export type FindCategoryByNameQueryError = unknown


export function useFindCategoryByName<TData = Awaited<ReturnType<typeof findCategoryByName>>, TError = unknown>(
 tenant: string,
    categoryName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCategoryByName>>,
          TError,
          Awaited<ReturnType<typeof findCategoryByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCategoryByName<TData = Awaited<ReturnType<typeof findCategoryByName>>, TError = unknown>(
 tenant: string,
    categoryName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCategoryByName>>,
          TError,
          Awaited<ReturnType<typeof findCategoryByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCategoryByName<TData = Awaited<ReturnType<typeof findCategoryByName>>, TError = unknown>(
 tenant: string,
    categoryName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma categoria pelo nome
 */

export function useFindCategoryByName<TData = Awaited<ReturnType<typeof findCategoryByName>>, TError = unknown>(
 tenant: string,
    categoryName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCategoryByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCategoryByNameQueryOptions(tenant,categoryName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchAuditLogsResponse200 = {
  data: string
  status: 200
}

export type searchAuditLogsResponse403 = {
  data: string
  status: 403
}

export type searchAuditLogsResponseSuccess = (searchAuditLogsResponse200) & {
  headers: Headers;
};
export type searchAuditLogsResponseError = (searchAuditLogsResponse403) & {
  headers: Headers;
};

export type searchAuditLogsResponse = (searchAuditLogsResponseSuccess | searchAuditLogsResponseError)

export const getSearchAuditLogsUrl = (tenant: string,
    params: SearchAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/audit-logs?${stringifiedParams}` : `/v1/${tenant}/audit-logs`
}

/**
 * @summary Consulta audit logs
 */
export const searchAuditLogs = async (tenant: string,
    params: SearchAuditLogsParams, options?: RequestInit): Promise<searchAuditLogsResponse> => {

  return customInstanceBpm<searchAuditLogsResponse>(getSearchAuditLogsUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAuditLogsQueryKey = (tenant: string,
    params?: SearchAuditLogsParams,) => {
    return [
    `/v1/${tenant}/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof searchAuditLogs>>, TError = string>(tenant: string,
    params: SearchAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAuditLogsQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAuditLogs>>> = ({ signal }) => searchAuditLogs(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAuditLogs>>>
export type SearchAuditLogsQueryError = string


export function useSearchAuditLogs<TData = Awaited<ReturnType<typeof searchAuditLogs>>, TError = string>(
 tenant: string,
    params: SearchAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof searchAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAuditLogs<TData = Awaited<ReturnType<typeof searchAuditLogs>>, TError = string>(
 tenant: string,
    params: SearchAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof searchAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAuditLogs<TData = Awaited<ReturnType<typeof searchAuditLogs>>, TError = string>(
 tenant: string,
    params: SearchAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta audit logs
 */

export function useSearchAuditLogs<TData = Awaited<ReturnType<typeof searchAuditLogs>>, TError = string>(
 tenant: string,
    params: SearchAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAuditLogsQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listAuditIndicesResponse200 = {
  data: string
  status: 200
}

export type listAuditIndicesResponse403 = {
  data: string
  status: 403
}

export type listAuditIndicesResponseSuccess = (listAuditIndicesResponse200) & {
  headers: Headers;
};
export type listAuditIndicesResponseError = (listAuditIndicesResponse403) & {
  headers: Headers;
};

export type listAuditIndicesResponse = (listAuditIndicesResponseSuccess | listAuditIndicesResponseError)

export const getListAuditIndicesUrl = (tenant: string,) => {




  return `/v1/${tenant}/audit-index/list`
}

/**
 * @summary Lista os índices de auditoria
 */
export const listAuditIndices = async (tenant: string, options?: RequestInit): Promise<listAuditIndicesResponse> => {

  return customInstanceBpm<listAuditIndicesResponse>(getListAuditIndicesUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditIndicesQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/audit-index/list`
    ] as const;
    }


export const getListAuditIndicesQueryOptions = <TData = Awaited<ReturnType<typeof listAuditIndices>>, TError = string>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditIndicesQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditIndices>>> = ({ signal }) => listAuditIndices(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditIndicesQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditIndices>>>
export type ListAuditIndicesQueryError = string


export function useListAuditIndices<TData = Awaited<ReturnType<typeof listAuditIndices>>, TError = string>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditIndices>>,
          TError,
          Awaited<ReturnType<typeof listAuditIndices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditIndices<TData = Awaited<ReturnType<typeof listAuditIndices>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditIndices>>,
          TError,
          Awaited<ReturnType<typeof listAuditIndices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditIndices<TData = Awaited<ReturnType<typeof listAuditIndices>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os índices de auditoria
 */

export function useListAuditIndices<TData = Awaited<ReturnType<typeof listAuditIndices>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditIndices>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditIndicesQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAuditIndexInfoResponse200 = {
  data: string
  status: 200
}

export type getAuditIndexInfoResponse403 = {
  data: string
  status: 403
}

export type getAuditIndexInfoResponseSuccess = (getAuditIndexInfoResponse200) & {
  headers: Headers;
};
export type getAuditIndexInfoResponseError = (getAuditIndexInfoResponse403) & {
  headers: Headers;
};

export type getAuditIndexInfoResponse = (getAuditIndexInfoResponseSuccess | getAuditIndexInfoResponseError)

export const getGetAuditIndexInfoUrl = (tenant: string,) => {




  return `/v1/${tenant}/audit-index/info`
}

/**
 * @summary Informações do índice de auditoria
 */
export const getAuditIndexInfo = async (tenant: string, options?: RequestInit): Promise<getAuditIndexInfoResponse> => {

  return customInstanceBpm<getAuditIndexInfoResponse>(getGetAuditIndexInfoUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuditIndexInfoQueryKey = (tenant: string,) => {
    return [
    `/v1/${tenant}/audit-index/info`
    ] as const;
    }


export const getGetAuditIndexInfoQueryOptions = <TData = Awaited<ReturnType<typeof getAuditIndexInfo>>, TError = string>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditIndexInfoQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditIndexInfo>>> = ({ signal }) => getAuditIndexInfo(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditIndexInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditIndexInfo>>>
export type GetAuditIndexInfoQueryError = string


export function useGetAuditIndexInfo<TData = Awaited<ReturnType<typeof getAuditIndexInfo>>, TError = string>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditIndexInfo>>,
          TError,
          Awaited<ReturnType<typeof getAuditIndexInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditIndexInfo<TData = Awaited<ReturnType<typeof getAuditIndexInfo>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditIndexInfo>>,
          TError,
          Awaited<ReturnType<typeof getAuditIndexInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditIndexInfo<TData = Awaited<ReturnType<typeof getAuditIndexInfo>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Informações do índice de auditoria
 */

export function useGetAuditIndexInfo<TData = Awaited<ReturnType<typeof getAuditIndexInfo>>, TError = string>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditIndexInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditIndexInfoQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listAccessProfileLogsResponse200 = {
  data: PageAccessProfileLogDto
  status: 200
}

export type listAccessProfileLogsResponseSuccess = (listAccessProfileLogsResponse200) & {
  headers: Headers;
};
;

export type listAccessProfileLogsResponse = (listAccessProfileLogsResponseSuccess)

export const getListAccessProfileLogsUrl = (tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/access-profiles/${accessProfileId}/logs?${stringifiedParams}` : `/v1/${tenant}/access-profiles/${accessProfileId}/logs`
}

/**
 * @summary Lista os logs do perfil de acesso
 */
export const listAccessProfileLogs = async (tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams, options?: RequestInit): Promise<listAccessProfileLogsResponse> => {

  return customInstanceBpm<listAccessProfileLogsResponse>(getListAccessProfileLogsUrl(tenant,accessProfileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccessProfileLogsQueryKey = (tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams,) => {
    return [
    `/v1/${tenant}/access-profiles/${accessProfileId}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccessProfileLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAccessProfileLogs>>, TError = unknown>(tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessProfileLogsQueryKey(tenant,accessProfileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessProfileLogs>>> = ({ signal }) => listAccessProfileLogs(tenant,accessProfileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && accessProfileId !== null && accessProfileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccessProfileLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessProfileLogs>>>
export type ListAccessProfileLogsQueryError = unknown


export function useListAccessProfileLogs<TData = Awaited<ReturnType<typeof listAccessProfileLogs>>, TError = unknown>(
 tenant: string,
    accessProfileId: number,
    params: undefined |  ListAccessProfileLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessProfileLogs>>,
          TError,
          Awaited<ReturnType<typeof listAccessProfileLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessProfileLogs<TData = Awaited<ReturnType<typeof listAccessProfileLogs>>, TError = unknown>(
 tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessProfileLogs>>,
          TError,
          Awaited<ReturnType<typeof listAccessProfileLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessProfileLogs<TData = Awaited<ReturnType<typeof listAccessProfileLogs>>, TError = unknown>(
 tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os logs do perfil de acesso
 */

export function useListAccessProfileLogs<TData = Awaited<ReturnType<typeof listAccessProfileLogs>>, TError = unknown>(
 tenant: string,
    accessProfileId: number,
    params?: ListAccessProfileLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessProfileLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccessProfileLogsQueryOptions(tenant,accessProfileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listTermAcceptedUsersResponse200 = {
  data: TermsAcceptanceDto[]
  status: 200
}

export type listTermAcceptedUsersResponseSuccess = (listTermAcceptedUsersResponse200) & {
  headers: Headers;
};
;

export type listTermAcceptedUsersResponse = (listTermAcceptedUsersResponseSuccess)

export const getListTermAcceptedUsersUrl = (id: string,) => {




  return `/v1/terms/${id}/accepted-users`
}

/**
 * @summary Lista os usuários que aceitaram o termo de uso
 */
export const listTermAcceptedUsers = async (id: string, options?: RequestInit): Promise<listTermAcceptedUsersResponse> => {

  return customInstanceBpm<listTermAcceptedUsersResponse>(getListTermAcceptedUsersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTermAcceptedUsersQueryKey = (id: string,) => {
    return [
    `/v1/terms/${id}/accepted-users`
    ] as const;
    }


export const getListTermAcceptedUsersQueryOptions = <TData = Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTermAcceptedUsersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTermAcceptedUsers>>> = ({ signal }) => listTermAcceptedUsers(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTermAcceptedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listTermAcceptedUsers>>>
export type ListTermAcceptedUsersQueryError = unknown


export function useListTermAcceptedUsers<TData = Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTermAcceptedUsers>>,
          TError,
          Awaited<ReturnType<typeof listTermAcceptedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTermAcceptedUsers<TData = Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTermAcceptedUsers>>,
          TError,
          Awaited<ReturnType<typeof listTermAcceptedUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTermAcceptedUsers<TData = Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os usuários que aceitaram o termo de uso
 */

export function useListTermAcceptedUsers<TData = Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTermAcceptedUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTermAcceptedUsersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTermAcceptanceByUserResponse200 = {
  data: TermsAcceptanceDto
  status: 200
}

export type getTermAcceptanceByUserResponseSuccess = (getTermAcceptanceByUserResponse200) & {
  headers: Headers;
};
;

export type getTermAcceptanceByUserResponse = (getTermAcceptanceByUserResponseSuccess)

export const getGetTermAcceptanceByUserUrl = (id: string,) => {




  return `/v1/terms/${id}/accepted-users/me`
}

/**
 * @summary Verifica se o usuario logado aceitou o termo de uso
 */
export const getTermAcceptanceByUser = async (id: string, options?: RequestInit): Promise<getTermAcceptanceByUserResponse> => {

  return customInstanceBpm<getTermAcceptanceByUserResponse>(getGetTermAcceptanceByUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTermAcceptanceByUserQueryKey = (id: string,) => {
    return [
    `/v1/terms/${id}/accepted-users/me`
    ] as const;
    }


export const getGetTermAcceptanceByUserQueryOptions = <TData = Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermAcceptanceByUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTermAcceptanceByUser>>> = ({ signal }) => getTermAcceptanceByUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTermAcceptanceByUserQueryResult = NonNullable<Awaited<ReturnType<typeof getTermAcceptanceByUser>>>
export type GetTermAcceptanceByUserQueryError = unknown


export function useGetTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermAcceptanceByUser>>,
          TError,
          Awaited<ReturnType<typeof getTermAcceptanceByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermAcceptanceByUser>>,
          TError,
          Awaited<ReturnType<typeof getTermAcceptanceByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Verifica se o usuario logado aceitou o termo de uso
 */

export function useGetTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTermAcceptanceByUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getLastestTermAcceptanceByUserResponse200 = {
  data: TermsAcceptanceDto
  status: 200
}

export type getLastestTermAcceptanceByUserResponseSuccess = (getLastestTermAcceptanceByUserResponse200) & {
  headers: Headers;
};
;

export type getLastestTermAcceptanceByUserResponse = (getLastestTermAcceptanceByUserResponseSuccess)

export const getGetLastestTermAcceptanceByUserUrl = (params?: GetLastestTermAcceptanceByUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/terms/latest/accepted-users/me?${stringifiedParams}` : `/v1/terms/latest/accepted-users/me`
}

/**
 * @summary Verifica se o usuario logado aceitou o termo de uso mais atual
 */
export const getLastestTermAcceptanceByUser = async (params?: GetLastestTermAcceptanceByUserParams, options?: RequestInit): Promise<getLastestTermAcceptanceByUserResponse> => {

  return customInstanceBpm<getLastestTermAcceptanceByUserResponse>(getGetLastestTermAcceptanceByUserUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLastestTermAcceptanceByUserQueryKey = (params?: GetLastestTermAcceptanceByUserParams,) => {
    return [
    `/v1/terms/latest/accepted-users/me`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLastestTermAcceptanceByUserQueryOptions = <TData = Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError = unknown>(params?: GetLastestTermAcceptanceByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastestTermAcceptanceByUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>> = ({ signal }) => getLastestTermAcceptanceByUser(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLastestTermAcceptanceByUserQueryResult = NonNullable<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>>
export type GetLastestTermAcceptanceByUserQueryError = unknown


export function useGetLastestTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError = unknown>(
 params: undefined |  GetLastestTermAcceptanceByUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>,
          TError,
          Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastestTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError = unknown>(
 params?: GetLastestTermAcceptanceByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>,
          TError,
          Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastestTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError = unknown>(
 params?: GetLastestTermAcceptanceByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Verifica se o usuario logado aceitou o termo de uso mais atual
 */

export function useGetLastestTermAcceptanceByUser<TData = Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError = unknown>(
 params?: GetLastestTermAcceptanceByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastestTermAcceptanceByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLastestTermAcceptanceByUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTenantsFromLoggedUserResponse200 = {
  data: string[]
  status: 200
}

export type getTenantsFromLoggedUserResponseSuccess = (getTenantsFromLoggedUserResponse200) & {
  headers: Headers;
};
;

export type getTenantsFromLoggedUserResponse = (getTenantsFromLoggedUserResponseSuccess)

export const getGetTenantsFromLoggedUserUrl = () => {




  return `/v1/tenants/tenants-from-logged-user`
}

/**
 * @summary Lista os tenants do usuário logado
 */
export const getTenantsFromLoggedUser = async ( options?: RequestInit): Promise<getTenantsFromLoggedUserResponse> => {

  return customInstanceBpm<getTenantsFromLoggedUserResponse>(getGetTenantsFromLoggedUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTenantsFromLoggedUserQueryKey = () => {
    return [
    `/v1/tenants/tenants-from-logged-user`
    ] as const;
    }


export const getGetTenantsFromLoggedUserQueryOptions = <TData = Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantsFromLoggedUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>> = ({ signal }) => getTenantsFromLoggedUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantsFromLoggedUserQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>>
export type GetTenantsFromLoggedUserQueryError = unknown


export function useGetTenantsFromLoggedUser<TData = Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsFromLoggedUser>>,
          TError,
          Awaited<ReturnType<typeof getTenantsFromLoggedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsFromLoggedUser<TData = Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantsFromLoggedUser>>,
          TError,
          Awaited<ReturnType<typeof getTenantsFromLoggedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantsFromLoggedUser<TData = Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os tenants do usuário logado
 */

export function useGetTenantsFromLoggedUser<TData = Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantsFromLoggedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantsFromLoggedUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listTasksIgnoringTenantResponse200 = {
  data: PageCustomTaskBpmDto
  status: 200
}

export type listTasksIgnoringTenantResponseSuccess = (listTasksIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type listTasksIgnoringTenantResponse = (listTasksIgnoringTenantResponseSuccess)

export const getListTasksIgnoringTenantUrl = (params?: ListTasksIgnoringTenantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tasks?${stringifiedParams}` : `/v1/tasks`
}

/**
 * @summary Lista as tarefas
 */
export const listTasksIgnoringTenant = async (params?: ListTasksIgnoringTenantParams, options?: RequestInit): Promise<listTasksIgnoringTenantResponse> => {

  return customInstanceBpm<listTasksIgnoringTenantResponse>(getListTasksIgnoringTenantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksIgnoringTenantQueryKey = (params?: ListTasksIgnoringTenantParams,) => {
    return [
    `/v1/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError = unknown>(params?: ListTasksIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksIgnoringTenantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasksIgnoringTenant>>> = ({ signal }) => listTasksIgnoringTenant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listTasksIgnoringTenant>>>
export type ListTasksIgnoringTenantQueryError = unknown


export function useListTasksIgnoringTenant<TData = Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError = unknown>(
 params: undefined |  ListTasksIgnoringTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasksIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listTasksIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasksIgnoringTenant<TData = Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError = unknown>(
 params?: ListTasksIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasksIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listTasksIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasksIgnoringTenant<TData = Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError = unknown>(
 params?: ListTasksIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as tarefas
 */

export function useListTasksIgnoringTenant<TData = Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError = unknown>(
 params?: ListTasksIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasksIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksIgnoringTenantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listExternalPortalTasksResponse200 = {
  data: PageCustomTaskBpmDto
  status: 200
}

export type listExternalPortalTasksResponseSuccess = (listExternalPortalTasksResponse200) & {
  headers: Headers;
};
;

export type listExternalPortalTasksResponse = (listExternalPortalTasksResponseSuccess)

export const getListExternalPortalTasksUrl = (params: ListExternalPortalTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tasks/portal-externo?${stringifiedParams}` : `/v1/tasks/portal-externo`
}

/**
 * @summary Lista tarefas disponiveis no portal externo
 */
export const listExternalPortalTasks = async (params: ListExternalPortalTasksParams, options?: RequestInit): Promise<listExternalPortalTasksResponse> => {

  return customInstanceBpm<listExternalPortalTasksResponse>(getListExternalPortalTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExternalPortalTasksQueryKey = (params?: ListExternalPortalTasksParams,) => {
    return [
    `/v1/tasks/portal-externo`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExternalPortalTasksQueryOptions = <TData = Awaited<ReturnType<typeof listExternalPortalTasks>>, TError = unknown>(params: ListExternalPortalTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExternalPortalTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExternalPortalTasks>>> = ({ signal }) => listExternalPortalTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExternalPortalTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listExternalPortalTasks>>>
export type ListExternalPortalTasksQueryError = unknown


export function useListExternalPortalTasks<TData = Awaited<ReturnType<typeof listExternalPortalTasks>>, TError = unknown>(
 params: ListExternalPortalTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalTasks>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalTasks<TData = Awaited<ReturnType<typeof listExternalPortalTasks>>, TError = unknown>(
 params: ListExternalPortalTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalTasks>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalTasks<TData = Awaited<ReturnType<typeof listExternalPortalTasks>>, TError = unknown>(
 params: ListExternalPortalTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista tarefas disponiveis no portal externo
 */

export function useListExternalPortalTasks<TData = Awaited<ReturnType<typeof listExternalPortalTasks>>, TError = unknown>(
 params: ListExternalPortalTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExternalPortalTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getUserByTokenResponse200 = {
  data: SmartUserWithAllPropertiesDto
  status: 200
}

export type getUserByTokenResponseSuccess = (getUserByTokenResponse200) & {
  headers: Headers;
};
;

export type getUserByTokenResponse = (getUserByTokenResponseSuccess)

export const getGetUserByTokenUrl = () => {




  return `/v1/security/user-info`
}

/**
 * @summary Retorna informações do usuário logado
 */
export const getUserByToken = async ( options?: RequestInit): Promise<getUserByTokenResponse> => {

  return customInstanceBpm<getUserByTokenResponse>(getGetUserByTokenUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserByTokenQueryKey = () => {
    return [
    `/v1/security/user-info`
    ] as const;
    }


export const getGetUserByTokenQueryOptions = <TData = Awaited<ReturnType<typeof getUserByToken>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserByTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserByToken>>> = ({ signal }) => getUserByToken({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserByTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getUserByToken>>>
export type GetUserByTokenQueryError = unknown


export function useGetUserByToken<TData = Awaited<ReturnType<typeof getUserByToken>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserByToken>>,
          TError,
          Awaited<ReturnType<typeof getUserByToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserByToken<TData = Awaited<ReturnType<typeof getUserByToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserByToken>>,
          TError,
          Awaited<ReturnType<typeof getUserByToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserByToken<TData = Awaited<ReturnType<typeof getUserByToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna informações do usuário logado
 */

export function useGetUserByToken<TData = Awaited<ReturnType<typeof getUserByToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserByToken>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserByTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessesHistoricIgnoringTenantResponse200 = {
  data: PageCustomHistoricProcessInstanceDto
  status: 200
}

export type listProcessesHistoricIgnoringTenantResponseSuccess = (listProcessesHistoricIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type listProcessesHistoricIgnoringTenantResponse = (listProcessesHistoricIgnoringTenantResponseSuccess)

export const getListProcessesHistoricIgnoringTenantUrl = (params?: ListProcessesHistoricIgnoringTenantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-instances?${stringifiedParams}` : `/v1/process-instances`
}

/**
 * @summary Lista o histórico de processos de todos os tenants (organizações) que o usuário tem acesso
 */
export const listProcessesHistoricIgnoringTenant = async (params?: ListProcessesHistoricIgnoringTenantParams, options?: RequestInit): Promise<listProcessesHistoricIgnoringTenantResponse> => {

  return customInstanceBpm<listProcessesHistoricIgnoringTenantResponse>(getListProcessesHistoricIgnoringTenantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessesHistoricIgnoringTenantQueryKey = (params?: ListProcessesHistoricIgnoringTenantParams,) => {
    return [
    `/v1/process-instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessesHistoricIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError = unknown>(params?: ListProcessesHistoricIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessesHistoricIgnoringTenantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>> = ({ signal }) => listProcessesHistoricIgnoringTenant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessesHistoricIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>>
export type ListProcessesHistoricIgnoringTenantQueryError = unknown


export function useListProcessesHistoricIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError = unknown>(
 params: undefined |  ListProcessesHistoricIgnoringTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessesHistoricIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError = unknown>(
 params?: ListProcessesHistoricIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessesHistoricIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError = unknown>(
 params?: ListProcessesHistoricIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o histórico de processos de todos os tenants (organizações) que o usuário tem acesso
 */

export function useListProcessesHistoricIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError = unknown>(
 params?: ListProcessesHistoricIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoricIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessesHistoricIgnoringTenantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessInstanceByIdIgnoringTenantResponse200 = {
  data: CustomHistoricProcessInstanceDto
  status: 200
}

export type getProcessInstanceByIdIgnoringTenantResponseSuccess = (getProcessInstanceByIdIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type getProcessInstanceByIdIgnoringTenantResponse = (getProcessInstanceByIdIgnoringTenantResponseSuccess)

export const getGetProcessInstanceByIdIgnoringTenantUrl = (processInstanceId: string,) => {




  return `/v1/process-instances/${processInstanceId}`
}

/**
 * @summary Busca instância do processo por ID
 */
export const getProcessInstanceByIdIgnoringTenant = async (processInstanceId: string, options?: RequestInit): Promise<getProcessInstanceByIdIgnoringTenantResponse> => {

  return customInstanceBpm<getProcessInstanceByIdIgnoringTenantResponse>(getGetProcessInstanceByIdIgnoringTenantUrl(processInstanceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessInstanceByIdIgnoringTenantQueryKey = (processInstanceId: string,) => {
    return [
    `/v1/process-instances/${processInstanceId}`
    ] as const;
    }


export const getGetProcessInstanceByIdIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError = unknown>(processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceByIdIgnoringTenantQueryKey(processInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>> = ({ signal }) => getProcessInstanceByIdIgnoringTenant(processInstanceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceByIdIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>>
export type GetProcessInstanceByIdIgnoringTenantQueryError = unknown


export function useGetProcessInstanceByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError = unknown>(
 processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca instância do processo por ID
 */

export function useGetProcessInstanceByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceByIdIgnoringTenantQueryOptions(processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getSignerResultHistoryResponse200 = {
  data: SignerSignatureProcessDto[]
  status: 200
}

export type getSignerResultHistoryResponseSuccess = (getSignerResultHistoryResponse200) & {
  headers: Headers;
};
;

export type getSignerResultHistoryResponse = (getSignerResultHistoryResponseSuccess)

export const getGetSignerResultHistoryUrl = (processInstanceId: string,) => {




  return `/v1/process-instances/${processInstanceId}/signer-history`
}

/**
 * @summary Retorna o histórico de assinaturas do Signer para uma instância de processo
 */
export const getSignerResultHistory = async (processInstanceId: string, options?: RequestInit): Promise<getSignerResultHistoryResponse> => {

  return customInstanceBpm<getSignerResultHistoryResponse>(getGetSignerResultHistoryUrl(processInstanceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSignerResultHistoryQueryKey = (processInstanceId: string,) => {
    return [
    `/v1/process-instances/${processInstanceId}/signer-history`
    ] as const;
    }


export const getGetSignerResultHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getSignerResultHistory>>, TError = unknown>(processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignerResultHistoryQueryKey(processInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignerResultHistory>>> = ({ signal }) => getSignerResultHistory(processInstanceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSignerResultHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSignerResultHistory>>>
export type GetSignerResultHistoryQueryError = unknown


export function useGetSignerResultHistory<TData = Awaited<ReturnType<typeof getSignerResultHistory>>, TError = unknown>(
 processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignerResultHistory>>,
          TError,
          Awaited<ReturnType<typeof getSignerResultHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignerResultHistory<TData = Awaited<ReturnType<typeof getSignerResultHistory>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSignerResultHistory>>,
          TError,
          Awaited<ReturnType<typeof getSignerResultHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSignerResultHistory<TData = Awaited<ReturnType<typeof getSignerResultHistory>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna o histórico de assinaturas do Signer para uma instância de processo
 */

export function useGetSignerResultHistory<TData = Awaited<ReturnType<typeof getSignerResultHistory>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSignerResultHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSignerResultHistoryQueryOptions(processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessInstanceIncidentsResponse200 = {
  data: IncidentDto[]
  status: 200
}

export type getProcessInstanceIncidentsResponseSuccess = (getProcessInstanceIncidentsResponse200) & {
  headers: Headers;
};
;

export type getProcessInstanceIncidentsResponse = (getProcessInstanceIncidentsResponseSuccess)

export const getGetProcessInstanceIncidentsUrl = (processInstanceId: string,) => {




  return `/v1/process-instances/${processInstanceId}/incidents`
}

/**
 * @summary Lista os incidentes da instância do processo
 */
export const getProcessInstanceIncidents = async (processInstanceId: string, options?: RequestInit): Promise<getProcessInstanceIncidentsResponse> => {

  return customInstanceBpm<getProcessInstanceIncidentsResponse>(getGetProcessInstanceIncidentsUrl(processInstanceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessInstanceIncidentsQueryKey = (processInstanceId: string,) => {
    return [
    `/v1/process-instances/${processInstanceId}/incidents`
    ] as const;
    }


export const getGetProcessInstanceIncidentsQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError = unknown>(processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceIncidentsQueryKey(processInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceIncidents>>> = ({ signal }) => getProcessInstanceIncidents(processInstanceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceIncidents>>>
export type GetProcessInstanceIncidentsQueryError = unknown


export function useGetProcessInstanceIncidents<TData = Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError = unknown>(
 processInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceIncidents>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceIncidents<TData = Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceIncidents>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceIncidents<TData = Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os incidentes da instância do processo
 */

export function useGetProcessInstanceIncidents<TData = Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError = unknown>(
 processInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceIncidents>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceIncidentsQueryOptions(processInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTaskVariablesIgnoringTenantResponse200 = {
  data: GetTaskVariablesIgnoringTenant200
  status: 200
}

export type getTaskVariablesIgnoringTenantResponseSuccess = (getTaskVariablesIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type getTaskVariablesIgnoringTenantResponse = (getTaskVariablesIgnoringTenantResponseSuccess)

export const getGetTaskVariablesIgnoringTenantUrl = (params: GetTaskVariablesIgnoringTenantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-instances/variables?${stringifiedParams}` : `/v1/process-instances/variables`
}

/**
 * @summary Retorna as variavies agrupadas por ID do processo
 */
export const getTaskVariablesIgnoringTenant = async (params: GetTaskVariablesIgnoringTenantParams, options?: RequestInit): Promise<getTaskVariablesIgnoringTenantResponse> => {

  return customInstanceBpm<getTaskVariablesIgnoringTenantResponse>(getGetTaskVariablesIgnoringTenantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskVariablesIgnoringTenantQueryKey = (params?: GetTaskVariablesIgnoringTenantParams,) => {
    return [
    `/v1/process-instances/variables`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskVariablesIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError = unknown>(params: GetTaskVariablesIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskVariablesIgnoringTenantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>> = ({ signal }) => getTaskVariablesIgnoringTenant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskVariablesIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>>
export type GetTaskVariablesIgnoringTenantQueryError = unknown


export function useGetTaskVariablesIgnoringTenant<TData = Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError = unknown>(
 params: GetTaskVariablesIgnoringTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariablesIgnoringTenant<TData = Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError = unknown>(
 params: GetTaskVariablesIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskVariablesIgnoringTenant<TData = Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError = unknown>(
 params: GetTaskVariablesIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna as variavies agrupadas por ID do processo
 */

export function useGetTaskVariablesIgnoringTenant<TData = Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError = unknown>(
 params: GetTaskVariablesIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskVariablesIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskVariablesIgnoringTenantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listLastActivityIgnoringTenantResponse200 = {
  data: ActivityInstanceDto[]
  status: 200
}

export type listLastActivityIgnoringTenantResponseSuccess = (listLastActivityIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type listLastActivityIgnoringTenantResponse = (listLastActivityIgnoringTenantResponseSuccess)

export const getListLastActivityIgnoringTenantUrl = (params: ListLastActivityIgnoringTenantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-instances/last-activity?${stringifiedParams}` : `/v1/process-instances/last-activity`
}

/**
 * @summary Lista ultima atividade das instâncias do processo
 */
export const listLastActivityIgnoringTenant = async (params: ListLastActivityIgnoringTenantParams, options?: RequestInit): Promise<listLastActivityIgnoringTenantResponse> => {

  return customInstanceBpm<listLastActivityIgnoringTenantResponse>(getListLastActivityIgnoringTenantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLastActivityIgnoringTenantQueryKey = (params?: ListLastActivityIgnoringTenantParams,) => {
    return [
    `/v1/process-instances/last-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLastActivityIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError = unknown>(params: ListLastActivityIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLastActivityIgnoringTenantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>> = ({ signal }) => listLastActivityIgnoringTenant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLastActivityIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>>
export type ListLastActivityIgnoringTenantQueryError = unknown


export function useListLastActivityIgnoringTenant<TData = Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError = unknown>(
 params: ListLastActivityIgnoringTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLastActivityIgnoringTenant<TData = Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError = unknown>(
 params: ListLastActivityIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLastActivityIgnoringTenant<TData = Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError = unknown>(
 params: ListLastActivityIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista ultima atividade das instâncias do processo
 */

export function useListLastActivityIgnoringTenant<TData = Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError = unknown>(
 params: ListLastActivityIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLastActivityIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLastActivityIgnoringTenantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessInstanceByEtiquetaResponse200 = {
  data: ProcessDoczDto[]
  status: 200
}

export type getProcessInstanceByEtiquetaResponseSuccess = (getProcessInstanceByEtiquetaResponse200) & {
  headers: Headers;
};
;

export type getProcessInstanceByEtiquetaResponse = (getProcessInstanceByEtiquetaResponseSuccess)

export const getGetProcessInstanceByEtiquetaUrl = (params: GetProcessInstanceByEtiquetaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-instances/etiqueta?${stringifiedParams}` : `/v1/process-instances/etiqueta`
}

/**
 * @summary Busca instância do processo por ID
 */
export const getProcessInstanceByEtiqueta = async (params: GetProcessInstanceByEtiquetaParams, options?: RequestInit): Promise<getProcessInstanceByEtiquetaResponse> => {

  return customInstanceBpm<getProcessInstanceByEtiquetaResponse>(getGetProcessInstanceByEtiquetaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessInstanceByEtiquetaQueryKey = (params?: GetProcessInstanceByEtiquetaParams,) => {
    return [
    `/v1/process-instances/etiqueta`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProcessInstanceByEtiquetaQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError = unknown>(params: GetProcessInstanceByEtiquetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceByEtiquetaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>> = ({ signal }) => getProcessInstanceByEtiqueta(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceByEtiquetaQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>>
export type GetProcessInstanceByEtiquetaQueryError = unknown


export function useGetProcessInstanceByEtiqueta<TData = Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError = unknown>(
 params: GetProcessInstanceByEtiquetaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceByEtiqueta<TData = Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError = unknown>(
 params: GetProcessInstanceByEtiquetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceByEtiqueta<TData = Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError = unknown>(
 params: GetProcessInstanceByEtiquetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca instância do processo por ID
 */

export function useGetProcessInstanceByEtiqueta<TData = Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError = unknown>(
 params: GetProcessInstanceByEtiquetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceByEtiquetaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessDefinitionIgnoringTenantResponse200 = {
  data: PageProcessDefinitionDto
  status: 200
}

export type listProcessDefinitionIgnoringTenantResponseSuccess = (listProcessDefinitionIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type listProcessDefinitionIgnoringTenantResponse = (listProcessDefinitionIgnoringTenantResponseSuccess)

export const getListProcessDefinitionIgnoringTenantUrl = (params?: ListProcessDefinitionIgnoringTenantParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-definitions?${stringifiedParams}` : `/v1/process-definitions`
}

/**
 * @summary Lista as definições do processo de todos os tenants (organizações) que o usuário tem acesso
 */
export const listProcessDefinitionIgnoringTenant = async (params?: ListProcessDefinitionIgnoringTenantParams, options?: RequestInit): Promise<listProcessDefinitionIgnoringTenantResponse> => {

  return customInstanceBpm<listProcessDefinitionIgnoringTenantResponse>(getListProcessDefinitionIgnoringTenantUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessDefinitionIgnoringTenantQueryKey = (params?: ListProcessDefinitionIgnoringTenantParams,) => {
    return [
    `/v1/process-definitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessDefinitionIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError = unknown>(params?: ListProcessDefinitionIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessDefinitionIgnoringTenantQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>> = ({ signal }) => listProcessDefinitionIgnoringTenant(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessDefinitionIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>>
export type ListProcessDefinitionIgnoringTenantQueryError = unknown


export function useListProcessDefinitionIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError = unknown>(
 params: undefined |  ListProcessDefinitionIgnoringTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitionIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError = unknown>(
 params?: ListProcessDefinitionIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessDefinitionIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError = unknown>(
 params?: ListProcessDefinitionIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as definições do processo de todos os tenants (organizações) que o usuário tem acesso
 */

export function useListProcessDefinitionIgnoringTenant<TData = Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError = unknown>(
 params?: ListProcessDefinitionIgnoringTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessDefinitionIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessDefinitionIgnoringTenantQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessDefinitionByIdIgnoringTenantResponse200 = {
  data: ProcessDefinitionDto
  status: 200
}

export type getProcessDefinitionByIdIgnoringTenantResponseSuccess = (getProcessDefinitionByIdIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type getProcessDefinitionByIdIgnoringTenantResponse = (getProcessDefinitionByIdIgnoringTenantResponseSuccess)

export const getGetProcessDefinitionByIdIgnoringTenantUrl = (processDefinitionId: string,) => {




  return `/v1/process-definitions/${processDefinitionId}`
}

/**
 * @summary Busca definição do processo pelo ID
 */
export const getProcessDefinitionByIdIgnoringTenant = async (processDefinitionId: string, options?: RequestInit): Promise<getProcessDefinitionByIdIgnoringTenantResponse> => {

  return customInstanceBpm<getProcessDefinitionByIdIgnoringTenantResponse>(getGetProcessDefinitionByIdIgnoringTenantUrl(processDefinitionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessDefinitionByIdIgnoringTenantQueryKey = (processDefinitionId: string,) => {
    return [
    `/v1/process-definitions/${processDefinitionId}`
    ] as const;
    }


export const getGetProcessDefinitionByIdIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError = unknown>(processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessDefinitionByIdIgnoringTenantQueryKey(processDefinitionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>> = ({ signal }) => getProcessDefinitionByIdIgnoringTenant(processDefinitionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processDefinitionId !== null && processDefinitionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessDefinitionByIdIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>>
export type GetProcessDefinitionByIdIgnoringTenantQueryError = unknown


export function useGetProcessDefinitionByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError = unknown>(
 processDefinitionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessDefinitionByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessDefinitionByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca definição do processo pelo ID
 */

export function useGetProcessDefinitionByIdIgnoringTenant<TData = Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDefinitionByIdIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessDefinitionByIdIgnoringTenantQueryOptions(processDefinitionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listExternalPortalProcessDefinitionsResponse200 = {
  data: PageProcessDefinitionDto
  status: 200
}

export type listExternalPortalProcessDefinitionsResponseSuccess = (listExternalPortalProcessDefinitionsResponse200) & {
  headers: Headers;
};
;

export type listExternalPortalProcessDefinitionsResponse = (listExternalPortalProcessDefinitionsResponseSuccess)

export const getListExternalPortalProcessDefinitionsUrl = (params?: ListExternalPortalProcessDefinitionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/process-definitions/portal-externo?${stringifiedParams}` : `/v1/process-definitions/portal-externo`
}

/**
 * @summary Lista processos disponiveis no portal externo
 */
export const listExternalPortalProcessDefinitions = async (params?: ListExternalPortalProcessDefinitionsParams, options?: RequestInit): Promise<listExternalPortalProcessDefinitionsResponse> => {

  return customInstanceBpm<listExternalPortalProcessDefinitionsResponse>(getListExternalPortalProcessDefinitionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExternalPortalProcessDefinitionsQueryKey = (params?: ListExternalPortalProcessDefinitionsParams,) => {
    return [
    `/v1/process-definitions/portal-externo`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExternalPortalProcessDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError = unknown>(params?: ListExternalPortalProcessDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExternalPortalProcessDefinitionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>> = ({ signal }) => listExternalPortalProcessDefinitions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExternalPortalProcessDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>>
export type ListExternalPortalProcessDefinitionsQueryError = unknown


export function useListExternalPortalProcessDefinitions<TData = Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError = unknown>(
 params: undefined |  ListExternalPortalProcessDefinitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalProcessDefinitions<TData = Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError = unknown>(
 params?: ListExternalPortalProcessDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalProcessDefinitions<TData = Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError = unknown>(
 params?: ListExternalPortalProcessDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista processos disponiveis no portal externo
 */

export function useListExternalPortalProcessDefinitions<TData = Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError = unknown>(
 params?: ListExternalPortalProcessDefinitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalProcessDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExternalPortalProcessDefinitionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type generatePublicProcessLinkResponse200 = {
  data: ProcessLinkStringDto
  status: 200
}

export type generatePublicProcessLinkResponseSuccess = (generatePublicProcessLinkResponse200) & {
  headers: Headers;
};
;

export type generatePublicProcessLinkResponse = (generatePublicProcessLinkResponseSuccess)

export const getGeneratePublicProcessLinkUrl = () => {




  return `/v1/process-definitions/generate-start-link`
}

/**
 * @summary Gera um link publico de inicialização do processo
 */
export const generatePublicProcessLink = async ( options?: RequestInit): Promise<generatePublicProcessLinkResponse> => {

  return customInstanceBpm<generatePublicProcessLinkResponse>(getGeneratePublicProcessLinkUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGeneratePublicProcessLinkQueryKey = () => {
    return [
    `/v1/process-definitions/generate-start-link`
    ] as const;
    }


export const getGeneratePublicProcessLinkQueryOptions = <TData = Awaited<ReturnType<typeof generatePublicProcessLink>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGeneratePublicProcessLinkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof generatePublicProcessLink>>> = ({ signal }) => generatePublicProcessLink({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GeneratePublicProcessLinkQueryResult = NonNullable<Awaited<ReturnType<typeof generatePublicProcessLink>>>
export type GeneratePublicProcessLinkQueryError = unknown


export function useGeneratePublicProcessLink<TData = Awaited<ReturnType<typeof generatePublicProcessLink>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePublicProcessLink>>,
          TError,
          Awaited<ReturnType<typeof generatePublicProcessLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneratePublicProcessLink<TData = Awaited<ReturnType<typeof generatePublicProcessLink>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePublicProcessLink>>,
          TError,
          Awaited<ReturnType<typeof generatePublicProcessLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneratePublicProcessLink<TData = Awaited<ReturnType<typeof generatePublicProcessLink>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gera um link publico de inicialização do processo
 */

export function useGeneratePublicProcessLink<TData = Awaited<ReturnType<typeof generatePublicProcessLink>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePublicProcessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGeneratePublicProcessLinkQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listPermissionResponse200 = {
  data: PageSmartPermissionDto
  status: 200
}

export type listPermissionResponseSuccess = (listPermissionResponse200) & {
  headers: Headers;
};
;

export type listPermissionResponse = (listPermissionResponseSuccess)

export const getListPermissionUrl = (params?: ListPermissionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/permissions?${stringifiedParams}` : `/v1/permissions`
}

/**
 * @summary Lista as permissões
 */
export const listPermission = async (params?: ListPermissionParams, options?: RequestInit): Promise<listPermissionResponse> => {

  return customInstanceBpm<listPermissionResponse>(getListPermissionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPermissionQueryKey = (params?: ListPermissionParams,) => {
    return [
    `/v1/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPermissionQueryOptions = <TData = Awaited<ReturnType<typeof listPermission>>, TError = unknown>(params?: ListPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPermissionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPermission>>> = ({ signal }) => listPermission(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof listPermission>>>
export type ListPermissionQueryError = unknown


export function useListPermission<TData = Awaited<ReturnType<typeof listPermission>>, TError = unknown>(
 params: undefined |  ListPermissionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermission>>,
          TError,
          Awaited<ReturnType<typeof listPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermission<TData = Awaited<ReturnType<typeof listPermission>>, TError = unknown>(
 params?: ListPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermission>>,
          TError,
          Awaited<ReturnType<typeof listPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermission<TData = Awaited<ReturnType<typeof listPermission>>, TError = unknown>(
 params?: ListPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as permissões
 */

export function useListPermission<TData = Awaited<ReturnType<typeof listPermission>>, TError = unknown>(
 params?: ListPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPermissionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findPermissionResponse404 = {
  data: Problem
  status: 404
}

;
export type findPermissionResponseError = (findPermissionResponse404) & {
  headers: Headers;
};

export type findPermissionResponse = (findPermissionResponseError)

export const getFindPermissionUrl = (permissionId: number,) => {




  return `/v1/permissions/${permissionId}`
}

/**
 * @summary Busca permissão por ID
 */
export const findPermission = async (permissionId: number, options?: RequestInit): Promise<findPermissionResponse> => {

  return customInstanceBpm<findPermissionResponse>(getFindPermissionUrl(permissionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindPermissionQueryKey = (permissionId: number,) => {
    return [
    `/v1/permissions/${permissionId}`
    ] as const;
    }


export const getFindPermissionQueryOptions = <TData = Awaited<ReturnType<typeof findPermission>>, TError = Problem>(permissionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPermissionQueryKey(permissionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPermission>>> = ({ signal }) => findPermission(permissionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: permissionId !== null && permissionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof findPermission>>>
export type FindPermissionQueryError = Problem


export function useFindPermission<TData = Awaited<ReturnType<typeof findPermission>>, TError = Problem>(
 permissionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPermission>>,
          TError,
          Awaited<ReturnType<typeof findPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermission<TData = Awaited<ReturnType<typeof findPermission>>, TError = Problem>(
 permissionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPermission>>,
          TError,
          Awaited<ReturnType<typeof findPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermission<TData = Awaited<ReturnType<typeof findPermission>>, TError = Problem>(
 permissionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca permissão por ID
 */

export function useFindPermission<TData = Awaited<ReturnType<typeof findPermission>>, TError = Problem>(
 permissionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPermissionQueryOptions(permissionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listAllOrganizationIgnoringTenantResponse200 = {
  data: OrganizationDto[]
  status: 200
}

export type listAllOrganizationIgnoringTenantResponseSuccess = (listAllOrganizationIgnoringTenantResponse200) & {
  headers: Headers;
};
;

export type listAllOrganizationIgnoringTenantResponse = (listAllOrganizationIgnoringTenantResponseSuccess)

export const getListAllOrganizationIgnoringTenantUrl = () => {




  return `/v1/organizations`
}

/**
 * @summary Lista as organizacoes do usuario
 */
export const listAllOrganizationIgnoringTenant = async ( options?: RequestInit): Promise<listAllOrganizationIgnoringTenantResponse> => {

  return customInstanceBpm<listAllOrganizationIgnoringTenantResponse>(getListAllOrganizationIgnoringTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllOrganizationIgnoringTenantQueryKey = () => {
    return [
    `/v1/organizations`
    ] as const;
    }


export const getListAllOrganizationIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllOrganizationIgnoringTenantQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>> = ({ signal }) => listAllOrganizationIgnoringTenant({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllOrganizationIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>>
export type ListAllOrganizationIgnoringTenantQueryError = unknown


export function useListAllOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as organizacoes do usuario
 */

export function useListAllOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllOrganizationIgnoringTenantQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getOrganizationIgnoringTenantResponse404 = {
  data: Problem
  status: 404
}

;
export type getOrganizationIgnoringTenantResponseError = (getOrganizationIgnoringTenantResponse404) & {
  headers: Headers;
};

export type getOrganizationIgnoringTenantResponse = (getOrganizationIgnoringTenantResponseError)

export const getGetOrganizationIgnoringTenantUrl = (organizationKey: string,) => {




  return `/v1/organizations/${organizationKey}`
}

/**
 * @summary Busca uma organizacao do usuario pela key
 */
export const getOrganizationIgnoringTenant = async (organizationKey: string, options?: RequestInit): Promise<getOrganizationIgnoringTenantResponse> => {

  return customInstanceBpm<getOrganizationIgnoringTenantResponse>(getGetOrganizationIgnoringTenantUrl(organizationKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationIgnoringTenantQueryKey = (organizationKey: string,) => {
    return [
    `/v1/organizations/${organizationKey}`
    ] as const;
    }


export const getGetOrganizationIgnoringTenantQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError = Problem>(organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationIgnoringTenantQueryKey(organizationKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>> = ({ signal }) => getOrganizationIgnoringTenant(organizationKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: organizationKey !== null && organizationKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationIgnoringTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>>
export type GetOrganizationIgnoringTenantQueryError = Problem


export function useGetOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError = Problem>(
 organizationKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError = Problem>(
 organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError = Problem>(
 organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma organizacao do usuario pela key
 */

export function useGetOrganizationIgnoringTenant<TData = Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError = Problem>(
 organizationKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationIgnoringTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationIgnoringTenantQueryOptions(organizationKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listExternalPortalOrganizationsResponse200 = {
  data: OrganizationDto[]
  status: 200
}

export type listExternalPortalOrganizationsResponseSuccess = (listExternalPortalOrganizationsResponse200) & {
  headers: Headers;
};
;

export type listExternalPortalOrganizationsResponse = (listExternalPortalOrganizationsResponseSuccess)

export const getListExternalPortalOrganizationsUrl = () => {




  return `/v1/organizations/portal-externo`
}

/**
 * @summary Lista organizacoes com processos disponiveis no portal externo
 */
export const listExternalPortalOrganizations = async ( options?: RequestInit): Promise<listExternalPortalOrganizationsResponse> => {

  return customInstanceBpm<listExternalPortalOrganizationsResponse>(getListExternalPortalOrganizationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExternalPortalOrganizationsQueryKey = () => {
    return [
    `/v1/organizations/portal-externo`
    ] as const;
    }


export const getListExternalPortalOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExternalPortalOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExternalPortalOrganizations>>> = ({ signal }) => listExternalPortalOrganizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExternalPortalOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listExternalPortalOrganizations>>>
export type ListExternalPortalOrganizationsQueryError = unknown


export function useListExternalPortalOrganizations<TData = Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalOrganizations<TData = Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExternalPortalOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listExternalPortalOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExternalPortalOrganizations<TData = Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista organizacoes com processos disponiveis no portal externo
 */

export function useListExternalPortalOrganizations<TData = Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExternalPortalOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExternalPortalOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProjetosDoczResponse200 = {
  data: DoczSesiProjetoDto[]
  status: 200
}

export type listProjetosDoczResponseSuccess = (listProjetosDoczResponse200) & {
  headers: Headers;
};
;

export type listProjetosDoczResponse = (listProjetosDoczResponseSuccess)

export const getListProjetosDoczUrl = (tenant: string,
    params: ListProjetosDoczParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/docz/${tenant}/projetos?${stringifiedParams}` : `/v1/docz/${tenant}/projetos`
}

/**
 * @summary Lista projetos do docz
 */
export const listProjetosDocz = async (tenant: string,
    params: ListProjetosDoczParams, options?: RequestInit): Promise<listProjetosDoczResponse> => {

  return customInstanceBpm<listProjetosDoczResponse>(getListProjetosDoczUrl(tenant,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProjetosDoczQueryKey = (tenant: string,
    params?: ListProjetosDoczParams,) => {
    return [
    `/v1/docz/${tenant}/projetos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjetosDoczQueryOptions = <TData = Awaited<ReturnType<typeof listProjetosDocz>>, TError = unknown>(tenant: string,
    params: ListProjetosDoczParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjetosDoczQueryKey(tenant,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjetosDocz>>> = ({ signal }) => listProjetosDocz(tenant,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjetosDoczQueryResult = NonNullable<Awaited<ReturnType<typeof listProjetosDocz>>>
export type ListProjetosDoczQueryError = unknown


export function useListProjetosDocz<TData = Awaited<ReturnType<typeof listProjetosDocz>>, TError = unknown>(
 tenant: string,
    params: ListProjetosDoczParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjetosDocz>>,
          TError,
          Awaited<ReturnType<typeof listProjetosDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjetosDocz<TData = Awaited<ReturnType<typeof listProjetosDocz>>, TError = unknown>(
 tenant: string,
    params: ListProjetosDoczParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjetosDocz>>,
          TError,
          Awaited<ReturnType<typeof listProjetosDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjetosDocz<TData = Awaited<ReturnType<typeof listProjetosDocz>>, TError = unknown>(
 tenant: string,
    params: ListProjetosDoczParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista projetos do docz
 */

export function useListProjetosDocz<TData = Awaited<ReturnType<typeof listProjetosDocz>>, TError = unknown>(
 tenant: string,
    params: ListProjetosDoczParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjetosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjetosDoczQueryOptions(tenant,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listPastasDoczResponse200 = {
  data: DoczSesiPastaListDto[]
  status: 200
}

export type listPastasDoczResponseSuccess = (listPastasDoczResponse200) & {
  headers: Headers;
};
;

export type listPastasDoczResponse = (listPastasDoczResponseSuccess)

export const getListPastasDoczUrl = (tenant: string,
    idProjeto: string,) => {




  return `/v1/docz/${tenant}/projetos/${idProjeto}/pastas`
}

/**
 * @summary Lista pastas do docz por projeto
 */
export const listPastasDocz = async (tenant: string,
    idProjeto: string, options?: RequestInit): Promise<listPastasDoczResponse> => {

  return customInstanceBpm<listPastasDoczResponse>(getListPastasDoczUrl(tenant,idProjeto),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPastasDoczQueryKey = (tenant: string,
    idProjeto: string,) => {
    return [
    `/v1/docz/${tenant}/projetos/${idProjeto}/pastas`
    ] as const;
    }


export const getListPastasDoczQueryOptions = <TData = Awaited<ReturnType<typeof listPastasDocz>>, TError = unknown>(tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPastasDoczQueryKey(tenant,idProjeto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPastasDocz>>> = ({ signal }) => listPastasDocz(tenant,idProjeto, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && idProjeto !== null && idProjeto !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPastasDoczQueryResult = NonNullable<Awaited<ReturnType<typeof listPastasDocz>>>
export type ListPastasDoczQueryError = unknown


export function useListPastasDocz<TData = Awaited<ReturnType<typeof listPastasDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPastasDocz>>,
          TError,
          Awaited<ReturnType<typeof listPastasDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPastasDocz<TData = Awaited<ReturnType<typeof listPastasDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPastasDocz>>,
          TError,
          Awaited<ReturnType<typeof listPastasDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPastasDocz<TData = Awaited<ReturnType<typeof listPastasDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista pastas do docz por projeto
 */

export function useListPastasDocz<TData = Awaited<ReturnType<typeof listPastasDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPastasDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPastasDoczQueryOptions(tenant,idProjeto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listMetadadosDoczResponse200 = {
  data: DoczMetadadoDto[]
  status: 200
}

export type listMetadadosDoczResponseSuccess = (listMetadadosDoczResponse200) & {
  headers: Headers;
};
;

export type listMetadadosDoczResponse = (listMetadadosDoczResponseSuccess)

export const getListMetadadosDoczUrl = (tenant: string,
    idProjeto: string,) => {




  return `/v1/docz/${tenant}/projetos/${idProjeto}/metadados`
}

/**
 * @summary Lista metadados do docz por projeto
 */
export const listMetadadosDocz = async (tenant: string,
    idProjeto: string, options?: RequestInit): Promise<listMetadadosDoczResponse> => {

  return customInstanceBpm<listMetadadosDoczResponse>(getListMetadadosDoczUrl(tenant,idProjeto),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetadadosDoczQueryKey = (tenant: string,
    idProjeto: string,) => {
    return [
    `/v1/docz/${tenant}/projetos/${idProjeto}/metadados`
    ] as const;
    }


export const getListMetadadosDoczQueryOptions = <TData = Awaited<ReturnType<typeof listMetadadosDocz>>, TError = unknown>(tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetadadosDoczQueryKey(tenant,idProjeto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetadadosDocz>>> = ({ signal }) => listMetadadosDocz(tenant,idProjeto, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && idProjeto !== null && idProjeto !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetadadosDoczQueryResult = NonNullable<Awaited<ReturnType<typeof listMetadadosDocz>>>
export type ListMetadadosDoczQueryError = unknown


export function useListMetadadosDocz<TData = Awaited<ReturnType<typeof listMetadadosDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetadadosDocz>>,
          TError,
          Awaited<ReturnType<typeof listMetadadosDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetadadosDocz<TData = Awaited<ReturnType<typeof listMetadadosDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetadadosDocz>>,
          TError,
          Awaited<ReturnType<typeof listMetadadosDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetadadosDocz<TData = Awaited<ReturnType<typeof listMetadadosDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista metadados do docz por projeto
 */

export function useListMetadadosDocz<TData = Awaited<ReturnType<typeof listMetadadosDocz>>, TError = unknown>(
 tenant: string,
    idProjeto: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetadadosDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetadadosDoczQueryOptions(tenant,idProjeto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listClienteDoczByTenantResponse200 = {
  data: DoczImportClienteDto[]
  status: 200
}

export type listClienteDoczByTenantResponseSuccess = (listClienteDoczByTenantResponse200) & {
  headers: Headers;
};
;

export type listClienteDoczByTenantResponse = (listClienteDoczByTenantResponseSuccess)

export const getListClienteDoczByTenantUrl = (tenant: string,) => {




  return `/v1/docz/${tenant}/clientes`
}

/**
 * @summary Lista o cliente do docz que está vinculado ao tenant principal
 */
export const listClienteDoczByTenant = async (tenant: string, options?: RequestInit): Promise<listClienteDoczByTenantResponse> => {

  return customInstanceBpm<listClienteDoczByTenantResponse>(getListClienteDoczByTenantUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClienteDoczByTenantQueryKey = (tenant: string,) => {
    return [
    `/v1/docz/${tenant}/clientes`
    ] as const;
    }


export const getListClienteDoczByTenantQueryOptions = <TData = Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClienteDoczByTenantQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClienteDoczByTenant>>> = ({ signal }) => listClienteDoczByTenant(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListClienteDoczByTenantQueryResult = NonNullable<Awaited<ReturnType<typeof listClienteDoczByTenant>>>
export type ListClienteDoczByTenantQueryError = unknown


export function useListClienteDoczByTenant<TData = Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClienteDoczByTenant>>,
          TError,
          Awaited<ReturnType<typeof listClienteDoczByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClienteDoczByTenant<TData = Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClienteDoczByTenant>>,
          TError,
          Awaited<ReturnType<typeof listClienteDoczByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClienteDoczByTenant<TData = Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o cliente do docz que está vinculado ao tenant principal
 */

export function useListClienteDoczByTenant<TData = Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDoczByTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClienteDoczByTenantQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDoczDocumentosResponse200 = {
  data: PageDoczDocumentoResumoSmartResponse
  status: 200
}

export type listDoczDocumentosResponseSuccess = (listDoczDocumentosResponse200) & {
  headers: Headers;
};
;

export type listDoczDocumentosResponse = (listDoczDocumentosResponseSuccess)

export const getListDoczDocumentosUrl = (params: ListDoczDocumentosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/docz/documentos?${stringifiedParams}` : `/v1/docz/documentos`
}

/**
 * @summary Lista as DCs do Docz
 */
export const listDoczDocumentos = async (params: ListDoczDocumentosParams, options?: RequestInit): Promise<listDoczDocumentosResponse> => {

  return customInstanceBpm<listDoczDocumentosResponse>(getListDoczDocumentosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDoczDocumentosQueryKey = (params?: ListDoczDocumentosParams,) => {
    return [
    `/v1/docz/documentos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDoczDocumentosQueryOptions = <TData = Awaited<ReturnType<typeof listDoczDocumentos>>, TError = unknown>(params: ListDoczDocumentosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoczDocumentosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoczDocumentos>>> = ({ signal }) => listDoczDocumentos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoczDocumentosQueryResult = NonNullable<Awaited<ReturnType<typeof listDoczDocumentos>>>
export type ListDoczDocumentosQueryError = unknown


export function useListDoczDocumentos<TData = Awaited<ReturnType<typeof listDoczDocumentos>>, TError = unknown>(
 params: ListDoczDocumentosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentos>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentos<TData = Awaited<ReturnType<typeof listDoczDocumentos>>, TError = unknown>(
 params: ListDoczDocumentosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentos>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentos<TData = Awaited<ReturnType<typeof listDoczDocumentos>>, TError = unknown>(
 params: ListDoczDocumentosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as DCs do Docz
 */

export function useListDoczDocumentos<TData = Awaited<ReturnType<typeof listDoczDocumentos>>, TError = unknown>(
 params: ListDoczDocumentosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoczDocumentosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDoczDocumentosPermitidosResponse200 = {
  data: PageDoczDocumentoResumoSmartResponse
  status: 200
}

export type listDoczDocumentosPermitidosResponseSuccess = (listDoczDocumentosPermitidosResponse200) & {
  headers: Headers;
};
;

export type listDoczDocumentosPermitidosResponse = (listDoczDocumentosPermitidosResponseSuccess)

export const getListDoczDocumentosPermitidosUrl = (params: ListDoczDocumentosPermitidosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/docz/documentos/permitidos?${stringifiedParams}` : `/v1/docz/documentos/permitidos`
}

/**
 * @summary Lista as DCs do Docz (Somente os documentos que o usuario tem permissão)
 */
export const listDoczDocumentosPermitidos = async (params: ListDoczDocumentosPermitidosParams, options?: RequestInit): Promise<listDoczDocumentosPermitidosResponse> => {

  return customInstanceBpm<listDoczDocumentosPermitidosResponse>(getListDoczDocumentosPermitidosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDoczDocumentosPermitidosQueryKey = (params?: ListDoczDocumentosPermitidosParams,) => {
    return [
    `/v1/docz/documentos/permitidos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDoczDocumentosPermitidosQueryOptions = <TData = Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError = unknown>(params: ListDoczDocumentosPermitidosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoczDocumentosPermitidosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>> = ({ signal }) => listDoczDocumentosPermitidos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoczDocumentosPermitidosQueryResult = NonNullable<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>>
export type ListDoczDocumentosPermitidosQueryError = unknown


export function useListDoczDocumentosPermitidos<TData = Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError = unknown>(
 params: ListDoczDocumentosPermitidosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentosPermitidos<TData = Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError = unknown>(
 params: ListDoczDocumentosPermitidosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentosPermitidos<TData = Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError = unknown>(
 params: ListDoczDocumentosPermitidosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as DCs do Docz (Somente os documentos que o usuario tem permissão)
 */

export function useListDoczDocumentosPermitidos<TData = Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError = unknown>(
 params: ListDoczDocumentosPermitidosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentosPermitidos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoczDocumentosPermitidosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getDoczDocumentoByEtiquetaResponse200 = {
  data: DoczDocumentoSmartResponse
  status: 200
}

export type getDoczDocumentoByEtiquetaResponseSuccess = (getDoczDocumentoByEtiquetaResponse200) & {
  headers: Headers;
};
;

export type getDoczDocumentoByEtiquetaResponse = (getDoczDocumentoByEtiquetaResponseSuccess)

export const getGetDoczDocumentoByEtiquetaUrl = (etiqueta: string,) => {




  return `/v1/docz/documentos/etiqueta/${etiqueta}`
}

/**
 * @summary Busca DC pela etiqueta
 */
export const getDoczDocumentoByEtiqueta = async (etiqueta: string, options?: RequestInit): Promise<getDoczDocumentoByEtiquetaResponse> => {

  return customInstanceBpm<getDoczDocumentoByEtiquetaResponse>(getGetDoczDocumentoByEtiquetaUrl(etiqueta),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDoczDocumentoByEtiquetaQueryKey = (etiqueta: string,) => {
    return [
    `/v1/docz/documentos/etiqueta/${etiqueta}`
    ] as const;
    }


export const getGetDoczDocumentoByEtiquetaQueryOptions = <TData = Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError = unknown>(etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDoczDocumentoByEtiquetaQueryKey(etiqueta);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>> = ({ signal }) => getDoczDocumentoByEtiqueta(etiqueta, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: etiqueta !== null && etiqueta !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDoczDocumentoByEtiquetaQueryResult = NonNullable<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>>
export type GetDoczDocumentoByEtiquetaQueryError = unknown


export function useGetDoczDocumentoByEtiqueta<TData = Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError = unknown>(
 etiqueta: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDoczDocumentoByEtiqueta<TData = Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDoczDocumentoByEtiqueta<TData = Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca DC pela etiqueta
 */

export function useGetDoczDocumentoByEtiqueta<TData = Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoczDocumentoByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDoczDocumentoByEtiquetaQueryOptions(etiqueta,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDoczDocumentoLogResponse200 = {
  data: DoczObjetoLogDto[]
  status: 200
}

export type listDoczDocumentoLogResponseSuccess = (listDoczDocumentoLogResponse200) & {
  headers: Headers;
};
;

export type listDoczDocumentoLogResponse = (listDoczDocumentoLogResponseSuccess)

export const getListDoczDocumentoLogUrl = (etiqueta: string,) => {




  return `/v1/docz/documentos/etiqueta/${etiqueta}/logs`
}

/**
 * @summary Lista log da etiqueta
 */
export const listDoczDocumentoLog = async (etiqueta: string, options?: RequestInit): Promise<listDoczDocumentoLogResponse> => {

  return customInstanceBpm<listDoczDocumentoLogResponse>(getListDoczDocumentoLogUrl(etiqueta),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDoczDocumentoLogQueryKey = (etiqueta: string,) => {
    return [
    `/v1/docz/documentos/etiqueta/${etiqueta}/logs`
    ] as const;
    }


export const getListDoczDocumentoLogQueryOptions = <TData = Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError = unknown>(etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoczDocumentoLogQueryKey(etiqueta);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoczDocumentoLog>>> = ({ signal }) => listDoczDocumentoLog(etiqueta, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: etiqueta !== null && etiqueta !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoczDocumentoLogQueryResult = NonNullable<Awaited<ReturnType<typeof listDoczDocumentoLog>>>
export type ListDoczDocumentoLogQueryError = unknown


export function useListDoczDocumentoLog<TData = Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError = unknown>(
 etiqueta: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentoLog>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentoLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentoLog<TData = Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczDocumentoLog>>,
          TError,
          Awaited<ReturnType<typeof listDoczDocumentoLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczDocumentoLog<TData = Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista log da etiqueta
 */

export function useListDoczDocumentoLog<TData = Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczDocumentoLog>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoczDocumentoLogQueryOptions(etiqueta,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDoczClientesProjetosResponse200 = {
  data: DoczClienteProjetos
  status: 200
}

export type listDoczClientesProjetosResponseSuccess = (listDoczClientesProjetosResponse200) & {
  headers: Headers;
};
;

export type listDoczClientesProjetosResponse = (listDoczClientesProjetosResponseSuccess)

export const getListDoczClientesProjetosUrl = (params: ListDoczClientesProjetosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/docz/documentos/cliente-projetos?${stringifiedParams}` : `/v1/docz/documentos/cliente-projetos`
}

/**
 * @summary Lista Cliente e Projetos do Docz
 */
export const listDoczClientesProjetos = async (params: ListDoczClientesProjetosParams, options?: RequestInit): Promise<listDoczClientesProjetosResponse> => {

  return customInstanceBpm<listDoczClientesProjetosResponse>(getListDoczClientesProjetosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDoczClientesProjetosQueryKey = (params?: ListDoczClientesProjetosParams,) => {
    return [
    `/v1/docz/documentos/cliente-projetos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDoczClientesProjetosQueryOptions = <TData = Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError = unknown>(params: ListDoczClientesProjetosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoczClientesProjetosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoczClientesProjetos>>> = ({ signal }) => listDoczClientesProjetos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoczClientesProjetosQueryResult = NonNullable<Awaited<ReturnType<typeof listDoczClientesProjetos>>>
export type ListDoczClientesProjetosQueryError = unknown


export function useListDoczClientesProjetos<TData = Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError = unknown>(
 params: ListDoczClientesProjetosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczClientesProjetos>>,
          TError,
          Awaited<ReturnType<typeof listDoczClientesProjetos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczClientesProjetos<TData = Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError = unknown>(
 params: ListDoczClientesProjetosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczClientesProjetos>>,
          TError,
          Awaited<ReturnType<typeof listDoczClientesProjetos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczClientesProjetos<TData = Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError = unknown>(
 params: ListDoczClientesProjetosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista Cliente e Projetos do Docz
 */

export function useListDoczClientesProjetos<TData = Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError = unknown>(
 params: ListDoczClientesProjetosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClientesProjetos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoczClientesProjetosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listDoczClassificacoesResponse200 = {
  data: DoczClassificacaoDto[]
  status: 200
}

export type listDoczClassificacoesResponseSuccess = (listDoczClassificacoesResponse200) & {
  headers: Headers;
};
;

export type listDoczClassificacoesResponse = (listDoczClassificacoesResponseSuccess)

export const getListDoczClassificacoesUrl = (params: ListDoczClassificacoesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/docz/documentos/classificacoes?${stringifiedParams}` : `/v1/docz/documentos/classificacoes`
}

/**
 * @summary Lista Cliente e Projetos do Docz
 */
export const listDoczClassificacoes = async (params: ListDoczClassificacoesParams, options?: RequestInit): Promise<listDoczClassificacoesResponse> => {

  return customInstanceBpm<listDoczClassificacoesResponse>(getListDoczClassificacoesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDoczClassificacoesQueryKey = (params?: ListDoczClassificacoesParams,) => {
    return [
    `/v1/docz/documentos/classificacoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDoczClassificacoesQueryOptions = <TData = Awaited<ReturnType<typeof listDoczClassificacoes>>, TError = unknown>(params: ListDoczClassificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoczClassificacoesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoczClassificacoes>>> = ({ signal }) => listDoczClassificacoes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoczClassificacoesQueryResult = NonNullable<Awaited<ReturnType<typeof listDoczClassificacoes>>>
export type ListDoczClassificacoesQueryError = unknown


export function useListDoczClassificacoes<TData = Awaited<ReturnType<typeof listDoczClassificacoes>>, TError = unknown>(
 params: ListDoczClassificacoesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczClassificacoes>>,
          TError,
          Awaited<ReturnType<typeof listDoczClassificacoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczClassificacoes<TData = Awaited<ReturnType<typeof listDoczClassificacoes>>, TError = unknown>(
 params: ListDoczClassificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoczClassificacoes>>,
          TError,
          Awaited<ReturnType<typeof listDoczClassificacoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoczClassificacoes<TData = Awaited<ReturnType<typeof listDoczClassificacoes>>, TError = unknown>(
 params: ListDoczClassificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista Cliente e Projetos do Docz
 */

export function useListDoczClassificacoes<TData = Awaited<ReturnType<typeof listDoczClassificacoes>>, TError = unknown>(
 params: ListDoczClassificacoesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoczClassificacoes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoczClassificacoesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadDoczArquivoByIdResponse200 = {
  data: DownloadDoczArquivoById200
  status: 200
}

export type downloadDoczArquivoByIdResponseSuccess = (downloadDoczArquivoByIdResponse200) & {
  headers: Headers;
};
;

export type downloadDoczArquivoByIdResponse = (downloadDoczArquivoByIdResponseSuccess)

export const getDownloadDoczArquivoByIdUrl = (arquivoId: string,) => {




  return `/v1/docz/documentos/arquivos/${arquivoId}/download`
}

/**
 * @summary Faz download do arquivo pelo ID
 */
export const downloadDoczArquivoById = async (arquivoId: string, options?: RequestInit): Promise<downloadDoczArquivoByIdResponse> => {

  return customInstanceBpm<downloadDoczArquivoByIdResponse>(getDownloadDoczArquivoByIdUrl(arquivoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadDoczArquivoByIdQueryKey = (arquivoId: string,) => {
    return [
    `/v1/docz/documentos/arquivos/${arquivoId}/download`
    ] as const;
    }


export const getDownloadDoczArquivoByIdQueryOptions = <TData = Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError = unknown>(arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDoczArquivoByIdQueryKey(arquivoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDoczArquivoById>>> = ({ signal }) => downloadDoczArquivoById(arquivoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: arquivoId !== null && arquivoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDoczArquivoByIdQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDoczArquivoById>>>
export type DownloadDoczArquivoByIdQueryError = unknown


export function useDownloadDoczArquivoById<TData = Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError = unknown>(
 arquivoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDoczArquivoById>>,
          TError,
          Awaited<ReturnType<typeof downloadDoczArquivoById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDoczArquivoById<TData = Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError = unknown>(
 arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDoczArquivoById>>,
          TError,
          Awaited<ReturnType<typeof downloadDoczArquivoById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDoczArquivoById<TData = Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError = unknown>(
 arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do arquivo pelo ID
 */

export function useDownloadDoczArquivoById<TData = Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError = unknown>(
 arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDoczArquivoById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDoczArquivoByIdQueryOptions(arquivoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listArquivosDoczByEtiquetaResponse200 = {
  data: DoczUploadSmartResponse[]
  status: 200
}

export type listArquivosDoczByEtiquetaResponseSuccess = (listArquivosDoczByEtiquetaResponse200) & {
  headers: Headers;
};
;

export type listArquivosDoczByEtiquetaResponse = (listArquivosDoczByEtiquetaResponseSuccess)

export const getListArquivosDoczByEtiquetaUrl = (etiqueta: string,) => {




  return `/v1/docz/documentos/arquivos/etiqueta/${etiqueta}`
}

/**
 * @summary Lista os arquivos da DC do Docz
 */
export const listArquivosDoczByEtiqueta = async (etiqueta: string, options?: RequestInit): Promise<listArquivosDoczByEtiquetaResponse> => {

  return customInstanceBpm<listArquivosDoczByEtiquetaResponse>(getListArquivosDoczByEtiquetaUrl(etiqueta),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListArquivosDoczByEtiquetaQueryKey = (etiqueta: string,) => {
    return [
    `/v1/docz/documentos/arquivos/etiqueta/${etiqueta}`
    ] as const;
    }


export const getListArquivosDoczByEtiquetaQueryOptions = <TData = Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError = unknown>(etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListArquivosDoczByEtiquetaQueryKey(etiqueta);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>> = ({ signal }) => listArquivosDoczByEtiqueta(etiqueta, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: etiqueta !== null && etiqueta !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListArquivosDoczByEtiquetaQueryResult = NonNullable<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>>
export type ListArquivosDoczByEtiquetaQueryError = unknown


export function useListArquivosDoczByEtiqueta<TData = Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError = unknown>(
 etiqueta: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArquivosDoczByEtiqueta<TData = Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>,
          TError,
          Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListArquivosDoczByEtiqueta<TData = Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os arquivos da DC do Docz
 */

export function useListArquivosDoczByEtiqueta<TData = Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError = unknown>(
 etiqueta: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listArquivosDoczByEtiqueta>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListArquivosDoczByEtiquetaQueryOptions(etiqueta,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listClienteDoczResponse200 = {
  data: DoczImportClienteDto[]
  status: 200
}

export type listClienteDoczResponseSuccess = (listClienteDoczResponse200) & {
  headers: Headers;
};
;

export type listClienteDoczResponse = (listClienteDoczResponseSuccess)

export const getListClienteDoczUrl = () => {




  return `/v1/docz/clientes`
}

/**
 * @summary Lista clientes do docz que foram importados
 */
export const listClienteDocz = async ( options?: RequestInit): Promise<listClienteDoczResponse> => {

  return customInstanceBpm<listClienteDoczResponse>(getListClienteDoczUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClienteDoczQueryKey = () => {
    return [
    `/v1/docz/clientes`
    ] as const;
    }


export const getListClienteDoczQueryOptions = <TData = Awaited<ReturnType<typeof listClienteDocz>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClienteDoczQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClienteDocz>>> = ({ signal }) => listClienteDocz({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListClienteDoczQueryResult = NonNullable<Awaited<ReturnType<typeof listClienteDocz>>>
export type ListClienteDoczQueryError = unknown


export function useListClienteDocz<TData = Awaited<ReturnType<typeof listClienteDocz>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClienteDocz>>,
          TError,
          Awaited<ReturnType<typeof listClienteDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClienteDocz<TData = Awaited<ReturnType<typeof listClienteDocz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClienteDocz>>,
          TError,
          Awaited<ReturnType<typeof listClienteDocz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClienteDocz<TData = Awaited<ReturnType<typeof listClienteDocz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista clientes do docz que foram importados
 */

export function useListClienteDocz<TData = Awaited<ReturnType<typeof listClienteDocz>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClienteDocz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClienteDoczQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listCachesResponse200 = {
  data: string[]
  status: 200
}

export type listCachesResponseSuccess = (listCachesResponse200) & {
  headers: Headers;
};
;

export type listCachesResponse = (listCachesResponseSuccess)

export const getListCachesUrl = () => {




  return `/v1/cache`
}

/**
 * @summary Lista as chaves do cache
 */
export const listCaches = async ( options?: RequestInit): Promise<listCachesResponse> => {

  return customInstanceBpm<listCachesResponse>(getListCachesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCachesQueryKey = () => {
    return [
    `/v1/cache`
    ] as const;
    }


export const getListCachesQueryOptions = <TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCachesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCaches>>> = ({ signal }) => listCaches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCachesQueryResult = NonNullable<Awaited<ReturnType<typeof listCaches>>>
export type ListCachesQueryError = unknown


export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaches>>,
          TError,
          Awaited<ReturnType<typeof listCaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaches>>,
          TError,
          Awaited<ReturnType<typeof listCaches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as chaves do cache
 */

export function useListCaches<TData = Awaited<ReturnType<typeof listCaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaches>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCachesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUserBatchResultsResponse200 = {
  data: BatchResultDto[]
  status: 200
}

export type listUserBatchResultsResponseSuccess = (listUserBatchResultsResponse200) & {
  headers: Headers;
};
;

export type listUserBatchResultsResponse = (listUserBatchResultsResponseSuccess)

export const getListUserBatchResultsUrl = (tenant: string,
    batchCode: string,) => {




  return `/v1/batch/${tenant}/results/${batchCode}`
}

/**
 * @summary Lista resultado da importação em lote pelo codigo
 */
export const listUserBatchResults = async (tenant: string,
    batchCode: string, options?: RequestInit): Promise<listUserBatchResultsResponse> => {

  return customInstanceBpm<listUserBatchResultsResponse>(getListUserBatchResultsUrl(tenant,batchCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserBatchResultsQueryKey = (tenant: string,
    batchCode: string,) => {
    return [
    `/v1/batch/${tenant}/results/${batchCode}`
    ] as const;
    }


export const getListUserBatchResultsQueryOptions = <TData = Awaited<ReturnType<typeof listUserBatchResults>>, TError = unknown>(tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserBatchResultsQueryKey(tenant,batchCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserBatchResults>>> = ({ signal }) => listUserBatchResults(tenant,batchCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && batchCode !== null && batchCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserBatchResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserBatchResults>>>
export type ListUserBatchResultsQueryError = unknown


export function useListUserBatchResults<TData = Awaited<ReturnType<typeof listUserBatchResults>>, TError = unknown>(
 tenant: string,
    batchCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserBatchResults>>,
          TError,
          Awaited<ReturnType<typeof listUserBatchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserBatchResults<TData = Awaited<ReturnType<typeof listUserBatchResults>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserBatchResults>>,
          TError,
          Awaited<ReturnType<typeof listUserBatchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserBatchResults<TData = Awaited<ReturnType<typeof listUserBatchResults>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista resultado da importação em lote pelo codigo
 */

export function useListUserBatchResults<TData = Awaited<ReturnType<typeof listUserBatchResults>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserBatchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserBatchResultsQueryOptions(tenant,batchCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listBatchResultsStringResponse200 = {
  data: string[]
  status: 200
}

export type listBatchResultsStringResponseSuccess = (listBatchResultsStringResponse200) & {
  headers: Headers;
};
;

export type listBatchResultsStringResponse = (listBatchResultsStringResponseSuccess)

export const getListBatchResultsStringUrl = (tenant: string,
    batchCode: string,) => {




  return `/v1/batch/${tenant}/results/${batchCode}/string`
}

/**
 * @summary Lista resultado da importação em lote pelo codigo
 */
export const listBatchResultsString = async (tenant: string,
    batchCode: string, options?: RequestInit): Promise<listBatchResultsStringResponse> => {

  return customInstanceBpm<listBatchResultsStringResponse>(getListBatchResultsStringUrl(tenant,batchCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBatchResultsStringQueryKey = (tenant: string,
    batchCode: string,) => {
    return [
    `/v1/batch/${tenant}/results/${batchCode}/string`
    ] as const;
    }


export const getListBatchResultsStringQueryOptions = <TData = Awaited<ReturnType<typeof listBatchResultsString>>, TError = unknown>(tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBatchResultsStringQueryKey(tenant,batchCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBatchResultsString>>> = ({ signal }) => listBatchResultsString(tenant,batchCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && batchCode !== null && batchCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBatchResultsStringQueryResult = NonNullable<Awaited<ReturnType<typeof listBatchResultsString>>>
export type ListBatchResultsStringQueryError = unknown


export function useListBatchResultsString<TData = Awaited<ReturnType<typeof listBatchResultsString>>, TError = unknown>(
 tenant: string,
    batchCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchResultsString>>,
          TError,
          Awaited<ReturnType<typeof listBatchResultsString>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBatchResultsString<TData = Awaited<ReturnType<typeof listBatchResultsString>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchResultsString>>,
          TError,
          Awaited<ReturnType<typeof listBatchResultsString>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBatchResultsString<TData = Awaited<ReturnType<typeof listBatchResultsString>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista resultado da importação em lote pelo codigo
 */

export function useListBatchResultsString<TData = Awaited<ReturnType<typeof listBatchResultsString>>, TError = unknown>(
 tenant: string,
    batchCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultsString>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBatchResultsStringQueryOptions(tenant,batchCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listBatchResultCodesResponse200 = {
  data: string[]
  status: 200
}

export type listBatchResultCodesResponseSuccess = (listBatchResultCodesResponse200) & {
  headers: Headers;
};
;

export type listBatchResultCodesResponse = (listBatchResultCodesResponseSuccess)

export const getListBatchResultCodesUrl = (tenant: string,) => {




  return `/v1/batch/${tenant}/results/list-codes`
}

/**
 * @summary Lista os códigos da importação em lote
 */
export const listBatchResultCodes = async (tenant: string, options?: RequestInit): Promise<listBatchResultCodesResponse> => {

  return customInstanceBpm<listBatchResultCodesResponse>(getListBatchResultCodesUrl(tenant),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBatchResultCodesQueryKey = (tenant: string,) => {
    return [
    `/v1/batch/${tenant}/results/list-codes`
    ] as const;
    }


export const getListBatchResultCodesQueryOptions = <TData = Awaited<ReturnType<typeof listBatchResultCodes>>, TError = unknown>(tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBatchResultCodesQueryKey(tenant);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBatchResultCodes>>> = ({ signal }) => listBatchResultCodes(tenant, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBatchResultCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listBatchResultCodes>>>
export type ListBatchResultCodesQueryError = unknown


export function useListBatchResultCodes<TData = Awaited<ReturnType<typeof listBatchResultCodes>>, TError = unknown>(
 tenant: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchResultCodes>>,
          TError,
          Awaited<ReturnType<typeof listBatchResultCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBatchResultCodes<TData = Awaited<ReturnType<typeof listBatchResultCodes>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchResultCodes>>,
          TError,
          Awaited<ReturnType<typeof listBatchResultCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBatchResultCodes<TData = Awaited<ReturnType<typeof listBatchResultCodes>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os códigos da importação em lote
 */

export function useListBatchResultCodes<TData = Awaited<ReturnType<typeof listBatchResultCodes>>, TError = unknown>(
 tenant: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBatchResultCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBatchResultCodesQueryOptions(tenant,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadPublicUserProfilePhotoResponse200 = {
  data: Blob
  status: 200
}

export type downloadPublicUserProfilePhotoResponseSuccess = (downloadPublicUserProfilePhotoResponse200) & {
  headers: Headers;
};
;

export type downloadPublicUserProfilePhotoResponse = (downloadPublicUserProfilePhotoResponseSuccess)

export const getDownloadPublicUserProfilePhotoUrl = (tenant: string,
    photoId: number,) => {




  return `/smart-bpm/${tenant}/avatar/photo/${photoId}`
}

/**
 * @summary Faz download da foto do perfil do usuário pelo id da foto
 */
export const downloadPublicUserProfilePhoto = async (tenant: string,
    photoId: number, options?: RequestInit): Promise<downloadPublicUserProfilePhotoResponse> => {

  return customInstanceBpm<downloadPublicUserProfilePhotoResponse>(getDownloadPublicUserProfilePhotoUrl(tenant,photoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPublicUserProfilePhotoQueryKey = (tenant: string,
    photoId: number,) => {
    return [
    `/smart-bpm/${tenant}/avatar/photo/${photoId}`
    ] as const;
    }


export const getDownloadPublicUserProfilePhotoQueryOptions = <TData = Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError = unknown>(tenant: string,
    photoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPublicUserProfilePhotoQueryKey(tenant,photoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>> = ({ signal }) => downloadPublicUserProfilePhoto(tenant,photoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && photoId !== null && photoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadPublicUserProfilePhotoQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>>
export type DownloadPublicUserProfilePhotoQueryError = unknown


export function useDownloadPublicUserProfilePhoto<TData = Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError = unknown>(
 tenant: string,
    photoId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>,
          TError,
          Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPublicUserProfilePhoto<TData = Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError = unknown>(
 tenant: string,
    photoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>,
          TError,
          Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPublicUserProfilePhoto<TData = Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError = unknown>(
 tenant: string,
    photoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download da foto do perfil do usuário pelo id da foto
 */

export function useDownloadPublicUserProfilePhoto<TData = Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError = unknown>(
 tenant: string,
    photoId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicUserProfilePhoto>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadPublicUserProfilePhotoQueryOptions(tenant,photoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadPublicThemeResponse200 = {
  data: ThemeConfigurationDownloadDto
  status: 200
}

export type downloadPublicThemeResponseSuccess = (downloadPublicThemeResponse200) & {
  headers: Headers;
};
;

export type downloadPublicThemeResponse = (downloadPublicThemeResponseSuccess)

export const getDownloadPublicThemeUrl = (params: DownloadPublicThemeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/theme/download?${stringifiedParams}` : `/smart-bpm/theme/download`
}

/**
 * @summary Faz download do tema pelo tenant
 */
export const downloadPublicTheme = async (params: DownloadPublicThemeParams, options?: RequestInit): Promise<downloadPublicThemeResponse> => {

  return customInstanceBpm<downloadPublicThemeResponse>(getDownloadPublicThemeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPublicThemeQueryKey = (params?: DownloadPublicThemeParams,) => {
    return [
    `/smart-bpm/theme/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadPublicThemeQueryOptions = <TData = Awaited<ReturnType<typeof downloadPublicTheme>>, TError = unknown>(params: DownloadPublicThemeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPublicThemeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPublicTheme>>> = ({ signal }) => downloadPublicTheme(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadPublicThemeQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPublicTheme>>>
export type DownloadPublicThemeQueryError = unknown


export function useDownloadPublicTheme<TData = Awaited<ReturnType<typeof downloadPublicTheme>>, TError = unknown>(
 params: DownloadPublicThemeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPublicTheme>>,
          TError,
          Awaited<ReturnType<typeof downloadPublicTheme>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPublicTheme<TData = Awaited<ReturnType<typeof downloadPublicTheme>>, TError = unknown>(
 params: DownloadPublicThemeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadPublicTheme>>,
          TError,
          Awaited<ReturnType<typeof downloadPublicTheme>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadPublicTheme<TData = Awaited<ReturnType<typeof downloadPublicTheme>>, TError = unknown>(
 params: DownloadPublicThemeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do tema pelo tenant
 */

export function useDownloadPublicTheme<TData = Awaited<ReturnType<typeof downloadPublicTheme>>, TError = unknown>(
 params: DownloadPublicThemeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadPublicTheme>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadPublicThemeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getThemeConfigurationResponse200 = {
  data: ThemeConfigurationDto
  status: 200
}

export type getThemeConfigurationResponseSuccess = (getThemeConfigurationResponse200) & {
  headers: Headers;
};
;

export type getThemeConfigurationResponse = (getThemeConfigurationResponseSuccess)

export const getGetThemeConfigurationUrl = (params: GetThemeConfigurationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/theme?${stringifiedParams}` : `/smart-bpm/rest/theme`
}

/**
 * @summary Busca informações do tema pelo tenant
 */
export const getThemeConfiguration = async (params: GetThemeConfigurationParams, options?: RequestInit): Promise<getThemeConfigurationResponse> => {

  return customInstanceBpm<getThemeConfigurationResponse>(getGetThemeConfigurationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetThemeConfigurationQueryKey = (params?: GetThemeConfigurationParams,) => {
    return [
    `/smart-bpm/rest/theme`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetThemeConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getThemeConfiguration>>, TError = unknown>(params: GetThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetThemeConfigurationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getThemeConfiguration>>> = ({ signal }) => getThemeConfiguration(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetThemeConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getThemeConfiguration>>>
export type GetThemeConfigurationQueryError = unknown


export function useGetThemeConfiguration<TData = Awaited<ReturnType<typeof getThemeConfiguration>>, TError = unknown>(
 params: GetThemeConfigurationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThemeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getThemeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThemeConfiguration<TData = Awaited<ReturnType<typeof getThemeConfiguration>>, TError = unknown>(
 params: GetThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThemeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getThemeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThemeConfiguration<TData = Awaited<ReturnType<typeof getThemeConfiguration>>, TError = unknown>(
 params: GetThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca informações do tema pelo tenant
 */

export function useGetThemeConfiguration<TData = Awaited<ReturnType<typeof getThemeConfiguration>>, TError = unknown>(
 params: GetThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetThemeConfigurationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadThemeConfigurationResponse200 = {
  data: ThemeConfigurationDownloadDto
  status: 200
}

export type downloadThemeConfigurationResponseSuccess = (downloadThemeConfigurationResponse200) & {
  headers: Headers;
};
;

export type downloadThemeConfigurationResponse = (downloadThemeConfigurationResponseSuccess)

export const getDownloadThemeConfigurationUrl = (params: DownloadThemeConfigurationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/theme/download?${stringifiedParams}` : `/smart-bpm/rest/theme/download`
}

/**
 * @summary Faz download do tema pelo tenant
 */
export const downloadThemeConfiguration = async (params: DownloadThemeConfigurationParams, options?: RequestInit): Promise<downloadThemeConfigurationResponse> => {

  return customInstanceBpm<downloadThemeConfigurationResponse>(getDownloadThemeConfigurationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadThemeConfigurationQueryKey = (params?: DownloadThemeConfigurationParams,) => {
    return [
    `/smart-bpm/rest/theme/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadThemeConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError = unknown>(params: DownloadThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadThemeConfigurationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadThemeConfiguration>>> = ({ signal }) => downloadThemeConfiguration(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadThemeConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof downloadThemeConfiguration>>>
export type DownloadThemeConfigurationQueryError = unknown


export function useDownloadThemeConfiguration<TData = Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError = unknown>(
 params: DownloadThemeConfigurationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadThemeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof downloadThemeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadThemeConfiguration<TData = Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError = unknown>(
 params: DownloadThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadThemeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof downloadThemeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadThemeConfiguration<TData = Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError = unknown>(
 params: DownloadThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do tema pelo tenant
 */

export function useDownloadThemeConfiguration<TData = Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError = unknown>(
 params: DownloadThemeConfigurationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadThemeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadThemeConfigurationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTaskFormVariablesResponse200 = {
  data: GetTaskFormVariables200
  status: 200
}

export type getTaskFormVariablesResponseSuccess = (getTaskFormVariablesResponse200) & {
  headers: Headers;
};
;

export type getTaskFormVariablesResponse = (getTaskFormVariablesResponseSuccess)

export const getGetTaskFormVariablesUrl = (id: string,
    params?: GetTaskFormVariablesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/task/${id}/form-variables?${stringifiedParams}` : `/smart-bpm/rest/task/${id}/form-variables`
}

/**
 * @summary Retorna variavies do formulário da tarefa
 */
export const getTaskFormVariables = async (id: string,
    params?: GetTaskFormVariablesParams, options?: RequestInit): Promise<getTaskFormVariablesResponse> => {

  return customInstanceBpm<getTaskFormVariablesResponse>(getGetTaskFormVariablesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskFormVariablesQueryKey = (id: string,
    params?: GetTaskFormVariablesParams,) => {
    return [
    `/smart-bpm/rest/task/${id}/form-variables`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskFormVariablesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskFormVariables>>, TError = unknown>(id: string,
    params?: GetTaskFormVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskFormVariablesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskFormVariables>>> = ({ signal }) => getTaskFormVariables(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskFormVariablesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskFormVariables>>>
export type GetTaskFormVariablesQueryError = unknown


export function useGetTaskFormVariables<TData = Awaited<ReturnType<typeof getTaskFormVariables>>, TError = unknown>(
 id: string,
    params: undefined |  GetTaskFormVariablesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFormVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskFormVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFormVariables<TData = Awaited<ReturnType<typeof getTaskFormVariables>>, TError = unknown>(
 id: string,
    params?: GetTaskFormVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFormVariables>>,
          TError,
          Awaited<ReturnType<typeof getTaskFormVariables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFormVariables<TData = Awaited<ReturnType<typeof getTaskFormVariables>>, TError = unknown>(
 id: string,
    params?: GetTaskFormVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna variavies do formulário da tarefa
 */

export function useGetTaskFormVariables<TData = Awaited<ReturnType<typeof getTaskFormVariables>>, TError = unknown>(
 id: string,
    params?: GetTaskFormVariablesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormVariables>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskFormVariablesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listTasksResponse200 = {
  data: PageCustomTaskBpmDto
  status: 200
}

export type listTasksResponseSuccess = (listTasksResponse200) & {
  headers: Headers;
};
;

export type listTasksResponse = (listTasksResponseSuccess)

export const getListTasksUrl = (params?: ListTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/task/list?${stringifiedParams}` : `/smart-bpm/rest/task/list`
}

/**
 * @summary Lista as tarefas
 */
export const listTasks = async (params?: ListTasksParams, options?: RequestInit): Promise<listTasksResponse> => {

  return customInstanceBpm<listTasksResponse>(getListTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    `/smart-bpm/rest/task/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = unknown>(params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = unknown


export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = unknown>(
 params: undefined |  ListTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = unknown>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = unknown>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as tarefas
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = unknown>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTaskDashboardResponse200 = {
  data: TaskDashboradDto
  status: 200
}

export type getTaskDashboardResponseSuccess = (getTaskDashboardResponse200) & {
  headers: Headers;
};
;

export type getTaskDashboardResponse = (getTaskDashboardResponseSuccess)

export const getGetTaskDashboardUrl = (params: GetTaskDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/task/dashboard?${stringifiedParams}` : `/smart-bpm/rest/task/dashboard`
}

/**
 * @summary Retorna estatísticas sobre as tarefas
 */
export const getTaskDashboard = async (params: GetTaskDashboardParams, options?: RequestInit): Promise<getTaskDashboardResponse> => {

  return customInstanceBpm<getTaskDashboardResponse>(getGetTaskDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskDashboardQueryKey = (params?: GetTaskDashboardParams,) => {
    return [
    `/smart-bpm/rest/task/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getTaskDashboard>>, TError = unknown>(params: GetTaskDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskDashboard>>> = ({ signal }) => getTaskDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskDashboard>>>
export type GetTaskDashboardQueryError = unknown


export function useGetTaskDashboard<TData = Awaited<ReturnType<typeof getTaskDashboard>>, TError = unknown>(
 params: GetTaskDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskDashboard>>,
          TError,
          Awaited<ReturnType<typeof getTaskDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskDashboard<TData = Awaited<ReturnType<typeof getTaskDashboard>>, TError = unknown>(
 params: GetTaskDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskDashboard>>,
          TError,
          Awaited<ReturnType<typeof getTaskDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskDashboard<TData = Awaited<ReturnType<typeof getTaskDashboard>>, TError = unknown>(
 params: GetTaskDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna estatísticas sobre as tarefas
 */

export function useGetTaskDashboard<TData = Awaited<ReturnType<typeof getTaskDashboard>>, TError = unknown>(
 params: GetTaskDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessInstanceStatisticResponse200 = {
  data: ProcessInstanceStatisticDto
  status: 200
}

export type getProcessInstanceStatisticResponseSuccess = (getProcessInstanceStatisticResponse200) & {
  headers: Headers;
};
;

export type getProcessInstanceStatisticResponse = (getProcessInstanceStatisticResponseSuccess)

export const getGetProcessInstanceStatisticUrl = (params: GetProcessInstanceStatisticParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/process-definition/statistic?${stringifiedParams}` : `/smart-bpm/rest/process-definition/statistic`
}

/**
 * @summary Retorna estatísticas sobre os processos e tarefas da plataforma
 */
export const getProcessInstanceStatistic = async (params: GetProcessInstanceStatisticParams, options?: RequestInit): Promise<getProcessInstanceStatisticResponse> => {

  return customInstanceBpm<getProcessInstanceStatisticResponse>(getGetProcessInstanceStatisticUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessInstanceStatisticQueryKey = (params?: GetProcessInstanceStatisticParams,) => {
    return [
    `/smart-bpm/rest/process-definition/statistic`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProcessInstanceStatisticQueryOptions = <TData = Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError = unknown>(params: GetProcessInstanceStatisticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInstanceStatisticQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessInstanceStatistic>>> = ({ signal }) => getProcessInstanceStatistic(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessInstanceStatisticQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessInstanceStatistic>>>
export type GetProcessInstanceStatisticQueryError = unknown


export function useGetProcessInstanceStatistic<TData = Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError = unknown>(
 params: GetProcessInstanceStatisticParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceStatistic>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceStatistic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceStatistic<TData = Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError = unknown>(
 params: GetProcessInstanceStatisticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessInstanceStatistic>>,
          TError,
          Awaited<ReturnType<typeof getProcessInstanceStatistic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessInstanceStatistic<TData = Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError = unknown>(
 params: GetProcessInstanceStatisticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna estatísticas sobre os processos e tarefas da plataforma
 */

export function useGetProcessInstanceStatistic<TData = Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError = unknown>(
 params: GetProcessInstanceStatisticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessInstanceStatistic>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessInstanceStatisticQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessDashboardResponse200 = {
  data: ProcessDashboardDto
  status: 200
}

export type getProcessDashboardResponseSuccess = (getProcessDashboardResponse200) & {
  headers: Headers;
};
;

export type getProcessDashboardResponse = (getProcessDashboardResponseSuccess)

export const getGetProcessDashboardUrl = (params?: GetProcessDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/process-definition/dashboard?${stringifiedParams}` : `/smart-bpm/rest/process-definition/dashboard`
}

/**
 * @summary Retorna indicadores consolidados dos processos do usuario
 */
export const getProcessDashboard = async (params?: GetProcessDashboardParams, options?: RequestInit): Promise<getProcessDashboardResponse> => {

  return customInstanceBpm<getProcessDashboardResponse>(getGetProcessDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessDashboardQueryKey = (params?: GetProcessDashboardParams,) => {
    return [
    `/smart-bpm/rest/process-definition/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProcessDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getProcessDashboard>>, TError = unknown>(params?: GetProcessDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessDashboard>>> = ({ signal }) => getProcessDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessDashboard>>>
export type GetProcessDashboardQueryError = unknown


export function useGetProcessDashboard<TData = Awaited<ReturnType<typeof getProcessDashboard>>, TError = unknown>(
 params: undefined |  GetProcessDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessDashboard>>,
          TError,
          Awaited<ReturnType<typeof getProcessDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessDashboard<TData = Awaited<ReturnType<typeof getProcessDashboard>>, TError = unknown>(
 params?: GetProcessDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessDashboard>>,
          TError,
          Awaited<ReturnType<typeof getProcessDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessDashboard<TData = Awaited<ReturnType<typeof getProcessDashboard>>, TError = unknown>(
 params?: GetProcessDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna indicadores consolidados dos processos do usuario
 */

export function useGetProcessDashboard<TData = Awaited<ReturnType<typeof getProcessDashboard>>, TError = unknown>(
 params?: GetProcessDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listUserNotificationsResponse200 = {
  data: PageNotificationDto
  status: 200
}

export type listUserNotificationsResponseSuccess = (listUserNotificationsResponse200) & {
  headers: Headers;
};
;

export type listUserNotificationsResponse = (listUserNotificationsResponseSuccess)

export const getListUserNotificationsUrl = (params: ListUserNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/notification/list?${stringifiedParams}` : `/smart-bpm/rest/notification/list`
}

/**
 * @summary Lista as notificações do usuário
 */
export const listUserNotifications = async (params: ListUserNotificationsParams, options?: RequestInit): Promise<listUserNotificationsResponse> => {

  return customInstanceBpm<listUserNotificationsResponse>(getListUserNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserNotificationsQueryKey = (params?: ListUserNotificationsParams,) => {
    return [
    `/smart-bpm/rest/notification/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUserNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listUserNotifications>>, TError = unknown>(params: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserNotifications>>> = ({ signal }) => listUserNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserNotifications>>>
export type ListUserNotificationsQueryError = unknown


export function useListUserNotifications<TData = Awaited<ReturnType<typeof listUserNotifications>>, TError = unknown>(
 params: ListUserNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotifications<TData = Awaited<ReturnType<typeof listUserNotifications>>, TError = unknown>(
 params: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserNotifications>>,
          TError,
          Awaited<ReturnType<typeof listUserNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotifications<TData = Awaited<ReturnType<typeof listUserNotifications>>, TError = unknown>(
 params: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as notificações do usuário
 */

export function useListUserNotifications<TData = Awaited<ReturnType<typeof listUserNotifications>>, TError = unknown>(
 params: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findNotificationByIdResponse200 = {
  data: NotificationDto
  status: 200
}

export type findNotificationByIdResponseSuccess = (findNotificationByIdResponse200) & {
  headers: Headers;
};
;

export type findNotificationByIdResponse = (findNotificationByIdResponseSuccess)

export const getFindNotificationByIdUrl = (id: number,) => {




  return `/smart-bpm/rest/notification/id/${id}`
}

/**
 * @summary Busca uma notificação por ID
 */
export const findNotificationById = async (id: number, options?: RequestInit): Promise<findNotificationByIdResponse> => {

  return customInstanceBpm<findNotificationByIdResponse>(getFindNotificationByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindNotificationByIdQueryKey = (id: number,) => {
    return [
    `/smart-bpm/rest/notification/id/${id}`
    ] as const;
    }


export const getFindNotificationByIdQueryOptions = <TData = Awaited<ReturnType<typeof findNotificationById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindNotificationByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findNotificationById>>> = ({ signal }) => findNotificationById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindNotificationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findNotificationById>>>
export type FindNotificationByIdQueryError = unknown


export function useFindNotificationById<TData = Awaited<ReturnType<typeof findNotificationById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotificationById>>,
          TError,
          Awaited<ReturnType<typeof findNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindNotificationById<TData = Awaited<ReturnType<typeof findNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotificationById>>,
          TError,
          Awaited<ReturnType<typeof findNotificationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindNotificationById<TData = Awaited<ReturnType<typeof findNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca uma notificação por ID
 */

export function useFindNotificationById<TData = Awaited<ReturnType<typeof findNotificationById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findNotificationById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindNotificationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type countUnreadedNotificationResponse200 = {
  data: number
  status: 200
}

export type countUnreadedNotificationResponseSuccess = (countUnreadedNotificationResponse200) & {
  headers: Headers;
};
;

export type countUnreadedNotificationResponse = (countUnreadedNotificationResponseSuccess)

export const getCountUnreadedNotificationUrl = () => {




  return `/smart-bpm/rest/notification/count-unreaded`
}

/**
 * @summary Conta as notificações não lidas do usuário
 */
export const countUnreadedNotification = async ( options?: RequestInit): Promise<countUnreadedNotificationResponse> => {

  return customInstanceBpm<countUnreadedNotificationResponse>(getCountUnreadedNotificationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountUnreadedNotificationQueryKey = () => {
    return [
    `/smart-bpm/rest/notification/count-unreaded`
    ] as const;
    }


export const getCountUnreadedNotificationQueryOptions = <TData = Awaited<ReturnType<typeof countUnreadedNotification>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountUnreadedNotificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countUnreadedNotification>>> = ({ signal }) => countUnreadedNotification({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountUnreadedNotificationQueryResult = NonNullable<Awaited<ReturnType<typeof countUnreadedNotification>>>
export type CountUnreadedNotificationQueryError = unknown


export function useCountUnreadedNotification<TData = Awaited<ReturnType<typeof countUnreadedNotification>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUnreadedNotification>>,
          TError,
          Awaited<ReturnType<typeof countUnreadedNotification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUnreadedNotification<TData = Awaited<ReturnType<typeof countUnreadedNotification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUnreadedNotification>>,
          TError,
          Awaited<ReturnType<typeof countUnreadedNotification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUnreadedNotification<TData = Awaited<ReturnType<typeof countUnreadedNotification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Conta as notificações não lidas do usuário
 */

export function useCountUnreadedNotification<TData = Awaited<ReturnType<typeof countUnreadedNotification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUnreadedNotification>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountUnreadedNotificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getSystemLogByIdResponse200 = {
  data: SmartLogDto
  status: 200
}

export type getSystemLogByIdResponseSuccess = (getSystemLogByIdResponse200) & {
  headers: Headers;
};
;

export type getSystemLogByIdResponse = (getSystemLogByIdResponseSuccess)

export const getGetSystemLogByIdUrl = (id: number,) => {




  return `/smart-bpm/rest/log/${id}`
}

/**
 * @summary Busca log por ID
 */
export const getSystemLogById = async (id: number, options?: RequestInit): Promise<getSystemLogByIdResponse> => {

  return customInstanceBpm<getSystemLogByIdResponse>(getGetSystemLogByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSystemLogByIdQueryKey = (id: number,) => {
    return [
    `/smart-bpm/rest/log/${id}`
    ] as const;
    }


export const getGetSystemLogByIdQueryOptions = <TData = Awaited<ReturnType<typeof getSystemLogById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSystemLogByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemLogById>>> = ({ signal }) => getSystemLogById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSystemLogByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemLogById>>>
export type GetSystemLogByIdQueryError = unknown


export function useGetSystemLogById<TData = Awaited<ReturnType<typeof getSystemLogById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemLogById>>,
          TError,
          Awaited<ReturnType<typeof getSystemLogById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemLogById<TData = Awaited<ReturnType<typeof getSystemLogById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemLogById>>,
          TError,
          Awaited<ReturnType<typeof getSystemLogById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemLogById<TData = Awaited<ReturnType<typeof getSystemLogById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca log por ID
 */

export function useGetSystemLogById<TData = Awaited<ReturnType<typeof getSystemLogById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSystemLogByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSystemLogsResponse200 = {
  data: PageSmartLogDto
  status: 200
}

export type listSystemLogsResponseSuccess = (listSystemLogsResponse200) & {
  headers: Headers;
};
;

export type listSystemLogsResponse = (listSystemLogsResponseSuccess)

export const getListSystemLogsUrl = (params: ListSystemLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/log/list?${stringifiedParams}` : `/smart-bpm/rest/log/list`
}

/**
 * @summary Lista os logs
 */
export const listSystemLogs = async (params: ListSystemLogsParams, options?: RequestInit): Promise<listSystemLogsResponse> => {

  return customInstanceBpm<listSystemLogsResponse>(getListSystemLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSystemLogsQueryKey = (params?: ListSystemLogsParams,) => {
    return [
    `/smart-bpm/rest/log/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSystemLogsQueryOptions = <TData = Awaited<ReturnType<typeof listSystemLogs>>, TError = unknown>(params: ListSystemLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSystemLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSystemLogs>>> = ({ signal }) => listSystemLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSystemLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listSystemLogs>>>
export type ListSystemLogsQueryError = unknown


export function useListSystemLogs<TData = Awaited<ReturnType<typeof listSystemLogs>>, TError = unknown>(
 params: ListSystemLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSystemLogs>>,
          TError,
          Awaited<ReturnType<typeof listSystemLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSystemLogs<TData = Awaited<ReturnType<typeof listSystemLogs>>, TError = unknown>(
 params: ListSystemLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSystemLogs>>,
          TError,
          Awaited<ReturnType<typeof listSystemLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSystemLogs<TData = Awaited<ReturnType<typeof listSystemLogs>>, TError = unknown>(
 params: ListSystemLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os logs
 */

export function useListSystemLogs<TData = Awaited<ReturnType<typeof listSystemLogs>>, TError = unknown>(
 params: ListSystemLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSystemLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSystemLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listProcessesHistoricResponse200 = {
  data: PageCustomHistoricProcessInstanceDto
  status: 200
}

export type listProcessesHistoricResponseSuccess = (listProcessesHistoricResponse200) & {
  headers: Headers;
};
;

export type listProcessesHistoricResponse = (listProcessesHistoricResponseSuccess)

export const getListProcessesHistoricUrl = (params?: ListProcessesHistoricParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/history/process-instance?${stringifiedParams}` : `/smart-bpm/rest/history/process-instance`
}

/**
 * @summary Lista o histórico de processos
 */
export const listProcessesHistoric = async (params?: ListProcessesHistoricParams, options?: RequestInit): Promise<listProcessesHistoricResponse> => {

  return customInstanceBpm<listProcessesHistoricResponse>(getListProcessesHistoricUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProcessesHistoricQueryKey = (params?: ListProcessesHistoricParams,) => {
    return [
    `/smart-bpm/rest/history/process-instance`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProcessesHistoricQueryOptions = <TData = Awaited<ReturnType<typeof listProcessesHistoric>>, TError = unknown>(params?: ListProcessesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProcessesHistoricQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProcessesHistoric>>> = ({ signal }) => listProcessesHistoric(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProcessesHistoricQueryResult = NonNullable<Awaited<ReturnType<typeof listProcessesHistoric>>>
export type ListProcessesHistoricQueryError = unknown


export function useListProcessesHistoric<TData = Awaited<ReturnType<typeof listProcessesHistoric>>, TError = unknown>(
 params: undefined |  ListProcessesHistoricParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessesHistoric>>,
          TError,
          Awaited<ReturnType<typeof listProcessesHistoric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessesHistoric<TData = Awaited<ReturnType<typeof listProcessesHistoric>>, TError = unknown>(
 params?: ListProcessesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProcessesHistoric>>,
          TError,
          Awaited<ReturnType<typeof listProcessesHistoric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProcessesHistoric<TData = Awaited<ReturnType<typeof listProcessesHistoric>>, TError = unknown>(
 params?: ListProcessesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o histórico de processos
 */

export function useListProcessesHistoric<TData = Awaited<ReturnType<typeof listProcessesHistoric>>, TError = unknown>(
 params?: ListProcessesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProcessesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProcessesHistoricQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getProcessActivitiesHistoricResponse200 = {
  data: PageCustomHistoricActivityInstanceDto
  status: 200
}

export type getProcessActivitiesHistoricResponseSuccess = (getProcessActivitiesHistoricResponse200) & {
  headers: Headers;
};
;

export type getProcessActivitiesHistoricResponse = (getProcessActivitiesHistoricResponseSuccess)

export const getGetProcessActivitiesHistoricUrl = (processInstanceId: string,
    params: GetProcessActivitiesHistoricParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/history/activity-instance/${processInstanceId}?${stringifiedParams}` : `/smart-bpm/rest/history/activity-instance/${processInstanceId}`
}

/**
 * @summary Lista o histórico de atividades da instância do processo
 */
export const getProcessActivitiesHistoric = async (processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options?: RequestInit): Promise<getProcessActivitiesHistoricResponse> => {

  return customInstanceBpm<getProcessActivitiesHistoricResponse>(getGetProcessActivitiesHistoricUrl(processInstanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProcessActivitiesHistoricQueryKey = (processInstanceId: string,
    params?: GetProcessActivitiesHistoricParams,) => {
    return [
    `/smart-bpm/rest/history/activity-instance/${processInstanceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProcessActivitiesHistoricQueryOptions = <TData = Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError = unknown>(processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessActivitiesHistoricQueryKey(processInstanceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>> = ({ signal }) => getProcessActivitiesHistoric(processInstanceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processInstanceId !== null && processInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProcessActivitiesHistoricQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>>
export type GetProcessActivitiesHistoricQueryError = unknown


export function useGetProcessActivitiesHistoric<TData = Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError = unknown>(
 processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessActivitiesHistoric>>,
          TError,
          Awaited<ReturnType<typeof getProcessActivitiesHistoric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessActivitiesHistoric<TData = Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError = unknown>(
 processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessActivitiesHistoric>>,
          TError,
          Awaited<ReturnType<typeof getProcessActivitiesHistoric>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProcessActivitiesHistoric<TData = Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError = unknown>(
 processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o histórico de atividades da instância do processo
 */

export function useGetProcessActivitiesHistoric<TData = Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError = unknown>(
 processInstanceId: string,
    params: GetProcessActivitiesHistoricParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessActivitiesHistoric>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProcessActivitiesHistoricQueryOptions(processInstanceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getFormByActivityInstanceIdResponse200 = {
  data: FormFieldDto
  status: 200
}

export type getFormByActivityInstanceIdResponseSuccess = (getFormByActivityInstanceIdResponse200) & {
  headers: Headers;
};
;

export type getFormByActivityInstanceIdResponse = (getFormByActivityInstanceIdResponseSuccess)

export const getGetFormByActivityInstanceIdUrl = (params: GetFormByActivityInstanceIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/form/find-by-activity?${stringifiedParams}` : `/smart-bpm/rest/form/find-by-activity`
}

/**
 * @summary Retorna as propriedades do formulário da atividade
 */
export const getFormByActivityInstanceId = async (params: GetFormByActivityInstanceIdParams, options?: RequestInit): Promise<getFormByActivityInstanceIdResponse> => {

  return customInstanceBpm<getFormByActivityInstanceIdResponse>(getGetFormByActivityInstanceIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFormByActivityInstanceIdQueryKey = (params?: GetFormByActivityInstanceIdParams,) => {
    return [
    `/smart-bpm/rest/form/find-by-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFormByActivityInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError = unknown>(params: GetFormByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFormByActivityInstanceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFormByActivityInstanceId>>> = ({ signal }) => getFormByActivityInstanceId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFormByActivityInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFormByActivityInstanceId>>>
export type GetFormByActivityInstanceIdQueryError = unknown


export function useGetFormByActivityInstanceId<TData = Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError = unknown>(
 params: GetFormByActivityInstanceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof getFormByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormByActivityInstanceId<TData = Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError = unknown>(
 params: GetFormByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof getFormByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFormByActivityInstanceId<TData = Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError = unknown>(
 params: GetFormByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna as propriedades do formulário da atividade
 */

export function useGetFormByActivityInstanceId<TData = Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError = unknown>(
 params: GetFormByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFormByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFormByActivityInstanceIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listFileSignaturesResponse200 = {
  data: AttachmentSignatureDto
  status: 200
}

export type listFileSignaturesResponseSuccess = (listFileSignaturesResponse200) & {
  headers: Headers;
};
;

export type listFileSignaturesResponse = (listFileSignaturesResponseSuccess)

export const getListFileSignaturesUrl = (params: ListFileSignaturesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/attachment/signatures?${stringifiedParams}` : `/smart-bpm/rest/attachment/signatures`
}

/**
 * @summary Faz download das assinaturas do arquivo
 */
export const listFileSignatures = async (params: ListFileSignaturesParams, options?: RequestInit): Promise<listFileSignaturesResponse> => {

  return customInstanceBpm<listFileSignaturesResponse>(getListFileSignaturesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFileSignaturesQueryKey = (params?: ListFileSignaturesParams,) => {
    return [
    `/smart-bpm/rest/attachment/signatures`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFileSignaturesQueryOptions = <TData = Awaited<ReturnType<typeof listFileSignatures>>, TError = unknown>(params: ListFileSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFileSignaturesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFileSignatures>>> = ({ signal }) => listFileSignatures(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFileSignaturesQueryResult = NonNullable<Awaited<ReturnType<typeof listFileSignatures>>>
export type ListFileSignaturesQueryError = unknown


export function useListFileSignatures<TData = Awaited<ReturnType<typeof listFileSignatures>>, TError = unknown>(
 params: ListFileSignaturesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFileSignatures>>,
          TError,
          Awaited<ReturnType<typeof listFileSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFileSignatures<TData = Awaited<ReturnType<typeof listFileSignatures>>, TError = unknown>(
 params: ListFileSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFileSignatures>>,
          TError,
          Awaited<ReturnType<typeof listFileSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFileSignatures<TData = Awaited<ReturnType<typeof listFileSignatures>>, TError = unknown>(
 params: ListFileSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download das assinaturas do arquivo
 */

export function useListFileSignatures<TData = Awaited<ReturnType<typeof listFileSignatures>>, TError = unknown>(
 params: ListFileSignaturesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSignatures>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFileSignaturesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchFilesResponse200 = {
  data: PageSmartEcmSuccinctPropertiesDto
  status: 200
}

export type searchFilesResponseSuccess = (searchFilesResponse200) & {
  headers: Headers;
};
;

export type searchFilesResponse = (searchFilesResponseSuccess)

export const getSearchFilesUrl = (params: SearchFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/attachment/search?${stringifiedParams}` : `/smart-bpm/rest/attachment/search`
}

/**
 * @summary Lista os arquivos
 */
export const searchFiles = async (params: SearchFilesParams, options?: RequestInit): Promise<searchFilesResponse> => {

  return customInstanceBpm<searchFilesResponse>(getSearchFilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchFilesQueryKey = (params?: SearchFilesParams,) => {
    return [
    `/smart-bpm/rest/attachment/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchFilesQueryOptions = <TData = Awaited<ReturnType<typeof searchFiles>>, TError = unknown>(params: SearchFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchFilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchFiles>>> = ({ signal }) => searchFiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchFilesQueryResult = NonNullable<Awaited<ReturnType<typeof searchFiles>>>
export type SearchFilesQueryError = unknown


export function useSearchFiles<TData = Awaited<ReturnType<typeof searchFiles>>, TError = unknown>(
 params: SearchFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFiles>>,
          TError,
          Awaited<ReturnType<typeof searchFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchFiles<TData = Awaited<ReturnType<typeof searchFiles>>, TError = unknown>(
 params: SearchFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFiles>>,
          TError,
          Awaited<ReturnType<typeof searchFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchFiles<TData = Awaited<ReturnType<typeof searchFiles>>, TError = unknown>(
 params: SearchFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os arquivos
 */

export function useSearchFiles<TData = Awaited<ReturnType<typeof searchFiles>>, TError = unknown>(
 params: SearchFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchFilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadFileResponse200 = {
  data: string[]
  status: 200
}

export type downloadFileResponseSuccess = (downloadFileResponse200) & {
  headers: Headers;
};
;

export type downloadFileResponse = (downloadFileResponseSuccess)

export const getDownloadFileUrl = (params: DownloadFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/smart-bpm/rest/attachment/download?${stringifiedParams}` : `/smart-bpm/rest/attachment/download`
}

/**
 * @summary Faz download do arquivo
 */
export const downloadFile = async (params: DownloadFileParams, options?: RequestInit): Promise<downloadFileResponse> => {

  return customInstanceBpm<downloadFileResponse>(getDownloadFileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadFileQueryKey = (params?: DownloadFileParams,) => {
    return [
    `/smart-bpm/rest/attachment/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(params: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadFileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = ({ signal }) => downloadFile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadFile>>>
export type DownloadFileQueryError = unknown


export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 params: DownloadFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 params: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 params: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download do arquivo
 */

export function useDownloadFile<TData = Awaited<ReturnType<typeof downloadFile>>, TError = unknown>(
 params: DownloadFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadFileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getFileByIdResponse200 = {
  data: UploadFileDto
  status: 200
}

export type getFileByIdResponseSuccess = (getFileByIdResponse200) & {
  headers: Headers;
};
;

export type getFileByIdResponse = (getFileByIdResponseSuccess)

export const getGetFileByIdUrl = (uid: string,) => {




  return `/smart-bpm/rest/attachment/detail/id/${uid}`
}

/**
 * @summary Retorna detalhes do arquivo
 */
export const getFileById = async (uid: string, options?: RequestInit): Promise<getFileByIdResponse> => {

  return customInstanceBpm<getFileByIdResponse>(getGetFileByIdUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFileByIdQueryKey = (uid: string,) => {
    return [
    `/smart-bpm/rest/attachment/detail/id/${uid}`
    ] as const;
    }


export const getGetFileByIdQueryOptions = <TData = Awaited<ReturnType<typeof getFileById>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileByIdQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileById>>> = ({ signal }) => getFileById(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFileByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFileById>>>
export type GetFileByIdQueryError = unknown


export function useGetFileById<TData = Awaited<ReturnType<typeof getFileById>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileById>>,
          TError,
          Awaited<ReturnType<typeof getFileById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileById<TData = Awaited<ReturnType<typeof getFileById>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileById>>,
          TError,
          Awaited<ReturnType<typeof getFileById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileById<TData = Awaited<ReturnType<typeof getFileById>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna detalhes do arquivo
 */

export function useGetFileById<TData = Awaited<ReturnType<typeof getFileById>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFileByIdQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type redirectToDoczLoginResponse200 = {
  data: RedirectView
  status: 200
}

export type redirectToDoczLoginResponseSuccess = (redirectToDoczLoginResponse200) & {
  headers: Headers;
};
;

export type redirectToDoczLoginResponse = (redirectToDoczLoginResponseSuccess)

export const getRedirectToDoczLoginUrl = (token: string,) => {




  return `/smart-bpm/docz/${token}`
}

/**
 * @summary Retorna os recusrsos que estão habilitados na plataforma
 */
export const redirectToDoczLogin = async (token: string, options?: RequestInit): Promise<redirectToDoczLoginResponse> => {

  return customInstanceBpm<redirectToDoczLoginResponse>(getRedirectToDoczLoginUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRedirectToDoczLoginQueryKey = (token: string,) => {
    return [
    `/smart-bpm/docz/${token}`
    ] as const;
    }


export const getRedirectToDoczLoginQueryOptions = <TData = Awaited<ReturnType<typeof redirectToDoczLogin>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRedirectToDoczLoginQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof redirectToDoczLogin>>> = ({ signal }) => redirectToDoczLogin(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedirectToDoczLoginQueryResult = NonNullable<Awaited<ReturnType<typeof redirectToDoczLogin>>>
export type RedirectToDoczLoginQueryError = unknown


export function useRedirectToDoczLogin<TData = Awaited<ReturnType<typeof redirectToDoczLogin>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectToDoczLogin>>,
          TError,
          Awaited<ReturnType<typeof redirectToDoczLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectToDoczLogin<TData = Awaited<ReturnType<typeof redirectToDoczLogin>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectToDoczLogin>>,
          TError,
          Awaited<ReturnType<typeof redirectToDoczLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectToDoczLogin<TData = Awaited<ReturnType<typeof redirectToDoczLogin>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna os recusrsos que estão habilitados na plataforma
 */

export function useRedirectToDoczLogin<TData = Awaited<ReturnType<typeof redirectToDoczLogin>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectToDoczLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRedirectToDoczLoginQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeUnidadeResponse200 = {
  data: string
  status: 200
}

export type listSgeUnidadeResponseSuccess = (listSgeUnidadeResponse200) & {
  headers: Headers;
};
;

export type listSgeUnidadeResponse = (listSgeUnidadeResponseSuccess)

export const getListSgeUnidadeUrl = (params: ListSgeUnidadeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/unidade?${stringifiedParams}` : `/sge/unidade`
}

/**
 * @summary Lista unidades do SGE
 */
export const listSgeUnidade = async (params: ListSgeUnidadeParams, options?: RequestInit): Promise<listSgeUnidadeResponse> => {

  return customInstanceBpm<listSgeUnidadeResponse>(getListSgeUnidadeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeUnidadeQueryKey = (params?: ListSgeUnidadeParams,) => {
    return [
    `/sge/unidade`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeUnidadeQueryOptions = <TData = Awaited<ReturnType<typeof listSgeUnidade>>, TError = unknown>(params: ListSgeUnidadeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeUnidadeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeUnidade>>> = ({ signal }) => listSgeUnidade(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeUnidadeQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeUnidade>>>
export type ListSgeUnidadeQueryError = unknown


export function useListSgeUnidade<TData = Awaited<ReturnType<typeof listSgeUnidade>>, TError = unknown>(
 params: ListSgeUnidadeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeUnidade>>,
          TError,
          Awaited<ReturnType<typeof listSgeUnidade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeUnidade<TData = Awaited<ReturnType<typeof listSgeUnidade>>, TError = unknown>(
 params: ListSgeUnidadeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeUnidade>>,
          TError,
          Awaited<ReturnType<typeof listSgeUnidade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeUnidade<TData = Awaited<ReturnType<typeof listSgeUnidade>>, TError = unknown>(
 params: ListSgeUnidadeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista unidades do SGE
 */

export function useListSgeUnidade<TData = Awaited<ReturnType<typeof listSgeUnidade>>, TError = unknown>(
 params: ListSgeUnidadeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeUnidade>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeUnidadeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeTurmasResponse200 = {
  data: string
  status: 200
}

export type listSgeTurmasResponseSuccess = (listSgeTurmasResponse200) & {
  headers: Headers;
};
;

export type listSgeTurmasResponse = (listSgeTurmasResponseSuccess)

export const getListSgeTurmasUrl = (params: ListSgeTurmasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/turmas?${stringifiedParams}` : `/sge/turmas`
}

/**
 * @summary Lista turmas do SGE
 */
export const listSgeTurmas = async (params: ListSgeTurmasParams, options?: RequestInit): Promise<listSgeTurmasResponse> => {

  return customInstanceBpm<listSgeTurmasResponse>(getListSgeTurmasUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeTurmasQueryKey = (params?: ListSgeTurmasParams,) => {
    return [
    `/sge/turmas`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeTurmasQueryOptions = <TData = Awaited<ReturnType<typeof listSgeTurmas>>, TError = unknown>(params: ListSgeTurmasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeTurmasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeTurmas>>> = ({ signal }) => listSgeTurmas(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeTurmasQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeTurmas>>>
export type ListSgeTurmasQueryError = unknown


export function useListSgeTurmas<TData = Awaited<ReturnType<typeof listSgeTurmas>>, TError = unknown>(
 params: ListSgeTurmasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeTurmas>>,
          TError,
          Awaited<ReturnType<typeof listSgeTurmas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeTurmas<TData = Awaited<ReturnType<typeof listSgeTurmas>>, TError = unknown>(
 params: ListSgeTurmasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeTurmas>>,
          TError,
          Awaited<ReturnType<typeof listSgeTurmas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeTurmas<TData = Awaited<ReturnType<typeof listSgeTurmas>>, TError = unknown>(
 params: ListSgeTurmasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista turmas do SGE
 */

export function useListSgeTurmas<TData = Awaited<ReturnType<typeof listSgeTurmas>>, TError = unknown>(
 params: ListSgeTurmasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmas>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeTurmasQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeTurmasDisciplinaResponse200 = {
  data: string
  status: 200
}

export type listSgeTurmasDisciplinaResponseSuccess = (listSgeTurmasDisciplinaResponse200) & {
  headers: Headers;
};
;

export type listSgeTurmasDisciplinaResponse = (listSgeTurmasDisciplinaResponseSuccess)

export const getListSgeTurmasDisciplinaUrl = (params: ListSgeTurmasDisciplinaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/turmas-disciplina?${stringifiedParams}` : `/sge/turmas-disciplina`
}

/**
 * @summary Lista turmas disciplinas do SGE
 */
export const listSgeTurmasDisciplina = async (params: ListSgeTurmasDisciplinaParams, options?: RequestInit): Promise<listSgeTurmasDisciplinaResponse> => {

  return customInstanceBpm<listSgeTurmasDisciplinaResponse>(getListSgeTurmasDisciplinaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeTurmasDisciplinaQueryKey = (params?: ListSgeTurmasDisciplinaParams,) => {
    return [
    `/sge/turmas-disciplina`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeTurmasDisciplinaQueryOptions = <TData = Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError = unknown>(params: ListSgeTurmasDisciplinaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeTurmasDisciplinaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>> = ({ signal }) => listSgeTurmasDisciplina(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeTurmasDisciplinaQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>>
export type ListSgeTurmasDisciplinaQueryError = unknown


export function useListSgeTurmasDisciplina<TData = Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError = unknown>(
 params: ListSgeTurmasDisciplinaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeTurmasDisciplina>>,
          TError,
          Awaited<ReturnType<typeof listSgeTurmasDisciplina>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeTurmasDisciplina<TData = Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError = unknown>(
 params: ListSgeTurmasDisciplinaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeTurmasDisciplina>>,
          TError,
          Awaited<ReturnType<typeof listSgeTurmasDisciplina>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeTurmasDisciplina<TData = Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError = unknown>(
 params: ListSgeTurmasDisciplinaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista turmas disciplinas do SGE
 */

export function useListSgeTurmasDisciplina<TData = Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError = unknown>(
 params: ListSgeTurmasDisciplinaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeTurmasDisciplina>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeTurmasDisciplinaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeSituacaoMatriculaResponse200 = {
  data: string
  status: 200
}

export type listSgeSituacaoMatriculaResponseSuccess = (listSgeSituacaoMatriculaResponse200) & {
  headers: Headers;
};
;

export type listSgeSituacaoMatriculaResponse = (listSgeSituacaoMatriculaResponseSuccess)

export const getListSgeSituacaoMatriculaUrl = (params: ListSgeSituacaoMatriculaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/situacao-matricula?${stringifiedParams}` : `/sge/situacao-matricula`
}

/**
 * @summary Lista situação matricula do SGE
 */
export const listSgeSituacaoMatricula = async (params: ListSgeSituacaoMatriculaParams, options?: RequestInit): Promise<listSgeSituacaoMatriculaResponse> => {

  return customInstanceBpm<listSgeSituacaoMatriculaResponse>(getListSgeSituacaoMatriculaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeSituacaoMatriculaQueryKey = (params?: ListSgeSituacaoMatriculaParams,) => {
    return [
    `/sge/situacao-matricula`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeSituacaoMatriculaQueryOptions = <TData = Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError = unknown>(params: ListSgeSituacaoMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeSituacaoMatriculaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>> = ({ signal }) => listSgeSituacaoMatricula(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeSituacaoMatriculaQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>>
export type ListSgeSituacaoMatriculaQueryError = unknown


export function useListSgeSituacaoMatricula<TData = Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError = unknown>(
 params: ListSgeSituacaoMatriculaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeSituacaoMatricula>>,
          TError,
          Awaited<ReturnType<typeof listSgeSituacaoMatricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeSituacaoMatricula<TData = Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError = unknown>(
 params: ListSgeSituacaoMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeSituacaoMatricula>>,
          TError,
          Awaited<ReturnType<typeof listSgeSituacaoMatricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeSituacaoMatricula<TData = Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError = unknown>(
 params: ListSgeSituacaoMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista situação matricula do SGE
 */

export function useListSgeSituacaoMatricula<TData = Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError = unknown>(
 params: ListSgeSituacaoMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSituacaoMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeSituacaoMatriculaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeSeriesResponse200 = {
  data: string
  status: 200
}

export type listSgeSeriesResponseSuccess = (listSgeSeriesResponse200) & {
  headers: Headers;
};
;

export type listSgeSeriesResponse = (listSgeSeriesResponseSuccess)

export const getListSgeSeriesUrl = (params: ListSgeSeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/series?${stringifiedParams}` : `/sge/series`
}

/**
 * @summary Lista series do SGE
 */
export const listSgeSeries = async (params: ListSgeSeriesParams, options?: RequestInit): Promise<listSgeSeriesResponse> => {

  return customInstanceBpm<listSgeSeriesResponse>(getListSgeSeriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeSeriesQueryKey = (params?: ListSgeSeriesParams,) => {
    return [
    `/sge/series`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeSeriesQueryOptions = <TData = Awaited<ReturnType<typeof listSgeSeries>>, TError = unknown>(params: ListSgeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeSeriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeSeries>>> = ({ signal }) => listSgeSeries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeSeriesQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeSeries>>>
export type ListSgeSeriesQueryError = unknown


export function useListSgeSeries<TData = Awaited<ReturnType<typeof listSgeSeries>>, TError = unknown>(
 params: ListSgeSeriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeSeries>>,
          TError,
          Awaited<ReturnType<typeof listSgeSeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeSeries<TData = Awaited<ReturnType<typeof listSgeSeries>>, TError = unknown>(
 params: ListSgeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeSeries>>,
          TError,
          Awaited<ReturnType<typeof listSgeSeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeSeries<TData = Awaited<ReturnType<typeof listSgeSeries>>, TError = unknown>(
 params: ListSgeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista series do SGE
 */

export function useListSgeSeries<TData = Awaited<ReturnType<typeof listSgeSeries>>, TError = unknown>(
 params: ListSgeSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeSeries>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeSeriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgePlanoPagamentoResponse200 = {
  data: string
  status: 200
}

export type listSgePlanoPagamentoResponseSuccess = (listSgePlanoPagamentoResponse200) & {
  headers: Headers;
};
;

export type listSgePlanoPagamentoResponse = (listSgePlanoPagamentoResponseSuccess)

export const getListSgePlanoPagamentoUrl = (params: ListSgePlanoPagamentoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/plano-pagamento?${stringifiedParams}` : `/sge/plano-pagamento`
}

/**
 * @summary Lista plano pagamento do SGE
 */
export const listSgePlanoPagamento = async (params: ListSgePlanoPagamentoParams, options?: RequestInit): Promise<listSgePlanoPagamentoResponse> => {

  return customInstanceBpm<listSgePlanoPagamentoResponse>(getListSgePlanoPagamentoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgePlanoPagamentoQueryKey = (params?: ListSgePlanoPagamentoParams,) => {
    return [
    `/sge/plano-pagamento`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgePlanoPagamentoQueryOptions = <TData = Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError = unknown>(params: ListSgePlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgePlanoPagamentoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgePlanoPagamento>>> = ({ signal }) => listSgePlanoPagamento(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgePlanoPagamentoQueryResult = NonNullable<Awaited<ReturnType<typeof listSgePlanoPagamento>>>
export type ListSgePlanoPagamentoQueryError = unknown


export function useListSgePlanoPagamento<TData = Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError = unknown>(
 params: ListSgePlanoPagamentoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgePlanoPagamento>>,
          TError,
          Awaited<ReturnType<typeof listSgePlanoPagamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgePlanoPagamento<TData = Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError = unknown>(
 params: ListSgePlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgePlanoPagamento>>,
          TError,
          Awaited<ReturnType<typeof listSgePlanoPagamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgePlanoPagamento<TData = Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError = unknown>(
 params: ListSgePlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista plano pagamento do SGE
 */

export function useListSgePlanoPagamento<TData = Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError = unknown>(
 params: ListSgePlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgePlanoPagamentoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgePeriodoLetivoResponse200 = {
  data: string
  status: 200
}

export type listSgePeriodoLetivoResponseSuccess = (listSgePeriodoLetivoResponse200) & {
  headers: Headers;
};
;

export type listSgePeriodoLetivoResponse = (listSgePeriodoLetivoResponseSuccess)

export const getListSgePeriodoLetivoUrl = (params: ListSgePeriodoLetivoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/periodo-letivo?${stringifiedParams}` : `/sge/periodo-letivo`
}

/**
 * @summary Lista periodo letivo do SGE
 */
export const listSgePeriodoLetivo = async (params: ListSgePeriodoLetivoParams, options?: RequestInit): Promise<listSgePeriodoLetivoResponse> => {

  return customInstanceBpm<listSgePeriodoLetivoResponse>(getListSgePeriodoLetivoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgePeriodoLetivoQueryKey = (params?: ListSgePeriodoLetivoParams,) => {
    return [
    `/sge/periodo-letivo`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgePeriodoLetivoQueryOptions = <TData = Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError = unknown>(params: ListSgePeriodoLetivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgePeriodoLetivoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgePeriodoLetivo>>> = ({ signal }) => listSgePeriodoLetivo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgePeriodoLetivoQueryResult = NonNullable<Awaited<ReturnType<typeof listSgePeriodoLetivo>>>
export type ListSgePeriodoLetivoQueryError = unknown


export function useListSgePeriodoLetivo<TData = Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError = unknown>(
 params: ListSgePeriodoLetivoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgePeriodoLetivo>>,
          TError,
          Awaited<ReturnType<typeof listSgePeriodoLetivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgePeriodoLetivo<TData = Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError = unknown>(
 params: ListSgePeriodoLetivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgePeriodoLetivo>>,
          TError,
          Awaited<ReturnType<typeof listSgePeriodoLetivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgePeriodoLetivo<TData = Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError = unknown>(
 params: ListSgePeriodoLetivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista periodo letivo do SGE
 */

export function useListSgePeriodoLetivo<TData = Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError = unknown>(
 params: ListSgePeriodoLetivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgePeriodoLetivo>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgePeriodoLetivoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeParcelaPlanoPagamentoResponse200 = {
  data: string
  status: 200
}

export type listSgeParcelaPlanoPagamentoResponseSuccess = (listSgeParcelaPlanoPagamentoResponse200) & {
  headers: Headers;
};
;

export type listSgeParcelaPlanoPagamentoResponse = (listSgeParcelaPlanoPagamentoResponseSuccess)

export const getListSgeParcelaPlanoPagamentoUrl = (params?: ListSgeParcelaPlanoPagamentoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/parcela-plano-pagamento?${stringifiedParams}` : `/sge/parcela-plano-pagamento`
}

/**
 * @summary Lista parcela do pagamento do SGE
 */
export const listSgeParcelaPlanoPagamento = async (params?: ListSgeParcelaPlanoPagamentoParams, options?: RequestInit): Promise<listSgeParcelaPlanoPagamentoResponse> => {

  return customInstanceBpm<listSgeParcelaPlanoPagamentoResponse>(getListSgeParcelaPlanoPagamentoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeParcelaPlanoPagamentoQueryKey = (params?: ListSgeParcelaPlanoPagamentoParams,) => {
    return [
    `/sge/parcela-plano-pagamento`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeParcelaPlanoPagamentoQueryOptions = <TData = Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError = unknown>(params?: ListSgeParcelaPlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeParcelaPlanoPagamentoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>> = ({ signal }) => listSgeParcelaPlanoPagamento(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeParcelaPlanoPagamentoQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>>
export type ListSgeParcelaPlanoPagamentoQueryError = unknown


export function useListSgeParcelaPlanoPagamento<TData = Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError = unknown>(
 params: undefined |  ListSgeParcelaPlanoPagamentoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>,
          TError,
          Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeParcelaPlanoPagamento<TData = Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError = unknown>(
 params?: ListSgeParcelaPlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>,
          TError,
          Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeParcelaPlanoPagamento<TData = Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError = unknown>(
 params?: ListSgeParcelaPlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista parcela do pagamento do SGE
 */

export function useListSgeParcelaPlanoPagamento<TData = Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError = unknown>(
 params?: ListSgeParcelaPlanoPagamentoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParcelaPlanoPagamento>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeParcelaPlanoPagamentoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeParametrizacaoCursoResponse200 = {
  data: string
  status: 200
}

export type listSgeParametrizacaoCursoResponseSuccess = (listSgeParametrizacaoCursoResponse200) & {
  headers: Headers;
};
;

export type listSgeParametrizacaoCursoResponse = (listSgeParametrizacaoCursoResponseSuccess)

export const getListSgeParametrizacaoCursoUrl = (params: ListSgeParametrizacaoCursoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/parametrizacao-curso?${stringifiedParams}` : `/sge/parametrizacao-curso`
}

/**
 * @summary Lista parametrização curso (turno) do SGE
 */
export const listSgeParametrizacaoCurso = async (params: ListSgeParametrizacaoCursoParams, options?: RequestInit): Promise<listSgeParametrizacaoCursoResponse> => {

  return customInstanceBpm<listSgeParametrizacaoCursoResponse>(getListSgeParametrizacaoCursoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeParametrizacaoCursoQueryKey = (params?: ListSgeParametrizacaoCursoParams,) => {
    return [
    `/sge/parametrizacao-curso`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeParametrizacaoCursoQueryOptions = <TData = Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError = unknown>(params: ListSgeParametrizacaoCursoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeParametrizacaoCursoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>> = ({ signal }) => listSgeParametrizacaoCurso(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeParametrizacaoCursoQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>>
export type ListSgeParametrizacaoCursoQueryError = unknown


export function useListSgeParametrizacaoCurso<TData = Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError = unknown>(
 params: ListSgeParametrizacaoCursoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>,
          TError,
          Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeParametrizacaoCurso<TData = Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError = unknown>(
 params: ListSgeParametrizacaoCursoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>,
          TError,
          Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeParametrizacaoCurso<TData = Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError = unknown>(
 params: ListSgeParametrizacaoCursoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista parametrização curso (turno) do SGE
 */

export function useListSgeParametrizacaoCurso<TData = Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError = unknown>(
 params: ListSgeParametrizacaoCursoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeParametrizacaoCurso>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeParametrizacaoCursoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeMatrizResponse200 = {
  data: string
  status: 200
}

export type listSgeMatrizResponseSuccess = (listSgeMatrizResponse200) & {
  headers: Headers;
};
;

export type listSgeMatrizResponse = (listSgeMatrizResponseSuccess)

export const getListSgeMatrizUrl = (params: ListSgeMatrizParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/matriz?${stringifiedParams}` : `/sge/matriz`
}

/**
 * @summary Lista matriz do SGE
 */
export const listSgeMatriz = async (params: ListSgeMatrizParams, options?: RequestInit): Promise<listSgeMatrizResponse> => {

  return customInstanceBpm<listSgeMatrizResponse>(getListSgeMatrizUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeMatrizQueryKey = (params?: ListSgeMatrizParams,) => {
    return [
    `/sge/matriz`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeMatrizQueryOptions = <TData = Awaited<ReturnType<typeof listSgeMatriz>>, TError = unknown>(params: ListSgeMatrizParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeMatrizQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeMatriz>>> = ({ signal }) => listSgeMatriz(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeMatrizQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeMatriz>>>
export type ListSgeMatrizQueryError = unknown


export function useListSgeMatriz<TData = Awaited<ReturnType<typeof listSgeMatriz>>, TError = unknown>(
 params: ListSgeMatrizParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeMatriz>>,
          TError,
          Awaited<ReturnType<typeof listSgeMatriz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeMatriz<TData = Awaited<ReturnType<typeof listSgeMatriz>>, TError = unknown>(
 params: ListSgeMatrizParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeMatriz>>,
          TError,
          Awaited<ReturnType<typeof listSgeMatriz>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeMatriz<TData = Awaited<ReturnType<typeof listSgeMatriz>>, TError = unknown>(
 params: ListSgeMatrizParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista matriz do SGE
 */

export function useListSgeMatriz<TData = Awaited<ReturnType<typeof listSgeMatriz>>, TError = unknown>(
 params: ListSgeMatrizParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeMatriz>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeMatrizQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSesiIpaasUrlsResponse200 = {
  data: SesiIpaasUrlDto[]
  status: 200
}

export type listSesiIpaasUrlsResponseSuccess = (listSesiIpaasUrlsResponse200) & {
  headers: Headers;
};
;

export type listSesiIpaasUrlsResponse = (listSesiIpaasUrlsResponseSuccess)

export const getListSesiIpaasUrlsUrl = () => {




  return `/sge/ipaas/ipaas-urls`
}

/**
 * @summary List urls do Ipaas
 */
export const listSesiIpaasUrls = async ( options?: RequestInit): Promise<listSesiIpaasUrlsResponse> => {

  return customInstanceBpm<listSesiIpaasUrlsResponse>(getListSesiIpaasUrlsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSesiIpaasUrlsQueryKey = () => {
    return [
    `/sge/ipaas/ipaas-urls`
    ] as const;
    }


export const getListSesiIpaasUrlsQueryOptions = <TData = Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSesiIpaasUrlsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSesiIpaasUrls>>> = ({ signal }) => listSesiIpaasUrls({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSesiIpaasUrlsQueryResult = NonNullable<Awaited<ReturnType<typeof listSesiIpaasUrls>>>
export type ListSesiIpaasUrlsQueryError = unknown


export function useListSesiIpaasUrls<TData = Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSesiIpaasUrls>>,
          TError,
          Awaited<ReturnType<typeof listSesiIpaasUrls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSesiIpaasUrls<TData = Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSesiIpaasUrls>>,
          TError,
          Awaited<ReturnType<typeof listSesiIpaasUrls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSesiIpaasUrls<TData = Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List urls do Ipaas
 */

export function useListSesiIpaasUrls<TData = Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSesiIpaasUrls>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSesiIpaasUrlsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteIpaasUrlsResponse204 = {
  data: void
  status: 204
}

export type deleteIpaasUrlsResponseSuccess = (deleteIpaasUrlsResponse204) & {
  headers: Headers;
};
;

export type deleteIpaasUrlsResponse = (deleteIpaasUrlsResponseSuccess)

export const getDeleteIpaasUrlsUrl = () => {




  return `/sge/ipaas/ipaas-urls`
}

/**
 * @summary Exclui todas as urls do Ipaas
 */
export const deleteIpaasUrls = async ( options?: RequestInit): Promise<deleteIpaasUrlsResponse> => {

  return customInstanceBpm<deleteIpaasUrlsResponse>(getDeleteIpaasUrlsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteIpaasUrlsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrls>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrls>>, TError,void, TContext> => {

const mutationKey = ['deleteIpaasUrls'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIpaasUrls>>, void> = () => {


          return  deleteIpaasUrls(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIpaasUrlsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIpaasUrls>>>

    export type DeleteIpaasUrlsMutationError = unknown

    /**
 * @summary Exclui todas as urls do Ipaas
 */
export const useDeleteIpaasUrls = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrls>>, TError,void, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIpaasUrls>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteIpaasUrlsMutationOptions(options), queryClient);
    }

export type downloadSesiIpaasUrlCsvResponse200 = {
  data: DownloadSesiIpaasUrlCsv200
  status: 200
}

export type downloadSesiIpaasUrlCsvResponseSuccess = (downloadSesiIpaasUrlCsvResponse200) & {
  headers: Headers;
};
;

export type downloadSesiIpaasUrlCsvResponse = (downloadSesiIpaasUrlCsvResponseSuccess)

export const getDownloadSesiIpaasUrlCsvUrl = () => {




  return `/sge/ipaas/ipaas-urls/download`
}

/**
 * @summary Faz download de um CSV com as urls do Ipaas
 */
export const downloadSesiIpaasUrlCsv = async ( options?: RequestInit): Promise<downloadSesiIpaasUrlCsvResponse> => {

  return customInstanceBpm<downloadSesiIpaasUrlCsvResponse>(getDownloadSesiIpaasUrlCsvUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadSesiIpaasUrlCsvQueryKey = () => {
    return [
    `/sge/ipaas/ipaas-urls/download`
    ] as const;
    }


export const getDownloadSesiIpaasUrlCsvQueryOptions = <TData = Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadSesiIpaasUrlCsvQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>> = ({ signal }) => downloadSesiIpaasUrlCsv({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadSesiIpaasUrlCsvQueryResult = NonNullable<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>>
export type DownloadSesiIpaasUrlCsvQueryError = unknown


export function useDownloadSesiIpaasUrlCsv<TData = Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadSesiIpaasUrlCsv<TData = Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>,
          TError,
          Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadSesiIpaasUrlCsv<TData = Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz download de um CSV com as urls do Ipaas
 */

export function useDownloadSesiIpaasUrlCsv<TData = Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadSesiIpaasUrlCsv>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadSesiIpaasUrlCsvQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type sgeHealthResponse200 = {
  data: SgeHealthDto
  status: 200
}

export type sgeHealthResponseSuccess = (sgeHealthResponse200) & {
  headers: Headers;
};
;

export type sgeHealthResponse = (sgeHealthResponseSuccess)

export const getSgeHealthUrl = () => {




  return `/sge/health`
}

/**
 * @summary Api para verificar o status das apis do SGE
 */
export const sgeHealth = async ( options?: RequestInit): Promise<sgeHealthResponse> => {

  return customInstanceBpm<sgeHealthResponse>(getSgeHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSgeHealthQueryKey = () => {
    return [
    `/sge/health`
    ] as const;
    }


export const getSgeHealthQueryOptions = <TData = Awaited<ReturnType<typeof sgeHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSgeHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sgeHealth>>> = ({ signal }) => sgeHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SgeHealthQueryResult = NonNullable<Awaited<ReturnType<typeof sgeHealth>>>
export type SgeHealthQueryError = unknown


export function useSgeHealth<TData = Awaited<ReturnType<typeof sgeHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sgeHealth>>,
          TError,
          Awaited<ReturnType<typeof sgeHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSgeHealth<TData = Awaited<ReturnType<typeof sgeHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sgeHealth>>,
          TError,
          Awaited<ReturnType<typeof sgeHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSgeHealth<TData = Awaited<ReturnType<typeof sgeHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Api para verificar o status das apis do SGE
 */

export function useSgeHealth<TData = Awaited<ReturnType<typeof sgeHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sgeHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSgeHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listarSgeDocumentosMatriculaResponse200 = {
  data: string
  status: 200
}

export type listarSgeDocumentosMatriculaResponseSuccess = (listarSgeDocumentosMatriculaResponse200) & {
  headers: Headers;
};
;

export type listarSgeDocumentosMatriculaResponse = (listarSgeDocumentosMatriculaResponseSuccess)

export const getListarSgeDocumentosMatriculaUrl = (params: ListarSgeDocumentosMatriculaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/documentos-rematricula?${stringifiedParams}` : `/sge/documentos-rematricula`
}

/**
 * @summary Lista documentos rematricula do SGE
 */
export const listarSgeDocumentosMatricula = async (params: ListarSgeDocumentosMatriculaParams, options?: RequestInit): Promise<listarSgeDocumentosMatriculaResponse> => {

  return customInstanceBpm<listarSgeDocumentosMatriculaResponse>(getListarSgeDocumentosMatriculaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListarSgeDocumentosMatriculaQueryKey = (params?: ListarSgeDocumentosMatriculaParams,) => {
    return [
    `/sge/documentos-rematricula`, ...(params ? [params] : [])
    ] as const;
    }


export const getListarSgeDocumentosMatriculaQueryOptions = <TData = Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError = unknown>(params: ListarSgeDocumentosMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListarSgeDocumentosMatriculaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>> = ({ signal }) => listarSgeDocumentosMatricula(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListarSgeDocumentosMatriculaQueryResult = NonNullable<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>>
export type ListarSgeDocumentosMatriculaQueryError = unknown


export function useListarSgeDocumentosMatricula<TData = Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError = unknown>(
 params: ListarSgeDocumentosMatriculaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>,
          TError,
          Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListarSgeDocumentosMatricula<TData = Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError = unknown>(
 params: ListarSgeDocumentosMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>,
          TError,
          Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListarSgeDocumentosMatricula<TData = Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError = unknown>(
 params: ListarSgeDocumentosMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista documentos rematricula do SGE
 */

export function useListarSgeDocumentosMatricula<TData = Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError = unknown>(
 params: ListarSgeDocumentosMatriculaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listarSgeDocumentosMatricula>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListarSgeDocumentosMatriculaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSgeCursosResponse200 = {
  data: string
  status: 200
}

export type listSgeCursosResponseSuccess = (listSgeCursosResponse200) & {
  headers: Headers;
};
;

export type listSgeCursosResponse = (listSgeCursosResponseSuccess)

export const getListSgeCursosUrl = (params: ListSgeCursosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/cursos?${stringifiedParams}` : `/sge/cursos`
}

/**
 * @summary Lista cursos do SGE
 */
export const listSgeCursos = async (params: ListSgeCursosParams, options?: RequestInit): Promise<listSgeCursosResponse> => {

  return customInstanceBpm<listSgeCursosResponse>(getListSgeCursosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSgeCursosQueryKey = (params?: ListSgeCursosParams,) => {
    return [
    `/sge/cursos`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSgeCursosQueryOptions = <TData = Awaited<ReturnType<typeof listSgeCursos>>, TError = unknown>(params: ListSgeCursosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSgeCursosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSgeCursos>>> = ({ signal }) => listSgeCursos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSgeCursosQueryResult = NonNullable<Awaited<ReturnType<typeof listSgeCursos>>>
export type ListSgeCursosQueryError = unknown


export function useListSgeCursos<TData = Awaited<ReturnType<typeof listSgeCursos>>, TError = unknown>(
 params: ListSgeCursosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeCursos>>,
          TError,
          Awaited<ReturnType<typeof listSgeCursos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeCursos<TData = Awaited<ReturnType<typeof listSgeCursos>>, TError = unknown>(
 params: ListSgeCursosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSgeCursos>>,
          TError,
          Awaited<ReturnType<typeof listSgeCursos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSgeCursos<TData = Awaited<ReturnType<typeof listSgeCursos>>, TError = unknown>(
 params: ListSgeCursosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista cursos do SGE
 */

export function useListSgeCursos<TData = Awaited<ReturnType<typeof listSgeCursos>>, TError = unknown>(
 params: ListSgeCursosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSgeCursos>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSgeCursosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type consultaSgeMatriculaAtivaResponse200 = {
  data: MatriculaAtiva
  status: 200
}

export type consultaSgeMatriculaAtivaResponseSuccess = (consultaSgeMatriculaAtivaResponse200) & {
  headers: Headers;
};
;

export type consultaSgeMatriculaAtivaResponse = (consultaSgeMatriculaAtivaResponseSuccess)

export const getConsultaSgeMatriculaAtivaUrl = (params?: ConsultaSgeMatriculaAtivaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/consultar-matricula-ativa?${stringifiedParams}` : `/sge/consultar-matricula-ativa`
}

/**
 * @summary Consulta matricula ativa do SGE
 */
export const consultaSgeMatriculaAtiva = async (params?: ConsultaSgeMatriculaAtivaParams, options?: RequestInit): Promise<consultaSgeMatriculaAtivaResponse> => {

  return customInstanceBpm<consultaSgeMatriculaAtivaResponse>(getConsultaSgeMatriculaAtivaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getConsultaSgeMatriculaAtivaQueryKey = (params?: ConsultaSgeMatriculaAtivaParams,) => {
    return [
    `/sge/consultar-matricula-ativa`, ...(params ? [params] : [])
    ] as const;
    }


export const getConsultaSgeMatriculaAtivaQueryOptions = <TData = Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError = unknown>(params?: ConsultaSgeMatriculaAtivaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsultaSgeMatriculaAtivaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>> = ({ signal }) => consultaSgeMatriculaAtiva(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConsultaSgeMatriculaAtivaQueryResult = NonNullable<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>>
export type ConsultaSgeMatriculaAtivaQueryError = unknown


export function useConsultaSgeMatriculaAtiva<TData = Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError = unknown>(
 params: undefined |  ConsultaSgeMatriculaAtivaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>,
          TError,
          Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsultaSgeMatriculaAtiva<TData = Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError = unknown>(
 params?: ConsultaSgeMatriculaAtivaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>,
          TError,
          Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConsultaSgeMatriculaAtiva<TData = Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError = unknown>(
 params?: ConsultaSgeMatriculaAtivaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta matricula ativa do SGE
 */

export function useConsultaSgeMatriculaAtiva<TData = Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError = unknown>(
 params?: ConsultaSgeMatriculaAtivaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consultaSgeMatriculaAtiva>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConsultaSgeMatriculaAtivaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type buscarSgePessoaResponse200 = {
  data: PessoaBusca
  status: 200
}

export type buscarSgePessoaResponseSuccess = (buscarSgePessoaResponse200) & {
  headers: Headers;
};
;

export type buscarSgePessoaResponse = (buscarSgePessoaResponseSuccess)

export const getBuscarSgePessoaUrl = (params?: BuscarSgePessoaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/buscar-pessoa?${stringifiedParams}` : `/sge/buscar-pessoa`
}

/**
 * @summary Busca pessoa do SGE
 */
export const buscarSgePessoa = async (params?: BuscarSgePessoaParams, options?: RequestInit): Promise<buscarSgePessoaResponse> => {

  return customInstanceBpm<buscarSgePessoaResponse>(getBuscarSgePessoaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBuscarSgePessoaQueryKey = (params?: BuscarSgePessoaParams,) => {
    return [
    `/sge/buscar-pessoa`, ...(params ? [params] : [])
    ] as const;
    }


export const getBuscarSgePessoaQueryOptions = <TData = Awaited<ReturnType<typeof buscarSgePessoa>>, TError = unknown>(params?: BuscarSgePessoaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarSgePessoaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarSgePessoa>>> = ({ signal }) => buscarSgePessoa(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BuscarSgePessoaQueryResult = NonNullable<Awaited<ReturnType<typeof buscarSgePessoa>>>
export type BuscarSgePessoaQueryError = unknown


export function useBuscarSgePessoa<TData = Awaited<ReturnType<typeof buscarSgePessoa>>, TError = unknown>(
 params: undefined |  BuscarSgePessoaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgePessoa>>,
          TError,
          Awaited<ReturnType<typeof buscarSgePessoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgePessoa<TData = Awaited<ReturnType<typeof buscarSgePessoa>>, TError = unknown>(
 params?: BuscarSgePessoaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgePessoa>>,
          TError,
          Awaited<ReturnType<typeof buscarSgePessoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgePessoa<TData = Awaited<ReturnType<typeof buscarSgePessoa>>, TError = unknown>(
 params?: BuscarSgePessoaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca pessoa do SGE
 */

export function useBuscarSgePessoa<TData = Awaited<ReturnType<typeof buscarSgePessoa>>, TError = unknown>(
 params?: BuscarSgePessoaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgePessoa>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBuscarSgePessoaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type buscarSgeAlunoResponse200 = {
  data: AlunoBusca
  status: 200
}

export type buscarSgeAlunoResponseSuccess = (buscarSgeAlunoResponse200) & {
  headers: Headers;
};
;

export type buscarSgeAlunoResponse = (buscarSgeAlunoResponseSuccess)

export const getBuscarSgeAlunoUrl = (params?: BuscarSgeAlunoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/buscar-aluno?${stringifiedParams}` : `/sge/buscar-aluno`
}

/**
 * @summary Busca alunos do SGE
 */
export const buscarSgeAluno = async (params?: BuscarSgeAlunoParams, options?: RequestInit): Promise<buscarSgeAlunoResponse> => {

  return customInstanceBpm<buscarSgeAlunoResponse>(getBuscarSgeAlunoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBuscarSgeAlunoQueryKey = (params?: BuscarSgeAlunoParams,) => {
    return [
    `/sge/buscar-aluno`, ...(params ? [params] : [])
    ] as const;
    }


export const getBuscarSgeAlunoQueryOptions = <TData = Awaited<ReturnType<typeof buscarSgeAluno>>, TError = unknown>(params?: BuscarSgeAlunoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarSgeAlunoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarSgeAluno>>> = ({ signal }) => buscarSgeAluno(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BuscarSgeAlunoQueryResult = NonNullable<Awaited<ReturnType<typeof buscarSgeAluno>>>
export type BuscarSgeAlunoQueryError = unknown


export function useBuscarSgeAluno<TData = Awaited<ReturnType<typeof buscarSgeAluno>>, TError = unknown>(
 params: undefined |  BuscarSgeAlunoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgeAluno>>,
          TError,
          Awaited<ReturnType<typeof buscarSgeAluno>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgeAluno<TData = Awaited<ReturnType<typeof buscarSgeAluno>>, TError = unknown>(
 params?: BuscarSgeAlunoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgeAluno>>,
          TError,
          Awaited<ReturnType<typeof buscarSgeAluno>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgeAluno<TData = Awaited<ReturnType<typeof buscarSgeAluno>>, TError = unknown>(
 params?: BuscarSgeAlunoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca alunos do SGE
 */

export function useBuscarSgeAluno<TData = Awaited<ReturnType<typeof buscarSgeAluno>>, TError = unknown>(
 params?: BuscarSgeAlunoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAluno>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBuscarSgeAlunoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type buscarSgeAlunoListResponse200 = {
  data: string
  status: 200
}

export type buscarSgeAlunoListResponseSuccess = (buscarSgeAlunoListResponse200) & {
  headers: Headers;
};
;

export type buscarSgeAlunoListResponse = (buscarSgeAlunoListResponseSuccess)

export const getBuscarSgeAlunoListUrl = (params?: BuscarSgeAlunoListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sge/buscar-aluno-list?${stringifiedParams}` : `/sge/buscar-aluno-list`
}

/**
 * @summary Busca alunos do SGE
 */
export const buscarSgeAlunoList = async (params?: BuscarSgeAlunoListParams, options?: RequestInit): Promise<buscarSgeAlunoListResponse> => {

  return customInstanceBpm<buscarSgeAlunoListResponse>(getBuscarSgeAlunoListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBuscarSgeAlunoListQueryKey = (params?: BuscarSgeAlunoListParams,) => {
    return [
    `/sge/buscar-aluno-list`, ...(params ? [params] : [])
    ] as const;
    }


export const getBuscarSgeAlunoListQueryOptions = <TData = Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError = unknown>(params?: BuscarSgeAlunoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarSgeAlunoListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarSgeAlunoList>>> = ({ signal }) => buscarSgeAlunoList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BuscarSgeAlunoListQueryResult = NonNullable<Awaited<ReturnType<typeof buscarSgeAlunoList>>>
export type BuscarSgeAlunoListQueryError = unknown


export function useBuscarSgeAlunoList<TData = Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError = unknown>(
 params: undefined |  BuscarSgeAlunoListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgeAlunoList>>,
          TError,
          Awaited<ReturnType<typeof buscarSgeAlunoList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgeAlunoList<TData = Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError = unknown>(
 params?: BuscarSgeAlunoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buscarSgeAlunoList>>,
          TError,
          Awaited<ReturnType<typeof buscarSgeAlunoList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBuscarSgeAlunoList<TData = Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError = unknown>(
 params?: BuscarSgeAlunoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca alunos do SGE
 */

export function useBuscarSgeAlunoList<TData = Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError = unknown>(
 params?: BuscarSgeAlunoListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buscarSgeAlunoList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBuscarSgeAlunoListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTermByIdResponse200 = {
  data: TermsOfUseDto
  status: 200
}

export type getTermByIdResponseSuccess = (getTermByIdResponse200) & {
  headers: Headers;
};
;

export type getTermByIdResponse = (getTermByIdResponseSuccess)

export const getGetTermByIdUrl = (id: string,) => {




  return `/public/v1/terms/${id}`
}

/**
 * @summary Busca o termo de uso por ID
 */
export const getTermById = async (id: string, options?: RequestInit): Promise<getTermByIdResponse> => {

  return customInstanceBpm<getTermByIdResponse>(getGetTermByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTermByIdQueryKey = (id: string,) => {
    return [
    `/public/v1/terms/${id}`
    ] as const;
    }


export const getGetTermByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTermById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTermById>>> = ({ signal }) => getTermById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTermByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTermById>>>
export type GetTermByIdQueryError = unknown


export function useGetTermById<TData = Awaited<ReturnType<typeof getTermById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermById>>,
          TError,
          Awaited<ReturnType<typeof getTermById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermById<TData = Awaited<ReturnType<typeof getTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermById>>,
          TError,
          Awaited<ReturnType<typeof getTermById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTermById<TData = Awaited<ReturnType<typeof getTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o termo de uso por ID
 */

export function useGetTermById<TData = Awaited<ReturnType<typeof getTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTermByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type downloadTermByIdResponse200 = {
  data: DownloadTermById200
  status: 200
}

export type downloadTermByIdResponseSuccess = (downloadTermByIdResponse200) & {
  headers: Headers;
};
;

export type downloadTermByIdResponse = (downloadTermByIdResponseSuccess)

export const getDownloadTermByIdUrl = (id: string,) => {




  return `/public/v1/terms/${id}/download`
}

/**
 * @summary Faz o download do termo de uso
 */
export const downloadTermById = async (id: string, options?: RequestInit): Promise<downloadTermByIdResponse> => {

  return customInstanceBpm<downloadTermByIdResponse>(getDownloadTermByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadTermByIdQueryKey = (id: string,) => {
    return [
    `/public/v1/terms/${id}/download`
    ] as const;
    }


export const getDownloadTermByIdQueryOptions = <TData = Awaited<ReturnType<typeof downloadTermById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTermByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTermById>>> = ({ signal }) => downloadTermById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadTermByIdQueryResult = NonNullable<Awaited<ReturnType<typeof downloadTermById>>>
export type DownloadTermByIdQueryError = unknown


export function useDownloadTermById<TData = Awaited<ReturnType<typeof downloadTermById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTermById>>,
          TError,
          Awaited<ReturnType<typeof downloadTermById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTermById<TData = Awaited<ReturnType<typeof downloadTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTermById>>,
          TError,
          Awaited<ReturnType<typeof downloadTermById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTermById<TData = Awaited<ReturnType<typeof downloadTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Faz o download do termo de uso
 */

export function useDownloadTermById<TData = Awaited<ReturnType<typeof downloadTermById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTermById>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadTermByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getLatestTermResponse200 = {
  data: TermsOfUseDto
  status: 200
}

export type getLatestTermResponseSuccess = (getLatestTermResponse200) & {
  headers: Headers;
};
;

export type getLatestTermResponse = (getLatestTermResponseSuccess)

export const getGetLatestTermUrl = (params?: GetLatestTermParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/public/v1/terms/latest?${stringifiedParams}` : `/public/v1/terms/latest`
}

/**
 * @summary Busca o termo de uso mais atual
 */
export const getLatestTerm = async (params?: GetLatestTermParams, options?: RequestInit): Promise<getLatestTermResponse> => {

  return customInstanceBpm<getLatestTermResponse>(getGetLatestTermUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLatestTermQueryKey = (params?: GetLatestTermParams,) => {
    return [
    `/public/v1/terms/latest`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLatestTermQueryOptions = <TData = Awaited<ReturnType<typeof getLatestTerm>>, TError = unknown>(params?: GetLatestTermParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestTermQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestTerm>>> = ({ signal }) => getLatestTerm(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestTermQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestTerm>>>
export type GetLatestTermQueryError = unknown


export function useGetLatestTerm<TData = Awaited<ReturnType<typeof getLatestTerm>>, TError = unknown>(
 params: undefined |  GetLatestTermParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestTerm>>,
          TError,
          Awaited<ReturnType<typeof getLatestTerm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestTerm<TData = Awaited<ReturnType<typeof getLatestTerm>>, TError = unknown>(
 params?: GetLatestTermParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestTerm>>,
          TError,
          Awaited<ReturnType<typeof getLatestTerm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestTerm<TData = Awaited<ReturnType<typeof getLatestTerm>>, TError = unknown>(
 params?: GetLatestTermParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o termo de uso mais atual
 */

export function useGetLatestTerm<TData = Awaited<ReturnType<typeof getLatestTerm>>, TError = unknown>(
 params?: GetLatestTermParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestTerm>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestTermQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getDefaultTenantResponse200 = {
  data: string
  status: 200
}

export type getDefaultTenantResponseSuccess = (getDefaultTenantResponse200) & {
  headers: Headers;
};
;

export type getDefaultTenantResponse = (getDefaultTenantResponseSuccess)

export const getGetDefaultTenantUrl = () => {




  return `/public/v1/server/default-tenant`
}

/**
 * @summary Retorna o tenant default do ambiente
 */
export const getDefaultTenant = async ( options?: RequestInit): Promise<getDefaultTenantResponse> => {

  return customInstanceBpm<getDefaultTenantResponse>(getGetDefaultTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDefaultTenantQueryKey = () => {
    return [
    `/public/v1/server/default-tenant`
    ] as const;
    }


export const getGetDefaultTenantQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultTenant>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultTenantQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultTenant>>> = ({ signal }) => getDefaultTenant({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultTenant>>>
export type GetDefaultTenantQueryError = unknown


export function useGetDefaultTenant<TData = Awaited<ReturnType<typeof getDefaultTenant>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultTenant>>,
          TError,
          Awaited<ReturnType<typeof getDefaultTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultTenant<TData = Awaited<ReturnType<typeof getDefaultTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultTenant>>,
          TError,
          Awaited<ReturnType<typeof getDefaultTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultTenant<TData = Awaited<ReturnType<typeof getDefaultTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna o tenant default do ambiente
 */

export function useGetDefaultTenant<TData = Awaited<ReturnType<typeof getDefaultTenant>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultTenant>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultTenantQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type redirectUrlByNameResponse200 = {
  data: RedirectView
  status: 200
}

export type redirectUrlByNameResponseSuccess = (redirectUrlByNameResponse200) & {
  headers: Headers;
};
;

export type redirectUrlByNameResponse = (redirectUrlByNameResponseSuccess)

export const getRedirectUrlByNameUrl = (service: string,) => {




  return `/public/v1/redirect-manager/${service}`
}

/**
 * @summary Redireciona a chamada para serviços cadastrados
 */
export const redirectUrlByName = async (service: string, options?: RequestInit): Promise<redirectUrlByNameResponse> => {

  return customInstanceBpm<redirectUrlByNameResponse>(getRedirectUrlByNameUrl(service),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRedirectUrlByNameQueryKey = (service: string,) => {
    return [
    `/public/v1/redirect-manager/${service}`
    ] as const;
    }


export const getRedirectUrlByNameQueryOptions = <TData = Awaited<ReturnType<typeof redirectUrlByName>>, TError = unknown>(service: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRedirectUrlByNameQueryKey(service);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof redirectUrlByName>>> = ({ signal }) => redirectUrlByName(service, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: service !== null && service !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RedirectUrlByNameQueryResult = NonNullable<Awaited<ReturnType<typeof redirectUrlByName>>>
export type RedirectUrlByNameQueryError = unknown


export function useRedirectUrlByName<TData = Awaited<ReturnType<typeof redirectUrlByName>>, TError = unknown>(
 service: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectUrlByName>>,
          TError,
          Awaited<ReturnType<typeof redirectUrlByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectUrlByName<TData = Awaited<ReturnType<typeof redirectUrlByName>>, TError = unknown>(
 service: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof redirectUrlByName>>,
          TError,
          Awaited<ReturnType<typeof redirectUrlByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRedirectUrlByName<TData = Awaited<ReturnType<typeof redirectUrlByName>>, TError = unknown>(
 service: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redireciona a chamada para serviços cadastrados
 */

export function useRedirectUrlByName<TData = Awaited<ReturnType<typeof redirectUrlByName>>, TError = unknown>(
 service: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof redirectUrlByName>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRedirectUrlByNameQueryOptions(service,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type validateProcessPublicLinkResponse204 = {
  data: void
  status: 204
}

export type validateProcessPublicLinkResponseSuccess = (validateProcessPublicLinkResponse204) & {
  headers: Headers;
};
;

export type validateProcessPublicLinkResponse = (validateProcessPublicLinkResponseSuccess)

export const getValidateProcessPublicLinkUrl = (linkCode: string,) => {




  return `/public/v1/process-definitions/link/${linkCode}/validate`
}

/**
 * @summary Verifica se o link público é valido
 */
export const validateProcessPublicLink = async (linkCode: string, options?: RequestInit): Promise<validateProcessPublicLinkResponse> => {

  return customInstanceBpm<validateProcessPublicLinkResponse>(getValidateProcessPublicLinkUrl(linkCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getValidateProcessPublicLinkQueryKey = (linkCode: string,) => {
    return [
    `/public/v1/process-definitions/link/${linkCode}/validate`
    ] as const;
    }


export const getValidateProcessPublicLinkQueryOptions = <TData = Awaited<ReturnType<typeof validateProcessPublicLink>>, TError = unknown>(linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateProcessPublicLinkQueryKey(linkCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateProcessPublicLink>>> = ({ signal }) => validateProcessPublicLink(linkCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: linkCode !== null && linkCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ValidateProcessPublicLinkQueryResult = NonNullable<Awaited<ReturnType<typeof validateProcessPublicLink>>>
export type ValidateProcessPublicLinkQueryError = unknown


export function useValidateProcessPublicLink<TData = Awaited<ReturnType<typeof validateProcessPublicLink>>, TError = unknown>(
 linkCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateProcessPublicLink>>,
          TError,
          Awaited<ReturnType<typeof validateProcessPublicLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateProcessPublicLink<TData = Awaited<ReturnType<typeof validateProcessPublicLink>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateProcessPublicLink>>,
          TError,
          Awaited<ReturnType<typeof validateProcessPublicLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateProcessPublicLink<TData = Awaited<ReturnType<typeof validateProcessPublicLink>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Verifica se o link público é valido
 */

export function useValidateProcessPublicLink<TData = Awaited<ReturnType<typeof validateProcessPublicLink>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateProcessPublicLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateProcessPublicLinkQueryOptions(linkCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getPublicStartFormFieldsResponse200 = {
  data: FormSmartDto
  status: 200
}

export type getPublicStartFormFieldsResponseSuccess = (getPublicStartFormFieldsResponse200) & {
  headers: Headers;
};
;

export type getPublicStartFormFieldsResponse = (getPublicStartFormFieldsResponseSuccess)

export const getGetPublicStartFormFieldsUrl = (linkCode: string,) => {




  return `/public/v1/forms/start-form/link/${linkCode}`
}

/**
 * @summary Retorna os campos do formulário de inicio do processo com as propriedades do form builder utilizando o link publico
 */
export const getPublicStartFormFields = async (linkCode: string, options?: RequestInit): Promise<getPublicStartFormFieldsResponse> => {

  return customInstanceBpm<getPublicStartFormFieldsResponse>(getGetPublicStartFormFieldsUrl(linkCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicStartFormFieldsQueryKey = (linkCode: string,) => {
    return [
    `/public/v1/forms/start-form/link/${linkCode}`
    ] as const;
    }


export const getGetPublicStartFormFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicStartFormFields>>, TError = unknown>(linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicStartFormFieldsQueryKey(linkCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicStartFormFields>>> = ({ signal }) => getPublicStartFormFields(linkCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: linkCode !== null && linkCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicStartFormFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicStartFormFields>>>
export type GetPublicStartFormFieldsQueryError = unknown


export function useGetPublicStartFormFields<TData = Awaited<ReturnType<typeof getPublicStartFormFields>>, TError = unknown>(
 linkCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStartFormFields>>,
          TError,
          Awaited<ReturnType<typeof getPublicStartFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStartFormFields<TData = Awaited<ReturnType<typeof getPublicStartFormFields>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStartFormFields>>,
          TError,
          Awaited<ReturnType<typeof getPublicStartFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStartFormFields<TData = Awaited<ReturnType<typeof getPublicStartFormFields>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna os campos do formulário de inicio do processo com as propriedades do form builder utilizando o link publico
 */

export function useGetPublicStartFormFields<TData = Awaited<ReturnType<typeof getPublicStartFormFields>>, TError = unknown>(
 linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicStartFormFieldsQueryOptions(linkCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listAllPublicDataListRowResponse200 = {
  data: DataListRowPageSwagger
  status: 200
}

export type listAllPublicDataListRowResponseSuccess = (listAllPublicDataListRowResponse200) & {
  headers: Headers;
};
;

export type listAllPublicDataListRowResponse = (listAllPublicDataListRowResponseSuccess)

export const getListAllPublicDataListRowUrl = (dataListId: string,
    linkCode: string,) => {




  return `/public/v1/data-list/${dataListId}/items/link/${linkCode}/all`
}

/**
 * @summary Lista os itens ativos da listas de dados pelo link publico
 */
export const listAllPublicDataListRow = async (dataListId: string,
    linkCode: string, options?: RequestInit): Promise<listAllPublicDataListRowResponse> => {

  return customInstanceBpm<listAllPublicDataListRowResponse>(getListAllPublicDataListRowUrl(dataListId,linkCode),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllPublicDataListRowQueryKey = (dataListId: string,
    linkCode: string,) => {
    return [
    `/public/v1/data-list/${dataListId}/items/link/${linkCode}/all`
    ] as const;
    }


export const getListAllPublicDataListRowQueryOptions = <TData = Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError = unknown>(dataListId: string,
    linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllPublicDataListRowQueryKey(dataListId,linkCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllPublicDataListRow>>> = ({ signal }) => listAllPublicDataListRow(dataListId,linkCode, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: dataListId !== null && dataListId !== undefined && linkCode !== null && linkCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllPublicDataListRowQueryResult = NonNullable<Awaited<ReturnType<typeof listAllPublicDataListRow>>>
export type ListAllPublicDataListRowQueryError = unknown


export function useListAllPublicDataListRow<TData = Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError = unknown>(
 dataListId: string,
    linkCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllPublicDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listAllPublicDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllPublicDataListRow<TData = Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError = unknown>(
 dataListId: string,
    linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllPublicDataListRow>>,
          TError,
          Awaited<ReturnType<typeof listAllPublicDataListRow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllPublicDataListRow<TData = Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError = unknown>(
 dataListId: string,
    linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os itens ativos da listas de dados pelo link publico
 */

export function useListAllPublicDataListRow<TData = Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError = unknown>(
 dataListId: string,
    linkCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllPublicDataListRow>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllPublicDataListRowQueryOptions(dataListId,linkCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type findTemplateExternalLinkResponse404 = {
  data: Problem
  status: 404
}

;
export type findTemplateExternalLinkResponseError = (findTemplateExternalLinkResponse404) & {
  headers: Headers;
};

export type findTemplateExternalLinkResponse = (findTemplateExternalLinkResponseError)

export const getFindTemplateExternalLinkUrl = (tenant: string,
    templateId: number,
    externalLinkId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/external-links/${externalLinkId}`
}

/**
 * @summary Busca o vinculo externo do template por ID
 */
export const findTemplateExternalLink = async (tenant: string,
    templateId: number,
    externalLinkId: number, options?: RequestInit): Promise<findTemplateExternalLinkResponse> => {

  return customInstanceBpm<findTemplateExternalLinkResponse>(getFindTemplateExternalLinkUrl(tenant,templateId,externalLinkId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindTemplateExternalLinkQueryKey = (tenant: string,
    templateId: number,
    externalLinkId: number,) => {
    return [
    `/documents/rest/${tenant}/templates/${templateId}/external-links/${externalLinkId}`
    ] as const;
    }


export const getFindTemplateExternalLinkQueryOptions = <TData = Awaited<ReturnType<typeof findTemplateExternalLink>>, TError = Problem>(tenant: string,
    templateId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTemplateExternalLinkQueryKey(tenant,templateId,externalLinkId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTemplateExternalLink>>> = ({ signal }) => findTemplateExternalLink(tenant,templateId,externalLinkId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && templateId !== null && templateId !== undefined && externalLinkId !== null && externalLinkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTemplateExternalLinkQueryResult = NonNullable<Awaited<ReturnType<typeof findTemplateExternalLink>>>
export type FindTemplateExternalLinkQueryError = Problem


export function useFindTemplateExternalLink<TData = Awaited<ReturnType<typeof findTemplateExternalLink>>, TError = Problem>(
 tenant: string,
    templateId: number,
    externalLinkId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTemplateExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findTemplateExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTemplateExternalLink<TData = Awaited<ReturnType<typeof findTemplateExternalLink>>, TError = Problem>(
 tenant: string,
    templateId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTemplateExternalLink>>,
          TError,
          Awaited<ReturnType<typeof findTemplateExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTemplateExternalLink<TData = Awaited<ReturnType<typeof findTemplateExternalLink>>, TError = Problem>(
 tenant: string,
    templateId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca o vinculo externo do template por ID
 */

export function useFindTemplateExternalLink<TData = Awaited<ReturnType<typeof findTemplateExternalLink>>, TError = Problem>(
 tenant: string,
    templateId: number,
    externalLinkId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTemplateExternalLinkQueryOptions(tenant,templateId,externalLinkId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteTemplateExternalLinkResponse204 = {
  data: void
  status: 204
}

export type deleteTemplateExternalLinkResponse404 = {
  data: Problem
  status: 404
}

export type deleteTemplateExternalLinkResponseSuccess = (deleteTemplateExternalLinkResponse204) & {
  headers: Headers;
};
export type deleteTemplateExternalLinkResponseError = (deleteTemplateExternalLinkResponse404) & {
  headers: Headers;
};

export type deleteTemplateExternalLinkResponse = (deleteTemplateExternalLinkResponseSuccess | deleteTemplateExternalLinkResponseError)

export const getDeleteTemplateExternalLinkUrl = (tenant: string,
    templateId: number,
    externalLinkId: number,) => {




  return `/documents/rest/${tenant}/templates/${templateId}/external-links/${externalLinkId}`
}

/**
 * @summary Remove o vinculo externo do template por ID
 */
export const deleteTemplateExternalLink = async (tenant: string,
    templateId: number,
    externalLinkId: number, options?: RequestInit): Promise<deleteTemplateExternalLinkResponse> => {

  return customInstanceBpm<deleteTemplateExternalLinkResponse>(getDeleteTemplateExternalLinkUrl(tenant,templateId,externalLinkId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTemplateExternalLinkMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateExternalLink>>, TError,{tenant: string;templateId: number;externalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateExternalLink>>, TError,{tenant: string;templateId: number;externalLinkId: number}, TContext> => {

const mutationKey = ['deleteTemplateExternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplateExternalLink>>, {tenant: string;templateId: number;externalLinkId: number}> = (props) => {
          const {tenant,templateId,externalLinkId} = props ?? {};

          return  deleteTemplateExternalLink(tenant,templateId,externalLinkId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateExternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplateExternalLink>>>

    export type DeleteTemplateExternalLinkMutationError = Problem

    /**
 * @summary Remove o vinculo externo do template por ID
 */
export const useDeleteTemplateExternalLink = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateExternalLink>>, TError,{tenant: string;templateId: number;externalLinkId: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplateExternalLink>>,
        TError,
        {tenant: string;templateId: number;externalLinkId: number},
        TContext
      > => {
      return useMutation(getDeleteTemplateExternalLinkMutationOptions(options), queryClient);
    }

export type listTemplateExternalLinkResponse200 = {
  data: PageTemplateExternalLinkDto
  status: 200
}

export type listTemplateExternalLinkResponseSuccess = (listTemplateExternalLinkResponse200) & {
  headers: Headers;
};
;

export type listTemplateExternalLinkResponse = (listTemplateExternalLinkResponseSuccess)

export const getListTemplateExternalLinkUrl = (tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/rest/${tenant}/templates/${templateId}/external-links?${stringifiedParams}` : `/documents/rest/${tenant}/templates/${templateId}/external-links`
}

/**
 * @summary Lista os vinculos externos do template
 */
export const listTemplateExternalLink = async (tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams, options?: RequestInit): Promise<listTemplateExternalLinkResponse> => {

  return customInstanceBpm<listTemplateExternalLinkResponse>(getListTemplateExternalLinkUrl(tenant,templateId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateExternalLinkQueryKey = (tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams,) => {
    return [
    `/documents/rest/${tenant}/templates/${templateId}/external-links`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplateExternalLinkQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateExternalLink>>, TError = unknown>(tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateExternalLinkQueryKey(tenant,templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateExternalLink>>> = ({ signal }) => listTemplateExternalLink(tenant,templateId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateExternalLinkQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateExternalLink>>>
export type ListTemplateExternalLinkQueryError = unknown


export function useListTemplateExternalLink<TData = Awaited<ReturnType<typeof listTemplateExternalLink>>, TError = unknown>(
 tenant: string,
    templateId: number,
    params: undefined |  ListTemplateExternalLinkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateExternalLink>>,
          TError,
          Awaited<ReturnType<typeof listTemplateExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateExternalLink<TData = Awaited<ReturnType<typeof listTemplateExternalLink>>, TError = unknown>(
 tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateExternalLink>>,
          TError,
          Awaited<ReturnType<typeof listTemplateExternalLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateExternalLink<TData = Awaited<ReturnType<typeof listTemplateExternalLink>>, TError = unknown>(
 tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os vinculos externos do template
 */

export function useListTemplateExternalLink<TData = Awaited<ReturnType<typeof listTemplateExternalLink>>, TError = unknown>(
 tenant: string,
    templateId: number,
    params?: ListTemplateExternalLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateExternalLink>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateExternalLinkQueryOptions(tenant,templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listTemplateVersionsByCodeResponse200 = {
  data: TemplateDto[]
  status: 200
}

export type listTemplateVersionsByCodeResponse404 = {
  data: Problem
  status: 404
}

export type listTemplateVersionsByCodeResponseSuccess = (listTemplateVersionsByCodeResponse200) & {
  headers: Headers;
};
export type listTemplateVersionsByCodeResponseError = (listTemplateVersionsByCodeResponse404) & {
  headers: Headers;
};

export type listTemplateVersionsByCodeResponse = (listTemplateVersionsByCodeResponseSuccess | listTemplateVersionsByCodeResponseError)

export const getListTemplateVersionsByCodeUrl = (tenant: string,
    code: string,) => {




  return `/documents/rest/${tenant}/templates/code/${code}/versions`
}

/**
 * @summary Lista todas as versões de um template pelo seu código
 */
export const listTemplateVersionsByCode = async (tenant: string,
    code: string, options?: RequestInit): Promise<listTemplateVersionsByCodeResponse> => {

  return customInstanceBpm<listTemplateVersionsByCodeResponse>(getListTemplateVersionsByCodeUrl(tenant,code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateVersionsByCodeQueryKey = (tenant: string,
    code: string,) => {
    return [
    `/documents/rest/${tenant}/templates/code/${code}/versions`
    ] as const;
    }


export const getListTemplateVersionsByCodeQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError = Problem>(tenant: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateVersionsByCodeQueryKey(tenant,code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateVersionsByCode>>> = ({ signal }) => listTemplateVersionsByCode(tenant,code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenant !== null && tenant !== undefined && code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateVersionsByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateVersionsByCode>>>
export type ListTemplateVersionsByCodeQueryError = Problem


export function useListTemplateVersionsByCode<TData = Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError = Problem>(
 tenant: string,
    code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateVersionsByCode>>,
          TError,
          Awaited<ReturnType<typeof listTemplateVersionsByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateVersionsByCode<TData = Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError = Problem>(
 tenant: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateVersionsByCode>>,
          TError,
          Awaited<ReturnType<typeof listTemplateVersionsByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateVersionsByCode<TData = Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError = Problem>(
 tenant: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todas as versões de um template pelo seu código
 */

export function useListTemplateVersionsByCode<TData = Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError = Problem>(
 tenant: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateVersionsByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateVersionsByCodeQueryOptions(tenant,code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getPendingDocumentsSyntheticListResponse200 = {
  data: PendingDocumentSyntheticDto[]
  status: 200
}

export type getPendingDocumentsSyntheticListResponseSuccess = (getPendingDocumentsSyntheticListResponse200) & {
  headers: Headers;
};
;

export type getPendingDocumentsSyntheticListResponse = (getPendingDocumentsSyntheticListResponseSuccess)

export const getGetPendingDocumentsSyntheticListUrl = () => {




  return `/documents/rest/pending-documental/synthetic`
}

/**
 * @summary Lista as pendências documentais
 */
export const getPendingDocumentsSyntheticList = async ( options?: RequestInit): Promise<getPendingDocumentsSyntheticListResponse> => {

  return customInstanceBpm<getPendingDocumentsSyntheticListResponse>(getGetPendingDocumentsSyntheticListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPendingDocumentsSyntheticListQueryKey = () => {
    return [
    `/documents/rest/pending-documental/synthetic`
    ] as const;
    }


export const getGetPendingDocumentsSyntheticListQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDocumentsSyntheticListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>> = ({ signal }) => getPendingDocumentsSyntheticList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingDocumentsSyntheticListQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>>
export type GetPendingDocumentsSyntheticListQueryError = unknown


export function useGetPendingDocumentsSyntheticList<TData = Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>,
          TError,
          Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDocumentsSyntheticList<TData = Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>,
          TError,
          Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDocumentsSyntheticList<TData = Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as pendências documentais
 */

export function useGetPendingDocumentsSyntheticList<TData = Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentsSyntheticList>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingDocumentsSyntheticListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getPendingDocumentAnalyticalResponse200 = {
  data: AnalyticalPendingDocumentDto
  status: 200
}

export type getPendingDocumentAnalyticalResponseSuccess = (getPendingDocumentAnalyticalResponse200) & {
  headers: Headers;
};
;

export type getPendingDocumentAnalyticalResponse = (getPendingDocumentAnalyticalResponseSuccess)

export const getGetPendingDocumentAnalyticalUrl = (id: number,) => {




  return `/documents/rest/pending-documental/analytical/${id}`
}

/**
 * @summary Busca pendência documental por ID
 */
export const getPendingDocumentAnalytical = async (id: number, options?: RequestInit): Promise<getPendingDocumentAnalyticalResponse> => {

  return customInstanceBpm<getPendingDocumentAnalyticalResponse>(getGetPendingDocumentAnalyticalUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPendingDocumentAnalyticalQueryKey = (id: number,) => {
    return [
    `/documents/rest/pending-documental/analytical/${id}`
    ] as const;
    }


export const getGetPendingDocumentAnalyticalQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDocumentAnalyticalQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>> = ({ signal }) => getPendingDocumentAnalytical(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingDocumentAnalyticalQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>>
export type GetPendingDocumentAnalyticalQueryError = unknown


export function useGetPendingDocumentAnalytical<TData = Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDocumentAnalytical>>,
          TError,
          Awaited<ReturnType<typeof getPendingDocumentAnalytical>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDocumentAnalytical<TData = Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDocumentAnalytical>>,
          TError,
          Awaited<ReturnType<typeof getPendingDocumentAnalytical>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingDocumentAnalytical<TData = Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca pendência documental por ID
 */

export function useGetPendingDocumentAnalytical<TData = Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDocumentAnalytical>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingDocumentAnalyticalQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getTaskFormFieldsResponse200 = {
  data: FormSmartDto
  status: 200
}

export type getTaskFormFieldsResponseSuccess = (getTaskFormFieldsResponse200) & {
  headers: Headers;
};
;

export type getTaskFormFieldsResponse = (getTaskFormFieldsResponseSuccess)

export const getGetTaskFormFieldsUrl = (taskId: string,) => {




  return `/api/v1/forms/task-form/${taskId}`
}

/**
 * @summary Retorna os campos do formulário da atividade do processo com as propriedades do form builder
 */
export const getTaskFormFields = async (taskId: string, options?: RequestInit): Promise<getTaskFormFieldsResponse> => {

  return customInstanceBpm<getTaskFormFieldsResponse>(getGetTaskFormFieldsUrl(taskId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskFormFieldsQueryKey = (taskId: string,) => {
    return [
    `/api/v1/forms/task-form/${taskId}`
    ] as const;
    }


export const getGetTaskFormFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskFormFields>>, TError = unknown>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskFormFieldsQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskFormFields>>> = ({ signal }) => getTaskFormFields(taskId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskFormFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskFormFields>>>
export type GetTaskFormFieldsQueryError = unknown


export function useGetTaskFormFields<TData = Awaited<ReturnType<typeof getTaskFormFields>>, TError = unknown>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFormFields>>,
          TError,
          Awaited<ReturnType<typeof getTaskFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFormFields<TData = Awaited<ReturnType<typeof getTaskFormFields>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFormFields>>,
          TError,
          Awaited<ReturnType<typeof getTaskFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFormFields<TData = Awaited<ReturnType<typeof getTaskFormFields>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna os campos do formulário da atividade do processo com as propriedades do form builder
 */

export function useGetTaskFormFields<TData = Awaited<ReturnType<typeof getTaskFormFields>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskFormFieldsQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getStartFormFieldsResponse200 = {
  data: FormSmartDto
  status: 200
}

export type getStartFormFieldsResponseSuccess = (getStartFormFieldsResponse200) & {
  headers: Headers;
};
;

export type getStartFormFieldsResponse = (getStartFormFieldsResponseSuccess)

export const getGetStartFormFieldsUrl = (processDefinitionId: string,) => {




  return `/api/v1/forms/start-form/${processDefinitionId}`
}

/**
 * @summary Retorna os campos do formulário de inicio do processo com as propriedades do form builder
 */
export const getStartFormFields = async (processDefinitionId: string, options?: RequestInit): Promise<getStartFormFieldsResponse> => {

  return customInstanceBpm<getStartFormFieldsResponse>(getGetStartFormFieldsUrl(processDefinitionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStartFormFieldsQueryKey = (processDefinitionId: string,) => {
    return [
    `/api/v1/forms/start-form/${processDefinitionId}`
    ] as const;
    }


export const getGetStartFormFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getStartFormFields>>, TError = unknown>(processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStartFormFieldsQueryKey(processDefinitionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStartFormFields>>> = ({ signal }) => getStartFormFields(processDefinitionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: processDefinitionId !== null && processDefinitionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStartFormFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getStartFormFields>>>
export type GetStartFormFieldsQueryError = unknown


export function useGetStartFormFields<TData = Awaited<ReturnType<typeof getStartFormFields>>, TError = unknown>(
 processDefinitionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStartFormFields>>,
          TError,
          Awaited<ReturnType<typeof getStartFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStartFormFields<TData = Awaited<ReturnType<typeof getStartFormFields>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStartFormFields>>,
          TError,
          Awaited<ReturnType<typeof getStartFormFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStartFormFields<TData = Awaited<ReturnType<typeof getStartFormFields>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna os campos do formulário de inicio do processo com as propriedades do form builder
 */

export function useGetStartFormFields<TData = Awaited<ReturnType<typeof getStartFormFields>>, TError = unknown>(
 processDefinitionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStartFormFields>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStartFormFieldsQueryOptions(processDefinitionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getOrganizationDashboardResponse200 = {
  data: OrganizationConsolidatedDashboardDto
  status: 200
}

export type getOrganizationDashboardResponseSuccess = (getOrganizationDashboardResponse200) & {
  headers: Headers;
};
;

export type getOrganizationDashboardResponse = (getOrganizationDashboardResponseSuccess)

export const getGetOrganizationDashboardUrl = (params: GetOrganizationDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/administrative/organization-dashboard?${stringifiedParams}` : `/administrative/organization-dashboard`
}

/**
 * @summary Pesquisa indicadores consolidados por organizacao
 */
export const getOrganizationDashboard = async (params: GetOrganizationDashboardParams, options?: RequestInit): Promise<getOrganizationDashboardResponse> => {

  return customInstanceBpm<getOrganizationDashboardResponse>(getGetOrganizationDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationDashboardQueryKey = (params?: GetOrganizationDashboardParams,) => {
    return [
    `/administrative/organization-dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDashboard>>, TError = unknown>(params: GetOrganizationDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDashboard>>> = ({ signal }) => getOrganizationDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDashboard>>>
export type GetOrganizationDashboardQueryError = unknown


export function useGetOrganizationDashboard<TData = Awaited<ReturnType<typeof getOrganizationDashboard>>, TError = unknown>(
 params: GetOrganizationDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDashboard>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDashboard<TData = Awaited<ReturnType<typeof getOrganizationDashboard>>, TError = unknown>(
 params: GetOrganizationDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDashboard>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDashboard<TData = Awaited<ReturnType<typeof getOrganizationDashboard>>, TError = unknown>(
 params: GetOrganizationDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pesquisa indicadores consolidados por organizacao
 */

export function useGetOrganizationDashboard<TData = Awaited<ReturnType<typeof getOrganizationDashboard>>, TError = unknown>(
 params: GetOrganizationDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getOrganizationDashboardUsersResponse200 = {
  data: OrganizationDashboardUsersDto
  status: 200
}

export type getOrganizationDashboardUsersResponseSuccess = (getOrganizationDashboardUsersResponse200) & {
  headers: Headers;
};
;

export type getOrganizationDashboardUsersResponse = (getOrganizationDashboardUsersResponseSuccess)

export const getGetOrganizationDashboardUsersUrl = (organizationKey: string,
    params: GetOrganizationDashboardUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/administrative/organization-dashboard/${organizationKey}/users?${stringifiedParams}` : `/administrative/organization-dashboard/${organizationKey}/users`
}

/**
 * @summary Pesquisa indicadores por usuario de uma organizacao
 */
export const getOrganizationDashboardUsers = async (organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options?: RequestInit): Promise<getOrganizationDashboardUsersResponse> => {

  return customInstanceBpm<getOrganizationDashboardUsersResponse>(getGetOrganizationDashboardUsersUrl(organizationKey,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationDashboardUsersQueryKey = (organizationKey: string,
    params?: GetOrganizationDashboardUsersParams,) => {
    return [
    `/administrative/organization-dashboard/${organizationKey}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationDashboardUsersQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError = unknown>(organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDashboardUsersQueryKey(organizationKey,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>> = ({ signal }) => getOrganizationDashboardUsers(organizationKey,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: organizationKey !== null && organizationKey !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDashboardUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>>
export type GetOrganizationDashboardUsersQueryError = unknown


export function useGetOrganizationDashboardUsers<TData = Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError = unknown>(
 organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDashboardUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDashboardUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDashboardUsers<TData = Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError = unknown>(
 organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDashboardUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDashboardUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDashboardUsers<TData = Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError = unknown>(
 organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pesquisa indicadores por usuario de uma organizacao
 */

export function useGetOrganizationDashboardUsers<TData = Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError = unknown>(
 organizationKey: string,
    params: GetOrganizationDashboardUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDashboardUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDashboardUsersQueryOptions(organizationKey,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAdministrativeDashboardResponse200 = {
  data: AdministrativeDashboardDto
  status: 200
}

export type getAdministrativeDashboardResponseSuccess = (getAdministrativeDashboardResponse200) & {
  headers: Headers;
};
;

export type getAdministrativeDashboardResponse = (getAdministrativeDashboardResponseSuccess)

export const getGetAdministrativeDashboardUrl = (params: GetAdministrativeDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/administrative/dashboard?${stringifiedParams}` : `/administrative/dashboard`
}

/**
 * @summary Pesquisa informações de uso da plataforma por periodo
 */
export const getAdministrativeDashboard = async (params: GetAdministrativeDashboardParams, options?: RequestInit): Promise<getAdministrativeDashboardResponse> => {

  return customInstanceBpm<getAdministrativeDashboardResponse>(getGetAdministrativeDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdministrativeDashboardQueryKey = (params?: GetAdministrativeDashboardParams,) => {
    return [
    `/administrative/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdministrativeDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError = unknown>(params: GetAdministrativeDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdministrativeDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdministrativeDashboard>>> = ({ signal }) => getAdministrativeDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdministrativeDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdministrativeDashboard>>>
export type GetAdministrativeDashboardQueryError = unknown


export function useGetAdministrativeDashboard<TData = Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError = unknown>(
 params: GetAdministrativeDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdministrativeDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAdministrativeDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdministrativeDashboard<TData = Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError = unknown>(
 params: GetAdministrativeDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdministrativeDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAdministrativeDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdministrativeDashboard<TData = Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError = unknown>(
 params: GetAdministrativeDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pesquisa informações de uso da plataforma por periodo
 */

export function useGetAdministrativeDashboard<TData = Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError = unknown>(
 params: GetAdministrativeDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdministrativeDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdministrativeDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getConfirmationLinkByCodeResponse404 = {
  data: Problem
  status: 404
}

;
export type getConfirmationLinkByCodeResponseError = (getConfirmationLinkByCodeResponse404) & {
  headers: Headers;
};

export type getConfirmationLinkByCodeResponse = (getConfirmationLinkByCodeResponseError)

export const getGetConfirmationLinkByCodeUrl = (params: GetConfirmationLinkByCodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account/confirm?${stringifiedParams}` : `/account/confirm`
}

/**
 * @summary Retorna link de confirmação de conta pelo código
 */
export const getConfirmationLinkByCode = async (params: GetConfirmationLinkByCodeParams, options?: RequestInit): Promise<getConfirmationLinkByCodeResponse> => {

  return customInstanceBpm<getConfirmationLinkByCodeResponse>(getGetConfirmationLinkByCodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConfirmationLinkByCodeQueryKey = (params?: GetConfirmationLinkByCodeParams,) => {
    return [
    `/account/confirm`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConfirmationLinkByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError = Problem>(params: GetConfirmationLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfirmationLinkByCodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfirmationLinkByCode>>> = ({ signal }) => getConfirmationLinkByCode(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfirmationLinkByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getConfirmationLinkByCode>>>
export type GetConfirmationLinkByCodeQueryError = Problem


export function useGetConfirmationLinkByCode<TData = Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError = Problem>(
 params: GetConfirmationLinkByCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfirmationLinkByCode>>,
          TError,
          Awaited<ReturnType<typeof getConfirmationLinkByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfirmationLinkByCode<TData = Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError = Problem>(
 params: GetConfirmationLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfirmationLinkByCode>>,
          TError,
          Awaited<ReturnType<typeof getConfirmationLinkByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfirmationLinkByCode<TData = Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError = Problem>(
 params: GetConfirmationLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna link de confirmação de conta pelo código
 */

export function useGetConfirmationLinkByCode<TData = Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError = Problem>(
 params: GetConfirmationLinkByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfirmationLinkByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfirmationLinkByCodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteProcessDefinitionByIdResponse204 = {
  data: void
  status: 204
}

export type deleteProcessDefinitionByIdResponse404 = {
  data: Problem
  status: 404
}

export type deleteProcessDefinitionByIdResponseSuccess = (deleteProcessDefinitionByIdResponse204) & {
  headers: Headers;
};
export type deleteProcessDefinitionByIdResponseError = (deleteProcessDefinitionByIdResponse404) & {
  headers: Headers;
};

export type deleteProcessDefinitionByIdResponse = (deleteProcessDefinitionByIdResponseSuccess | deleteProcessDefinitionByIdResponseError)

export const getDeleteProcessDefinitionByIdUrl = (tenant: string,
    processDefinitionId: string,
    params?: DeleteProcessDefinitionByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/process-definitions/${processDefinitionId}?${stringifiedParams}` : `/v1/${tenant}/process-definitions/${processDefinitionId}`
}

/**
 * @summary Remove definição do processo por ID
 */
export const deleteProcessDefinitionById = async (tenant: string,
    processDefinitionId: string,
    params?: DeleteProcessDefinitionByIdParams, options?: RequestInit): Promise<deleteProcessDefinitionByIdResponse> => {

  return customInstanceBpm<deleteProcessDefinitionByIdResponse>(getDeleteProcessDefinitionByIdUrl(tenant,processDefinitionId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProcessDefinitionByIdMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DeleteProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DeleteProcessDefinitionByIdParams}, TContext> => {

const mutationKey = ['deleteProcessDefinitionById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProcessDefinitionById>>, {tenant: string;processDefinitionId: string;params?: DeleteProcessDefinitionByIdParams}> = (props) => {
          const {tenant,processDefinitionId,params} = props ?? {};

          return  deleteProcessDefinitionById(tenant,processDefinitionId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProcessDefinitionByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProcessDefinitionById>>>

    export type DeleteProcessDefinitionByIdMutationError = Problem

    /**
 * @summary Remove definição do processo por ID
 */
export const useDeleteProcessDefinitionById = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcessDefinitionById>>, TError,{tenant: string;processDefinitionId: string;params?: DeleteProcessDefinitionByIdParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProcessDefinitionById>>,
        TError,
        {tenant: string;processDefinitionId: string;params?: DeleteProcessDefinitionByIdParams},
        TContext
      > => {
      return useMutation(getDeleteProcessDefinitionByIdMutationOptions(options), queryClient);
    }

export type deleteNotificationCenterResponse204 = {
  data: void
  status: 204
}

export type deleteNotificationCenterResponseSuccess = (deleteNotificationCenterResponse204) & {
  headers: Headers;
};
;

export type deleteNotificationCenterResponse = (deleteNotificationCenterResponseSuccess)

export const getDeleteNotificationCenterUrl = (tenant: string,
    id: number,) => {




  return `/v1/${tenant}/notification-center/notifications/${id}`
}

/**
 * @summary Exclui notificacao para o usuario logado
 */
export const deleteNotificationCenter = async (tenant: string,
    id: number, options?: RequestInit): Promise<deleteNotificationCenterResponse> => {

  return customInstanceBpm<deleteNotificationCenterResponse>(getDeleteNotificationCenterUrl(tenant,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteNotificationCenterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationCenter>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationCenter>>, TError,{tenant: string;id: number}, TContext> => {

const mutationKey = ['deleteNotificationCenter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotificationCenter>>, {tenant: string;id: number}> = (props) => {
          const {tenant,id} = props ?? {};

          return  deleteNotificationCenter(tenant,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationCenterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotificationCenter>>>

    export type DeleteNotificationCenterMutationError = unknown

    /**
 * @summary Exclui notificacao para o usuario logado
 */
export const useDeleteNotificationCenter = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationCenter>>, TError,{tenant: string;id: number}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotificationCenter>>,
        TError,
        {tenant: string;id: number},
        TContext
      > => {
      return useMutation(getDeleteNotificationCenterMutationOptions(options), queryClient);
    }

export type disableDataListRowResponse204 = {
  data: void
  status: 204
}

export type disableDataListRowResponse404 = {
  data: Problem
  status: 404
}

export type disableDataListRowResponseSuccess = (disableDataListRowResponse204) & {
  headers: Headers;
};
export type disableDataListRowResponseError = (disableDataListRowResponse404) & {
  headers: Headers;
};

export type disableDataListRowResponse = (disableDataListRowResponseSuccess | disableDataListRowResponseError)

export const getDisableDataListRowUrl = (tenant: string,
    dataListId: string,
    itemId: string,) => {




  return `/v1/${tenant}/data-list/${dataListId}/items/${itemId}/deactivate`
}

/**
 * @summary Desativa um item da lista de dados por ID
 */
export const disableDataListRow = async (tenant: string,
    dataListId: string,
    itemId: string, options?: RequestInit): Promise<disableDataListRowResponse> => {

  return customInstanceBpm<disableDataListRowResponse>(getDisableDataListRowUrl(tenant,dataListId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableDataListRowMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext> => {

const mutationKey = ['disableDataListRow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableDataListRow>>, {tenant: string;dataListId: string;itemId: string}> = (props) => {
          const {tenant,dataListId,itemId} = props ?? {};

          return  disableDataListRow(tenant,dataListId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableDataListRowMutationResult = NonNullable<Awaited<ReturnType<typeof disableDataListRow>>>

    export type DisableDataListRowMutationError = Problem

    /**
 * @summary Desativa um item da lista de dados por ID
 */
export const useDisableDataListRow = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableDataListRow>>, TError,{tenant: string;dataListId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableDataListRow>>,
        TError,
        {tenant: string;dataListId: string;itemId: string},
        TContext
      > => {
      return useMutation(getDisableDataListRowMutationOptions(options), queryClient);
    }

export type disableDataListResponse204 = {
  data: void
  status: 204
}

export type disableDataListResponse404 = {
  data: Problem
  status: 404
}

export type disableDataListResponseSuccess = (disableDataListResponse204) & {
  headers: Headers;
};
export type disableDataListResponseError = (disableDataListResponse404) & {
  headers: Headers;
};

export type disableDataListResponse = (disableDataListResponseSuccess | disableDataListResponseError)

export const getDisableDataListUrl = (tenant: string,
    dataListId: string,
    params?: DisableDataListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/${tenant}/data-list/${dataListId}/deactivate?${stringifiedParams}` : `/v1/${tenant}/data-list/${dataListId}/deactivate`
}

/**
 * @summary Desativa uma lista de dados por ID
 */
export const disableDataList = async (tenant: string,
    dataListId: string,
    params?: DisableDataListParams, options?: RequestInit): Promise<disableDataListResponse> => {

  return customInstanceBpm<disableDataListResponse>(getDisableDataListUrl(tenant,dataListId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisableDataListMutationOptions = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableDataList>>, TError,{tenant: string;dataListId: string;params?: DisableDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof disableDataList>>, TError,{tenant: string;dataListId: string;params?: DisableDataListParams}, TContext> => {

const mutationKey = ['disableDataList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableDataList>>, {tenant: string;dataListId: string;params?: DisableDataListParams}> = (props) => {
          const {tenant,dataListId,params} = props ?? {};

          return  disableDataList(tenant,dataListId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableDataListMutationResult = NonNullable<Awaited<ReturnType<typeof disableDataList>>>

    export type DisableDataListMutationError = Problem

    /**
 * @summary Desativa uma lista de dados por ID
 */
export const useDisableDataList = <TError = Problem,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableDataList>>, TError,{tenant: string;dataListId: string;params?: DisableDataListParams}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableDataList>>,
        TError,
        {tenant: string;dataListId: string;params?: DisableDataListParams},
        TContext
      > => {
      return useMutation(getDisableDataListMutationOptions(options), queryClient);
    }

export type clearCacheResponse200 = {
  data: void
  status: 200
}

export type clearCacheResponseSuccess = (clearCacheResponse200) & {
  headers: Headers;
};
;

export type clearCacheResponse = (clearCacheResponseSuccess)

export const getClearCacheUrl = (cacheName: string,) => {




  return `/v1/cache/${cacheName}`
}

/**
 * @summary Limpa cache pelo nome
 */
export const clearCache = async (cacheName: string, options?: RequestInit): Promise<clearCacheResponse> => {

  return customInstanceBpm<clearCacheResponse>(getClearCacheUrl(cacheName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext> => {

const mutationKey = ['clearCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCache>>, {cacheName: string}> = (props) => {
          const {cacheName} = props ?? {};

          return  clearCache(cacheName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCacheMutationResult = NonNullable<Awaited<ReturnType<typeof clearCache>>>

    export type ClearCacheMutationError = unknown

    /**
 * @summary Limpa cache pelo nome
 */
export const useClearCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCache>>, TError,{cacheName: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCache>>,
        TError,
        {cacheName: string},
        TContext
      > => {
      return useMutation(getClearCacheMutationOptions(options), queryClient);
    }

export type clearCacheByKeyResponse200 = {
  data: void
  status: 200
}

export type clearCacheByKeyResponseSuccess = (clearCacheByKeyResponse200) & {
  headers: Headers;
};
;

export type clearCacheByKeyResponse = (clearCacheByKeyResponseSuccess)

export const getClearCacheByKeyUrl = (cacheName: string,
    key: string,) => {




  return `/v1/cache/${cacheName}/${key}`
}

/**
 * @summary Limpa cache pelo nome e chave
 */
export const clearCacheByKey = async (cacheName: string,
    key: string, options?: RequestInit): Promise<clearCacheByKeyResponse> => {

  return customInstanceBpm<clearCacheByKeyResponse>(getClearCacheByKeyUrl(cacheName,key),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearCacheByKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext> => {

const mutationKey = ['clearCacheByKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCacheByKey>>, {cacheName: string;key: string}> = (props) => {
          const {cacheName,key} = props ?? {};

          return  clearCacheByKey(cacheName,key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCacheByKeyMutationResult = NonNullable<Awaited<ReturnType<typeof clearCacheByKey>>>

    export type ClearCacheByKeyMutationError = unknown

    /**
 * @summary Limpa cache pelo nome e chave
 */
export const useClearCacheByKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCacheByKey>>, TError,{cacheName: string;key: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearCacheByKey>>,
        TError,
        {cacheName: string;key: string},
        TContext
      > => {
      return useMutation(getClearCacheByKeyMutationOptions(options), queryClient);
    }

export type deleteAttachmentResponse204 = {
  data: void
  status: 204
}

export type deleteAttachmentResponseSuccess = (deleteAttachmentResponse204) & {
  headers: Headers;
};
;

export type deleteAttachmentResponse = (deleteAttachmentResponseSuccess)

export const getDeleteAttachmentUrl = (documentUID: string,) => {




  return `/smart-bpm/rest/attachment/${documentUID}`
}

/**
 * @summary Exclui o arquivo
 */
export const deleteAttachment = async (documentUID: string, options?: RequestInit): Promise<deleteAttachmentResponse> => {

  return customInstanceBpm<deleteAttachmentResponse>(getDeleteAttachmentUrl(documentUID),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAttachmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{documentUID: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{documentUID: string}, TContext> => {

const mutationKey = ['deleteAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachment>>, {documentUID: string}> = (props) => {
          const {documentUID} = props ?? {};

          return  deleteAttachment(documentUID,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachment>>>

    export type DeleteAttachmentMutationError = unknown

    /**
 * @summary Exclui o arquivo
 */
export const useDeleteAttachment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{documentUID: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachment>>,
        TError,
        {documentUID: string},
        TContext
      > => {
      return useMutation(getDeleteAttachmentMutationOptions(options), queryClient);
    }

export type deleteIpaasUrlsByTenantResponse204 = {
  data: void
  status: 204
}

export type deleteIpaasUrlsByTenantResponseSuccess = (deleteIpaasUrlsByTenantResponse204) & {
  headers: Headers;
};
;

export type deleteIpaasUrlsByTenantResponse = (deleteIpaasUrlsByTenantResponseSuccess)

export const getDeleteIpaasUrlsByTenantUrl = (tenant: string,) => {




  return `/sge/ipaas/ipaas-urls/${tenant}`
}

/**
 * @summary Excluir urls do Ipaas por tenant
 */
export const deleteIpaasUrlsByTenant = async (tenant: string, options?: RequestInit): Promise<deleteIpaasUrlsByTenantResponse> => {

  return customInstanceBpm<deleteIpaasUrlsByTenantResponse>(getDeleteIpaasUrlsByTenantUrl(tenant),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteIpaasUrlsByTenantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>, TError,{tenant: string}, TContext> => {

const mutationKey = ['deleteIpaasUrlsByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>, {tenant: string}> = (props) => {
          const {tenant} = props ?? {};

          return  deleteIpaasUrlsByTenant(tenant,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIpaasUrlsByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>>

    export type DeleteIpaasUrlsByTenantMutationError = unknown

    /**
 * @summary Excluir urls do Ipaas por tenant
 */
export const useDeleteIpaasUrlsByTenant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>, TError,{tenant: string}, TContext>, request?: SecondParameter<typeof customInstanceBpm>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIpaasUrlsByTenant>>,
        TError,
        {tenant: string},
        TContext
      > => {
      return useMutation(getDeleteIpaasUrlsByTenantMutationOptions(options), queryClient);
    }

